/*! For license information please see main.js.LICENSE */ ! function(e) {
    var t = {};

    function n(i) {
        if (t[i]) return t[i].exports;
        var s = t[i] = {
            i: i,
            l: !1,
            exports: {}
        };
        return e[i].call(s.exports, s, s.exports, n), s.l = !0, s.exports
    }
    n.m = e, n.c = t, n.d = function(e, t, i) {
        n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: i
        })
    }, n.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }, n.t = function(e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var i = Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e)
            for (var s in e) n.d(i, s, function(t) {
                return e[t]
            }.bind(null, s));
        return i
    }, n.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default
        } : function() {
            return e
        };
        return n.d(t, "a", t), t
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, n.p = "/", n(n.s = 143)
}([function(e, t, n) {
    (function(e) {
        e.exports = function() {
            "use strict";
            var t, i;

            function s() {
                return t.apply(null, arguments)
            }

            function a(e) {
                return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e)
            }

            function o(e) {
                return null != e && "[object Object]" === Object.prototype.toString.call(e)
            }

            function r(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t)
            }

            function d(e) {
                if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
                var t;
                for (t in e)
                    if (r(e, t)) return !1;
                return !0
            }

            function l(e) {
                return void 0 === e
            }

            function u(e) {
                return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e)
            }

            function c(e) {
                return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e)
            }

            function h(e, t) {
                var n, i = [],
                    s = e.length;
                for (n = 0; n < s; ++n) i.push(t(e[n], n));
                return i
            }

            function m(e, t) {
                for (var n in t) r(t, n) && (e[n] = t[n]);
                return r(t, "toString") && (e.toString = t.toString), r(t, "valueOf") && (e.valueOf = t.valueOf), e
            }

            function f(e, t, n, i) {
                return Ct(e, t, n, i, !0).utc()
            }

            function _(e) {
                return null == e._pf && (e._pf = {
                    empty: !1,
                    unusedTokens: [],
                    unusedInput: [],
                    overflow: -2,
                    charsLeftOver: 0,
                    nullInput: !1,
                    invalidEra: null,
                    invalidMonth: null,
                    invalidFormat: !1,
                    userInvalidated: !1,
                    iso: !1,
                    parsedDateParts: [],
                    era: null,
                    meridiem: null,
                    rfc2822: !1,
                    weekdayMismatch: !1
                }), e._pf
            }

            function p(e) {
                if (null == e._isValid) {
                    var t = _(e),
                        n = i.call(t.parsedDateParts, function(e) {
                            return null != e
                        }),
                        s = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
                    if (e._strict && (s = s && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour), null != Object.isFrozen && Object.isFrozen(e)) return s;
                    e._isValid = s
                }
                return e._isValid
            }

            function g(e) {
                var t = f(NaN);
                return null != e ? m(_(t), e) : _(t).userInvalidated = !0, t
            }
            i = Array.prototype.some ? Array.prototype.some : function(e) {
                var t, n = Object(this),
                    i = n.length >>> 0;
                for (t = 0; t < i; t++)
                    if (t in n && e.call(this, n[t], t, n)) return !0;
                return !1
            };
            var y = s.momentProperties = [],
                v = !1;

            function M(e, t) {
                var n, i, s, a = y.length;
                if (l(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), l(t._i) || (e._i = t._i), l(t._f) || (e._f = t._f), l(t._l) || (e._l = t._l), l(t._strict) || (e._strict = t._strict), l(t._tzm) || (e._tzm = t._tzm), l(t._isUTC) || (e._isUTC = t._isUTC), l(t._offset) || (e._offset = t._offset), l(t._pf) || (e._pf = _(t)), l(t._locale) || (e._locale = t._locale), a > 0)
                    for (n = 0; n < a; n++) i = y[n], l(s = t[i]) || (e[i] = s);
                return e
            }

            function L(e) {
                M(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === v && (v = !0, s.updateOffset(this), v = !1)
            }

            function w(e) {
                return e instanceof L || null != e && null != e._isAMomentObject
            }

            function b(e) {
                !1 === s.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e)
            }

            function k(e, t) {
                var n = !0;
                return m(function() {
                    if (null != s.deprecationHandler && s.deprecationHandler(null, e), n) {
                        var i, a, o, d = [],
                            l = arguments.length;
                        for (a = 0; a < l; a++) {
                            if (i = "", "object" == typeof arguments[a]) {
                                for (o in i += "\n[" + a + "] ", arguments[0]) r(arguments[0], o) && (i += o + ": " + arguments[0][o] + ", ");
                                i = i.slice(0, -2)
                            } else i = arguments[a];
                            d.push(i)
                        }
                        b(e + "\nArguments: " + Array.prototype.slice.call(d).join("") + "\n" + (new Error).stack), n = !1
                    }
                    return t.apply(this, arguments)
                }, t)
            }
            var Y, T = {};

            function D(e, t) {
                null != s.deprecationHandler && s.deprecationHandler(e, t), T[e] || (b(t), T[e] = !0)
            }

            function S(e) {
                return "undefined" != typeof Function && e instanceof Function || "[object Function]" === Object.prototype.toString.call(e)
            }

            function x(e, t) {
                var n, i = m({}, e);
                for (n in t) r(t, n) && (o(e[n]) && o(t[n]) ? (i[n] = {}, m(i[n], e[n]), m(i[n], t[n])) : null != t[n] ? i[n] = t[n] : delete i[n]);
                for (n in e) r(e, n) && !r(t, n) && o(e[n]) && (i[n] = m({}, i[n]));
                return i
            }

            function H(e) {
                null != e && this.set(e)
            }

            function j(e, t, n) {
                var i = "" + Math.abs(e),
                    s = t - i.length,
                    a = e >= 0;
                return (a ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + i
            }
            s.suppressDeprecationWarnings = !1, s.deprecationHandler = null, Y = Object.keys ? Object.keys : function(e) {
                var t, n = [];
                for (t in e) r(e, t) && n.push(t);
                return n
            };
            var C = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
                P = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
                E = {},
                A = {};

            function O(e, t, n, i) {
                var s = i;
                "string" == typeof i && (s = function() {
                    return this[i]()
                }), e && (A[e] = s), t && (A[t[0]] = function() {
                    return j(s.apply(this, arguments), t[1], t[2])
                }), n && (A[n] = function() {
                    return this.localeData().ordinal(s.apply(this, arguments), e)
                })
            }

            function F(e) {
                return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "")
            }

            function $(e, t) {
                return e.isValid() ? (t = W(t, e.localeData()), E[t] = E[t] || function(e) {
                    var t, n, i = e.match(C);
                    for (t = 0, n = i.length; t < n; t++) A[i[t]] ? i[t] = A[i[t]] : i[t] = F(i[t]);
                    return function(t) {
                        var s, a = "";
                        for (s = 0; s < n; s++) a += S(i[s]) ? i[s].call(t, e) : i[s];
                        return a
                    }
                }(t), E[t](e)) : e.localeData().invalidDate()
            }

            function W(e, t) {
                var n = 5;

                function i(e) {
                    return t.longDateFormat(e) || e
                }
                for (P.lastIndex = 0; n >= 0 && P.test(e);) e = e.replace(P, i), P.lastIndex = 0, n -= 1;
                return e
            }
            var N = {};

            function z(e, t) {
                var n = e.toLowerCase();
                N[n] = N[n + "s"] = N[t] = e
            }

            function R(e) {
                return "string" == typeof e ? N[e] || N[e.toLowerCase()] : void 0
            }

            function I(e) {
                var t, n, i = {};
                for (n in e) r(e, n) && (t = R(n)) && (i[t] = e[n]);
                return i
            }
            var q = {};

            function B(e, t) {
                q[e] = t
            }

            function U(e) {
                return e % 4 == 0 && e % 100 != 0 || e % 400 == 0
            }

            function J(e) {
                return e < 0 ? Math.ceil(e) || 0 : Math.floor(e)
            }

            function V(e) {
                var t = +e,
                    n = 0;
                return 0 !== t && isFinite(t) && (n = J(t)), n
            }

            function G(e, t) {
                return function(n) {
                    return null != n ? (K(this, e, n), s.updateOffset(this, t), this) : X(this, e)
                }
            }

            function X(e, t) {
                return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN
            }

            function K(e, t, n) {
                e.isValid() && !isNaN(n) && ("FullYear" === t && U(e.year()) && 1 === e.month() && 29 === e.date() ? (n = V(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](n, e.month(), Ce(n, e.month()))) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n))
            }
            var Z, Q = /\d/,
                ee = /\d\d/,
                te = /\d{3}/,
                ne = /\d{4}/,
                ie = /[+-]?\d{6}/,
                se = /\d\d?/,
                ae = /\d\d\d\d?/,
                oe = /\d\d\d\d\d\d?/,
                re = /\d{1,3}/,
                de = /\d{1,4}/,
                le = /[+-]?\d{1,6}/,
                ue = /\d+/,
                ce = /[+-]?\d+/,
                he = /Z|[+-]\d\d:?\d\d/gi,
                me = /Z|[+-]\d\d(?::?\d\d)?/gi,
                fe = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

            function _e(e, t, n) {
                Z[e] = S(t) ? t : function(e, i) {
                    return e && n ? n : t
                }
            }

            function pe(e, t) {
                return r(Z, e) ? Z[e](t._strict, t._locale) : new RegExp(function(e) {
                    return ge(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(e, t, n, i, s) {
                        return t || n || i || s
                    }))
                }(e))
            }

            function ge(e) {
                return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
            }
            Z = {};
            var ye = {};

            function ve(e, t) {
                var n, i, s = t;
                for ("string" == typeof e && (e = [e]), u(t) && (s = function(e, n) {
                        n[t] = V(e)
                    }), i = e.length, n = 0; n < i; n++) ye[e[n]] = s
            }

            function Me(e, t) {
                ve(e, function(e, n, i, s) {
                    i._w = i._w || {}, t(e, i._w, i, s)
                })
            }

            function Le(e, t, n) {
                null != t && r(ye, e) && ye[e](t, n._a, n, e)
            }
            var we, be = 0,
                ke = 1,
                Ye = 2,
                Te = 3,
                De = 4,
                Se = 5,
                xe = 6,
                He = 7,
                je = 8;

            function Ce(e, t) {
                if (isNaN(e) || isNaN(t)) return NaN;
                var n = function(e, t) {
                    return (e % t + t) % t
                }(t, 12);
                return e += (t - n) / 12, 1 === n ? U(e) ? 29 : 28 : 31 - n % 7 % 2
            }
            we = Array.prototype.indexOf ? Array.prototype.indexOf : function(e) {
                var t;
                for (t = 0; t < this.length; ++t)
                    if (this[t] === e) return t;
                return -1
            }, O("M", ["MM", 2], "Mo", function() {
                return this.month() + 1
            }), O("MMM", 0, 0, function(e) {
                return this.localeData().monthsShort(this, e)
            }), O("MMMM", 0, 0, function(e) {
                return this.localeData().months(this, e)
            }), z("month", "M"), B("month", 8), _e("M", se), _e("MM", se, ee), _e("MMM", function(e, t) {
                return t.monthsShortRegex(e)
            }), _e("MMMM", function(e, t) {
                return t.monthsRegex(e)
            }), ve(["M", "MM"], function(e, t) {
                t[ke] = V(e) - 1
            }), ve(["MMM", "MMMM"], function(e, t, n, i) {
                var s = n._locale.monthsParse(e, i, n._strict);
                null != s ? t[ke] = s : _(n).invalidMonth = e
            });
            var Pe = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                Ee = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
                Ae = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
                Oe = fe,
                Fe = fe;

            function $e(e, t) {
                var n;
                if (!e.isValid()) return e;
                if ("string" == typeof t)
                    if (/^\d+$/.test(t)) t = V(t);
                    else if (!u(t = e.localeData().monthsParse(t))) return e;
                return n = Math.min(e.date(), Ce(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e
            }

            function We(e) {
                return null != e ? ($e(this, e), s.updateOffset(this, !0), this) : X(this, "Month")
            }

            function Ne() {
                function e(e, t) {
                    return t.length - e.length
                }
                var t, n, i = [],
                    s = [],
                    a = [];
                for (t = 0; t < 12; t++) n = f([2e3, t]), i.push(this.monthsShort(n, "")), s.push(this.months(n, "")), a.push(this.months(n, "")), a.push(this.monthsShort(n, ""));
                for (i.sort(e), s.sort(e), a.sort(e), t = 0; t < 12; t++) i[t] = ge(i[t]), s[t] = ge(s[t]);
                for (t = 0; t < 24; t++) a[t] = ge(a[t]);
                this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + i.join("|") + ")", "i")
            }

            function ze(e) {
                return U(e) ? 366 : 365
            }
            O("Y", 0, 0, function() {
                var e = this.year();
                return e <= 9999 ? j(e, 4) : "+" + e
            }), O(0, ["YY", 2], 0, function() {
                return this.year() % 100
            }), O(0, ["YYYY", 4], 0, "year"), O(0, ["YYYYY", 5], 0, "year"), O(0, ["YYYYYY", 6, !0], 0, "year"), z("year", "y"), B("year", 1), _e("Y", ce), _e("YY", se, ee), _e("YYYY", de, ne), _e("YYYYY", le, ie), _e("YYYYYY", le, ie), ve(["YYYYY", "YYYYYY"], be), ve("YYYY", function(e, t) {
                t[be] = 2 === e.length ? s.parseTwoDigitYear(e) : V(e)
            }), ve("YY", function(e, t) {
                t[be] = s.parseTwoDigitYear(e)
            }), ve("Y", function(e, t) {
                t[be] = parseInt(e, 10)
            }), s.parseTwoDigitYear = function(e) {
                return V(e) + (V(e) > 68 ? 1900 : 2e3)
            };
            var Re = G("FullYear", !0);

            function Ie(e) {
                var t, n;
                return e < 100 && e >= 0 ? ((n = Array.prototype.slice.call(arguments))[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t
            }

            function qe(e, t, n) {
                var i = 7 + t - n,
                    s = (7 + Ie(e, 0, i).getUTCDay() - t) % 7;
                return -s + i - 1
            }

            function Be(e, t, n, i, s) {
                var a, o, r = (7 + n - i) % 7,
                    d = qe(e, i, s),
                    l = 1 + 7 * (t - 1) + r + d;
                return l <= 0 ? o = ze(a = e - 1) + l : l > ze(e) ? (a = e + 1, o = l - ze(e)) : (a = e, o = l), {
                    year: a,
                    dayOfYear: o
                }
            }

            function Ue(e, t, n) {
                var i, s, a = qe(e.year(), t, n),
                    o = Math.floor((e.dayOfYear() - a - 1) / 7) + 1;
                return o < 1 ? (s = e.year() - 1, i = o + Je(s, t, n)) : o > Je(e.year(), t, n) ? (i = o - Je(e.year(), t, n), s = e.year() + 1) : (s = e.year(), i = o), {
                    week: i,
                    year: s
                }
            }

            function Je(e, t, n) {
                var i = qe(e, t, n),
                    s = qe(e + 1, t, n);
                return (ze(e) - i + s) / 7
            }

            function Ve(e, t) {
                return e.slice(t, 7).concat(e.slice(0, t))
            }
            O("w", ["ww", 2], "wo", "week"), O("W", ["WW", 2], "Wo", "isoWeek"), z("week", "w"), z("isoWeek", "W"), B("week", 5), B("isoWeek", 5), _e("w", se), _e("ww", se, ee), _e("W", se), _e("WW", se, ee), Me(["w", "ww", "W", "WW"], function(e, t, n, i) {
                t[i.substr(0, 1)] = V(e)
            }), O("d", 0, "do", "day"), O("dd", 0, 0, function(e) {
                return this.localeData().weekdaysMin(this, e)
            }), O("ddd", 0, 0, function(e) {
                return this.localeData().weekdaysShort(this, e)
            }), O("dddd", 0, 0, function(e) {
                return this.localeData().weekdays(this, e)
            }), O("e", 0, 0, "weekday"), O("E", 0, 0, "isoWeekday"), z("day", "d"), z("weekday", "e"), z("isoWeekday", "E"), B("day", 11), B("weekday", 11), B("isoWeekday", 11), _e("d", se), _e("e", se), _e("E", se), _e("dd", function(e, t) {
                return t.weekdaysMinRegex(e)
            }), _e("ddd", function(e, t) {
                return t.weekdaysShortRegex(e)
            }), _e("dddd", function(e, t) {
                return t.weekdaysRegex(e)
            }), Me(["dd", "ddd", "dddd"], function(e, t, n, i) {
                var s = n._locale.weekdaysParse(e, i, n._strict);
                null != s ? t.d = s : _(n).invalidWeekday = e
            }), Me(["d", "e", "E"], function(e, t, n, i) {
                t[i] = V(e)
            });
            var Ge = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                Xe = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
                Ke = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
                Ze = fe,
                Qe = fe,
                et = fe;

            function tt() {
                function e(e, t) {
                    return t.length - e.length
                }
                var t, n, i, s, a, o = [],
                    r = [],
                    d = [],
                    l = [];
                for (t = 0; t < 7; t++) n = f([2e3, 1]).day(t), i = ge(this.weekdaysMin(n, "")), s = ge(this.weekdaysShort(n, "")), a = ge(this.weekdays(n, "")), o.push(i), r.push(s), d.push(a), l.push(i), l.push(s), l.push(a);
                o.sort(e), r.sort(e), d.sort(e), l.sort(e), this._weekdaysRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i")
            }

            function nt() {
                return this.hours() % 12 || 12
            }

            function it(e, t) {
                O(e, 0, 0, function() {
                    return this.localeData().meridiem(this.hours(), this.minutes(), t)
                })
            }

            function st(e, t) {
                return t._meridiemParse
            }
            O("H", ["HH", 2], 0, "hour"), O("h", ["hh", 2], 0, nt), O("k", ["kk", 2], 0, function() {
                return this.hours() || 24
            }), O("hmm", 0, 0, function() {
                return "" + nt.apply(this) + j(this.minutes(), 2)
            }), O("hmmss", 0, 0, function() {
                return "" + nt.apply(this) + j(this.minutes(), 2) + j(this.seconds(), 2)
            }), O("Hmm", 0, 0, function() {
                return "" + this.hours() + j(this.minutes(), 2)
            }), O("Hmmss", 0, 0, function() {
                return "" + this.hours() + j(this.minutes(), 2) + j(this.seconds(), 2)
            }), it("a", !0), it("A", !1), z("hour", "h"), B("hour", 13), _e("a", st), _e("A", st), _e("H", se), _e("h", se), _e("k", se), _e("HH", se, ee), _e("hh", se, ee), _e("kk", se, ee), _e("hmm", ae), _e("hmmss", oe), _e("Hmm", ae), _e("Hmmss", oe), ve(["H", "HH"], Te), ve(["k", "kk"], function(e, t, n) {
                var i = V(e);
                t[Te] = 24 === i ? 0 : i
            }), ve(["a", "A"], function(e, t, n) {
                n._isPm = n._locale.isPM(e), n._meridiem = e
            }), ve(["h", "hh"], function(e, t, n) {
                t[Te] = V(e), _(n).bigHour = !0
            }), ve("hmm", function(e, t, n) {
                var i = e.length - 2;
                t[Te] = V(e.substr(0, i)), t[De] = V(e.substr(i)), _(n).bigHour = !0
            }), ve("hmmss", function(e, t, n) {
                var i = e.length - 4,
                    s = e.length - 2;
                t[Te] = V(e.substr(0, i)), t[De] = V(e.substr(i, 2)), t[Se] = V(e.substr(s)), _(n).bigHour = !0
            }), ve("Hmm", function(e, t, n) {
                var i = e.length - 2;
                t[Te] = V(e.substr(0, i)), t[De] = V(e.substr(i))
            }), ve("Hmmss", function(e, t, n) {
                var i = e.length - 4,
                    s = e.length - 2;
                t[Te] = V(e.substr(0, i)), t[De] = V(e.substr(i, 2)), t[Se] = V(e.substr(s))
            });
            var at, ot = G("Hours", !0),
                rt = {
                    calendar: {
                        sameDay: "[Today at] LT",
                        nextDay: "[Tomorrow at] LT",
                        nextWeek: "dddd [at] LT",
                        lastDay: "[Yesterday at] LT",
                        lastWeek: "[Last] dddd [at] LT",
                        sameElse: "L"
                    },
                    longDateFormat: {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    },
                    invalidDate: "Invalid date",
                    ordinal: "%d",
                    dayOfMonthOrdinalParse: /\d{1,2}/,
                    relativeTime: {
                        future: "in %s",
                        past: "%s ago",
                        s: "a few seconds",
                        ss: "%d seconds",
                        m: "a minute",
                        mm: "%d minutes",
                        h: "an hour",
                        hh: "%d hours",
                        d: "a day",
                        dd: "%d days",
                        w: "a week",
                        ww: "%d weeks",
                        M: "a month",
                        MM: "%d months",
                        y: "a year",
                        yy: "%d years"
                    },
                    months: Pe,
                    monthsShort: Ee,
                    week: {
                        dow: 0,
                        doy: 6
                    },
                    weekdays: Ge,
                    weekdaysMin: Ke,
                    weekdaysShort: Xe,
                    meridiemParse: /[ap]\.?m?\.?/i
                },
                dt = {},
                lt = {};

            function ut(e, t) {
                var n, i = Math.min(e.length, t.length);
                for (n = 0; n < i; n += 1)
                    if (e[n] !== t[n]) return n;
                return i
            }

            function ct(e) {
                return e ? e.toLowerCase().replace("_", "-") : e
            }

            function ht(t) {
                var i = null;
                if (void 0 === dt[t] && void 0 !== e && e && e.exports && function(e) {
                        return null != e.match("^[^/\\\\]*$")
                    }(t)) try {
                    i = at._abbr, n(182)("./" + t), mt(i)
                } catch (e) {
                    dt[t] = null
                }
                return dt[t]
            }

            function mt(e, t) {
                var n;
                return e && ((n = l(t) ? _t(e) : ft(e, t)) ? at = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), at._abbr
            }

            function ft(e, t) {
                if (null !== t) {
                    var n, i = rt;
                    if (t.abbr = e, null != dt[e]) D("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), i = dt[e]._config;
                    else if (null != t.parentLocale)
                        if (null != dt[t.parentLocale]) i = dt[t.parentLocale]._config;
                        else {
                            if (null == (n = ht(t.parentLocale))) return lt[t.parentLocale] || (lt[t.parentLocale] = []), lt[t.parentLocale].push({
                                name: e,
                                config: t
                            }), null;
                            i = n._config
                        } return dt[e] = new H(x(i, t)), lt[e] && lt[e].forEach(function(e) {
                        ft(e.name, e.config)
                    }), mt(e), dt[e]
                }
                return delete dt[e], null
            }

            function _t(e) {
                var t;
                if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return at;
                if (!a(e)) {
                    if (t = ht(e)) return t;
                    e = [e]
                }
                return function(e) {
                    for (var t, n, i, s, a = 0; a < e.length;) {
                        for (s = ct(e[a]).split("-"), t = s.length, n = (n = ct(e[a + 1])) ? n.split("-") : null; t > 0;) {
                            if (i = ht(s.slice(0, t).join("-"))) return i;
                            if (n && n.length >= t && ut(s, n) >= t - 1) break;
                            t--
                        }
                        a++
                    }
                    return at
                }(e)
            }

            function pt(e) {
                var t, n = e._a;
                return n && -2 === _(e).overflow && (t = n[ke] < 0 || n[ke] > 11 ? ke : n[Ye] < 1 || n[Ye] > Ce(n[be], n[ke]) ? Ye : n[Te] < 0 || n[Te] > 24 || 24 === n[Te] && (0 !== n[De] || 0 !== n[Se] || 0 !== n[xe]) ? Te : n[De] < 0 || n[De] > 59 ? De : n[Se] < 0 || n[Se] > 59 ? Se : n[xe] < 0 || n[xe] > 999 ? xe : -1, _(e)._overflowDayOfYear && (t < be || t > Ye) && (t = Ye), _(e)._overflowWeeks && -1 === t && (t = He), _(e)._overflowWeekday && -1 === t && (t = je), _(e).overflow = t), e
            }
            var gt = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                yt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                vt = /Z|[+-]\d\d(?::?\d\d)?/,
                Mt = [
                    ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
                    ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
                    ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
                    ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
                    ["YYYY-DDD", /\d{4}-\d{3}/],
                    ["YYYY-MM", /\d{4}-\d\d/, !1],
                    ["YYYYYYMMDD", /[+-]\d{10}/],
                    ["YYYYMMDD", /\d{8}/],
                    ["GGGG[W]WWE", /\d{4}W\d{3}/],
                    ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
                    ["YYYYDDD", /\d{7}/],
                    ["YYYYMM", /\d{6}/, !1],
                    ["YYYY", /\d{4}/, !1]
                ],
                Lt = [
                    ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
                    ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
                    ["HH:mm:ss", /\d\d:\d\d:\d\d/],
                    ["HH:mm", /\d\d:\d\d/],
                    ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
                    ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
                    ["HHmmss", /\d\d\d\d\d\d/],
                    ["HHmm", /\d\d\d\d/],
                    ["HH", /\d\d/]
                ],
                wt = /^\/?Date\((-?\d+)/i,
                bt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
                kt = {
                    UT: 0,
                    GMT: 0,
                    EDT: -240,
                    EST: -300,
                    CDT: -300,
                    CST: -360,
                    MDT: -360,
                    MST: -420,
                    PDT: -420,
                    PST: -480
                };

            function Yt(e) {
                var t, n, i, s, a, o, r = e._i,
                    d = gt.exec(r) || yt.exec(r),
                    l = Mt.length,
                    u = Lt.length;
                if (d) {
                    for (_(e).iso = !0, t = 0, n = l; t < n; t++)
                        if (Mt[t][1].exec(d[1])) {
                            s = Mt[t][0], i = !1 !== Mt[t][2];
                            break
                        } if (null == s) return void(e._isValid = !1);
                    if (d[3]) {
                        for (t = 0, n = u; t < n; t++)
                            if (Lt[t][1].exec(d[3])) {
                                a = (d[2] || " ") + Lt[t][0];
                                break
                            } if (null == a) return void(e._isValid = !1)
                    }
                    if (!i && null != a) return void(e._isValid = !1);
                    if (d[4]) {
                        if (!vt.exec(d[4])) return void(e._isValid = !1);
                        o = "Z"
                    }
                    e._f = s + (a || "") + (o || ""), Ht(e)
                } else e._isValid = !1
            }

            function Tt(e, t, n, i, s, a) {
                var o = [function(e) {
                    var t = parseInt(e, 10);
                    return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t
                }(e), Ee.indexOf(t), parseInt(n, 10), parseInt(i, 10), parseInt(s, 10)];
                return a && o.push(parseInt(a, 10)), o
            }

            function Dt(e) {
                var t, n = bt.exec(function(e) {
                    return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                }(e._i));
                if (n) {
                    if (t = Tt(n[4], n[3], n[2], n[5], n[6], n[7]), ! function(e, t, n) {
                            if (e) {
                                var i = Xe.indexOf(e),
                                    s = new Date(t[0], t[1], t[2]).getDay();
                                if (i !== s) return _(n).weekdayMismatch = !0, n._isValid = !1, !1
                            }
                            return !0
                        }(n[1], t, e)) return;
                    e._a = t, e._tzm = function(e, t, n) {
                        if (e) return kt[e];
                        if (t) return 0;
                        var i = parseInt(n, 10),
                            s = i % 100,
                            a = (i - s) / 100;
                        return 60 * a + s
                    }(n[8], n[9], n[10]), e._d = Ie.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), _(e).rfc2822 = !0
                } else e._isValid = !1
            }

            function St(e, t, n) {
                return null != e ? e : null != t ? t : n
            }

            function xt(e) {
                var t, n, i, a, o, r = [];
                if (!e._d) {
                    for (i = function(e) {
                            var t = new Date(s.now());
                            return e._useUTC ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()] : [t.getFullYear(), t.getMonth(), t.getDate()]
                        }(e), e._w && null == e._a[Ye] && null == e._a[ke] && function(e) {
                            var t, n, i, s, a, o, r, d, l;
                            null != (t = e._w).GG || null != t.W || null != t.E ? (a = 1, o = 4, n = St(t.GG, e._a[be], Ue(Pt(), 1, 4).year), i = St(t.W, 1), ((s = St(t.E, 1)) < 1 || s > 7) && (d = !0)) : (a = e._locale._week.dow, o = e._locale._week.doy, l = Ue(Pt(), a, o), n = St(t.gg, e._a[be], l.year), i = St(t.w, l.week), null != t.d ? ((s = t.d) < 0 || s > 6) && (d = !0) : null != t.e ? (s = t.e + a, (t.e < 0 || t.e > 6) && (d = !0)) : s = a), i < 1 || i > Je(n, a, o) ? _(e)._overflowWeeks = !0 : null != d ? _(e)._overflowWeekday = !0 : (r = Be(n, i, s, a, o), e._a[be] = r.year, e._dayOfYear = r.dayOfYear)
                        }(e), null != e._dayOfYear && (o = St(e._a[be], i[be]), (e._dayOfYear > ze(o) || 0 === e._dayOfYear) && (_(e)._overflowDayOfYear = !0), n = Ie(o, 0, e._dayOfYear), e._a[ke] = n.getUTCMonth(), e._a[Ye] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) e._a[t] = r[t] = i[t];
                    for (; t < 7; t++) e._a[t] = r[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
                    24 === e._a[Te] && 0 === e._a[De] && 0 === e._a[Se] && 0 === e._a[xe] && (e._nextDay = !0, e._a[Te] = 0), e._d = (e._useUTC ? Ie : function(e, t, n, i, s, a, o) {
                        var r;
                        return e < 100 && e >= 0 ? (r = new Date(e + 400, t, n, i, s, a, o), isFinite(r.getFullYear()) && r.setFullYear(e)) : r = new Date(e, t, n, i, s, a, o), r
                    }).apply(null, r), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Te] = 24), e._w && void 0 !== e._w.d && e._w.d !== a && (_(e).weekdayMismatch = !0)
                }
            }

            function Ht(e) {
                if (e._f !== s.ISO_8601)
                    if (e._f !== s.RFC_2822) {
                        e._a = [], _(e).empty = !0;
                        var t, n, i, a, o, r, d, l = "" + e._i,
                            u = l.length,
                            c = 0;
                        for (i = W(e._f, e._locale).match(C) || [], d = i.length, t = 0; t < d; t++) a = i[t], (n = (l.match(pe(a, e)) || [])[0]) && ((o = l.substr(0, l.indexOf(n))).length > 0 && _(e).unusedInput.push(o), l = l.slice(l.indexOf(n) + n.length), c += n.length), A[a] ? (n ? _(e).empty = !1 : _(e).unusedTokens.push(a), Le(a, n, e)) : e._strict && !n && _(e).unusedTokens.push(a);
                        _(e).charsLeftOver = u - c, l.length > 0 && _(e).unusedInput.push(l), e._a[Te] <= 12 && !0 === _(e).bigHour && e._a[Te] > 0 && (_(e).bigHour = void 0), _(e).parsedDateParts = e._a.slice(0), _(e).meridiem = e._meridiem, e._a[Te] = function(e, t, n) {
                            var i;
                            return null == n ? t : null != e.meridiemHour ? e.meridiemHour(t, n) : null != e.isPM ? ((i = e.isPM(n)) && t < 12 && (t += 12), i || 12 !== t || (t = 0), t) : t
                        }(e._locale, e._a[Te], e._meridiem), null !== (r = _(e).era) && (e._a[be] = e._locale.erasConvertYear(r, e._a[be])), xt(e), pt(e)
                    } else Dt(e);
                else Yt(e)
            }

            function jt(e) {
                var t = e._i,
                    n = e._f;
                return e._locale = e._locale || _t(e._l), null === t || void 0 === n && "" === t ? g({
                    nullInput: !0
                }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), w(t) ? new L(pt(t)) : (c(t) ? e._d = t : a(n) ? function(e) {
                    var t, n, i, s, a, o, r = !1,
                        d = e._f.length;
                    if (0 === d) return _(e).invalidFormat = !0, void(e._d = new Date(NaN));
                    for (s = 0; s < d; s++) a = 0, o = !1, t = M({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[s], Ht(t), p(t) && (o = !0), a += _(t).charsLeftOver, a += 10 * _(t).unusedTokens.length, _(t).score = a, r ? a < i && (i = a, n = t) : (null == i || a < i || o) && (i = a, n = t, o && (r = !0));
                    m(e, n || t)
                }(e) : n ? Ht(e) : function(e) {
                    var t = e._i;
                    l(t) ? e._d = new Date(s.now()) : c(t) ? e._d = new Date(t.valueOf()) : "string" == typeof t ? function(e) {
                        var t = wt.exec(e._i);
                        null === t ? (Yt(e), !1 === e._isValid && (delete e._isValid, Dt(e), !1 === e._isValid && (delete e._isValid, e._strict ? e._isValid = !1 : s.createFromInputFallback(e)))) : e._d = new Date(+t[1])
                    }(e) : a(t) ? (e._a = h(t.slice(0), function(e) {
                        return parseInt(e, 10)
                    }), xt(e)) : o(t) ? function(e) {
                        if (!e._d) {
                            var t = I(e._i),
                                n = void 0 === t.day ? t.date : t.day;
                            e._a = h([t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond], function(e) {
                                return e && parseInt(e, 10)
                            }), xt(e)
                        }
                    }(e) : u(t) ? e._d = new Date(t) : s.createFromInputFallback(e)
                }(e), p(e) || (e._d = null), e))
            }

            function Ct(e, t, n, i, s) {
                var r = {};
                return !0 !== t && !1 !== t || (i = t, t = void 0), !0 !== n && !1 !== n || (i = n, n = void 0), (o(e) && d(e) || a(e) && 0 === e.length) && (e = void 0), r._isAMomentObject = !0, r._useUTC = r._isUTC = s, r._l = n, r._i = e, r._f = t, r._strict = i,
                    function(e) {
                        var t = new L(pt(jt(e)));
                        return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t
                    }(r)
            }

            function Pt(e, t, n, i) {
                return Ct(e, t, n, i, !1)
            }
            s.createFromInputFallback = k("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(e) {
                e._d = new Date(e._i + (e._useUTC ? " UTC" : ""))
            }), s.ISO_8601 = function() {}, s.RFC_2822 = function() {};
            var Et = k("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                    var e = Pt.apply(null, arguments);
                    return this.isValid() && e.isValid() ? e < this ? this : e : g()
                }),
                At = k("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                    var e = Pt.apply(null, arguments);
                    return this.isValid() && e.isValid() ? e > this ? this : e : g()
                });

            function Ot(e, t) {
                var n, i;
                if (1 === t.length && a(t[0]) && (t = t[0]), !t.length) return Pt();
                for (n = t[0], i = 1; i < t.length; ++i) t[i].isValid() && !t[i][e](n) || (n = t[i]);
                return n
            }
            var Ft = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

            function $t(e) {
                var t = I(e),
                    n = t.year || 0,
                    i = t.quarter || 0,
                    s = t.month || 0,
                    a = t.week || t.isoWeek || 0,
                    o = t.day || 0,
                    d = t.hour || 0,
                    l = t.minute || 0,
                    u = t.second || 0,
                    c = t.millisecond || 0;
                this._isValid = function(e) {
                    var t, n, i = !1,
                        s = Ft.length;
                    for (t in e)
                        if (r(e, t) && (-1 === we.call(Ft, t) || null != e[t] && isNaN(e[t]))) return !1;
                    for (n = 0; n < s; ++n)
                        if (e[Ft[n]]) {
                            if (i) return !1;
                            parseFloat(e[Ft[n]]) !== V(e[Ft[n]]) && (i = !0)
                        } return !0
                }(t), this._milliseconds = +c + 1e3 * u + 6e4 * l + 1e3 * d * 60 * 60, this._days = +o + 7 * a, this._months = +s + 3 * i + 12 * n, this._data = {}, this._locale = _t(), this._bubble()
            }

            function Wt(e) {
                return e instanceof $t
            }

            function Nt(e) {
                return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e)
            }

            function zt(e, t) {
                O(e, 0, 0, function() {
                    var e = this.utcOffset(),
                        n = "+";
                    return e < 0 && (e = -e, n = "-"), n + j(~~(e / 60), 2) + t + j(~~e % 60, 2)
                })
            }
            zt("Z", ":"), zt("ZZ", ""), _e("Z", me), _e("ZZ", me), ve(["Z", "ZZ"], function(e, t, n) {
                n._useUTC = !0, n._tzm = It(me, e)
            });
            var Rt = /([\+\-]|\d\d)/gi;

            function It(e, t) {
                var n, i, s, a = (t || "").match(e);
                return null === a ? null : (n = a[a.length - 1] || [], i = (n + "").match(Rt) || ["-", 0, 0], 0 === (s = 60 * i[1] + V(i[2])) ? 0 : "+" === i[0] ? s : -s)
            }

            function qt(e, t) {
                var n, i;
                return t._isUTC ? (n = t.clone(), i = (w(e) || c(e) ? e.valueOf() : Pt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + i), s.updateOffset(n, !1), n) : Pt(e).local()
            }

            function Bt(e) {
                return -Math.round(e._d.getTimezoneOffset())
            }

            function Ut() {
                return !!this.isValid() && this._isUTC && 0 === this._offset
            }
            s.updateOffset = function() {};
            var Jt = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
                Vt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

            function Gt(e, t) {
                var n, i, s, a = e,
                    o = null;
                return Wt(e) ? a = {
                    ms: e._milliseconds,
                    d: e._days,
                    M: e._months
                } : u(e) || !isNaN(+e) ? (a = {}, t ? a[t] = +e : a.milliseconds = +e) : (o = Jt.exec(e)) ? (n = "-" === o[1] ? -1 : 1, a = {
                    y: 0,
                    d: V(o[Ye]) * n,
                    h: V(o[Te]) * n,
                    m: V(o[De]) * n,
                    s: V(o[Se]) * n,
                    ms: V(Nt(1e3 * o[xe])) * n
                }) : (o = Vt.exec(e)) ? (n = "-" === o[1] ? -1 : 1, a = {
                    y: Xt(o[2], n),
                    M: Xt(o[3], n),
                    w: Xt(o[4], n),
                    d: Xt(o[5], n),
                    h: Xt(o[6], n),
                    m: Xt(o[7], n),
                    s: Xt(o[8], n)
                }) : null == a ? a = {} : "object" == typeof a && ("from" in a || "to" in a) && (s = function(e, t) {
                    var n;
                    return e.isValid() && t.isValid() ? (t = qt(t, e), e.isBefore(t) ? n = Kt(e, t) : ((n = Kt(t, e)).milliseconds = -n.milliseconds, n.months = -n.months), n) : {
                        milliseconds: 0,
                        months: 0
                    }
                }(Pt(a.from), Pt(a.to)), (a = {}).ms = s.milliseconds, a.M = s.months), i = new $t(a), Wt(e) && r(e, "_locale") && (i._locale = e._locale), Wt(e) && r(e, "_isValid") && (i._isValid = e._isValid), i
            }

            function Xt(e, t) {
                var n = e && parseFloat(e.replace(",", "."));
                return (isNaN(n) ? 0 : n) * t
            }

            function Kt(e, t) {
                var n = {};
                return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n
            }

            function Zt(e, t) {
                return function(n, i) {
                    var s;
                    return null === i || isNaN(+i) || (D(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), s = n, n = i, i = s), Qt(this, Gt(n, i), e), this
                }
            }

            function Qt(e, t, n, i) {
                var a = t._milliseconds,
                    o = Nt(t._days),
                    r = Nt(t._months);
                e.isValid() && (i = null == i || i, r && $e(e, X(e, "Month") + r * n), o && K(e, "Date", X(e, "Date") + o * n), a && e._d.setTime(e._d.valueOf() + a * n), i && s.updateOffset(e, o || r))
            }
            Gt.fn = $t.prototype, Gt.invalid = function() {
                return Gt(NaN)
            };
            var en = Zt(1, "add"),
                tn = Zt(-1, "subtract");

            function nn(e) {
                return "string" == typeof e || e instanceof String
            }

            function sn(e, t) {
                if (e.date() < t.date()) return -sn(t, e);
                var n, i, s = 12 * (t.year() - e.year()) + (t.month() - e.month()),
                    a = e.clone().add(s, "months");
                return t - a < 0 ? (n = e.clone().add(s - 1, "months"), i = (t - a) / (a - n)) : (n = e.clone().add(s + 1, "months"), i = (t - a) / (n - a)), -(s + i) || 0
            }

            function an(e) {
                var t;
                return void 0 === e ? this._locale._abbr : (null != (t = _t(e)) && (this._locale = t), this)
            }
            s.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", s.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
            var on = k("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(e) {
                return void 0 === e ? this.localeData() : this.locale(e)
            });

            function rn() {
                return this._locale
            }
            var dn = 1e3,
                ln = 60 * dn,
                un = 60 * ln,
                cn = 3506328 * un;

            function hn(e, t) {
                return (e % t + t) % t
            }

            function mn(e, t, n) {
                return e < 100 && e >= 0 ? new Date(e + 400, t, n) - cn : new Date(e, t, n).valueOf()
            }

            function fn(e, t, n) {
                return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - cn : Date.UTC(e, t, n)
            }

            function _n(e, t) {
                return t.erasAbbrRegex(e)
            }

            function pn() {
                var e, t, n = [],
                    i = [],
                    s = [],
                    a = [],
                    o = this.eras();
                for (e = 0, t = o.length; e < t; ++e) i.push(ge(o[e].name)), n.push(ge(o[e].abbr)), s.push(ge(o[e].narrow)), a.push(ge(o[e].name)), a.push(ge(o[e].abbr)), a.push(ge(o[e].narrow));
                this._erasRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + s.join("|") + ")", "i")
            }

            function gn(e, t) {
                O(0, [e, e.length], 0, t)
            }

            function yn(e, t, n, i, s) {
                var a;
                return null == e ? Ue(this, i, s).year : (a = Je(e, i, s), t > a && (t = a), function(e, t, n, i, s) {
                    var a = Be(e, t, n, i, s),
                        o = Ie(a.year, 0, a.dayOfYear);
                    return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this
                }.call(this, e, t, n, i, s))
            }
            O("N", 0, 0, "eraAbbr"), O("NN", 0, 0, "eraAbbr"), O("NNN", 0, 0, "eraAbbr"), O("NNNN", 0, 0, "eraName"), O("NNNNN", 0, 0, "eraNarrow"), O("y", ["y", 1], "yo", "eraYear"), O("y", ["yy", 2], 0, "eraYear"), O("y", ["yyy", 3], 0, "eraYear"), O("y", ["yyyy", 4], 0, "eraYear"), _e("N", _n), _e("NN", _n), _e("NNN", _n), _e("NNNN", function(e, t) {
                return t.erasNameRegex(e)
            }), _e("NNNNN", function(e, t) {
                return t.erasNarrowRegex(e)
            }), ve(["N", "NN", "NNN", "NNNN", "NNNNN"], function(e, t, n, i) {
                var s = n._locale.erasParse(e, i, n._strict);
                s ? _(n).era = s : _(n).invalidEra = e
            }), _e("y", ue), _e("yy", ue), _e("yyy", ue), _e("yyyy", ue), _e("yo", function(e, t) {
                return t._eraYearOrdinalRegex || ue
            }), ve(["y", "yy", "yyy", "yyyy"], be), ve(["yo"], function(e, t, n, i) {
                var s;
                n._locale._eraYearOrdinalRegex && (s = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[be] = n._locale.eraYearOrdinalParse(e, s) : t[be] = parseInt(e, 10)
            }), O(0, ["gg", 2], 0, function() {
                return this.weekYear() % 100
            }), O(0, ["GG", 2], 0, function() {
                return this.isoWeekYear() % 100
            }), gn("gggg", "weekYear"), gn("ggggg", "weekYear"), gn("GGGG", "isoWeekYear"), gn("GGGGG", "isoWeekYear"), z("weekYear", "gg"), z("isoWeekYear", "GG"), B("weekYear", 1), B("isoWeekYear", 1), _e("G", ce), _e("g", ce), _e("GG", se, ee), _e("gg", se, ee), _e("GGGG", de, ne), _e("gggg", de, ne), _e("GGGGG", le, ie), _e("ggggg", le, ie), Me(["gggg", "ggggg", "GGGG", "GGGGG"], function(e, t, n, i) {
                t[i.substr(0, 2)] = V(e)
            }), Me(["gg", "GG"], function(e, t, n, i) {
                t[i] = s.parseTwoDigitYear(e)
            }), O("Q", 0, "Qo", "quarter"), z("quarter", "Q"), B("quarter", 7), _e("Q", Q), ve("Q", function(e, t) {
                t[ke] = 3 * (V(e) - 1)
            }), O("D", ["DD", 2], "Do", "date"), z("date", "D"), B("date", 9), _e("D", se), _e("DD", se, ee), _e("Do", function(e, t) {
                return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient
            }), ve(["D", "DD"], Ye), ve("Do", function(e, t) {
                t[Ye] = V(e.match(se)[0])
            });
            var vn = G("Date", !0);
            O("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), z("dayOfYear", "DDD"), B("dayOfYear", 4), _e("DDD", re), _e("DDDD", te), ve(["DDD", "DDDD"], function(e, t, n) {
                n._dayOfYear = V(e)
            }), O("m", ["mm", 2], 0, "minute"), z("minute", "m"), B("minute", 14), _e("m", se), _e("mm", se, ee), ve(["m", "mm"], De);
            var Mn = G("Minutes", !1);
            O("s", ["ss", 2], 0, "second"), z("second", "s"), B("second", 15), _e("s", se), _e("ss", se, ee), ve(["s", "ss"], Se);
            var Ln, wn, bn = G("Seconds", !1);
            for (O("S", 0, 0, function() {
                    return ~~(this.millisecond() / 100)
                }), O(0, ["SS", 2], 0, function() {
                    return ~~(this.millisecond() / 10)
                }), O(0, ["SSS", 3], 0, "millisecond"), O(0, ["SSSS", 4], 0, function() {
                    return 10 * this.millisecond()
                }), O(0, ["SSSSS", 5], 0, function() {
                    return 100 * this.millisecond()
                }), O(0, ["SSSSSS", 6], 0, function() {
                    return 1e3 * this.millisecond()
                }), O(0, ["SSSSSSS", 7], 0, function() {
                    return 1e4 * this.millisecond()
                }), O(0, ["SSSSSSSS", 8], 0, function() {
                    return 1e5 * this.millisecond()
                }), O(0, ["SSSSSSSSS", 9], 0, function() {
                    return 1e6 * this.millisecond()
                }), z("millisecond", "ms"), B("millisecond", 16), _e("S", re, Q), _e("SS", re, ee), _e("SSS", re, te), Ln = "SSSS"; Ln.length <= 9; Ln += "S") _e(Ln, ue);

            function kn(e, t) {
                t[xe] = V(1e3 * ("0." + e))
            }
            for (Ln = "S"; Ln.length <= 9; Ln += "S") ve(Ln, kn);
            wn = G("Milliseconds", !1), O("z", 0, 0, "zoneAbbr"), O("zz", 0, 0, "zoneName");
            var Yn = L.prototype;

            function Tn(e) {
                return e
            }
            Yn.add = en, Yn.calendar = function(e, t) {
                1 === arguments.length && (arguments[0] ? function(e) {
                    return w(e) || c(e) || nn(e) || u(e) || function(e) {
                        var t = a(e),
                            n = !1;
                        return t && (n = 0 === e.filter(function(t) {
                            return !u(t) && nn(e)
                        }).length), t && n
                    }(e) || function(e) {
                        var t, n = o(e) && !d(e),
                            i = !1,
                            s = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"],
                            a = s.length;
                        for (t = 0; t < a; t += 1) i = i || r(e, s[t]);
                        return n && i
                    }(e) || null === e || void 0 === e
                }(arguments[0]) ? (e = arguments[0], t = void 0) : function(e) {
                    var t, n = o(e) && !d(e),
                        i = !1,
                        s = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
                    for (t = 0; t < s.length; t += 1) i = i || r(e, s[t]);
                    return n && i
                }(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
                var n = e || Pt(),
                    i = qt(n, this).startOf("day"),
                    l = s.calendarFormat(this, i) || "sameElse",
                    h = t && (S(t[l]) ? t[l].call(this, n) : t[l]);
                return this.format(h || this.localeData().calendar(l, this, Pt(n)))
            }, Yn.clone = function() {
                return new L(this)
            }, Yn.diff = function(e, t, n) {
                var i, s, a;
                if (!this.isValid()) return NaN;
                if (!(i = qt(e, this)).isValid()) return NaN;
                switch (s = 6e4 * (i.utcOffset() - this.utcOffset()), t = R(t)) {
                    case "year":
                        a = sn(this, i) / 12;
                        break;
                    case "month":
                        a = sn(this, i);
                        break;
                    case "quarter":
                        a = sn(this, i) / 3;
                        break;
                    case "second":
                        a = (this - i) / 1e3;
                        break;
                    case "minute":
                        a = (this - i) / 6e4;
                        break;
                    case "hour":
                        a = (this - i) / 36e5;
                        break;
                    case "day":
                        a = (this - i - s) / 864e5;
                        break;
                    case "week":
                        a = (this - i - s) / 6048e5;
                        break;
                    default:
                        a = this - i
                }
                return n ? a : J(a)
            }, Yn.endOf = function(e) {
                var t, n;
                if (void 0 === (e = R(e)) || "millisecond" === e || !this.isValid()) return this;
                switch (n = this._isUTC ? fn : mn, e) {
                    case "year":
                        t = n(this.year() + 1, 0, 1) - 1;
                        break;
                    case "quarter":
                        t = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                        break;
                    case "month":
                        t = n(this.year(), this.month() + 1, 1) - 1;
                        break;
                    case "week":
                        t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                        break;
                    case "isoWeek":
                        t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                        break;
                    case "day":
                    case "date":
                        t = n(this.year(), this.month(), this.date() + 1) - 1;
                        break;
                    case "hour":
                        t = this._d.valueOf(), t += un - hn(t + (this._isUTC ? 0 : this.utcOffset() * ln), un) - 1;
                        break;
                    case "minute":
                        t = this._d.valueOf(), t += ln - hn(t, ln) - 1;
                        break;
                    case "second":
                        t = this._d.valueOf(), t += dn - hn(t, dn) - 1
                }
                return this._d.setTime(t), s.updateOffset(this, !0), this
            }, Yn.format = function(e) {
                e || (e = this.isUtc() ? s.defaultFormatUtc : s.defaultFormat);
                var t = $(this, e);
                return this.localeData().postformat(t)
            }, Yn.from = function(e, t) {
                return this.isValid() && (w(e) && e.isValid() || Pt(e).isValid()) ? Gt({
                    to: this,
                    from: e
                }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate()
            }, Yn.fromNow = function(e) {
                return this.from(Pt(), e)
            }, Yn.to = function(e, t) {
                return this.isValid() && (w(e) && e.isValid() || Pt(e).isValid()) ? Gt({
                    from: this,
                    to: e
                }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate()
            }, Yn.toNow = function(e) {
                return this.to(Pt(), e)
            }, Yn.get = function(e) {
                return S(this[e = R(e)]) ? this[e]() : this
            }, Yn.invalidAt = function() {
                return _(this).overflow
            }, Yn.isAfter = function(e, t) {
                var n = w(e) ? e : Pt(e);
                return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf())
            }, Yn.isBefore = function(e, t) {
                var n = w(e) ? e : Pt(e);
                return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf())
            }, Yn.isBetween = function(e, t, n, i) {
                var s = w(e) ? e : Pt(e),
                    a = w(t) ? t : Pt(t);
                return !!(this.isValid() && s.isValid() && a.isValid()) && ("(" === (i = i || "()")[0] ? this.isAfter(s, n) : !this.isBefore(s, n)) && (")" === i[1] ? this.isBefore(a, n) : !this.isAfter(a, n))
            }, Yn.isSame = function(e, t) {
                var n, i = w(e) ? e : Pt(e);
                return !(!this.isValid() || !i.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() === i.valueOf() : (n = i.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()))
            }, Yn.isSameOrAfter = function(e, t) {
                return this.isSame(e, t) || this.isAfter(e, t)
            }, Yn.isSameOrBefore = function(e, t) {
                return this.isSame(e, t) || this.isBefore(e, t)
            }, Yn.isValid = function() {
                return p(this)
            }, Yn.lang = on, Yn.locale = an, Yn.localeData = rn, Yn.max = At, Yn.min = Et, Yn.parsingFlags = function() {
                return m({}, _(this))
            }, Yn.set = function(e, t) {
                if ("object" == typeof e) {
                    var n, i = function(e) {
                            var t, n = [];
                            for (t in e) r(e, t) && n.push({
                                unit: t,
                                priority: q[t]
                            });
                            return n.sort(function(e, t) {
                                return e.priority - t.priority
                            }), n
                        }(e = I(e)),
                        s = i.length;
                    for (n = 0; n < s; n++) this[i[n].unit](e[i[n].unit])
                } else if (S(this[e = R(e)])) return this[e](t);
                return this
            }, Yn.startOf = function(e) {
                var t, n;
                if (void 0 === (e = R(e)) || "millisecond" === e || !this.isValid()) return this;
                switch (n = this._isUTC ? fn : mn, e) {
                    case "year":
                        t = n(this.year(), 0, 1);
                        break;
                    case "quarter":
                        t = n(this.year(), this.month() - this.month() % 3, 1);
                        break;
                    case "month":
                        t = n(this.year(), this.month(), 1);
                        break;
                    case "week":
                        t = n(this.year(), this.month(), this.date() - this.weekday());
                        break;
                    case "isoWeek":
                        t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                        break;
                    case "day":
                    case "date":
                        t = n(this.year(), this.month(), this.date());
                        break;
                    case "hour":
                        t = this._d.valueOf(), t -= hn(t + (this._isUTC ? 0 : this.utcOffset() * ln), un);
                        break;
                    case "minute":
                        t = this._d.valueOf(), t -= hn(t, ln);
                        break;
                    case "second":
                        t = this._d.valueOf(), t -= hn(t, dn)
                }
                return this._d.setTime(t), s.updateOffset(this, !0), this
            }, Yn.subtract = tn, Yn.toArray = function() {
                var e = this;
                return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()]
            }, Yn.toObject = function() {
                var e = this;
                return {
                    years: e.year(),
                    months: e.month(),
                    date: e.date(),
                    hours: e.hours(),
                    minutes: e.minutes(),
                    seconds: e.seconds(),
                    milliseconds: e.milliseconds()
                }
            }, Yn.toDate = function() {
                return new Date(this.valueOf())
            }, Yn.toISOString = function(e) {
                if (!this.isValid()) return null;
                var t = !0 !== e,
                    n = t ? this.clone().utc() : this;
                return n.year() < 0 || n.year() > 9999 ? $(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : S(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", $(n, "Z")) : $(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ")
            }, Yn.inspect = function() {
                if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
                var e, t, n, i = "moment",
                    s = "";
                return this.isLocal() || (i = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", s = "Z"), e = "[" + i + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = s + '[")]', this.format(e + t + "-MM-DD[T]HH:mm:ss.SSS" + n)
            }, "undefined" != typeof Symbol && null != Symbol.for && (Yn[Symbol.for("nodejs.util.inspect.custom")] = function() {
                return "Moment<" + this.format() + ">"
            }), Yn.toJSON = function() {
                return this.isValid() ? this.toISOString() : null
            }, Yn.toString = function() {
                return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
            }, Yn.unix = function() {
                return Math.floor(this.valueOf() / 1e3)
            }, Yn.valueOf = function() {
                return this._d.valueOf() - 6e4 * (this._offset || 0)
            }, Yn.creationData = function() {
                return {
                    input: this._i,
                    format: this._f,
                    locale: this._locale,
                    isUTC: this._isUTC,
                    strict: this._strict
                }
            }, Yn.eraName = function() {
                var e, t, n, i = this.localeData().eras();
                for (e = 0, t = i.length; e < t; ++e) {
                    if (n = this.clone().startOf("day").valueOf(), i[e].since <= n && n <= i[e].until) return i[e].name;
                    if (i[e].until <= n && n <= i[e].since) return i[e].name
                }
                return ""
            }, Yn.eraNarrow = function() {
                var e, t, n, i = this.localeData().eras();
                for (e = 0, t = i.length; e < t; ++e) {
                    if (n = this.clone().startOf("day").valueOf(), i[e].since <= n && n <= i[e].until) return i[e].narrow;
                    if (i[e].until <= n && n <= i[e].since) return i[e].narrow
                }
                return ""
            }, Yn.eraAbbr = function() {
                var e, t, n, i = this.localeData().eras();
                for (e = 0, t = i.length; e < t; ++e) {
                    if (n = this.clone().startOf("day").valueOf(), i[e].since <= n && n <= i[e].until) return i[e].abbr;
                    if (i[e].until <= n && n <= i[e].since) return i[e].abbr
                }
                return ""
            }, Yn.eraYear = function() {
                var e, t, n, i, a = this.localeData().eras();
                for (e = 0, t = a.length; e < t; ++e)
                    if (n = a[e].since <= a[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), a[e].since <= i && i <= a[e].until || a[e].until <= i && i <= a[e].since) return (this.year() - s(a[e].since).year()) * n + a[e].offset;
                return this.year()
            }, Yn.year = Re, Yn.isLeapYear = function() {
                return U(this.year())
            }, Yn.weekYear = function(e) {
                return yn.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
            }, Yn.isoWeekYear = function(e) {
                return yn.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4)
            }, Yn.quarter = Yn.quarters = function(e) {
                return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3)
            }, Yn.month = We, Yn.daysInMonth = function() {
                return Ce(this.year(), this.month())
            }, Yn.week = Yn.weeks = function(e) {
                var t = this.localeData().week(this);
                return null == e ? t : this.add(7 * (e - t), "d")
            }, Yn.isoWeek = Yn.isoWeeks = function(e) {
                var t = Ue(this, 1, 4).week;
                return null == e ? t : this.add(7 * (e - t), "d")
            }, Yn.weeksInYear = function() {
                var e = this.localeData()._week;
                return Je(this.year(), e.dow, e.doy)
            }, Yn.weeksInWeekYear = function() {
                var e = this.localeData()._week;
                return Je(this.weekYear(), e.dow, e.doy)
            }, Yn.isoWeeksInYear = function() {
                return Je(this.year(), 1, 4)
            }, Yn.isoWeeksInISOWeekYear = function() {
                return Je(this.isoWeekYear(), 1, 4)
            }, Yn.date = vn, Yn.day = Yn.days = function(e) {
                if (!this.isValid()) return null != e ? this : NaN;
                var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                return null != e ? (e = function(e, t) {
                    return "string" != typeof e ? e : isNaN(e) ? "number" == typeof(e = t.weekdaysParse(e)) ? e : null : parseInt(e, 10)
                }(e, this.localeData()), this.add(e - t, "d")) : t
            }, Yn.weekday = function(e) {
                if (!this.isValid()) return null != e ? this : NaN;
                var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
                return null == e ? t : this.add(e - t, "d")
            }, Yn.isoWeekday = function(e) {
                if (!this.isValid()) return null != e ? this : NaN;
                if (null != e) {
                    var t = function(e, t) {
                        return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e
                    }(e, this.localeData());
                    return this.day(this.day() % 7 ? t : t - 7)
                }
                return this.day() || 7
            }, Yn.dayOfYear = function(e) {
                var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
                return null == e ? t : this.add(e - t, "d")
            }, Yn.hour = Yn.hours = ot, Yn.minute = Yn.minutes = Mn, Yn.second = Yn.seconds = bn, Yn.millisecond = Yn.milliseconds = wn, Yn.utcOffset = function(e, t, n) {
                var i, a = this._offset || 0;
                if (!this.isValid()) return null != e ? this : NaN;
                if (null != e) {
                    if ("string" == typeof e) {
                        if (null === (e = It(me, e))) return this
                    } else Math.abs(e) < 16 && !n && (e *= 60);
                    return !this._isUTC && t && (i = Bt(this)), this._offset = e, this._isUTC = !0, null != i && this.add(i, "m"), a !== e && (!t || this._changeInProgress ? Qt(this, Gt(e - a, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, s.updateOffset(this, !0), this._changeInProgress = null)), this
                }
                return this._isUTC ? a : Bt(this)
            }, Yn.utc = function(e) {
                return this.utcOffset(0, e)
            }, Yn.local = function(e) {
                return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Bt(this), "m")), this
            }, Yn.parseZone = function() {
                if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
                else if ("string" == typeof this._i) {
                    var e = It(he, this._i);
                    null != e ? this.utcOffset(e) : this.utcOffset(0, !0)
                }
                return this
            }, Yn.hasAlignedHourOffset = function(e) {
                return !!this.isValid() && (e = e ? Pt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0)
            }, Yn.isDST = function() {
                return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
            }, Yn.isLocal = function() {
                return !!this.isValid() && !this._isUTC
            }, Yn.isUtcOffset = function() {
                return !!this.isValid() && this._isUTC
            }, Yn.isUtc = Ut, Yn.isUTC = Ut, Yn.zoneAbbr = function() {
                return this._isUTC ? "UTC" : ""
            }, Yn.zoneName = function() {
                return this._isUTC ? "Coordinated Universal Time" : ""
            }, Yn.dates = k("dates accessor is deprecated. Use date instead.", vn), Yn.months = k("months accessor is deprecated. Use month instead", We), Yn.years = k("years accessor is deprecated. Use year instead", Re), Yn.zone = k("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function(e, t) {
                return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset()
            }), Yn.isDSTShifted = k("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function() {
                if (!l(this._isDSTShifted)) return this._isDSTShifted;
                var e, t = {};
                return M(t, this), (t = jt(t))._a ? (e = t._isUTC ? f(t._a) : Pt(t._a), this._isDSTShifted = this.isValid() && function(e, t, n) {
                    var i, s = Math.min(e.length, t.length),
                        a = Math.abs(e.length - t.length),
                        o = 0;
                    for (i = 0; i < s; i++)(n && e[i] !== t[i] || !n && V(e[i]) !== V(t[i])) && o++;
                    return o + a
                }(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted
            });
            var Dn = H.prototype;

            function Sn(e, t, n, i) {
                var s = _t(),
                    a = f().set(i, t);
                return s[n](a, e)
            }

            function xn(e, t, n) {
                if (u(e) && (t = e, e = void 0), e = e || "", null != t) return Sn(e, t, n, "month");
                var i, s = [];
                for (i = 0; i < 12; i++) s[i] = Sn(e, i, n, "month");
                return s
            }

            function Hn(e, t, n, i) {
                "boolean" == typeof e ? (u(t) && (n = t, t = void 0), t = t || "") : (n = t = e, e = !1, u(t) && (n = t, t = void 0), t = t || "");
                var s, a = _t(),
                    o = e ? a._week.dow : 0,
                    r = [];
                if (null != n) return Sn(t, (n + o) % 7, i, "day");
                for (s = 0; s < 7; s++) r[s] = Sn(t, (s + o) % 7, i, "day");
                return r
            }
            Dn.calendar = function(e, t, n) {
                var i = this._calendar[e] || this._calendar.sameElse;
                return S(i) ? i.call(t, n) : i
            }, Dn.longDateFormat = function(e) {
                var t = this._longDateFormat[e],
                    n = this._longDateFormat[e.toUpperCase()];
                return t || !n ? t : (this._longDateFormat[e] = n.match(C).map(function(e) {
                    return "MMMM" === e || "MM" === e || "DD" === e || "dddd" === e ? e.slice(1) : e
                }).join(""), this._longDateFormat[e])
            }, Dn.invalidDate = function() {
                return this._invalidDate
            }, Dn.ordinal = function(e) {
                return this._ordinal.replace("%d", e)
            }, Dn.preparse = Tn, Dn.postformat = Tn, Dn.relativeTime = function(e, t, n, i) {
                var s = this._relativeTime[n];
                return S(s) ? s(e, t, n, i) : s.replace(/%d/i, e)
            }, Dn.pastFuture = function(e, t) {
                var n = this._relativeTime[e > 0 ? "future" : "past"];
                return S(n) ? n(t) : n.replace(/%s/i, t)
            }, Dn.set = function(e) {
                var t, n;
                for (n in e) r(e, n) && (S(t = e[n]) ? this[n] = t : this["_" + n] = t);
                this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source)
            }, Dn.eras = function(e, t) {
                var n, i, a, o = this._eras || _t("en")._eras;
                for (n = 0, i = o.length; n < i; ++n) {
                    switch (typeof o[n].since) {
                        case "string":
                            a = s(o[n].since).startOf("day"), o[n].since = a.valueOf()
                    }
                    switch (typeof o[n].until) {
                        case "undefined":
                            o[n].until = 1 / 0;
                            break;
                        case "string":
                            a = s(o[n].until).startOf("day").valueOf(), o[n].until = a.valueOf()
                    }
                }
                return o
            }, Dn.erasParse = function(e, t, n) {
                var i, s, a, o, r, d = this.eras();
                for (e = e.toUpperCase(), i = 0, s = d.length; i < s; ++i)
                    if (a = d[i].name.toUpperCase(), o = d[i].abbr.toUpperCase(), r = d[i].narrow.toUpperCase(), n) switch (t) {
                        case "N":
                        case "NN":
                        case "NNN":
                            if (o === e) return d[i];
                            break;
                        case "NNNN":
                            if (a === e) return d[i];
                            break;
                        case "NNNNN":
                            if (r === e) return d[i]
                    } else if ([a, o, r].indexOf(e) >= 0) return d[i]
            }, Dn.erasConvertYear = function(e, t) {
                var n = e.since <= e.until ? 1 : -1;
                return void 0 === t ? s(e.since).year() : s(e.since).year() + (t - e.offset) * n
            }, Dn.erasAbbrRegex = function(e) {
                return r(this, "_erasAbbrRegex") || pn.call(this), e ? this._erasAbbrRegex : this._erasRegex
            }, Dn.erasNameRegex = function(e) {
                return r(this, "_erasNameRegex") || pn.call(this), e ? this._erasNameRegex : this._erasRegex
            }, Dn.erasNarrowRegex = function(e) {
                return r(this, "_erasNarrowRegex") || pn.call(this), e ? this._erasNarrowRegex : this._erasRegex
            }, Dn.months = function(e, t) {
                return e ? a(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Ae).test(t) ? "format" : "standalone"][e.month()] : a(this._months) ? this._months : this._months.standalone
            }, Dn.monthsShort = function(e, t) {
                return e ? a(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Ae.test(t) ? "format" : "standalone"][e.month()] : a(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone
            }, Dn.monthsParse = function(e, t, n) {
                var i, s, a;
                if (this._monthsParseExact) return function(e, t, n) {
                    var i, s, a, o = e.toLocaleLowerCase();
                    if (!this._monthsParse)
                        for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i) a = f([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(a, "").toLocaleLowerCase(), this._longMonthsParse[i] = this.months(a, "").toLocaleLowerCase();
                    return n ? "MMM" === t ? -1 !== (s = we.call(this._shortMonthsParse, o)) ? s : null : -1 !== (s = we.call(this._longMonthsParse, o)) ? s : null : "MMM" === t ? -1 !== (s = we.call(this._shortMonthsParse, o)) ? s : -1 !== (s = we.call(this._longMonthsParse, o)) ? s : null : -1 !== (s = we.call(this._longMonthsParse, o)) ? s : -1 !== (s = we.call(this._shortMonthsParse, o)) ? s : null
                }.call(this, e, t, n);
                for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++) {
                    if (s = f([2e3, i]), n && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp("^" + this.months(s, "").replace(".", "") + "$", "i"), this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(s, "").replace(".", "") + "$", "i")), n || this._monthsParse[i] || (a = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[i] = new RegExp(a.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[i].test(e)) return i;
                    if (n && "MMM" === t && this._shortMonthsParse[i].test(e)) return i;
                    if (!n && this._monthsParse[i].test(e)) return i
                }
            }, Dn.monthsRegex = function(e) {
                return this._monthsParseExact ? (r(this, "_monthsRegex") || Ne.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (r(this, "_monthsRegex") || (this._monthsRegex = Fe), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex)
            }, Dn.monthsShortRegex = function(e) {
                return this._monthsParseExact ? (r(this, "_monthsRegex") || Ne.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (r(this, "_monthsShortRegex") || (this._monthsShortRegex = Oe), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex)
            }, Dn.week = function(e) {
                return Ue(e, this._week.dow, this._week.doy).week
            }, Dn.firstDayOfYear = function() {
                return this._week.doy
            }, Dn.firstDayOfWeek = function() {
                return this._week.dow
            }, Dn.weekdays = function(e, t) {
                var n = a(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
                return !0 === e ? Ve(n, this._week.dow) : e ? n[e.day()] : n
            }, Dn.weekdaysMin = function(e) {
                return !0 === e ? Ve(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin
            }, Dn.weekdaysShort = function(e) {
                return !0 === e ? Ve(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort
            }, Dn.weekdaysParse = function(e, t, n) {
                var i, s, a;
                if (this._weekdaysParseExact) return function(e, t, n) {
                    var i, s, a, o = e.toLocaleLowerCase();
                    if (!this._weekdaysParse)
                        for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i) a = f([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(a, "").toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(a, "").toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(a, "").toLocaleLowerCase();
                    return n ? "dddd" === t ? -1 !== (s = we.call(this._weekdaysParse, o)) ? s : null : "ddd" === t ? -1 !== (s = we.call(this._shortWeekdaysParse, o)) ? s : null : -1 !== (s = we.call(this._minWeekdaysParse, o)) ? s : null : "dddd" === t ? -1 !== (s = we.call(this._weekdaysParse, o)) ? s : -1 !== (s = we.call(this._shortWeekdaysParse, o)) ? s : -1 !== (s = we.call(this._minWeekdaysParse, o)) ? s : null : "ddd" === t ? -1 !== (s = we.call(this._shortWeekdaysParse, o)) ? s : -1 !== (s = we.call(this._weekdaysParse, o)) ? s : -1 !== (s = we.call(this._minWeekdaysParse, o)) ? s : null : -1 !== (s = we.call(this._minWeekdaysParse, o)) ? s : -1 !== (s = we.call(this._weekdaysParse, o)) ? s : -1 !== (s = we.call(this._shortWeekdaysParse, o)) ? s : null
                }.call(this, e, t, n);
                for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++) {
                    if (s = f([2e3, 1]).day(i), n && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(s, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[i] || (a = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[i] = new RegExp(a.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[i].test(e)) return i;
                    if (n && "ddd" === t && this._shortWeekdaysParse[i].test(e)) return i;
                    if (n && "dd" === t && this._minWeekdaysParse[i].test(e)) return i;
                    if (!n && this._weekdaysParse[i].test(e)) return i
                }
            }, Dn.weekdaysRegex = function(e) {
                return this._weekdaysParseExact ? (r(this, "_weekdaysRegex") || tt.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (r(this, "_weekdaysRegex") || (this._weekdaysRegex = Ze), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex)
            }, Dn.weekdaysShortRegex = function(e) {
                return this._weekdaysParseExact ? (r(this, "_weekdaysRegex") || tt.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (r(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Qe), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
            }, Dn.weekdaysMinRegex = function(e) {
                return this._weekdaysParseExact ? (r(this, "_weekdaysRegex") || tt.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (r(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = et), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
            }, Dn.isPM = function(e) {
                return "p" === (e + "").toLowerCase().charAt(0)
            }, Dn.meridiem = function(e, t, n) {
                return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM"
            }, mt("en", {
                eras: [{
                    since: "0001-01-01",
                    until: 1 / 0,
                    offset: 1,
                    name: "Anno Domini",
                    narrow: "AD",
                    abbr: "AD"
                }, {
                    since: "0000-12-31",
                    until: -1 / 0,
                    offset: 1,
                    name: "Before Christ",
                    narrow: "BC",
                    abbr: "BC"
                }],
                dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                ordinal: function(e) {
                    var t = e % 10,
                        n = 1 === V(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                    return e + n
                }
            }), s.lang = k("moment.lang is deprecated. Use moment.locale instead.", mt), s.langData = k("moment.langData is deprecated. Use moment.localeData instead.", _t);
            var jn = Math.abs;

            function Cn(e, t, n, i) {
                var s = Gt(t, n);
                return e._milliseconds += i * s._milliseconds, e._days += i * s._days, e._months += i * s._months, e._bubble()
            }

            function Pn(e) {
                return e < 0 ? Math.floor(e) : Math.ceil(e)
            }

            function En(e) {
                return 4800 * e / 146097
            }

            function An(e) {
                return 146097 * e / 4800
            }

            function On(e) {
                return function() {
                    return this.as(e)
                }
            }
            var Fn = On("ms"),
                $n = On("s"),
                Wn = On("m"),
                Nn = On("h"),
                zn = On("d"),
                Rn = On("w"),
                In = On("M"),
                qn = On("Q"),
                Bn = On("y");

            function Un(e) {
                return function() {
                    return this.isValid() ? this._data[e] : NaN
                }
            }
            var Jn = Un("milliseconds"),
                Vn = Un("seconds"),
                Gn = Un("minutes"),
                Xn = Un("hours"),
                Kn = Un("days"),
                Zn = Un("months"),
                Qn = Un("years"),
                ei = Math.round,
                ti = {
                    ss: 44,
                    s: 45,
                    m: 45,
                    h: 22,
                    d: 26,
                    w: null,
                    M: 11
                },
                ni = Math.abs;

            function ii(e) {
                return (e > 0) - (e < 0) || +e
            }

            function si() {
                if (!this.isValid()) return this.localeData().invalidDate();
                var e, t, n, i, s, a, o, r, d = ni(this._milliseconds) / 1e3,
                    l = ni(this._days),
                    u = ni(this._months),
                    c = this.asSeconds();
                return c ? (e = J(d / 60), t = J(e / 60), d %= 60, e %= 60, n = J(u / 12), u %= 12, i = d ? d.toFixed(3).replace(/\.?0+$/, "") : "", s = c < 0 ? "-" : "", a = ii(this._months) !== ii(c) ? "-" : "", o = ii(this._days) !== ii(c) ? "-" : "", r = ii(this._milliseconds) !== ii(c) ? "-" : "", s + "P" + (n ? a + n + "Y" : "") + (u ? a + u + "M" : "") + (l ? o + l + "D" : "") + (t || e || d ? "T" : "") + (t ? r + t + "H" : "") + (e ? r + e + "M" : "") + (d ? r + i + "S" : "")) : "P0D"
            }
            var ai = $t.prototype;
            return ai.isValid = function() {
                    return this._isValid
                }, ai.abs = function() {
                    var e = this._data;
                    return this._milliseconds = jn(this._milliseconds), this._days = jn(this._days), this._months = jn(this._months), e.milliseconds = jn(e.milliseconds), e.seconds = jn(e.seconds), e.minutes = jn(e.minutes), e.hours = jn(e.hours), e.months = jn(e.months), e.years = jn(e.years), this
                }, ai.add = function(e, t) {
                    return Cn(this, e, t, 1)
                }, ai.subtract = function(e, t) {
                    return Cn(this, e, t, -1)
                }, ai.as = function(e) {
                    if (!this.isValid()) return NaN;
                    var t, n, i = this._milliseconds;
                    if ("month" === (e = R(e)) || "quarter" === e || "year" === e) switch (t = this._days + i / 864e5, n = this._months + En(t), e) {
                        case "month":
                            return n;
                        case "quarter":
                            return n / 3;
                        case "year":
                            return n / 12
                    } else switch (t = this._days + Math.round(An(this._months)), e) {
                        case "week":
                            return t / 7 + i / 6048e5;
                        case "day":
                            return t + i / 864e5;
                        case "hour":
                            return 24 * t + i / 36e5;
                        case "minute":
                            return 1440 * t + i / 6e4;
                        case "second":
                            return 86400 * t + i / 1e3;
                        case "millisecond":
                            return Math.floor(864e5 * t) + i;
                        default:
                            throw new Error("Unknown unit " + e)
                    }
                }, ai.asMilliseconds = Fn, ai.asSeconds = $n, ai.asMinutes = Wn, ai.asHours = Nn, ai.asDays = zn, ai.asWeeks = Rn, ai.asMonths = In, ai.asQuarters = qn, ai.asYears = Bn, ai.valueOf = function() {
                    return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * V(this._months / 12) : NaN
                }, ai._bubble = function() {
                    var e, t, n, i, s, a = this._milliseconds,
                        o = this._days,
                        r = this._months,
                        d = this._data;
                    return a >= 0 && o >= 0 && r >= 0 || a <= 0 && o <= 0 && r <= 0 || (a += 864e5 * Pn(An(r) + o), o = 0, r = 0), d.milliseconds = a % 1e3, e = J(a / 1e3), d.seconds = e % 60, t = J(e / 60), d.minutes = t % 60, n = J(t / 60), d.hours = n % 24, o += J(n / 24), s = J(En(o)), r += s, o -= Pn(An(s)), i = J(r / 12), r %= 12, d.days = o, d.months = r, d.years = i, this
                }, ai.clone = function() {
                    return Gt(this)
                }, ai.get = function(e) {
                    return e = R(e), this.isValid() ? this[e + "s"]() : NaN
                }, ai.milliseconds = Jn, ai.seconds = Vn, ai.minutes = Gn, ai.hours = Xn, ai.days = Kn, ai.weeks = function() {
                    return J(this.days() / 7)
                }, ai.months = Zn, ai.years = Qn, ai.humanize = function(e, t) {
                    if (!this.isValid()) return this.localeData().invalidDate();
                    var n, i, s = !1,
                        a = ti;
                    return "object" == typeof e && (t = e, e = !1), "boolean" == typeof e && (s = e), "object" == typeof t && (a = Object.assign({}, ti, t), null != t.s && null == t.ss && (a.ss = t.s - 1)), n = this.localeData(), i = function(e, t, n, i) {
                        var s = Gt(e).abs(),
                            a = ei(s.as("s")),
                            o = ei(s.as("m")),
                            r = ei(s.as("h")),
                            d = ei(s.as("d")),
                            l = ei(s.as("M")),
                            u = ei(s.as("w")),
                            c = ei(s.as("y")),
                            h = a <= n.ss && ["s", a] || a < n.s && ["ss", a] || o <= 1 && ["m"] || o < n.m && ["mm", o] || r <= 1 && ["h"] || r < n.h && ["hh", r] || d <= 1 && ["d"] || d < n.d && ["dd", d];
                        return null != n.w && (h = h || u <= 1 && ["w"] || u < n.w && ["ww", u]), (h = h || l <= 1 && ["M"] || l < n.M && ["MM", l] || c <= 1 && ["y"] || ["yy", c])[2] = t, h[3] = +e > 0, h[4] = i,
                            function(e, t, n, i, s) {
                                return s.relativeTime(t || 1, !!n, e, i)
                            }.apply(null, h)
                    }(this, !s, a, n), s && (i = n.pastFuture(+this, i)), n.postformat(i)
                }, ai.toISOString = si, ai.toString = si, ai.toJSON = si, ai.locale = an, ai.localeData = rn, ai.toIsoString = k("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", si), ai.lang = on, O("X", 0, 0, "unix"), O("x", 0, 0, "valueOf"), _e("x", ce), _e("X", /[+-]?\d+(\.\d{1,3})?/), ve("X", function(e, t, n) {
                    n._d = new Date(1e3 * parseFloat(e))
                }), ve("x", function(e, t, n) {
                    n._d = new Date(V(e))
                }), s.version = "2.29.4",
                function(e) {
                    t = e
                }(Pt), s.fn = Yn, s.min = function() {
                    return Ot("isBefore", [].slice.call(arguments, 0))
                }, s.max = function() {
                    return Ot("isAfter", [].slice.call(arguments, 0))
                }, s.now = function() {
                    return Date.now ? Date.now() : +new Date
                }, s.utc = f, s.unix = function(e) {
                    return Pt(1e3 * e)
                }, s.months = function(e, t) {
                    return xn(e, t, "months")
                }, s.isDate = c, s.locale = mt, s.invalid = g, s.duration = Gt, s.isMoment = w, s.weekdays = function(e, t, n) {
                    return Hn(e, t, n, "weekdays")
                }, s.parseZone = function() {
                    return Pt.apply(null, arguments).parseZone()
                }, s.localeData = _t, s.isDuration = Wt, s.monthsShort = function(e, t) {
                    return xn(e, t, "monthsShort")
                }, s.weekdaysMin = function(e, t, n) {
                    return Hn(e, t, n, "weekdaysMin")
                }, s.defineLocale = ft, s.updateLocale = function(e, t) {
                    if (null != t) {
                        var n, i, s = rt;
                        null != dt[e] && null != dt[e].parentLocale ? dt[e].set(x(dt[e]._config, t)) : (null != (i = ht(e)) && (s = i._config), t = x(s, t), null == i && (t.abbr = e), (n = new H(t)).parentLocale = dt[e], dt[e] = n), mt(e)
                    } else null != dt[e] && (null != dt[e].parentLocale ? (dt[e] = dt[e].parentLocale, e === mt() && mt(e)) : null != dt[e] && delete dt[e]);
                    return dt[e]
                }, s.locales = function() {
                    return Y(dt)
                }, s.weekdaysShort = function(e, t, n) {
                    return Hn(e, t, n, "weekdaysShort")
                }, s.normalizeUnits = R, s.relativeTimeRounding = function(e) {
                    return void 0 === e ? ei : "function" == typeof e && (ei = e, !0)
                }, s.relativeTimeThreshold = function(e, t) {
                    return void 0 !== ti[e] && (void 0 === t ? ti[e] : (ti[e] = t, "s" === e && (ti.ss = t - 1), !0))
                }, s.calendarFormat = function(e, t) {
                    var n = e.diff(t, "days", !0);
                    return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse"
                }, s.prototype = Yn, s.HTML5_FMT = {
                    DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
                    DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
                    DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
                    DATE: "YYYY-MM-DD",
                    TIME: "HH:mm",
                    TIME_SECONDS: "HH:mm:ss",
                    TIME_MS: "HH:mm:ss.SSS",
                    WEEK: "GGGG-[W]WW",
                    MONTH: "YYYY-MM"
                }, s
        }()
    }).call(this, n(181)(e))
}, function(e, t, n) {
    var i;
    ! function(t, n) {
        "use strict";
        "object" == typeof e.exports ? e.exports = t.document ? n(t, !0) : function(e) {
            if (!e.document) throw new Error("jQuery requires a window with a document");
            return n(e)
        } : n(t)
    }("undefined" != typeof window ? window : this, function(n, s) {
        "use strict";
        var a = [],
            o = Object.getPrototypeOf,
            r = a.slice,
            d = a.flat ? function(e) {
                return a.flat.call(e)
            } : function(e) {
                return a.concat.apply([], e)
            },
            l = a.push,
            u = a.indexOf,
            c = {},
            h = c.toString,
            m = c.hasOwnProperty,
            f = m.toString,
            _ = f.call(Object),
            p = {},
            g = function(e) {
                return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item
            },
            y = function(e) {
                return null != e && e === e.window
            },
            v = n.document,
            M = {
                type: !0,
                src: !0,
                nonce: !0,
                noModule: !0
            };

        function L(e, t, n) {
            var i, s, a = (n = n || v).createElement("script");
            if (a.text = e, t)
                for (i in M)(s = t[i] || t.getAttribute && t.getAttribute(i)) && a.setAttribute(i, s);
            n.head.appendChild(a).parentNode.removeChild(a)
        }

        function w(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? c[h.call(e)] || "object" : typeof e
        }
        var b = function(e, t) {
            return new b.fn.init(e, t)
        };

        function k(e) {
            var t = !!e && "length" in e && e.length,
                n = w(e);
            return !g(e) && !y(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
        }
        b.fn = b.prototype = {
            jquery: "3.6.0",
            constructor: b,
            length: 0,
            toArray: function() {
                return r.call(this)
            },
            get: function(e) {
                return null == e ? r.call(this) : e < 0 ? this[e + this.length] : this[e]
            },
            pushStack: function(e) {
                var t = b.merge(this.constructor(), e);
                return t.prevObject = this, t
            },
            each: function(e) {
                return b.each(this, e)
            },
            map: function(e) {
                return this.pushStack(b.map(this, function(t, n) {
                    return e.call(t, n, t)
                }))
            },
            slice: function() {
                return this.pushStack(r.apply(this, arguments))
            },
            first: function() {
                return this.eq(0)
            },
            last: function() {
                return this.eq(-1)
            },
            even: function() {
                return this.pushStack(b.grep(this, function(e, t) {
                    return (t + 1) % 2
                }))
            },
            odd: function() {
                return this.pushStack(b.grep(this, function(e, t) {
                    return t % 2
                }))
            },
            eq: function(e) {
                var t = this.length,
                    n = +e + (e < 0 ? t : 0);
                return this.pushStack(n >= 0 && n < t ? [this[n]] : [])
            },
            end: function() {
                return this.prevObject || this.constructor()
            },
            push: l,
            sort: a.sort,
            splice: a.splice
        }, b.extend = b.fn.extend = function() {
            var e, t, n, i, s, a, o = arguments[0] || {},
                r = 1,
                d = arguments.length,
                l = !1;
            for ("boolean" == typeof o && (l = o, o = arguments[r] || {}, r++), "object" == typeof o || g(o) || (o = {}), r === d && (o = this, r--); r < d; r++)
                if (null != (e = arguments[r]))
                    for (t in e) i = e[t], "__proto__" !== t && o !== i && (l && i && (b.isPlainObject(i) || (s = Array.isArray(i))) ? (n = o[t], a = s && !Array.isArray(n) ? [] : s || b.isPlainObject(n) ? n : {}, s = !1, o[t] = b.extend(l, a, i)) : void 0 !== i && (o[t] = i));
            return o
        }, b.extend({
            expando: "jQuery" + ("3.6.0" + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function(e) {
                throw new Error(e)
            },
            noop: function() {},
            isPlainObject: function(e) {
                var t, n;
                return !(!e || "[object Object]" !== h.call(e)) && (!(t = o(e)) || "function" == typeof(n = m.call(t, "constructor") && t.constructor) && f.call(n) === _)
            },
            isEmptyObject: function(e) {
                var t;
                for (t in e) return !1;
                return !0
            },
            globalEval: function(e, t, n) {
                L(e, {
                    nonce: t && t.nonce
                }, n)
            },
            each: function(e, t) {
                var n, i = 0;
                if (k(e))
                    for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
                else
                    for (i in e)
                        if (!1 === t.call(e[i], i, e[i])) break;
                return e
            },
            makeArray: function(e, t) {
                var n = t || [];
                return null != e && (k(Object(e)) ? b.merge(n, "string" == typeof e ? [e] : e) : l.call(n, e)), n
            },
            inArray: function(e, t, n) {
                return null == t ? -1 : u.call(t, e, n)
            },
            merge: function(e, t) {
                for (var n = +t.length, i = 0, s = e.length; i < n; i++) e[s++] = t[i];
                return e.length = s, e
            },
            grep: function(e, t, n) {
                for (var i = [], s = 0, a = e.length, o = !n; s < a; s++) !t(e[s], s) !== o && i.push(e[s]);
                return i
            },
            map: function(e, t, n) {
                var i, s, a = 0,
                    o = [];
                if (k(e))
                    for (i = e.length; a < i; a++) null != (s = t(e[a], a, n)) && o.push(s);
                else
                    for (a in e) null != (s = t(e[a], a, n)) && o.push(s);
                return d(o)
            },
            guid: 1,
            support: p
        }), "function" == typeof Symbol && (b.fn[Symbol.iterator] = a[Symbol.iterator]), b.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
            c["[object " + t + "]"] = t.toLowerCase()
        });
        var Y = function(e) {
            var t, n, i, s, a, o, r, d, l, u, c, h, m, f, _, p, g, y, v, M = "sizzle" + 1 * new Date,
                L = e.document,
                w = 0,
                b = 0,
                k = de(),
                Y = de(),
                T = de(),
                D = de(),
                S = function(e, t) {
                    return e === t && (c = !0), 0
                },
                x = {}.hasOwnProperty,
                H = [],
                j = H.pop,
                C = H.push,
                P = H.push,
                E = H.slice,
                A = function(e, t) {
                    for (var n = 0, i = e.length; n < i; n++)
                        if (e[n] === t) return n;
                    return -1
                },
                O = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                F = "[\\x20\\t\\r\\n\\f]",
                $ = "(?:\\\\[\\da-fA-F]{1,6}" + F + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                W = "\\[" + F + "*(" + $ + ")(?:" + F + "*([*^$|!~]?=)" + F + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + $ + "))|)" + F + "*\\]",
                N = ":(" + $ + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + W + ")*)|.*)\\)|)",
                z = new RegExp(F + "+", "g"),
                R = new RegExp("^" + F + "+|((?:^|[^\\\\])(?:\\\\.)*)" + F + "+$", "g"),
                I = new RegExp("^" + F + "*," + F + "*"),
                q = new RegExp("^" + F + "*([>+~]|" + F + ")" + F + "*"),
                B = new RegExp(F + "|>"),
                U = new RegExp(N),
                J = new RegExp("^" + $ + "$"),
                V = {
                    ID: new RegExp("^#(" + $ + ")"),
                    CLASS: new RegExp("^\\.(" + $ + ")"),
                    TAG: new RegExp("^(" + $ + "|[*])"),
                    ATTR: new RegExp("^" + W),
                    PSEUDO: new RegExp("^" + N),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + F + "*(even|odd|(([+-]|)(\\d*)n|)" + F + "*(?:([+-]|)" + F + "*(\\d+)|))" + F + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + O + ")$", "i"),
                    needsContext: new RegExp("^" + F + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + F + "*((?:-\\d)?\\d*)" + F + "*\\)|)(?=[^-]|$)", "i")
                },
                G = /HTML$/i,
                X = /^(?:input|select|textarea|button)$/i,
                K = /^h\d$/i,
                Z = /^[^{]+\{\s*\[native \w/,
                Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                ee = /[+~]/,
                te = new RegExp("\\\\[\\da-fA-F]{1,6}" + F + "?|\\\\([^\\r\\n\\f])", "g"),
                ne = function(e, t) {
                    var n = "0x" + e.slice(1) - 65536;
                    return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320))
                },
                ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                se = function(e, t) {
                    return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
                },
                ae = function() {
                    h()
                },
                oe = Me(function(e) {
                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
                }, {
                    dir: "parentNode",
                    next: "legend"
                });
            try {
                P.apply(H = E.call(L.childNodes), L.childNodes), H[L.childNodes.length].nodeType
            } catch (e) {
                P = {
                    apply: H.length ? function(e, t) {
                        C.apply(e, E.call(t))
                    } : function(e, t) {
                        for (var n = e.length, i = 0; e[n++] = t[i++];);
                        e.length = n - 1
                    }
                }
            }

            function re(e, t, i, s) {
                var a, r, l, u, c, f, g, y = t && t.ownerDocument,
                    L = t ? t.nodeType : 9;
                if (i = i || [], "string" != typeof e || !e || 1 !== L && 9 !== L && 11 !== L) return i;
                if (!s && (h(t), t = t || m, _)) {
                    if (11 !== L && (c = Q.exec(e)))
                        if (a = c[1]) {
                            if (9 === L) {
                                if (!(l = t.getElementById(a))) return i;
                                if (l.id === a) return i.push(l), i
                            } else if (y && (l = y.getElementById(a)) && v(t, l) && l.id === a) return i.push(l), i
                        } else {
                            if (c[2]) return P.apply(i, t.getElementsByTagName(e)), i;
                            if ((a = c[3]) && n.getElementsByClassName && t.getElementsByClassName) return P.apply(i, t.getElementsByClassName(a)), i
                        } if (n.qsa && !D[e + " "] && (!p || !p.test(e)) && (1 !== L || "object" !== t.nodeName.toLowerCase())) {
                        if (g = e, y = t, 1 === L && (B.test(e) || q.test(e))) {
                            for ((y = ee.test(e) && ge(t.parentNode) || t) === t && n.scope || ((u = t.getAttribute("id")) ? u = u.replace(ie, se) : t.setAttribute("id", u = M)), r = (f = o(e)).length; r--;) f[r] = (u ? "#" + u : ":scope") + " " + ve(f[r]);
                            g = f.join(",")
                        }
                        try {
                            return P.apply(i, y.querySelectorAll(g)), i
                        } catch (t) {
                            D(e, !0)
                        } finally {
                            u === M && t.removeAttribute("id")
                        }
                    }
                }
                return d(e.replace(R, "$1"), t, i, s)
            }

            function de() {
                var e = [];
                return function t(n, s) {
                    return e.push(n + " ") > i.cacheLength && delete t[e.shift()], t[n + " "] = s
                }
            }

            function le(e) {
                return e[M] = !0, e
            }

            function ue(e) {
                var t = m.createElement("fieldset");
                try {
                    return !!e(t)
                } catch (e) {
                    return !1
                } finally {
                    t.parentNode && t.parentNode.removeChild(t), t = null
                }
            }

            function ce(e, t) {
                for (var n = e.split("|"), s = n.length; s--;) i.attrHandle[n[s]] = t
            }

            function he(e, t) {
                var n = t && e,
                    i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                if (i) return i;
                if (n)
                    for (; n = n.nextSibling;)
                        if (n === t) return -1;
                return e ? 1 : -1
            }

            function me(e) {
                return function(t) {
                    return "input" === t.nodeName.toLowerCase() && t.type === e
                }
            }

            function fe(e) {
                return function(t) {
                    var n = t.nodeName.toLowerCase();
                    return ("input" === n || "button" === n) && t.type === e
                }
            }

            function _e(e) {
                return function(t) {
                    return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && oe(t) === e : t.disabled === e : "label" in t && t.disabled === e
                }
            }

            function pe(e) {
                return le(function(t) {
                    return t = +t, le(function(n, i) {
                        for (var s, a = e([], n.length, t), o = a.length; o--;) n[s = a[o]] && (n[s] = !(i[s] = n[s]))
                    })
                })
            }

            function ge(e) {
                return e && void 0 !== e.getElementsByTagName && e
            }
            for (t in n = re.support = {}, a = re.isXML = function(e) {
                    var t = e && e.namespaceURI,
                        n = e && (e.ownerDocument || e).documentElement;
                    return !G.test(t || n && n.nodeName || "HTML")
                }, h = re.setDocument = function(e) {
                    var t, s, o = e ? e.ownerDocument || e : L;
                    return o != m && 9 === o.nodeType && o.documentElement ? (f = (m = o).documentElement, _ = !a(m), L != m && (s = m.defaultView) && s.top !== s && (s.addEventListener ? s.addEventListener("unload", ae, !1) : s.attachEvent && s.attachEvent("onunload", ae)), n.scope = ue(function(e) {
                        return f.appendChild(e).appendChild(m.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
                    }), n.attributes = ue(function(e) {
                        return e.className = "i", !e.getAttribute("className")
                    }), n.getElementsByTagName = ue(function(e) {
                        return e.appendChild(m.createComment("")), !e.getElementsByTagName("*").length
                    }), n.getElementsByClassName = Z.test(m.getElementsByClassName), n.getById = ue(function(e) {
                        return f.appendChild(e).id = M, !m.getElementsByName || !m.getElementsByName(M).length
                    }), n.getById ? (i.filter.ID = function(e) {
                        var t = e.replace(te, ne);
                        return function(e) {
                            return e.getAttribute("id") === t
                        }
                    }, i.find.ID = function(e, t) {
                        if (void 0 !== t.getElementById && _) {
                            var n = t.getElementById(e);
                            return n ? [n] : []
                        }
                    }) : (i.filter.ID = function(e) {
                        var t = e.replace(te, ne);
                        return function(e) {
                            var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                            return n && n.value === t
                        }
                    }, i.find.ID = function(e, t) {
                        if (void 0 !== t.getElementById && _) {
                            var n, i, s, a = t.getElementById(e);
                            if (a) {
                                if ((n = a.getAttributeNode("id")) && n.value === e) return [a];
                                for (s = t.getElementsByName(e), i = 0; a = s[i++];)
                                    if ((n = a.getAttributeNode("id")) && n.value === e) return [a]
                            }
                            return []
                        }
                    }), i.find.TAG = n.getElementsByTagName ? function(e, t) {
                        return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0
                    } : function(e, t) {
                        var n, i = [],
                            s = 0,
                            a = t.getElementsByTagName(e);
                        if ("*" === e) {
                            for (; n = a[s++];) 1 === n.nodeType && i.push(n);
                            return i
                        }
                        return a
                    }, i.find.CLASS = n.getElementsByClassName && function(e, t) {
                        if (void 0 !== t.getElementsByClassName && _) return t.getElementsByClassName(e)
                    }, g = [], p = [], (n.qsa = Z.test(m.querySelectorAll)) && (ue(function(e) {
                        var t;
                        f.appendChild(e).innerHTML = "<a id='" + M + "'></a><select id='" + M + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && p.push("[*^$]=" + F + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || p.push("\\[" + F + "*(?:value|" + O + ")"), e.querySelectorAll("[id~=" + M + "-]").length || p.push("~="), (t = m.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || p.push("\\[" + F + "*name" + F + "*=" + F + "*(?:''|\"\")"), e.querySelectorAll(":checked").length || p.push(":checked"), e.querySelectorAll("a#" + M + "+*").length || p.push(".#.+[+~]"), e.querySelectorAll("\\\f"), p.push("[\\r\\n\\f]")
                    }), ue(function(e) {
                        e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        var t = m.createElement("input");
                        t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && p.push("name" + F + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && p.push(":enabled", ":disabled"), f.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && p.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), p.push(",.*:")
                    })), (n.matchesSelector = Z.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && ue(function(e) {
                        n.disconnectedMatch = y.call(e, "*"), y.call(e, "[s!='']:x"), g.push("!=", N)
                    }), p = p.length && new RegExp(p.join("|")), g = g.length && new RegExp(g.join("|")), t = Z.test(f.compareDocumentPosition), v = t || Z.test(f.contains) ? function(e, t) {
                        var n = 9 === e.nodeType ? e.documentElement : e,
                            i = t && t.parentNode;
                        return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
                    } : function(e, t) {
                        if (t)
                            for (; t = t.parentNode;)
                                if (t === e) return !0;
                        return !1
                    }, S = t ? function(e, t) {
                        if (e === t) return c = !0, 0;
                        var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                        return i || (1 & (i = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === i ? e == m || e.ownerDocument == L && v(L, e) ? -1 : t == m || t.ownerDocument == L && v(L, t) ? 1 : u ? A(u, e) - A(u, t) : 0 : 4 & i ? -1 : 1)
                    } : function(e, t) {
                        if (e === t) return c = !0, 0;
                        var n, i = 0,
                            s = e.parentNode,
                            a = t.parentNode,
                            o = [e],
                            r = [t];
                        if (!s || !a) return e == m ? -1 : t == m ? 1 : s ? -1 : a ? 1 : u ? A(u, e) - A(u, t) : 0;
                        if (s === a) return he(e, t);
                        for (n = e; n = n.parentNode;) o.unshift(n);
                        for (n = t; n = n.parentNode;) r.unshift(n);
                        for (; o[i] === r[i];) i++;
                        return i ? he(o[i], r[i]) : o[i] == L ? -1 : r[i] == L ? 1 : 0
                    }, m) : m
                }, re.matches = function(e, t) {
                    return re(e, null, null, t)
                }, re.matchesSelector = function(e, t) {
                    if (h(e), n.matchesSelector && _ && !D[t + " "] && (!g || !g.test(t)) && (!p || !p.test(t))) try {
                        var i = y.call(e, t);
                        if (i || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i
                    } catch (e) {
                        D(t, !0)
                    }
                    return re(t, m, null, [e]).length > 0
                }, re.contains = function(e, t) {
                    return (e.ownerDocument || e) != m && h(e), v(e, t)
                }, re.attr = function(e, t) {
                    (e.ownerDocument || e) != m && h(e);
                    var s = i.attrHandle[t.toLowerCase()],
                        a = s && x.call(i.attrHandle, t.toLowerCase()) ? s(e, t, !_) : void 0;
                    return void 0 !== a ? a : n.attributes || !_ ? e.getAttribute(t) : (a = e.getAttributeNode(t)) && a.specified ? a.value : null
                }, re.escape = function(e) {
                    return (e + "").replace(ie, se)
                }, re.error = function(e) {
                    throw new Error("Syntax error, unrecognized expression: " + e)
                }, re.uniqueSort = function(e) {
                    var t, i = [],
                        s = 0,
                        a = 0;
                    if (c = !n.detectDuplicates, u = !n.sortStable && e.slice(0), e.sort(S), c) {
                        for (; t = e[a++];) t === e[a] && (s = i.push(a));
                        for (; s--;) e.splice(i[s], 1)
                    }
                    return u = null, e
                }, s = re.getText = function(e) {
                    var t, n = "",
                        i = 0,
                        a = e.nodeType;
                    if (a) {
                        if (1 === a || 9 === a || 11 === a) {
                            if ("string" == typeof e.textContent) return e.textContent;
                            for (e = e.firstChild; e; e = e.nextSibling) n += s(e)
                        } else if (3 === a || 4 === a) return e.nodeValue
                    } else
                        for (; t = e[i++];) n += s(t);
                    return n
                }, (i = re.selectors = {
                    cacheLength: 50,
                    createPseudo: le,
                    match: V,
                    attrHandle: {},
                    find: {},
                    relative: {
                        ">": {
                            dir: "parentNode",
                            first: !0
                        },
                        " ": {
                            dir: "parentNode"
                        },
                        "+": {
                            dir: "previousSibling",
                            first: !0
                        },
                        "~": {
                            dir: "previousSibling"
                        }
                    },
                    preFilter: {
                        ATTR: function(e) {
                            return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                        },
                        CHILD: function(e) {
                            return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || re.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && re.error(e[0]), e
                        },
                        PSEUDO: function(e) {
                            var t, n = !e[6] && e[2];
                            return V.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && U.test(n) && (t = o(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
                        }
                    },
                    filter: {
                        TAG: function(e) {
                            var t = e.replace(te, ne).toLowerCase();
                            return "*" === e ? function() {
                                return !0
                            } : function(e) {
                                return e.nodeName && e.nodeName.toLowerCase() === t
                            }
                        },
                        CLASS: function(e) {
                            var t = k[e + " "];
                            return t || (t = new RegExp("(^|" + F + ")" + e + "(" + F + "|$)")) && k(e, function(e) {
                                return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                            })
                        },
                        ATTR: function(e, t, n) {
                            return function(i) {
                                var s = re.attr(i, e);
                                return null == s ? "!=" === t : !t || (s += "", "=" === t ? s === n : "!=" === t ? s !== n : "^=" === t ? n && 0 === s.indexOf(n) : "*=" === t ? n && s.indexOf(n) > -1 : "$=" === t ? n && s.slice(-n.length) === n : "~=" === t ? (" " + s.replace(z, " ") + " ").indexOf(n) > -1 : "|=" === t && (s === n || s.slice(0, n.length + 1) === n + "-"))
                            }
                        },
                        CHILD: function(e, t, n, i, s) {
                            var a = "nth" !== e.slice(0, 3),
                                o = "last" !== e.slice(-4),
                                r = "of-type" === t;
                            return 1 === i && 0 === s ? function(e) {
                                return !!e.parentNode
                            } : function(t, n, d) {
                                var l, u, c, h, m, f, _ = a !== o ? "nextSibling" : "previousSibling",
                                    p = t.parentNode,
                                    g = r && t.nodeName.toLowerCase(),
                                    y = !d && !r,
                                    v = !1;
                                if (p) {
                                    if (a) {
                                        for (; _;) {
                                            for (h = t; h = h[_];)
                                                if (r ? h.nodeName.toLowerCase() === g : 1 === h.nodeType) return !1;
                                            f = _ = "only" === e && !f && "nextSibling"
                                        }
                                        return !0
                                    }
                                    if (f = [o ? p.firstChild : p.lastChild], o && y) {
                                        for (v = (m = (l = (u = (c = (h = p)[M] || (h[M] = {}))[h.uniqueID] || (c[h.uniqueID] = {}))[e] || [])[0] === w && l[1]) && l[2], h = m && p.childNodes[m]; h = ++m && h && h[_] || (v = m = 0) || f.pop();)
                                            if (1 === h.nodeType && ++v && h === t) {
                                                u[e] = [w, m, v];
                                                break
                                            }
                                    } else if (y && (v = m = (l = (u = (c = (h = t)[M] || (h[M] = {}))[h.uniqueID] || (c[h.uniqueID] = {}))[e] || [])[0] === w && l[1]), !1 === v)
                                        for (;
                                            (h = ++m && h && h[_] || (v = m = 0) || f.pop()) && ((r ? h.nodeName.toLowerCase() !== g : 1 !== h.nodeType) || !++v || (y && ((u = (c = h[M] || (h[M] = {}))[h.uniqueID] || (c[h.uniqueID] = {}))[e] = [w, v]), h !== t)););
                                    return (v -= s) === i || v % i == 0 && v / i >= 0
                                }
                            }
                        },
                        PSEUDO: function(e, t) {
                            var n, s = i.pseudos[e] || i.setFilters[e.toLowerCase()] || re.error("unsupported pseudo: " + e);
                            return s[M] ? s(t) : s.length > 1 ? (n = [e, e, "", t], i.setFilters.hasOwnProperty(e.toLowerCase()) ? le(function(e, n) {
                                for (var i, a = s(e, t), o = a.length; o--;) e[i = A(e, a[o])] = !(n[i] = a[o])
                            }) : function(e) {
                                return s(e, 0, n)
                            }) : s
                        }
                    },
                    pseudos: {
                        not: le(function(e) {
                            var t = [],
                                n = [],
                                i = r(e.replace(R, "$1"));
                            return i[M] ? le(function(e, t, n, s) {
                                for (var a, o = i(e, null, s, []), r = e.length; r--;)(a = o[r]) && (e[r] = !(t[r] = a))
                            }) : function(e, s, a) {
                                return t[0] = e, i(t, null, a, n), t[0] = null, !n.pop()
                            }
                        }),
                        has: le(function(e) {
                            return function(t) {
                                return re(e, t).length > 0
                            }
                        }),
                        contains: le(function(e) {
                            return e = e.replace(te, ne),
                                function(t) {
                                    return (t.textContent || s(t)).indexOf(e) > -1
                                }
                        }),
                        lang: le(function(e) {
                            return J.test(e || "") || re.error("unsupported lang: " + e), e = e.replace(te, ne).toLowerCase(),
                                function(t) {
                                    var n;
                                    do {
                                        if (n = _ ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                                    } while ((t = t.parentNode) && 1 === t.nodeType);
                                    return !1
                                }
                        }),
                        target: function(t) {
                            var n = e.location && e.location.hash;
                            return n && n.slice(1) === t.id
                        },
                        root: function(e) {
                            return e === f
                        },
                        focus: function(e) {
                            return e === m.activeElement && (!m.hasFocus || m.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                        },
                        enabled: _e(!1),
                        disabled: _e(!0),
                        checked: function(e) {
                            var t = e.nodeName.toLowerCase();
                            return "input" === t && !!e.checked || "option" === t && !!e.selected
                        },
                        selected: function(e) {
                            return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                        },
                        empty: function(e) {
                            for (e = e.firstChild; e; e = e.nextSibling)
                                if (e.nodeType < 6) return !1;
                            return !0
                        },
                        parent: function(e) {
                            return !i.pseudos.empty(e)
                        },
                        header: function(e) {
                            return K.test(e.nodeName)
                        },
                        input: function(e) {
                            return X.test(e.nodeName)
                        },
                        button: function(e) {
                            var t = e.nodeName.toLowerCase();
                            return "input" === t && "button" === e.type || "button" === t
                        },
                        text: function(e) {
                            var t;
                            return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                        },
                        first: pe(function() {
                            return [0]
                        }),
                        last: pe(function(e, t) {
                            return [t - 1]
                        }),
                        eq: pe(function(e, t, n) {
                            return [n < 0 ? n + t : n]
                        }),
                        even: pe(function(e, t) {
                            for (var n = 0; n < t; n += 2) e.push(n);
                            return e
                        }),
                        odd: pe(function(e, t) {
                            for (var n = 1; n < t; n += 2) e.push(n);
                            return e
                        }),
                        lt: pe(function(e, t, n) {
                            for (var i = n < 0 ? n + t : n > t ? t : n; --i >= 0;) e.push(i);
                            return e
                        }),
                        gt: pe(function(e, t, n) {
                            for (var i = n < 0 ? n + t : n; ++i < t;) e.push(i);
                            return e
                        })
                    }
                }).pseudos.nth = i.pseudos.eq, {
                    radio: !0,
                    checkbox: !0,
                    file: !0,
                    password: !0,
                    image: !0
                }) i.pseudos[t] = me(t);
            for (t in {
                    submit: !0,
                    reset: !0
                }) i.pseudos[t] = fe(t);

            function ye() {}

            function ve(e) {
                for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
                return i
            }

            function Me(e, t, n) {
                var i = t.dir,
                    s = t.next,
                    a = s || i,
                    o = n && "parentNode" === a,
                    r = b++;
                return t.first ? function(t, n, s) {
                    for (; t = t[i];)
                        if (1 === t.nodeType || o) return e(t, n, s);
                    return !1
                } : function(t, n, d) {
                    var l, u, c, h = [w, r];
                    if (d) {
                        for (; t = t[i];)
                            if ((1 === t.nodeType || o) && e(t, n, d)) return !0
                    } else
                        for (; t = t[i];)
                            if (1 === t.nodeType || o)
                                if (u = (c = t[M] || (t[M] = {}))[t.uniqueID] || (c[t.uniqueID] = {}), s && s === t.nodeName.toLowerCase()) t = t[i] || t;
                                else {
                                    if ((l = u[a]) && l[0] === w && l[1] === r) return h[2] = l[2];
                                    if (u[a] = h, h[2] = e(t, n, d)) return !0
                                } return !1
                }
            }

            function Le(e) {
                return e.length > 1 ? function(t, n, i) {
                    for (var s = e.length; s--;)
                        if (!e[s](t, n, i)) return !1;
                    return !0
                } : e[0]
            }

            function we(e, t, n, i, s) {
                for (var a, o = [], r = 0, d = e.length, l = null != t; r < d; r++)(a = e[r]) && (n && !n(a, i, s) || (o.push(a), l && t.push(r)));
                return o
            }

            function be(e, t, n, i, s, a) {
                return i && !i[M] && (i = be(i)), s && !s[M] && (s = be(s, a)), le(function(a, o, r, d) {
                    var l, u, c, h = [],
                        m = [],
                        f = o.length,
                        _ = a || function(e, t, n) {
                            for (var i = 0, s = t.length; i < s; i++) re(e, t[i], n);
                            return n
                        }(t || "*", r.nodeType ? [r] : r, []),
                        p = !e || !a && t ? _ : we(_, h, e, r, d),
                        g = n ? s || (a ? e : f || i) ? [] : o : p;
                    if (n && n(p, g, r, d), i)
                        for (l = we(g, m), i(l, [], r, d), u = l.length; u--;)(c = l[u]) && (g[m[u]] = !(p[m[u]] = c));
                    if (a) {
                        if (s || e) {
                            if (s) {
                                for (l = [], u = g.length; u--;)(c = g[u]) && l.push(p[u] = c);
                                s(null, g = [], l, d)
                            }
                            for (u = g.length; u--;)(c = g[u]) && (l = s ? A(a, c) : h[u]) > -1 && (a[l] = !(o[l] = c))
                        }
                    } else g = we(g === o ? g.splice(f, g.length) : g), s ? s(null, o, g, d) : P.apply(o, g)
                })
            }

            function ke(e) {
                for (var t, n, s, a = e.length, o = i.relative[e[0].type], r = o || i.relative[" "], d = o ? 1 : 0, u = Me(function(e) {
                        return e === t
                    }, r, !0), c = Me(function(e) {
                        return A(t, e) > -1
                    }, r, !0), h = [function(e, n, i) {
                        var s = !o && (i || n !== l) || ((t = n).nodeType ? u(e, n, i) : c(e, n, i));
                        return t = null, s
                    }]; d < a; d++)
                    if (n = i.relative[e[d].type]) h = [Me(Le(h), n)];
                    else {
                        if ((n = i.filter[e[d].type].apply(null, e[d].matches))[M]) {
                            for (s = ++d; s < a && !i.relative[e[s].type]; s++);
                            return be(d > 1 && Le(h), d > 1 && ve(e.slice(0, d - 1).concat({
                                value: " " === e[d - 2].type ? "*" : ""
                            })).replace(R, "$1"), n, d < s && ke(e.slice(d, s)), s < a && ke(e = e.slice(s)), s < a && ve(e))
                        }
                        h.push(n)
                    } return Le(h)
            }
            return ye.prototype = i.filters = i.pseudos, i.setFilters = new ye, o = re.tokenize = function(e, t) {
                var n, s, a, o, r, d, l, u = Y[e + " "];
                if (u) return t ? 0 : u.slice(0);
                for (r = e, d = [], l = i.preFilter; r;) {
                    for (o in n && !(s = I.exec(r)) || (s && (r = r.slice(s[0].length) || r), d.push(a = [])), n = !1, (s = q.exec(r)) && (n = s.shift(), a.push({
                            value: n,
                            type: s[0].replace(R, " ")
                        }), r = r.slice(n.length)), i.filter) !(s = V[o].exec(r)) || l[o] && !(s = l[o](s)) || (n = s.shift(), a.push({
                        value: n,
                        type: o,
                        matches: s
                    }), r = r.slice(n.length));
                    if (!n) break
                }
                return t ? r.length : r ? re.error(e) : Y(e, d).slice(0)
            }, r = re.compile = function(e, t) {
                var n, s = [],
                    a = [],
                    r = T[e + " "];
                if (!r) {
                    for (t || (t = o(e)), n = t.length; n--;)(r = ke(t[n]))[M] ? s.push(r) : a.push(r);
                    (r = T(e, function(e, t) {
                        var n = t.length > 0,
                            s = e.length > 0,
                            a = function(a, o, r, d, u) {
                                var c, f, p, g = 0,
                                    y = "0",
                                    v = a && [],
                                    M = [],
                                    L = l,
                                    b = a || s && i.find.TAG("*", u),
                                    k = w += null == L ? 1 : Math.random() || .1,
                                    Y = b.length;
                                for (u && (l = o == m || o || u); y !== Y && null != (c = b[y]); y++) {
                                    if (s && c) {
                                        for (f = 0, o || c.ownerDocument == m || (h(c), r = !_); p = e[f++];)
                                            if (p(c, o || m, r)) {
                                                d.push(c);
                                                break
                                            } u && (w = k)
                                    }
                                    n && ((c = !p && c) && g--, a && v.push(c))
                                }
                                if (g += y, n && y !== g) {
                                    for (f = 0; p = t[f++];) p(v, M, o, r);
                                    if (a) {
                                        if (g > 0)
                                            for (; y--;) v[y] || M[y] || (M[y] = j.call(d));
                                        M = we(M)
                                    }
                                    P.apply(d, M), u && !a && M.length > 0 && g + t.length > 1 && re.uniqueSort(d)
                                }
                                return u && (w = k, l = L), v
                            };
                        return n ? le(a) : a
                    }(a, s))).selector = e
                }
                return r
            }, d = re.select = function(e, t, n, s) {
                var a, d, l, u, c, h = "function" == typeof e && e,
                    m = !s && o(e = h.selector || e);
                if (n = n || [], 1 === m.length) {
                    if ((d = m[0] = m[0].slice(0)).length > 2 && "ID" === (l = d[0]).type && 9 === t.nodeType && _ && i.relative[d[1].type]) {
                        if (!(t = (i.find.ID(l.matches[0].replace(te, ne), t) || [])[0])) return n;
                        h && (t = t.parentNode), e = e.slice(d.shift().value.length)
                    }
                    for (a = V.needsContext.test(e) ? 0 : d.length; a-- && (l = d[a], !i.relative[u = l.type]);)
                        if ((c = i.find[u]) && (s = c(l.matches[0].replace(te, ne), ee.test(d[0].type) && ge(t.parentNode) || t))) {
                            if (d.splice(a, 1), !(e = s.length && ve(d))) return P.apply(n, s), n;
                            break
                        }
                }
                return (h || r(e, m))(s, t, !_, n, !t || ee.test(e) && ge(t.parentNode) || t), n
            }, n.sortStable = M.split("").sort(S).join("") === M, n.detectDuplicates = !!c, h(), n.sortDetached = ue(function(e) {
                return 1 & e.compareDocumentPosition(m.createElement("fieldset"))
            }), ue(function(e) {
                return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
            }) || ce("type|href|height|width", function(e, t, n) {
                if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
            }), n.attributes && ue(function(e) {
                return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
            }) || ce("value", function(e, t, n) {
                if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue
            }), ue(function(e) {
                return null == e.getAttribute("disabled")
            }) || ce(O, function(e, t, n) {
                var i;
                if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
            }), re
        }(n);
        b.find = Y, b.expr = Y.selectors, b.expr[":"] = b.expr.pseudos, b.uniqueSort = b.unique = Y.uniqueSort, b.text = Y.getText, b.isXMLDoc = Y.isXML, b.contains = Y.contains, b.escapeSelector = Y.escape;
        var T = function(e, t, n) {
                for (var i = [], s = void 0 !== n;
                    (e = e[t]) && 9 !== e.nodeType;)
                    if (1 === e.nodeType) {
                        if (s && b(e).is(n)) break;
                        i.push(e)
                    } return i
            },
            D = function(e, t) {
                for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
                return n
            },
            S = b.expr.match.needsContext;

        function x(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
        }
        var H = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

        function j(e, t, n) {
            return g(t) ? b.grep(e, function(e, i) {
                return !!t.call(e, i, e) !== n
            }) : t.nodeType ? b.grep(e, function(e) {
                return e === t !== n
            }) : "string" != typeof t ? b.grep(e, function(e) {
                return u.call(t, e) > -1 !== n
            }) : b.filter(t, e, n)
        }
        b.filter = function(e, t, n) {
            var i = t[0];
            return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? b.find.matchesSelector(i, e) ? [i] : [] : b.find.matches(e, b.grep(t, function(e) {
                return 1 === e.nodeType
            }))
        }, b.fn.extend({
            find: function(e) {
                var t, n, i = this.length,
                    s = this;
                if ("string" != typeof e) return this.pushStack(b(e).filter(function() {
                    for (t = 0; t < i; t++)
                        if (b.contains(s[t], this)) return !0
                }));
                for (n = this.pushStack([]), t = 0; t < i; t++) b.find(e, s[t], n);
                return i > 1 ? b.uniqueSort(n) : n
            },
            filter: function(e) {
                return this.pushStack(j(this, e || [], !1))
            },
            not: function(e) {
                return this.pushStack(j(this, e || [], !0))
            },
            is: function(e) {
                return !!j(this, "string" == typeof e && S.test(e) ? b(e) : e || [], !1).length
            }
        });
        var C, P = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        (b.fn.init = function(e, t, n) {
            var i, s;
            if (!e) return this;
            if (n = n || C, "string" == typeof e) {
                if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : P.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                if (i[1]) {
                    if (t = t instanceof b ? t[0] : t, b.merge(this, b.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : v, !0)), H.test(i[1]) && b.isPlainObject(t))
                        for (i in t) g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                    return this
                }
                return (s = v.getElementById(i[2])) && (this[0] = s, this.length = 1), this
            }
            return e.nodeType ? (this[0] = e, this.length = 1, this) : g(e) ? void 0 !== n.ready ? n.ready(e) : e(b) : b.makeArray(e, this)
        }).prototype = b.fn, C = b(v);
        var E = /^(?:parents|prev(?:Until|All))/,
            A = {
                children: !0,
                contents: !0,
                next: !0,
                prev: !0
            };

        function O(e, t) {
            for (;
                (e = e[t]) && 1 !== e.nodeType;);
            return e
        }
        b.fn.extend({
            has: function(e) {
                var t = b(e, this),
                    n = t.length;
                return this.filter(function() {
                    for (var e = 0; e < n; e++)
                        if (b.contains(this, t[e])) return !0
                })
            },
            closest: function(e, t) {
                var n, i = 0,
                    s = this.length,
                    a = [],
                    o = "string" != typeof e && b(e);
                if (!S.test(e))
                    for (; i < s; i++)
                        for (n = this[i]; n && n !== t; n = n.parentNode)
                            if (n.nodeType < 11 && (o ? o.index(n) > -1 : 1 === n.nodeType && b.find.matchesSelector(n, e))) {
                                a.push(n);
                                break
                            } return this.pushStack(a.length > 1 ? b.uniqueSort(a) : a)
            },
            index: function(e) {
                return e ? "string" == typeof e ? u.call(b(e), this[0]) : u.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
            },
            add: function(e, t) {
                return this.pushStack(b.uniqueSort(b.merge(this.get(), b(e, t))))
            },
            addBack: function(e) {
                return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
            }
        }), b.each({
            parent: function(e) {
                var t = e.parentNode;
                return t && 11 !== t.nodeType ? t : null
            },
            parents: function(e) {
                return T(e, "parentNode")
            },
            parentsUntil: function(e, t, n) {
                return T(e, "parentNode", n)
            },
            next: function(e) {
                return O(e, "nextSibling")
            },
            prev: function(e) {
                return O(e, "previousSibling")
            },
            nextAll: function(e) {
                return T(e, "nextSibling")
            },
            prevAll: function(e) {
                return T(e, "previousSibling")
            },
            nextUntil: function(e, t, n) {
                return T(e, "nextSibling", n)
            },
            prevUntil: function(e, t, n) {
                return T(e, "previousSibling", n)
            },
            siblings: function(e) {
                return D((e.parentNode || {}).firstChild, e)
            },
            children: function(e) {
                return D(e.firstChild)
            },
            contents: function(e) {
                return null != e.contentDocument && o(e.contentDocument) ? e.contentDocument : (x(e, "template") && (e = e.content || e), b.merge([], e.childNodes))
            }
        }, function(e, t) {
            b.fn[e] = function(n, i) {
                var s = b.map(this, t, n);
                return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (s = b.filter(i, s)), this.length > 1 && (A[e] || b.uniqueSort(s), E.test(e) && s.reverse()), this.pushStack(s)
            }
        });
        var F = /[^\x20\t\r\n\f]+/g;

        function $(e) {
            return e
        }

        function W(e) {
            throw e
        }

        function N(e, t, n, i) {
            var s;
            try {
                e && g(s = e.promise) ? s.call(e).done(t).fail(n) : e && g(s = e.then) ? s.call(e, t, n) : t.apply(void 0, [e].slice(i))
            } catch (e) {
                n.apply(void 0, [e])
            }
        }
        b.Callbacks = function(e) {
            e = "string" == typeof e ? function(e) {
                var t = {};
                return b.each(e.match(F) || [], function(e, n) {
                    t[n] = !0
                }), t
            }(e) : b.extend({}, e);
            var t, n, i, s, a = [],
                o = [],
                r = -1,
                d = function() {
                    for (s = s || e.once, i = t = !0; o.length; r = -1)
                        for (n = o.shift(); ++r < a.length;) !1 === a[r].apply(n[0], n[1]) && e.stopOnFalse && (r = a.length, n = !1);
                    e.memory || (n = !1), t = !1, s && (a = n ? [] : "")
                },
                l = {
                    add: function() {
                        return a && (n && !t && (r = a.length - 1, o.push(n)), function t(n) {
                            b.each(n, function(n, i) {
                                g(i) ? e.unique && l.has(i) || a.push(i) : i && i.length && "string" !== w(i) && t(i)
                            })
                        }(arguments), n && !t && d()), this
                    },
                    remove: function() {
                        return b.each(arguments, function(e, t) {
                            for (var n;
                                (n = b.inArray(t, a, n)) > -1;) a.splice(n, 1), n <= r && r--
                        }), this
                    },
                    has: function(e) {
                        return e ? b.inArray(e, a) > -1 : a.length > 0
                    },
                    empty: function() {
                        return a && (a = []), this
                    },
                    disable: function() {
                        return s = o = [], a = n = "", this
                    },
                    disabled: function() {
                        return !a
                    },
                    lock: function() {
                        return s = o = [], n || t || (a = n = ""), this
                    },
                    locked: function() {
                        return !!s
                    },
                    fireWith: function(e, n) {
                        return s || (n = [e, (n = n || []).slice ? n.slice() : n], o.push(n), t || d()), this
                    },
                    fire: function() {
                        return l.fireWith(this, arguments), this
                    },
                    fired: function() {
                        return !!i
                    }
                };
            return l
        }, b.extend({
            Deferred: function(e) {
                var t = [
                        ["notify", "progress", b.Callbacks("memory"), b.Callbacks("memory"), 2],
                        ["resolve", "done", b.Callbacks("once memory"), b.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", b.Callbacks("once memory"), b.Callbacks("once memory"), 1, "rejected"]
                    ],
                    i = "pending",
                    s = {
                        state: function() {
                            return i
                        },
                        always: function() {
                            return a.done(arguments).fail(arguments), this
                        },
                        catch: function(e) {
                            return s.then(null, e)
                        },
                        pipe: function() {
                            var e = arguments;
                            return b.Deferred(function(n) {
                                b.each(t, function(t, i) {
                                    var s = g(e[i[4]]) && e[i[4]];
                                    a[i[1]](function() {
                                        var e = s && s.apply(this, arguments);
                                        e && g(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[i[0] + "With"](this, s ? [e] : arguments)
                                    })
                                }), e = null
                            }).promise()
                        },
                        then: function(e, i, s) {
                            var a = 0;

                            function o(e, t, i, s) {
                                return function() {
                                    var r = this,
                                        d = arguments,
                                        l = function() {
                                            var n, l;
                                            if (!(e < a)) {
                                                if ((n = i.apply(r, d)) === t.promise()) throw new TypeError("Thenable self-resolution");
                                                l = n && ("object" == typeof n || "function" == typeof n) && n.then, g(l) ? s ? l.call(n, o(a, t, $, s), o(a, t, W, s)) : (a++, l.call(n, o(a, t, $, s), o(a, t, W, s), o(a, t, $, t.notifyWith))) : (i !== $ && (r = void 0, d = [n]), (s || t.resolveWith)(r, d))
                                            }
                                        },
                                        u = s ? l : function() {
                                            try {
                                                l()
                                            } catch (n) {
                                                b.Deferred.exceptionHook && b.Deferred.exceptionHook(n, u.stackTrace), e + 1 >= a && (i !== W && (r = void 0, d = [n]), t.rejectWith(r, d))
                                            }
                                        };
                                    e ? u() : (b.Deferred.getStackHook && (u.stackTrace = b.Deferred.getStackHook()), n.setTimeout(u))
                                }
                            }
                            return b.Deferred(function(n) {
                                t[0][3].add(o(0, n, g(s) ? s : $, n.notifyWith)), t[1][3].add(o(0, n, g(e) ? e : $)), t[2][3].add(o(0, n, g(i) ? i : W))
                            }).promise()
                        },
                        promise: function(e) {
                            return null != e ? b.extend(e, s) : s
                        }
                    },
                    a = {};
                return b.each(t, function(e, n) {
                    var o = n[2],
                        r = n[5];
                    s[n[1]] = o.add, r && o.add(function() {
                        i = r
                    }, t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock), o.add(n[3].fire), a[n[0]] = function() {
                        return a[n[0] + "With"](this === a ? void 0 : this, arguments), this
                    }, a[n[0] + "With"] = o.fireWith
                }), s.promise(a), e && e.call(a, a), a
            },
            when: function(e) {
                var t = arguments.length,
                    n = t,
                    i = Array(n),
                    s = r.call(arguments),
                    a = b.Deferred(),
                    o = function(e) {
                        return function(n) {
                            i[e] = this, s[e] = arguments.length > 1 ? r.call(arguments) : n, --t || a.resolveWith(i, s)
                        }
                    };
                if (t <= 1 && (N(e, a.done(o(n)).resolve, a.reject, !t), "pending" === a.state() || g(s[n] && s[n].then))) return a.then();
                for (; n--;) N(s[n], o(n), a.reject);
                return a.promise()
            }
        });
        var z = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        b.Deferred.exceptionHook = function(e, t) {
            n.console && n.console.warn && e && z.test(e.name) && n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
        }, b.readyException = function(e) {
            n.setTimeout(function() {
                throw e
            })
        };
        var R = b.Deferred();

        function I() {
            v.removeEventListener("DOMContentLoaded", I), n.removeEventListener("load", I), b.ready()
        }
        b.fn.ready = function(e) {
            return R.then(e).catch(function(e) {
                b.readyException(e)
            }), this
        }, b.extend({
            isReady: !1,
            readyWait: 1,
            ready: function(e) {
                (!0 === e ? --b.readyWait : b.isReady) || (b.isReady = !0, !0 !== e && --b.readyWait > 0 || R.resolveWith(v, [b]))
            }
        }), b.ready.then = R.then, "complete" === v.readyState || "loading" !== v.readyState && !v.documentElement.doScroll ? n.setTimeout(b.ready) : (v.addEventListener("DOMContentLoaded", I), n.addEventListener("load", I));
        var q = function(e, t, n, i, s, a, o) {
                var r = 0,
                    d = e.length,
                    l = null == n;
                if ("object" === w(n))
                    for (r in s = !0, n) q(e, t, r, n[r], !0, a, o);
                else if (void 0 !== i && (s = !0, g(i) || (o = !0), l && (o ? (t.call(e, i), t = null) : (l = t, t = function(e, t, n) {
                        return l.call(b(e), n)
                    })), t))
                    for (; r < d; r++) t(e[r], n, o ? i : i.call(e[r], r, t(e[r], n)));
                return s ? e : l ? t.call(e) : d ? t(e[0], n) : a
            },
            B = /^-ms-/,
            U = /-([a-z])/g;

        function J(e, t) {
            return t.toUpperCase()
        }

        function V(e) {
            return e.replace(B, "ms-").replace(U, J)
        }
        var G = function(e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
        };

        function X() {
            this.expando = b.expando + X.uid++
        }
        X.uid = 1, X.prototype = {
            cache: function(e) {
                var t = e[this.expando];
                return t || (t = {}, G(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0
                }))), t
            },
            set: function(e, t, n) {
                var i, s = this.cache(e);
                if ("string" == typeof t) s[V(t)] = n;
                else
                    for (i in t) s[V(i)] = t[i];
                return s
            },
            get: function(e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][V(t)]
            },
            access: function(e, t, n) {
                return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t)
            },
            remove: function(e, t) {
                var n, i = e[this.expando];
                if (void 0 !== i) {
                    if (void 0 !== t) {
                        n = (t = Array.isArray(t) ? t.map(V) : (t = V(t)) in i ? [t] : t.match(F) || []).length;
                        for (; n--;) delete i[t[n]]
                    }(void 0 === t || b.isEmptyObject(i)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
                }
            },
            hasData: function(e) {
                var t = e[this.expando];
                return void 0 !== t && !b.isEmptyObject(t)
            }
        };
        var K = new X,
            Z = new X,
            Q = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            ee = /[A-Z]/g;

        function te(e, t, n) {
            var i;
            if (void 0 === n && 1 === e.nodeType)
                if (i = "data-" + t.replace(ee, "-$&").toLowerCase(), "string" == typeof(n = e.getAttribute(i))) {
                    try {
                        n = function(e) {
                            return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : Q.test(e) ? JSON.parse(e) : e)
                        }(n)
                    } catch (e) {}
                    Z.set(e, t, n)
                } else n = void 0;
            return n
        }
        b.extend({
            hasData: function(e) {
                return Z.hasData(e) || K.hasData(e)
            },
            data: function(e, t, n) {
                return Z.access(e, t, n)
            },
            removeData: function(e, t) {
                Z.remove(e, t)
            },
            _data: function(e, t, n) {
                return K.access(e, t, n)
            },
            _removeData: function(e, t) {
                K.remove(e, t)
            }
        }), b.fn.extend({
            data: function(e, t) {
                var n, i, s, a = this[0],
                    o = a && a.attributes;
                if (void 0 === e) {
                    if (this.length && (s = Z.get(a), 1 === a.nodeType && !K.get(a, "hasDataAttrs"))) {
                        for (n = o.length; n--;) o[n] && 0 === (i = o[n].name).indexOf("data-") && (i = V(i.slice(5)), te(a, i, s[i]));
                        K.set(a, "hasDataAttrs", !0)
                    }
                    return s
                }
                return "object" == typeof e ? this.each(function() {
                    Z.set(this, e)
                }) : q(this, function(t) {
                    var n;
                    if (a && void 0 === t) return void 0 !== (n = Z.get(a, e)) ? n : void 0 !== (n = te(a, e)) ? n : void 0;
                    this.each(function() {
                        Z.set(this, e, t)
                    })
                }, null, t, arguments.length > 1, null, !0)
            },
            removeData: function(e) {
                return this.each(function() {
                    Z.remove(this, e)
                })
            }
        }), b.extend({
            queue: function(e, t, n) {
                var i;
                if (e) return t = (t || "fx") + "queue", i = K.get(e, t), n && (!i || Array.isArray(n) ? i = K.access(e, t, b.makeArray(n)) : i.push(n)), i || []
            },
            dequeue: function(e, t) {
                t = t || "fx";
                var n = b.queue(e, t),
                    i = n.length,
                    s = n.shift(),
                    a = b._queueHooks(e, t);
                "inprogress" === s && (s = n.shift(), i--), s && ("fx" === t && n.unshift("inprogress"), delete a.stop, s.call(e, function() {
                    b.dequeue(e, t)
                }, a)), !i && a && a.empty.fire()
            },
            _queueHooks: function(e, t) {
                var n = t + "queueHooks";
                return K.get(e, n) || K.access(e, n, {
                    empty: b.Callbacks("once memory").add(function() {
                        K.remove(e, [t + "queue", n])
                    })
                })
            }
        }), b.fn.extend({
            queue: function(e, t) {
                var n = 2;
                return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? b.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                    var n = b.queue(this, e, t);
                    b._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && b.dequeue(this, e)
                })
            },
            dequeue: function(e) {
                return this.each(function() {
                    b.dequeue(this, e)
                })
            },
            clearQueue: function(e) {
                return this.queue(e || "fx", [])
            },
            promise: function(e, t) {
                var n, i = 1,
                    s = b.Deferred(),
                    a = this,
                    o = this.length,
                    r = function() {
                        --i || s.resolveWith(a, [a])
                    };
                for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; o--;)(n = K.get(a[o], e + "queueHooks")) && n.empty && (i++, n.empty.add(r));
                return r(), s.promise(t)
            }
        });
        var ne = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            ie = new RegExp("^(?:([+-])=|)(" + ne + ")([a-z%]*)$", "i"),
            se = ["Top", "Right", "Bottom", "Left"],
            ae = v.documentElement,
            oe = function(e) {
                return b.contains(e.ownerDocument, e)
            },
            re = {
                composed: !0
            };
        ae.getRootNode && (oe = function(e) {
            return b.contains(e.ownerDocument, e) || e.getRootNode(re) === e.ownerDocument
        });
        var de = function(e, t) {
            return "none" === (e = t || e).style.display || "" === e.style.display && oe(e) && "none" === b.css(e, "display")
        };

        function le(e, t, n, i) {
            var s, a, o = 20,
                r = i ? function() {
                    return i.cur()
                } : function() {
                    return b.css(e, t, "")
                },
                d = r(),
                l = n && n[3] || (b.cssNumber[t] ? "" : "px"),
                u = e.nodeType && (b.cssNumber[t] || "px" !== l && +d) && ie.exec(b.css(e, t));
            if (u && u[3] !== l) {
                for (d /= 2, l = l || u[3], u = +d || 1; o--;) b.style(e, t, u + l), (1 - a) * (1 - (a = r() / d || .5)) <= 0 && (o = 0), u /= a;
                u *= 2, b.style(e, t, u + l), n = n || []
            }
            return n && (u = +u || +d || 0, s = n[1] ? u + (n[1] + 1) * n[2] : +n[2], i && (i.unit = l, i.start = u, i.end = s)), s
        }
        var ue = {};

        function ce(e) {
            var t, n = e.ownerDocument,
                i = e.nodeName,
                s = ue[i];
            return s || (t = n.body.appendChild(n.createElement(i)), s = b.css(t, "display"), t.parentNode.removeChild(t), "none" === s && (s = "block"), ue[i] = s, s)
        }

        function he(e, t) {
            for (var n, i, s = [], a = 0, o = e.length; a < o; a++)(i = e[a]).style && (n = i.style.display, t ? ("none" === n && (s[a] = K.get(i, "display") || null, s[a] || (i.style.display = "")), "" === i.style.display && de(i) && (s[a] = ce(i))) : "none" !== n && (s[a] = "none", K.set(i, "display", n)));
            for (a = 0; a < o; a++) null != s[a] && (e[a].style.display = s[a]);
            return e
        }
        b.fn.extend({
            show: function() {
                return he(this, !0)
            },
            hide: function() {
                return he(this)
            },
            toggle: function(e) {
                return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                    de(this) ? b(this).show() : b(this).hide()
                })
            }
        });
        var me = /^(?:checkbox|radio)$/i,
            fe = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            _e = /^$|^module$|\/(?:java|ecma)script/i;
        ! function() {
            var e = v.createDocumentFragment().appendChild(v.createElement("div")),
                t = v.createElement("input");
            t.setAttribute("type", "radio"), t.setAttribute("checked", "checked"), t.setAttribute("name", "t"), e.appendChild(t), p.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", p.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue, e.innerHTML = "<option></option>", p.option = !!e.lastChild
        }();
        var pe = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };

        function ge(e, t) {
            var n;
            return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && x(e, t) ? b.merge([e], n) : n
        }

        function ye(e, t) {
            for (var n = 0, i = e.length; n < i; n++) K.set(e[n], "globalEval", !t || K.get(t[n], "globalEval"))
        }
        pe.tbody = pe.tfoot = pe.colgroup = pe.caption = pe.thead, pe.th = pe.td, p.option || (pe.optgroup = pe.option = [1, "<select multiple='multiple'>", "</select>"]);
        var ve = /<|&#?\w+;/;

        function Me(e, t, n, i, s) {
            for (var a, o, r, d, l, u, c = t.createDocumentFragment(), h = [], m = 0, f = e.length; m < f; m++)
                if ((a = e[m]) || 0 === a)
                    if ("object" === w(a)) b.merge(h, a.nodeType ? [a] : a);
                    else if (ve.test(a)) {
                for (o = o || c.appendChild(t.createElement("div")), r = (fe.exec(a) || ["", ""])[1].toLowerCase(), d = pe[r] || pe._default, o.innerHTML = d[1] + b.htmlPrefilter(a) + d[2], u = d[0]; u--;) o = o.lastChild;
                b.merge(h, o.childNodes), (o = c.firstChild).textContent = ""
            } else h.push(t.createTextNode(a));
            for (c.textContent = "", m = 0; a = h[m++];)
                if (i && b.inArray(a, i) > -1) s && s.push(a);
                else if (l = oe(a), o = ge(c.appendChild(a), "script"), l && ye(o), n)
                for (u = 0; a = o[u++];) _e.test(a.type || "") && n.push(a);
            return c
        }
        var Le = /^([^.]*)(?:\.(.+)|)/;

        function we() {
            return !0
        }

        function be() {
            return !1
        }

        function ke(e, t) {
            return e === function() {
                try {
                    return v.activeElement
                } catch (e) {}
            }() == ("focus" === t)
        }

        function Ye(e, t, n, i, s, a) {
            var o, r;
            if ("object" == typeof t) {
                for (r in "string" != typeof n && (i = i || n, n = void 0), t) Ye(e, r, n, i, t[r], a);
                return e
            }
            if (null == i && null == s ? (s = n, i = n = void 0) : null == s && ("string" == typeof n ? (s = i, i = void 0) : (s = i, i = n, n = void 0)), !1 === s) s = be;
            else if (!s) return e;
            return 1 === a && (o = s, (s = function(e) {
                return b().off(e), o.apply(this, arguments)
            }).guid = o.guid || (o.guid = b.guid++)), e.each(function() {
                b.event.add(this, t, s, i, n)
            })
        }

        function Te(e, t, n) {
            n ? (K.set(e, t, !1), b.event.add(e, t, {
                namespace: !1,
                handler: function(e) {
                    var i, s, a = K.get(this, t);
                    if (1 & e.isTrigger && this[t]) {
                        if (a.length)(b.event.special[t] || {}).delegateType && e.stopPropagation();
                        else if (a = r.call(arguments), K.set(this, t, a), i = n(this, t), this[t](), a !== (s = K.get(this, t)) || i ? K.set(this, t, !1) : s = {}, a !== s) return e.stopImmediatePropagation(), e.preventDefault(), s && s.value
                    } else a.length && (K.set(this, t, {
                        value: b.event.trigger(b.extend(a[0], b.Event.prototype), a.slice(1), this)
                    }), e.stopImmediatePropagation())
                }
            })) : void 0 === K.get(e, t) && b.event.add(e, t, we)
        }
        b.event = {
            global: {},
            add: function(e, t, n, i, s) {
                var a, o, r, d, l, u, c, h, m, f, _, p = K.get(e);
                if (G(e))
                    for (n.handler && (n = (a = n).handler, s = a.selector), s && b.find.matchesSelector(ae, s), n.guid || (n.guid = b.guid++), (d = p.events) || (d = p.events = Object.create(null)), (o = p.handle) || (o = p.handle = function(t) {
                            return void 0 !== b && b.event.triggered !== t.type ? b.event.dispatch.apply(e, arguments) : void 0
                        }), l = (t = (t || "").match(F) || [""]).length; l--;) m = _ = (r = Le.exec(t[l]) || [])[1], f = (r[2] || "").split(".").sort(), m && (c = b.event.special[m] || {}, m = (s ? c.delegateType : c.bindType) || m, c = b.event.special[m] || {}, u = b.extend({
                        type: m,
                        origType: _,
                        data: i,
                        handler: n,
                        guid: n.guid,
                        selector: s,
                        needsContext: s && b.expr.match.needsContext.test(s),
                        namespace: f.join(".")
                    }, a), (h = d[m]) || ((h = d[m] = []).delegateCount = 0, c.setup && !1 !== c.setup.call(e, i, f, o) || e.addEventListener && e.addEventListener(m, o)), c.add && (c.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)), s ? h.splice(h.delegateCount++, 0, u) : h.push(u), b.event.global[m] = !0)
            },
            remove: function(e, t, n, i, s) {
                var a, o, r, d, l, u, c, h, m, f, _, p = K.hasData(e) && K.get(e);
                if (p && (d = p.events)) {
                    for (l = (t = (t || "").match(F) || [""]).length; l--;)
                        if (m = _ = (r = Le.exec(t[l]) || [])[1], f = (r[2] || "").split(".").sort(), m) {
                            for (c = b.event.special[m] || {}, h = d[m = (i ? c.delegateType : c.bindType) || m] || [], r = r[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), o = a = h.length; a--;) u = h[a], !s && _ !== u.origType || n && n.guid !== u.guid || r && !r.test(u.namespace) || i && i !== u.selector && ("**" !== i || !u.selector) || (h.splice(a, 1), u.selector && h.delegateCount--, c.remove && c.remove.call(e, u));
                            o && !h.length && (c.teardown && !1 !== c.teardown.call(e, f, p.handle) || b.removeEvent(e, m, p.handle), delete d[m])
                        } else
                            for (m in d) b.event.remove(e, m + t[l], n, i, !0);
                    b.isEmptyObject(d) && K.remove(e, "handle events")
                }
            },
            dispatch: function(e) {
                var t, n, i, s, a, o, r = new Array(arguments.length),
                    d = b.event.fix(e),
                    l = (K.get(this, "events") || Object.create(null))[d.type] || [],
                    u = b.event.special[d.type] || {};
                for (r[0] = d, t = 1; t < arguments.length; t++) r[t] = arguments[t];
                if (d.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, d)) {
                    for (o = b.event.handlers.call(this, d, l), t = 0;
                        (s = o[t++]) && !d.isPropagationStopped();)
                        for (d.currentTarget = s.elem, n = 0;
                            (a = s.handlers[n++]) && !d.isImmediatePropagationStopped();) d.rnamespace && !1 !== a.namespace && !d.rnamespace.test(a.namespace) || (d.handleObj = a, d.data = a.data, void 0 !== (i = ((b.event.special[a.origType] || {}).handle || a.handler).apply(s.elem, r)) && !1 === (d.result = i) && (d.preventDefault(), d.stopPropagation()));
                    return u.postDispatch && u.postDispatch.call(this, d), d.result
                }
            },
            handlers: function(e, t) {
                var n, i, s, a, o, r = [],
                    d = t.delegateCount,
                    l = e.target;
                if (d && l.nodeType && !("click" === e.type && e.button >= 1))
                    for (; l !== this; l = l.parentNode || this)
                        if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                            for (a = [], o = {}, n = 0; n < d; n++) void 0 === o[s = (i = t[n]).selector + " "] && (o[s] = i.needsContext ? b(s, this).index(l) > -1 : b.find(s, this, null, [l]).length), o[s] && a.push(i);
                            a.length && r.push({
                                elem: l,
                                handlers: a
                            })
                        } return l = this, d < t.length && r.push({
                    elem: l,
                    handlers: t.slice(d)
                }), r
            },
            addProp: function(e, t) {
                Object.defineProperty(b.Event.prototype, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: g(t) ? function() {
                        if (this.originalEvent) return t(this.originalEvent)
                    } : function() {
                        if (this.originalEvent) return this.originalEvent[e]
                    },
                    set: function(t) {
                        Object.defineProperty(this, e, {
                            enumerable: !0,
                            configurable: !0,
                            writable: !0,
                            value: t
                        })
                    }
                })
            },
            fix: function(e) {
                return e[b.expando] ? e : new b.Event(e)
            },
            special: {
                load: {
                    noBubble: !0
                },
                click: {
                    setup: function(e) {
                        var t = this || e;
                        return me.test(t.type) && t.click && x(t, "input") && Te(t, "click", we), !1
                    },
                    trigger: function(e) {
                        var t = this || e;
                        return me.test(t.type) && t.click && x(t, "input") && Te(t, "click"), !0
                    },
                    _default: function(e) {
                        var t = e.target;
                        return me.test(t.type) && t.click && x(t, "input") && K.get(t, "click") || x(t, "a")
                    }
                },
                beforeunload: {
                    postDispatch: function(e) {
                        void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                    }
                }
            }
        }, b.removeEvent = function(e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n)
        }, b.Event = function(e, t) {
            if (!(this instanceof b.Event)) return new b.Event(e, t);
            e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? we : be, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && b.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[b.expando] = !0
        }, b.Event.prototype = {
            constructor: b.Event,
            isDefaultPrevented: be,
            isPropagationStopped: be,
            isImmediatePropagationStopped: be,
            isSimulated: !1,
            preventDefault: function() {
                var e = this.originalEvent;
                this.isDefaultPrevented = we, e && !this.isSimulated && e.preventDefault()
            },
            stopPropagation: function() {
                var e = this.originalEvent;
                this.isPropagationStopped = we, e && !this.isSimulated && e.stopPropagation()
            },
            stopImmediatePropagation: function() {
                var e = this.originalEvent;
                this.isImmediatePropagationStopped = we, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
            }
        }, b.each({
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            char: !0,
            code: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: !0
        }, b.event.addProp), b.each({
            focus: "focusin",
            blur: "focusout"
        }, function(e, t) {
            b.event.special[e] = {
                setup: function() {
                    return Te(this, e, ke), !1
                },
                trigger: function() {
                    return Te(this, e), !0
                },
                _default: function() {
                    return !0
                },
                delegateType: t
            }
        }), b.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
        }, function(e, t) {
            b.event.special[e] = {
                delegateType: t,
                bindType: t,
                handle: function(e) {
                    var n, i = e.relatedTarget,
                        s = e.handleObj;
                    return i && (i === this || b.contains(this, i)) || (e.type = s.origType, n = s.handler.apply(this, arguments), e.type = t), n
                }
            }
        }), b.fn.extend({
            on: function(e, t, n, i) {
                return Ye(this, e, t, n, i)
            },
            one: function(e, t, n, i) {
                return Ye(this, e, t, n, i, 1)
            },
            off: function(e, t, n) {
                var i, s;
                if (e && e.preventDefault && e.handleObj) return i = e.handleObj, b(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                if ("object" == typeof e) {
                    for (s in e) this.off(s, t, e[s]);
                    return this
                }
                return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = be), this.each(function() {
                    b.event.remove(this, e, n, t)
                })
            }
        });
        var De = /<script|<style|<link/i,
            Se = /checked\s*(?:[^=]|=\s*.checked.)/i,
            xe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

        function He(e, t) {
            return x(e, "table") && x(11 !== t.nodeType ? t : t.firstChild, "tr") && b(e).children("tbody")[0] || e
        }

        function je(e) {
            return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
        }

        function Ce(e) {
            return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
        }

        function Pe(e, t) {
            var n, i, s, a, o, r;
            if (1 === t.nodeType) {
                if (K.hasData(e) && (r = K.get(e).events))
                    for (s in K.remove(t, "handle events"), r)
                        for (n = 0, i = r[s].length; n < i; n++) b.event.add(t, s, r[s][n]);
                Z.hasData(e) && (a = Z.access(e), o = b.extend({}, a), Z.set(t, o))
            }
        }

        function Ee(e, t) {
            var n = t.nodeName.toLowerCase();
            "input" === n && me.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
        }

        function Ae(e, t, n, i) {
            t = d(t);
            var s, a, o, r, l, u, c = 0,
                h = e.length,
                m = h - 1,
                f = t[0],
                _ = g(f);
            if (_ || h > 1 && "string" == typeof f && !p.checkClone && Se.test(f)) return e.each(function(s) {
                var a = e.eq(s);
                _ && (t[0] = f.call(this, s, a.html())), Ae(a, t, n, i)
            });
            if (h && (a = (s = Me(t, e[0].ownerDocument, !1, e, i)).firstChild, 1 === s.childNodes.length && (s = a), a || i)) {
                for (r = (o = b.map(ge(s, "script"), je)).length; c < h; c++) l = s, c !== m && (l = b.clone(l, !0, !0), r && b.merge(o, ge(l, "script"))), n.call(e[c], l, c);
                if (r)
                    for (u = o[o.length - 1].ownerDocument, b.map(o, Ce), c = 0; c < r; c++) l = o[c], _e.test(l.type || "") && !K.access(l, "globalEval") && b.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? b._evalUrl && !l.noModule && b._evalUrl(l.src, {
                        nonce: l.nonce || l.getAttribute("nonce")
                    }, u) : L(l.textContent.replace(xe, ""), l, u))
            }
            return e
        }

        function Oe(e, t, n) {
            for (var i, s = t ? b.filter(t, e) : e, a = 0; null != (i = s[a]); a++) n || 1 !== i.nodeType || b.cleanData(ge(i)), i.parentNode && (n && oe(i) && ye(ge(i, "script")), i.parentNode.removeChild(i));
            return e
        }
        b.extend({
            htmlPrefilter: function(e) {
                return e
            },
            clone: function(e, t, n) {
                var i, s, a, o, r = e.cloneNode(!0),
                    d = oe(e);
                if (!(p.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || b.isXMLDoc(e)))
                    for (o = ge(r), i = 0, s = (a = ge(e)).length; i < s; i++) Ee(a[i], o[i]);
                if (t)
                    if (n)
                        for (a = a || ge(e), o = o || ge(r), i = 0, s = a.length; i < s; i++) Pe(a[i], o[i]);
                    else Pe(e, r);
                return (o = ge(r, "script")).length > 0 && ye(o, !d && ge(e, "script")), r
            },
            cleanData: function(e) {
                for (var t, n, i, s = b.event.special, a = 0; void 0 !== (n = e[a]); a++)
                    if (G(n)) {
                        if (t = n[K.expando]) {
                            if (t.events)
                                for (i in t.events) s[i] ? b.event.remove(n, i) : b.removeEvent(n, i, t.handle);
                            n[K.expando] = void 0
                        }
                        n[Z.expando] && (n[Z.expando] = void 0)
                    }
            }
        }), b.fn.extend({
            detach: function(e) {
                return Oe(this, e, !0)
            },
            remove: function(e) {
                return Oe(this, e)
            },
            text: function(e) {
                return q(this, function(e) {
                    return void 0 === e ? b.text(this) : this.empty().each(function() {
                        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                    })
                }, null, e, arguments.length)
            },
            append: function() {
                return Ae(this, arguments, function(e) {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || He(this, e).appendChild(e)
                })
            },
            prepend: function() {
                return Ae(this, arguments, function(e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = He(this, e);
                        t.insertBefore(e, t.firstChild)
                    }
                })
            },
            before: function() {
                return Ae(this, arguments, function(e) {
                    this.parentNode && this.parentNode.insertBefore(e, this)
                })
            },
            after: function() {
                return Ae(this, arguments, function(e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
                })
            },
            empty: function() {
                for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (b.cleanData(ge(e, !1)), e.textContent = "");
                return this
            },
            clone: function(e, t) {
                return e = null != e && e, t = null == t ? e : t, this.map(function() {
                    return b.clone(this, e, t)
                })
            },
            html: function(e) {
                return q(this, function(e) {
                    var t = this[0] || {},
                        n = 0,
                        i = this.length;
                    if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                    if ("string" == typeof e && !De.test(e) && !pe[(fe.exec(e) || ["", ""])[1].toLowerCase()]) {
                        e = b.htmlPrefilter(e);
                        try {
                            for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (b.cleanData(ge(t, !1)), t.innerHTML = e);
                            t = 0
                        } catch (e) {}
                    }
                    t && this.empty().append(e)
                }, null, e, arguments.length)
            },
            replaceWith: function() {
                var e = [];
                return Ae(this, arguments, function(t) {
                    var n = this.parentNode;
                    b.inArray(this, e) < 0 && (b.cleanData(ge(this)), n && n.replaceChild(t, this))
                }, e)
            }
        }), b.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
        }, function(e, t) {
            b.fn[e] = function(e) {
                for (var n, i = [], s = b(e), a = s.length - 1, o = 0; o <= a; o++) n = o === a ? this : this.clone(!0), b(s[o])[t](n), l.apply(i, n.get());
                return this.pushStack(i)
            }
        });
        var Fe = new RegExp("^(" + ne + ")(?!px)[a-z%]+$", "i"),
            $e = function(e) {
                var t = e.ownerDocument.defaultView;
                return t && t.opener || (t = n), t.getComputedStyle(e)
            },
            We = function(e, t, n) {
                var i, s, a = {};
                for (s in t) a[s] = e.style[s], e.style[s] = t[s];
                for (s in i = n.call(e), t) e.style[s] = a[s];
                return i
            },
            Ne = new RegExp(se.join("|"), "i");

        function ze(e, t, n) {
            var i, s, a, o, r = e.style;
            return (n = n || $e(e)) && ("" !== (o = n.getPropertyValue(t) || n[t]) || oe(e) || (o = b.style(e, t)), !p.pixelBoxStyles() && Fe.test(o) && Ne.test(t) && (i = r.width, s = r.minWidth, a = r.maxWidth, r.minWidth = r.maxWidth = r.width = o, o = n.width, r.width = i, r.minWidth = s, r.maxWidth = a)), void 0 !== o ? o + "" : o
        }

        function Re(e, t) {
            return {
                get: function() {
                    if (!e()) return (this.get = t).apply(this, arguments);
                    delete this.get
                }
            }
        }! function() {
            function e() {
                if (u) {
                    l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", ae.appendChild(l).appendChild(u);
                    var e = n.getComputedStyle(u);
                    i = "1%" !== e.top, d = 12 === t(e.marginLeft), u.style.right = "60%", o = 36 === t(e.right), s = 36 === t(e.width), u.style.position = "absolute", a = 12 === t(u.offsetWidth / 3), ae.removeChild(l), u = null
                }
            }

            function t(e) {
                return Math.round(parseFloat(e))
            }
            var i, s, a, o, r, d, l = v.createElement("div"),
                u = v.createElement("div");
            u.style && (u.style.backgroundClip = "content-box", u.cloneNode(!0).style.backgroundClip = "", p.clearCloneStyle = "content-box" === u.style.backgroundClip, b.extend(p, {
                boxSizingReliable: function() {
                    return e(), s
                },
                pixelBoxStyles: function() {
                    return e(), o
                },
                pixelPosition: function() {
                    return e(), i
                },
                reliableMarginLeft: function() {
                    return e(), d
                },
                scrollboxSize: function() {
                    return e(), a
                },
                reliableTrDimensions: function() {
                    var e, t, i, s;
                    return null == r && (e = v.createElement("table"), t = v.createElement("tr"), i = v.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", t.style.cssText = "border:1px solid", t.style.height = "1px", i.style.height = "9px", i.style.display = "block", ae.appendChild(e).appendChild(t).appendChild(i), s = n.getComputedStyle(t), r = parseInt(s.height, 10) + parseInt(s.borderTopWidth, 10) + parseInt(s.borderBottomWidth, 10) === t.offsetHeight, ae.removeChild(e)), r
                }
            }))
        }();
        var Ie = ["Webkit", "Moz", "ms"],
            qe = v.createElement("div").style,
            Be = {};

        function Ue(e) {
            var t = b.cssProps[e] || Be[e];
            return t || (e in qe ? e : Be[e] = function(e) {
                for (var t = e[0].toUpperCase() + e.slice(1), n = Ie.length; n--;)
                    if ((e = Ie[n] + t) in qe) return e
            }(e) || e)
        }
        var Je = /^(none|table(?!-c[ea]).+)/,
            Ve = /^--/,
            Ge = {
                position: "absolute",
                visibility: "hidden",
                display: "block"
            },
            Xe = {
                letterSpacing: "0",
                fontWeight: "400"
            };

        function Ke(e, t, n) {
            var i = ie.exec(t);
            return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t
        }

        function Ze(e, t, n, i, s, a) {
            var o = "width" === t ? 1 : 0,
                r = 0,
                d = 0;
            if (n === (i ? "border" : "content")) return 0;
            for (; o < 4; o += 2) "margin" === n && (d += b.css(e, n + se[o], !0, s)), i ? ("content" === n && (d -= b.css(e, "padding" + se[o], !0, s)), "margin" !== n && (d -= b.css(e, "border" + se[o] + "Width", !0, s))) : (d += b.css(e, "padding" + se[o], !0, s), "padding" !== n ? d += b.css(e, "border" + se[o] + "Width", !0, s) : r += b.css(e, "border" + se[o] + "Width", !0, s));
            return !i && a >= 0 && (d += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - a - d - r - .5)) || 0), d
        }

        function Qe(e, t, n) {
            var i = $e(e),
                s = (!p.boxSizingReliable() || n) && "border-box" === b.css(e, "boxSizing", !1, i),
                a = s,
                o = ze(e, t, i),
                r = "offset" + t[0].toUpperCase() + t.slice(1);
            if (Fe.test(o)) {
                if (!n) return o;
                o = "auto"
            }
            return (!p.boxSizingReliable() && s || !p.reliableTrDimensions() && x(e, "tr") || "auto" === o || !parseFloat(o) && "inline" === b.css(e, "display", !1, i)) && e.getClientRects().length && (s = "border-box" === b.css(e, "boxSizing", !1, i), (a = r in e) && (o = e[r])), (o = parseFloat(o) || 0) + Ze(e, t, n || (s ? "border" : "content"), a, i, o) + "px"
        }

        function et(e, t, n, i, s) {
            return new et.prototype.init(e, t, n, i, s)
        }
        b.extend({
            cssHooks: {
                opacity: {
                    get: function(e, t) {
                        if (t) {
                            var n = ze(e, "opacity");
                            return "" === n ? "1" : n
                        }
                    }
                }
            },
            cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                gridArea: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnStart: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowStart: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0
            },
            cssProps: {},
            style: function(e, t, n, i) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var s, a, o, r = V(t),
                        d = Ve.test(t),
                        l = e.style;
                    if (d || (t = Ue(r)), o = b.cssHooks[t] || b.cssHooks[r], void 0 === n) return o && "get" in o && void 0 !== (s = o.get(e, !1, i)) ? s : l[t];
                    "string" === (a = typeof n) && (s = ie.exec(n)) && s[1] && (n = le(e, t, s), a = "number"), null != n && n == n && ("number" !== a || d || (n += s && s[3] || (b.cssNumber[r] ? "" : "px")), p.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), o && "set" in o && void 0 === (n = o.set(e, n, i)) || (d ? l.setProperty(t, n) : l[t] = n))
                }
            },
            css: function(e, t, n, i) {
                var s, a, o, r = V(t);
                return Ve.test(t) || (t = Ue(r)), (o = b.cssHooks[t] || b.cssHooks[r]) && "get" in o && (s = o.get(e, !0, n)), void 0 === s && (s = ze(e, t, i)), "normal" === s && t in Xe && (s = Xe[t]), "" === n || n ? (a = parseFloat(s), !0 === n || isFinite(a) ? a || 0 : s) : s
            }
        }), b.each(["height", "width"], function(e, t) {
            b.cssHooks[t] = {
                get: function(e, n, i) {
                    if (n) return !Je.test(b.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? Qe(e, t, i) : We(e, Ge, function() {
                        return Qe(e, t, i)
                    })
                },
                set: function(e, n, i) {
                    var s, a = $e(e),
                        o = !p.scrollboxSize() && "absolute" === a.position,
                        r = (o || i) && "border-box" === b.css(e, "boxSizing", !1, a),
                        d = i ? Ze(e, t, i, r, a) : 0;
                    return r && o && (d -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(a[t]) - Ze(e, t, "border", !1, a) - .5)), d && (s = ie.exec(n)) && "px" !== (s[3] || "px") && (e.style[t] = n, n = b.css(e, t)), Ke(0, n, d)
                }
            }
        }), b.cssHooks.marginLeft = Re(p.reliableMarginLeft, function(e, t) {
            if (t) return (parseFloat(ze(e, "marginLeft")) || e.getBoundingClientRect().left - We(e, {
                marginLeft: 0
            }, function() {
                return e.getBoundingClientRect().left
            })) + "px"
        }), b.each({
            margin: "",
            padding: "",
            border: "Width"
        }, function(e, t) {
            b.cssHooks[e + t] = {
                expand: function(n) {
                    for (var i = 0, s = {}, a = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) s[e + se[i] + t] = a[i] || a[i - 2] || a[0];
                    return s
                }
            }, "margin" !== e && (b.cssHooks[e + t].set = Ke)
        }), b.fn.extend({
            css: function(e, t) {
                return q(this, function(e, t, n) {
                    var i, s, a = {},
                        o = 0;
                    if (Array.isArray(t)) {
                        for (i = $e(e), s = t.length; o < s; o++) a[t[o]] = b.css(e, t[o], !1, i);
                        return a
                    }
                    return void 0 !== n ? b.style(e, t, n) : b.css(e, t)
                }, e, t, arguments.length > 1)
            }
        }), b.Tween = et, et.prototype = {
            constructor: et,
            init: function(e, t, n, i, s, a) {
                this.elem = e, this.prop = n, this.easing = s || b.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = a || (b.cssNumber[n] ? "" : "px")
            },
            cur: function() {
                var e = et.propHooks[this.prop];
                return e && e.get ? e.get(this) : et.propHooks._default.get(this)
            },
            run: function(e) {
                var t, n = et.propHooks[this.prop];
                return this.options.duration ? this.pos = t = b.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : et.propHooks._default.set(this), this
            }
        }, et.prototype.init.prototype = et.prototype, et.propHooks = {
            _default: {
                get: function(e) {
                    var t;
                    return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = b.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
                },
                set: function(e) {
                    b.fx.step[e.prop] ? b.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !b.cssHooks[e.prop] && null == e.elem.style[Ue(e.prop)] ? e.elem[e.prop] = e.now : b.style(e.elem, e.prop, e.now + e.unit)
                }
            }
        }, et.propHooks.scrollTop = et.propHooks.scrollLeft = {
            set: function(e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
            }
        }, b.easing = {
            linear: function(e) {
                return e
            },
            swing: function(e) {
                return .5 - Math.cos(e * Math.PI) / 2
            },
            _default: "swing"
        }, b.fx = et.prototype.init, b.fx.step = {};
        var tt, nt, it = /^(?:toggle|show|hide)$/,
            st = /queueHooks$/;

        function at() {
            nt && (!1 === v.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(at) : n.setTimeout(at, b.fx.interval), b.fx.tick())
        }

        function ot() {
            return n.setTimeout(function() {
                tt = void 0
            }), tt = Date.now()
        }

        function rt(e, t) {
            var n, i = 0,
                s = {
                    height: e
                };
            for (t = t ? 1 : 0; i < 4; i += 2 - t) s["margin" + (n = se[i])] = s["padding" + n] = e;
            return t && (s.opacity = s.width = e), s
        }

        function dt(e, t, n) {
            for (var i, s = (lt.tweeners[t] || []).concat(lt.tweeners["*"]), a = 0, o = s.length; a < o; a++)
                if (i = s[a].call(n, t, e)) return i
        }

        function lt(e, t, n) {
            var i, s, a = 0,
                o = lt.prefilters.length,
                r = b.Deferred().always(function() {
                    delete d.elem
                }),
                d = function() {
                    if (s) return !1;
                    for (var t = tt || ot(), n = Math.max(0, l.startTime + l.duration - t), i = 1 - (n / l.duration || 0), a = 0, o = l.tweens.length; a < o; a++) l.tweens[a].run(i);
                    return r.notifyWith(e, [l, i, n]), i < 1 && o ? n : (o || r.notifyWith(e, [l, 1, 0]), r.resolveWith(e, [l]), !1)
                },
                l = r.promise({
                    elem: e,
                    props: b.extend({}, t),
                    opts: b.extend(!0, {
                        specialEasing: {},
                        easing: b.easing._default
                    }, n),
                    originalProperties: t,
                    originalOptions: n,
                    startTime: tt || ot(),
                    duration: n.duration,
                    tweens: [],
                    createTween: function(t, n) {
                        var i = b.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
                        return l.tweens.push(i), i
                    },
                    stop: function(t) {
                        var n = 0,
                            i = t ? l.tweens.length : 0;
                        if (s) return this;
                        for (s = !0; n < i; n++) l.tweens[n].run(1);
                        return t ? (r.notifyWith(e, [l, 1, 0]), r.resolveWith(e, [l, t])) : r.rejectWith(e, [l, t]), this
                    }
                }),
                u = l.props;
            for (! function(e, t) {
                    var n, i, s, a, o;
                    for (n in e)
                        if (s = t[i = V(n)], a = e[n], Array.isArray(a) && (s = a[1], a = e[n] = a[0]), n !== i && (e[i] = a, delete e[n]), (o = b.cssHooks[i]) && "expand" in o)
                            for (n in a = o.expand(a), delete e[i], a) n in e || (e[n] = a[n], t[n] = s);
                        else t[i] = s
                }(u, l.opts.specialEasing); a < o; a++)
                if (i = lt.prefilters[a].call(l, e, u, l.opts)) return g(i.stop) && (b._queueHooks(l.elem, l.opts.queue).stop = i.stop.bind(i)), i;
            return b.map(u, dt, l), g(l.opts.start) && l.opts.start.call(e, l), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always), b.fx.timer(b.extend(d, {
                elem: e,
                anim: l,
                queue: l.opts.queue
            })), l
        }
        b.Animation = b.extend(lt, {
                tweeners: {
                    "*": [function(e, t) {
                        var n = this.createTween(e, t);
                        return le(n.elem, e, ie.exec(t), n), n
                    }]
                },
                tweener: function(e, t) {
                    g(e) ? (t = e, e = ["*"]) : e = e.match(F);
                    for (var n, i = 0, s = e.length; i < s; i++) n = e[i], lt.tweeners[n] = lt.tweeners[n] || [], lt.tweeners[n].unshift(t)
                },
                prefilters: [function(e, t, n) {
                    var i, s, a, o, r, d, l, u, c = "width" in t || "height" in t,
                        h = this,
                        m = {},
                        f = e.style,
                        _ = e.nodeType && de(e),
                        p = K.get(e, "fxshow");
                    for (i in n.queue || (null == (o = b._queueHooks(e, "fx")).unqueued && (o.unqueued = 0, r = o.empty.fire, o.empty.fire = function() {
                            o.unqueued || r()
                        }), o.unqueued++, h.always(function() {
                            h.always(function() {
                                o.unqueued--, b.queue(e, "fx").length || o.empty.fire()
                            })
                        })), t)
                        if (s = t[i], it.test(s)) {
                            if (delete t[i], a = a || "toggle" === s, s === (_ ? "hide" : "show")) {
                                if ("show" !== s || !p || void 0 === p[i]) continue;
                                _ = !0
                            }
                            m[i] = p && p[i] || b.style(e, i)
                        } if ((d = !b.isEmptyObject(t)) || !b.isEmptyObject(m))
                        for (i in c && 1 === e.nodeType && (n.overflow = [f.overflow, f.overflowX, f.overflowY], null == (l = p && p.display) && (l = K.get(e, "display")), "none" === (u = b.css(e, "display")) && (l ? u = l : (he([e], !0), l = e.style.display || l, u = b.css(e, "display"), he([e]))), ("inline" === u || "inline-block" === u && null != l) && "none" === b.css(e, "float") && (d || (h.done(function() {
                                f.display = l
                            }), null == l && (u = f.display, l = "none" === u ? "" : u)), f.display = "inline-block")), n.overflow && (f.overflow = "hidden", h.always(function() {
                                f.overflow = n.overflow[0], f.overflowX = n.overflow[1], f.overflowY = n.overflow[2]
                            })), d = !1, m) d || (p ? "hidden" in p && (_ = p.hidden) : p = K.access(e, "fxshow", {
                            display: l
                        }), a && (p.hidden = !_), _ && he([e], !0), h.done(function() {
                            for (i in _ || he([e]), K.remove(e, "fxshow"), m) b.style(e, i, m[i])
                        })), d = dt(_ ? p[i] : 0, i, h), i in p || (p[i] = d.start, _ && (d.end = d.start, d.start = 0))
                }],
                prefilter: function(e, t) {
                    t ? lt.prefilters.unshift(e) : lt.prefilters.push(e)
                }
            }), b.speed = function(e, t, n) {
                var i = e && "object" == typeof e ? b.extend({}, e) : {
                    complete: n || !n && t || g(e) && e,
                    duration: e,
                    easing: n && t || t && !g(t) && t
                };
                return b.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in b.fx.speeds ? i.duration = b.fx.speeds[i.duration] : i.duration = b.fx.speeds._default), null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
                    g(i.old) && i.old.call(this), i.queue && b.dequeue(this, i.queue)
                }, i
            }, b.fn.extend({
                fadeTo: function(e, t, n, i) {
                    return this.filter(de).css("opacity", 0).show().end().animate({
                        opacity: t
                    }, e, n, i)
                },
                animate: function(e, t, n, i) {
                    var s = b.isEmptyObject(e),
                        a = b.speed(t, n, i),
                        o = function() {
                            var t = lt(this, b.extend({}, e), a);
                            (s || K.get(this, "finish")) && t.stop(!0)
                        };
                    return o.finish = o, s || !1 === a.queue ? this.each(o) : this.queue(a.queue, o)
                },
                stop: function(e, t, n) {
                    var i = function(e) {
                        var t = e.stop;
                        delete e.stop, t(n)
                    };
                    return "string" != typeof e && (n = t, t = e, e = void 0), t && this.queue(e || "fx", []), this.each(function() {
                        var t = !0,
                            s = null != e && e + "queueHooks",
                            a = b.timers,
                            o = K.get(this);
                        if (s) o[s] && o[s].stop && i(o[s]);
                        else
                            for (s in o) o[s] && o[s].stop && st.test(s) && i(o[s]);
                        for (s = a.length; s--;) a[s].elem !== this || null != e && a[s].queue !== e || (a[s].anim.stop(n), t = !1, a.splice(s, 1));
                        !t && n || b.dequeue(this, e)
                    })
                },
                finish: function(e) {
                    return !1 !== e && (e = e || "fx"), this.each(function() {
                        var t, n = K.get(this),
                            i = n[e + "queue"],
                            s = n[e + "queueHooks"],
                            a = b.timers,
                            o = i ? i.length : 0;
                        for (n.finish = !0, b.queue(this, e, []), s && s.stop && s.stop.call(this, !0), t = a.length; t--;) a[t].elem === this && a[t].queue === e && (a[t].anim.stop(!0), a.splice(t, 1));
                        for (t = 0; t < o; t++) i[t] && i[t].finish && i[t].finish.call(this);
                        delete n.finish
                    })
                }
            }), b.each(["toggle", "show", "hide"], function(e, t) {
                var n = b.fn[t];
                b.fn[t] = function(e, i, s) {
                    return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(rt(t, !0), e, i, s)
                }
            }), b.each({
                slideDown: rt("show"),
                slideUp: rt("hide"),
                slideToggle: rt("toggle"),
                fadeIn: {
                    opacity: "show"
                },
                fadeOut: {
                    opacity: "hide"
                },
                fadeToggle: {
                    opacity: "toggle"
                }
            }, function(e, t) {
                b.fn[e] = function(e, n, i) {
                    return this.animate(t, e, n, i)
                }
            }), b.timers = [], b.fx.tick = function() {
                var e, t = 0,
                    n = b.timers;
                for (tt = Date.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1);
                n.length || b.fx.stop(), tt = void 0
            }, b.fx.timer = function(e) {
                b.timers.push(e), b.fx.start()
            }, b.fx.interval = 13, b.fx.start = function() {
                nt || (nt = !0, at())
            }, b.fx.stop = function() {
                nt = null
            }, b.fx.speeds = {
                slow: 600,
                fast: 200,
                _default: 400
            }, b.fn.delay = function(e, t) {
                return e = b.fx && b.fx.speeds[e] || e, t = t || "fx", this.queue(t, function(t, i) {
                    var s = n.setTimeout(t, e);
                    i.stop = function() {
                        n.clearTimeout(s)
                    }
                })
            },
            function() {
                var e = v.createElement("input"),
                    t = v.createElement("select").appendChild(v.createElement("option"));
                e.type = "checkbox", p.checkOn = "" !== e.value, p.optSelected = t.selected, (e = v.createElement("input")).value = "t", e.type = "radio", p.radioValue = "t" === e.value
            }();
        var ut, ct = b.expr.attrHandle;
        b.fn.extend({
            attr: function(e, t) {
                return q(this, b.attr, e, t, arguments.length > 1)
            },
            removeAttr: function(e) {
                return this.each(function() {
                    b.removeAttr(this, e)
                })
            }
        }), b.extend({
            attr: function(e, t, n) {
                var i, s, a = e.nodeType;
                if (3 !== a && 8 !== a && 2 !== a) return void 0 === e.getAttribute ? b.prop(e, t, n) : (1 === a && b.isXMLDoc(e) || (s = b.attrHooks[t.toLowerCase()] || (b.expr.match.bool.test(t) ? ut : void 0)), void 0 !== n ? null === n ? void b.removeAttr(e, t) : s && "set" in s && void 0 !== (i = s.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : s && "get" in s && null !== (i = s.get(e, t)) ? i : null == (i = b.find.attr(e, t)) ? void 0 : i)
            },
            attrHooks: {
                type: {
                    set: function(e, t) {
                        if (!p.radioValue && "radio" === t && x(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t), n && (e.value = n), t
                        }
                    }
                }
            },
            removeAttr: function(e, t) {
                var n, i = 0,
                    s = t && t.match(F);
                if (s && 1 === e.nodeType)
                    for (; n = s[i++];) e.removeAttribute(n)
            }
        }), ut = {
            set: function(e, t, n) {
                return !1 === t ? b.removeAttr(e, n) : e.setAttribute(n, n), n
            }
        }, b.each(b.expr.match.bool.source.match(/\w+/g), function(e, t) {
            var n = ct[t] || b.find.attr;
            ct[t] = function(e, t, i) {
                var s, a, o = t.toLowerCase();
                return i || (a = ct[o], ct[o] = s, s = null != n(e, t, i) ? o : null, ct[o] = a), s
            }
        });
        var ht = /^(?:input|select|textarea|button)$/i,
            mt = /^(?:a|area)$/i;

        function ft(e) {
            return (e.match(F) || []).join(" ")
        }

        function _t(e) {
            return e.getAttribute && e.getAttribute("class") || ""
        }

        function pt(e) {
            return Array.isArray(e) ? e : "string" == typeof e && e.match(F) || []
        }
        b.fn.extend({
            prop: function(e, t) {
                return q(this, b.prop, e, t, arguments.length > 1)
            },
            removeProp: function(e) {
                return this.each(function() {
                    delete this[b.propFix[e] || e]
                })
            }
        }), b.extend({
            prop: function(e, t, n) {
                var i, s, a = e.nodeType;
                if (3 !== a && 8 !== a && 2 !== a) return 1 === a && b.isXMLDoc(e) || (t = b.propFix[t] || t, s = b.propHooks[t]), void 0 !== n ? s && "set" in s && void 0 !== (i = s.set(e, n, t)) ? i : e[t] = n : s && "get" in s && null !== (i = s.get(e, t)) ? i : e[t]
            },
            propHooks: {
                tabIndex: {
                    get: function(e) {
                        var t = b.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : ht.test(e.nodeName) || mt.test(e.nodeName) && e.href ? 0 : -1
                    }
                }
            },
            propFix: {
                for: "htmlFor",
                class: "className"
            }
        }), p.optSelected || (b.propHooks.selected = {
            get: function(e) {
                var t = e.parentNode;
                return t && t.parentNode && t.parentNode.selectedIndex, null
            },
            set: function(e) {
                var t = e.parentNode;
                t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
            }
        }), b.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
            b.propFix[this.toLowerCase()] = this
        }), b.fn.extend({
            addClass: function(e) {
                var t, n, i, s, a, o, r, d = 0;
                if (g(e)) return this.each(function(t) {
                    b(this).addClass(e.call(this, t, _t(this)))
                });
                if ((t = pt(e)).length)
                    for (; n = this[d++];)
                        if (s = _t(n), i = 1 === n.nodeType && " " + ft(s) + " ") {
                            for (o = 0; a = t[o++];) i.indexOf(" " + a + " ") < 0 && (i += a + " ");
                            s !== (r = ft(i)) && n.setAttribute("class", r)
                        } return this
            },
            removeClass: function(e) {
                var t, n, i, s, a, o, r, d = 0;
                if (g(e)) return this.each(function(t) {
                    b(this).removeClass(e.call(this, t, _t(this)))
                });
                if (!arguments.length) return this.attr("class", "");
                if ((t = pt(e)).length)
                    for (; n = this[d++];)
                        if (s = _t(n), i = 1 === n.nodeType && " " + ft(s) + " ") {
                            for (o = 0; a = t[o++];)
                                for (; i.indexOf(" " + a + " ") > -1;) i = i.replace(" " + a + " ", " ");
                            s !== (r = ft(i)) && n.setAttribute("class", r)
                        } return this
            },
            toggleClass: function(e, t) {
                var n = typeof e,
                    i = "string" === n || Array.isArray(e);
                return "boolean" == typeof t && i ? t ? this.addClass(e) : this.removeClass(e) : g(e) ? this.each(function(n) {
                    b(this).toggleClass(e.call(this, n, _t(this), t), t)
                }) : this.each(function() {
                    var t, s, a, o;
                    if (i)
                        for (s = 0, a = b(this), o = pt(e); t = o[s++];) a.hasClass(t) ? a.removeClass(t) : a.addClass(t);
                    else void 0 !== e && "boolean" !== n || ((t = _t(this)) && K.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : K.get(this, "__className__") || ""))
                })
            },
            hasClass: function(e) {
                var t, n, i = 0;
                for (t = " " + e + " "; n = this[i++];)
                    if (1 === n.nodeType && (" " + ft(_t(n)) + " ").indexOf(t) > -1) return !0;
                return !1
            }
        });
        var gt = /\r/g;
        b.fn.extend({
            val: function(e) {
                var t, n, i, s = this[0];
                return arguments.length ? (i = g(e), this.each(function(n) {
                    var s;
                    1 === this.nodeType && (null == (s = i ? e.call(this, n, b(this).val()) : e) ? s = "" : "number" == typeof s ? s += "" : Array.isArray(s) && (s = b.map(s, function(e) {
                        return null == e ? "" : e + ""
                    })), (t = b.valHooks[this.type] || b.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, s, "value") || (this.value = s))
                })) : s ? (t = b.valHooks[s.type] || b.valHooks[s.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(s, "value")) ? n : "string" == typeof(n = s.value) ? n.replace(gt, "") : null == n ? "" : n : void 0
            }
        }), b.extend({
            valHooks: {
                option: {
                    get: function(e) {
                        var t = b.find.attr(e, "value");
                        return null != t ? t : ft(b.text(e))
                    }
                },
                select: {
                    get: function(e) {
                        var t, n, i, s = e.options,
                            a = e.selectedIndex,
                            o = "select-one" === e.type,
                            r = o ? null : [],
                            d = o ? a + 1 : s.length;
                        for (i = a < 0 ? d : o ? a : 0; i < d; i++)
                            if (((n = s[i]).selected || i === a) && !n.disabled && (!n.parentNode.disabled || !x(n.parentNode, "optgroup"))) {
                                if (t = b(n).val(), o) return t;
                                r.push(t)
                            } return r
                    },
                    set: function(e, t) {
                        for (var n, i, s = e.options, a = b.makeArray(t), o = s.length; o--;)((i = s[o]).selected = b.inArray(b.valHooks.option.get(i), a) > -1) && (n = !0);
                        return n || (e.selectedIndex = -1), a
                    }
                }
            }
        }), b.each(["radio", "checkbox"], function() {
            b.valHooks[this] = {
                set: function(e, t) {
                    if (Array.isArray(t)) return e.checked = b.inArray(b(e).val(), t) > -1
                }
            }, p.checkOn || (b.valHooks[this].get = function(e) {
                return null === e.getAttribute("value") ? "on" : e.value
            })
        }), p.focusin = "onfocusin" in n;
        var yt = /^(?:focusinfocus|focusoutblur)$/,
            vt = function(e) {
                e.stopPropagation()
            };
        b.extend(b.event, {
            trigger: function(e, t, i, s) {
                var a, o, r, d, l, u, c, h, f = [i || v],
                    _ = m.call(e, "type") ? e.type : e,
                    p = m.call(e, "namespace") ? e.namespace.split(".") : [];
                if (o = h = r = i = i || v, 3 !== i.nodeType && 8 !== i.nodeType && !yt.test(_ + b.event.triggered) && (_.indexOf(".") > -1 && (_ = (p = _.split(".")).shift(), p.sort()), l = _.indexOf(":") < 0 && "on" + _, (e = e[b.expando] ? e : new b.Event(_, "object" == typeof e && e)).isTrigger = s ? 2 : 3, e.namespace = p.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = i), t = null == t ? [e] : b.makeArray(t, [e]), c = b.event.special[_] || {}, s || !c.trigger || !1 !== c.trigger.apply(i, t))) {
                    if (!s && !c.noBubble && !y(i)) {
                        for (d = c.delegateType || _, yt.test(d + _) || (o = o.parentNode); o; o = o.parentNode) f.push(o), r = o;
                        r === (i.ownerDocument || v) && f.push(r.defaultView || r.parentWindow || n)
                    }
                    for (a = 0;
                        (o = f[a++]) && !e.isPropagationStopped();) h = o, e.type = a > 1 ? d : c.bindType || _, (u = (K.get(o, "events") || Object.create(null))[e.type] && K.get(o, "handle")) && u.apply(o, t), (u = l && o[l]) && u.apply && G(o) && (e.result = u.apply(o, t), !1 === e.result && e.preventDefault());
                    return e.type = _, s || e.isDefaultPrevented() || c._default && !1 !== c._default.apply(f.pop(), t) || !G(i) || l && g(i[_]) && !y(i) && ((r = i[l]) && (i[l] = null), b.event.triggered = _, e.isPropagationStopped() && h.addEventListener(_, vt), i[_](), e.isPropagationStopped() && h.removeEventListener(_, vt), b.event.triggered = void 0, r && (i[l] = r)), e.result
                }
            },
            simulate: function(e, t, n) {
                var i = b.extend(new b.Event, n, {
                    type: e,
                    isSimulated: !0
                });
                b.event.trigger(i, null, t)
            }
        }), b.fn.extend({
            trigger: function(e, t) {
                return this.each(function() {
                    b.event.trigger(e, t, this)
                })
            },
            triggerHandler: function(e, t) {
                var n = this[0];
                if (n) return b.event.trigger(e, t, n, !0)
            }
        }), p.focusin || b.each({
            focus: "focusin",
            blur: "focusout"
        }, function(e, t) {
            var n = function(e) {
                b.event.simulate(t, e.target, b.event.fix(e))
            };
            b.event.special[t] = {
                setup: function() {
                    var i = this.ownerDocument || this.document || this,
                        s = K.access(i, t);
                    s || i.addEventListener(e, n, !0), K.access(i, t, (s || 0) + 1)
                },
                teardown: function() {
                    var i = this.ownerDocument || this.document || this,
                        s = K.access(i, t) - 1;
                    s ? K.access(i, t, s) : (i.removeEventListener(e, n, !0), K.remove(i, t))
                }
            }
        });
        var Mt = n.location,
            Lt = {
                guid: Date.now()
            },
            wt = /\?/;
        b.parseXML = function(e) {
            var t, i;
            if (!e || "string" != typeof e) return null;
            try {
                t = (new n.DOMParser).parseFromString(e, "text/xml")
            } catch (e) {}
            return i = t && t.getElementsByTagName("parsererror")[0], t && !i || b.error("Invalid XML: " + (i ? b.map(i.childNodes, function(e) {
                return e.textContent
            }).join("\n") : e)), t
        };
        var bt = /\[\]$/,
            kt = /\r?\n/g,
            Yt = /^(?:submit|button|image|reset|file)$/i,
            Tt = /^(?:input|select|textarea|keygen)/i;

        function Dt(e, t, n, i) {
            var s;
            if (Array.isArray(t)) b.each(t, function(t, s) {
                n || bt.test(e) ? i(e, s) : Dt(e + "[" + ("object" == typeof s && null != s ? t : "") + "]", s, n, i)
            });
            else if (n || "object" !== w(t)) i(e, t);
            else
                for (s in t) Dt(e + "[" + s + "]", t[s], n, i)
        }
        b.param = function(e, t) {
            var n, i = [],
                s = function(e, t) {
                    var n = g(t) ? t() : t;
                    i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
                };
            if (null == e) return "";
            if (Array.isArray(e) || e.jquery && !b.isPlainObject(e)) b.each(e, function() {
                s(this.name, this.value)
            });
            else
                for (n in e) Dt(n, e[n], t, s);
            return i.join("&")
        }, b.fn.extend({
            serialize: function() {
                return b.param(this.serializeArray())
            },
            serializeArray: function() {
                return this.map(function() {
                    var e = b.prop(this, "elements");
                    return e ? b.makeArray(e) : this
                }).filter(function() {
                    var e = this.type;
                    return this.name && !b(this).is(":disabled") && Tt.test(this.nodeName) && !Yt.test(e) && (this.checked || !me.test(e))
                }).map(function(e, t) {
                    var n = b(this).val();
                    return null == n ? null : Array.isArray(n) ? b.map(n, function(e) {
                        return {
                            name: t.name,
                            value: e.replace(kt, "\r\n")
                        }
                    }) : {
                        name: t.name,
                        value: n.replace(kt, "\r\n")
                    }
                }).get()
            }
        });
        var St = /%20/g,
            xt = /#.*$/,
            Ht = /([?&])_=[^&]*/,
            jt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Ct = /^(?:GET|HEAD)$/,
            Pt = /^\/\//,
            Et = {},
            At = {},
            Ot = "*/".concat("*"),
            Ft = v.createElement("a");

        function $t(e) {
            return function(t, n) {
                "string" != typeof t && (n = t, t = "*");
                var i, s = 0,
                    a = t.toLowerCase().match(F) || [];
                if (g(n))
                    for (; i = a[s++];) "+" === i[0] ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n)
            }
        }

        function Wt(e, t, n, i) {
            var s = {},
                a = e === At;

            function o(r) {
                var d;
                return s[r] = !0, b.each(e[r] || [], function(e, r) {
                    var l = r(t, n, i);
                    return "string" != typeof l || a || s[l] ? a ? !(d = l) : void 0 : (t.dataTypes.unshift(l), o(l), !1)
                }), d
            }
            return o(t.dataTypes[0]) || !s["*"] && o("*")
        }

        function Nt(e, t) {
            var n, i, s = b.ajaxSettings.flatOptions || {};
            for (n in t) void 0 !== t[n] && ((s[n] ? e : i || (i = {}))[n] = t[n]);
            return i && b.extend(!0, e, i), e
        }
        Ft.href = Mt.href, b.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: Mt.origin+Mt.pathname,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Mt.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                    "*": Ot,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript"
                },
                contents: {
                    xml: /\bxml\b/,
                    html: /\bhtml/,
                    json: /\bjson\b/
                },
                responseFields: {
                    xml: "responseXML",
                    text: "responseText",
                    json: "responseJSON"
                },
                converters: {
                    "* text": String,
                    "text html": !0,
                    "text json": JSON.parse,
                    "text xml": b.parseXML
                },
                flatOptions: {
                    url: !0,
                    context: !0
                }
            },
            ajaxSetup: function(e, t) {
                return t ? Nt(Nt(e, b.ajaxSettings), t) : Nt(b.ajaxSettings, e)
            },
            ajaxPrefilter: $t(Et),
            ajaxTransport: $t(At),
            ajax: function(e, t) {
                "object" == typeof e && (t = e, e = void 0), t = t || {};
                var i, s, a, o, r, d, l, u, c, h, m = b.ajaxSetup({}, t),
                    f = m.context || m,
                    _ = m.context && (f.nodeType || f.jquery) ? b(f) : b.event,
                    p = b.Deferred(),
                    g = b.Callbacks("once memory"),
                    y = m.statusCode || {},
                    M = {},
                    L = {},
                    w = "canceled",
                    k = {
                        readyState: 0,
                        getResponseHeader: function(e) {
                            var t;
                            if (l) {
                                if (!o)
                                    for (o = {}; t = jt.exec(a);) o[t[1].toLowerCase() + " "] = (o[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                t = o[e.toLowerCase() + " "]
                            }
                            return null == t ? null : t.join(", ")
                        },
                        getAllResponseHeaders: function() {
                            return l ? a : null
                        },
                        setRequestHeader: function(e, t) {
                            return null == l && (e = L[e.toLowerCase()] = L[e.toLowerCase()] || e, M[e] = t), this
                        },
                        overrideMimeType: function(e) {
                            return null == l && (m.mimeType = e), this
                        },
                        statusCode: function(e) {
                            var t;
                            if (e)
                                if (l) k.always(e[k.status]);
                                else
                                    for (t in e) y[t] = [y[t], e[t]];
                            return this
                        },
                        abort: function(e) {
                            var t = e || w;
                            return i && i.abort(t), Y(0, t), this
                        }
                    };
                if (p.promise(k), m.url = ((e || m.url || Mt.href) + "").replace(Pt, Mt.protocol + "//"), m.type = t.method || t.type || m.method || m.type, m.dataTypes = (m.dataType || "*").toLowerCase().match(F) || [""], null == m.crossDomain) {
                    d = v.createElement("a");
                    try {
                        d.href = m.url, d.href = d.href, m.crossDomain = Ft.protocol + "//" + Ft.host != d.protocol + "//" + d.host
                    } catch (e) {
                        m.crossDomain = !0
                    }
                }
                if (m.data && m.processData && "string" != typeof m.data && (m.data = b.param(m.data, m.traditional)), Wt(Et, m, t, k), l) return k;
                for (c in (u = b.event && m.global) && 0 == b.active++ && b.event.trigger("ajaxStart"), m.type = m.type.toUpperCase(), m.hasContent = !Ct.test(m.type), s = m.url.replace(xt, ""), m.hasContent ? m.data && m.processData && 0 === (m.contentType || "").indexOf("application/x-www-form-urlencoded") && (m.data = m.data.replace(St, "+")) : (h = m.url.slice(s.length), m.data && (m.processData || "string" == typeof m.data) && (s += (wt.test(s) ? "&" : "?") + m.data, delete m.data), !1 === m.cache && (s = s.replace(Ht, "$1"), h = (wt.test(s) ? "&" : "?") + "_=" + Lt.guid++ + h), m.url = s + h), m.ifModified && (b.lastModified[s] && k.setRequestHeader("If-Modified-Since", b.lastModified[s]), b.etag[s] && k.setRequestHeader("If-None-Match", b.etag[s])), (m.data && m.hasContent && !1 !== m.contentType || t.contentType) && k.setRequestHeader("Content-Type", m.contentType), k.setRequestHeader("Accept", m.dataTypes[0] && m.accepts[m.dataTypes[0]] ? m.accepts[m.dataTypes[0]] + ("*" !== m.dataTypes[0] ? ", " + Ot + "; q=0.01" : "") : m.accepts["*"]), m.headers) k.setRequestHeader(c, m.headers[c]);
                if (m.beforeSend && (!1 === m.beforeSend.call(f, k, m) || l)) return k.abort();
                if (w = "abort", g.add(m.complete), k.done(m.success), k.fail(m.error), i = Wt(At, m, t, k)) {
                    if (k.readyState = 1, u && _.trigger("ajaxSend", [k, m]), l) return k;
                    m.async && m.timeout > 0 && (r = n.setTimeout(function() {
                        k.abort("timeout")
                    }, m.timeout));
                    try {
                        l = !1, i.send(M, Y)
                    } catch (e) {
                        if (l) throw e;
                        Y(-1, e)
                    }
                } else Y(-1, "No Transport");

                function Y(e, t, o, d) {
                    var c, h, v, M, L, w = t;
                    l || (l = !0, r && n.clearTimeout(r), i = void 0, a = d || "", k.readyState = e > 0 ? 4 : 0, c = e >= 200 && e < 300 || 304 === e, o && (M = function(e, t, n) {
                        for (var i, s, a, o, r = e.contents, d = e.dataTypes;
                            "*" === d[0];) d.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                        if (i)
                            for (s in r)
                                if (r[s] && r[s].test(i)) {
                                    d.unshift(s);
                                    break
                                } if (d[0] in n) a = d[0];
                        else {
                            for (s in n) {
                                if (!d[0] || e.converters[s + " " + d[0]]) {
                                    a = s;
                                    break
                                }
                                o || (o = s)
                            }
                            a = a || o
                        }
                        if (a) return a !== d[0] && d.unshift(a), n[a]
                    }(m, k, o)), !c && b.inArray("script", m.dataTypes) > -1 && b.inArray("json", m.dataTypes) < 0 && (m.converters["text script"] = function() {}), M = function(e, t, n, i) {
                        var s, a, o, r, d, l = {},
                            u = e.dataTypes.slice();
                        if (u[1])
                            for (o in e.converters) l[o.toLowerCase()] = e.converters[o];
                        for (a = u.shift(); a;)
                            if (e.responseFields[a] && (n[e.responseFields[a]] = t), !d && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), d = a, a = u.shift())
                                if ("*" === a) a = d;
                                else if ("*" !== d && d !== a) {
                            if (!(o = l[d + " " + a] || l["* " + a]))
                                for (s in l)
                                    if ((r = s.split(" "))[1] === a && (o = l[d + " " + r[0]] || l["* " + r[0]])) {
                                        !0 === o ? o = l[s] : !0 !== l[s] && (a = r[0], u.unshift(r[1]));
                                        break
                                    } if (!0 !== o)
                                if (o && e.throws) t = o(t);
                                else try {
                                    t = o(t)
                                } catch (e) {
                                    return {
                                        state: "parsererror",
                                        error: o ? e : "No conversion from " + d + " to " + a
                                    }
                                }
                        }
                        return {
                            state: "success",
                            data: t
                        }
                    }(m, M, k, c), c ? (m.ifModified && ((L = k.getResponseHeader("Last-Modified")) && (b.lastModified[s] = L), (L = k.getResponseHeader("etag")) && (b.etag[s] = L)), 204 === e || "HEAD" === m.type ? w = "nocontent" : 304 === e ? w = "notmodified" : (w = M.state, h = M.data, c = !(v = M.error))) : (v = w, !e && w || (w = "error", e < 0 && (e = 0))), k.status = e, k.statusText = (t || w) + "", c ? p.resolveWith(f, [h, w, k]) : p.rejectWith(f, [k, w, v]), k.statusCode(y), y = void 0, u && _.trigger(c ? "ajaxSuccess" : "ajaxError", [k, m, c ? h : v]), g.fireWith(f, [k, w]), u && (_.trigger("ajaxComplete", [k, m]), --b.active || b.event.trigger("ajaxStop")))
                }
                return k
            },
            getJSON: function(e, t, n) {
                return b.get(e, t, n, "json")
            },
            getScript: function(e, t) {
                return b.get(e, void 0, t, "script")
            }
        }), b.each(["get", "post"], function(e, t) {
            b[t] = function(e, n, i, s) {
                return g(n) && (s = s || i, i = n, n = void 0), b.ajax(b.extend({
                    url: e,
                    type: t,
                    dataType: s,
                    data: n,
                    success: i
                }, b.isPlainObject(e) && e))
            }
        }), b.ajaxPrefilter(function(e) {
            var t;
            for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "")
        }), b._evalUrl = function(e, t, n) {
            return b.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: {
                    "text script": function() {}
                },
                dataFilter: function(e) {
                    b.globalEval(e, t, n)
                }
            })
        }, b.fn.extend({
            wrapAll: function(e) {
                var t;
                return this[0] && (g(e) && (e = e.call(this[0])), t = b(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                    for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                    return e
                }).append(this)), this
            },
            wrapInner: function(e) {
                return g(e) ? this.each(function(t) {
                    b(this).wrapInner(e.call(this, t))
                }) : this.each(function() {
                    var t = b(this),
                        n = t.contents();
                    n.length ? n.wrapAll(e) : t.append(e)
                })
            },
            wrap: function(e) {
                var t = g(e);
                return this.each(function(n) {
                    b(this).wrapAll(t ? e.call(this, n) : e)
                })
            },
            unwrap: function(e) {
                return this.parent(e).not("body").each(function() {
                    b(this).replaceWith(this.childNodes)
                }), this
            }
        }), b.expr.pseudos.hidden = function(e) {
            return !b.expr.pseudos.visible(e)
        }, b.expr.pseudos.visible = function(e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
        }, b.ajaxSettings.xhr = function() {
            try {
                return new n.XMLHttpRequest
            } catch (e) {}
        };
        var zt = {
                0: 200,
                1223: 204
            },
            Rt = b.ajaxSettings.xhr();
        p.cors = !!Rt && "withCredentials" in Rt, p.ajax = Rt = !!Rt, b.ajaxTransport(function(e) {
            var t, i;
            if (p.cors || Rt && !e.crossDomain) return {
                send: function(s, a) {
                    var o, r = e.xhr();
                    if (r.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                        for (o in e.xhrFields) r[o] = e.xhrFields[o];
                    for (o in e.mimeType && r.overrideMimeType && r.overrideMimeType(e.mimeType), e.crossDomain || s["X-Requested-With"] || (s["X-Requested-With"] = "XMLHttpRequest"), s) r.setRequestHeader(o, s[o]);
                    t = function(e) {
                        return function() {
                            t && (t = i = r.onload = r.onerror = r.onabort = r.ontimeout = r.onreadystatechange = null, "abort" === e ? r.abort() : "error" === e ? "number" != typeof r.status ? a(0, "error") : a(r.status, r.statusText) : a(zt[r.status] || r.status, r.statusText, "text" !== (r.responseType || "text") || "string" != typeof r.responseText ? {
                                binary: r.response
                            } : {
                                text: r.responseText
                            }, r.getAllResponseHeaders()))
                        }
                    }, r.onload = t(), i = r.onerror = r.ontimeout = t("error"), void 0 !== r.onabort ? r.onabort = i : r.onreadystatechange = function() {
                        4 === r.readyState && n.setTimeout(function() {
                            t && i()
                        })
                    }, t = t("abort");
                    try {
                        r.send(e.hasContent && e.data || null)
                    } catch (e) {
                        if (t) throw e
                    }
                },
                abort: function() {
                    t && t()
                }
            }
        }), b.ajaxPrefilter(function(e) {
            e.crossDomain && (e.contents.script = !1)
        }), b.ajaxSetup({
            accepts: {
                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
            },
            contents: {
                script: /\b(?:java|ecma)script\b/
            },
            converters: {
                "text script": function(e) {
                    return b.globalEval(e), e
                }
            }
        }), b.ajaxPrefilter("script", function(e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
        }), b.ajaxTransport("script", function(e) {
            var t, n;
            if (e.crossDomain || e.scriptAttrs) return {
                send: function(i, s) {
                    t = b("<script>").attr(e.scriptAttrs || {}).prop({
                        charset: e.scriptCharset,
                        src: e.url
                    }).on("load error", n = function(e) {
                        t.remove(), n = null, e && s("error" === e.type ? 404 : 200, e.type)
                    }), v.head.appendChild(t[0])
                },
                abort: function() {
                    n && n()
                }
            }
        });
        var It = [],
            qt = /(=)\?(?=&|$)|\?\?/;
        b.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function() {
                var e = It.pop() || b.expando + "_" + Lt.guid++;
                return this[e] = !0, e
            }
        }), b.ajaxPrefilter("json jsonp", function(e, t, i) {
            var s, a, o, r = !1 !== e.jsonp && (qt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && qt.test(e.data) && "data");
            if (r || "jsonp" === e.dataTypes[0]) return s = e.jsonpCallback = g(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, r ? e[r] = e[r].replace(qt, "$1" + s) : !1 !== e.jsonp && (e.url += (wt.test(e.url) ? "&" : "?") + e.jsonp + "=" + s), e.converters["script json"] = function() {
                return o || b.error(s + " was not called"), o[0]
            }, e.dataTypes[0] = "json", a = n[s], n[s] = function() {
                o = arguments
            }, i.always(function() {
                void 0 === a ? b(n).removeProp(s) : n[s] = a, e[s] && (e.jsonpCallback = t.jsonpCallback, It.push(s)), o && g(a) && a(o[0]), o = a = void 0
            }), "script"
        }), p.createHTMLDocument = function() {
            var e = v.implementation.createHTMLDocument("").body;
            return e.innerHTML = "<form></form><form></form>", 2 === e.childNodes.length
        }(), b.parseHTML = function(e, t, n) {
            return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (p.createHTMLDocument ? ((i = (t = v.implementation.createHTMLDocument("")).createElement("base")).href = v.location.href, t.head.appendChild(i)) : t = v), s = H.exec(e), a = !n && [], s ? [t.createElement(s[1])] : (s = Me([e], t, a), a && a.length && b(a).remove(), b.merge([], s.childNodes)));
            var i, s, a
        }, b.fn.load = function(e, t, n) {
            var i, s, a, o = this,
                r = e.indexOf(" ");
            return r > -1 && (i = ft(e.slice(r)), e = e.slice(0, r)), g(t) ? (n = t, t = void 0) : t && "object" == typeof t && (s = "POST"), o.length > 0 && b.ajax({
                url: e,
                type: s || "GET",
                dataType: "html",
                data: t
            }).done(function(e) {
                a = arguments, o.html(i ? b("<div>").append(b.parseHTML(e)).find(i) : e)
            }).always(n && function(e, t) {
                o.each(function() {
                    n.apply(this, a || [e.responseText, t, e])
                })
            }), this
        }, b.expr.pseudos.animated = function(e) {
            return b.grep(b.timers, function(t) {
                return e === t.elem
            }).length
        }, b.offset = {
            setOffset: function(e, t, n) {
                var i, s, a, o, r, d, l = b.css(e, "position"),
                    u = b(e),
                    c = {};
                "static" === l && (e.style.position = "relative"), r = u.offset(), a = b.css(e, "top"), d = b.css(e, "left"), ("absolute" === l || "fixed" === l) && (a + d).indexOf("auto") > -1 ? (o = (i = u.position()).top, s = i.left) : (o = parseFloat(a) || 0, s = parseFloat(d) || 0), g(t) && (t = t.call(e, n, b.extend({}, r))), null != t.top && (c.top = t.top - r.top + o), null != t.left && (c.left = t.left - r.left + s), "using" in t ? t.using.call(e, c) : u.css(c)
            }
        }, b.fn.extend({
            offset: function(e) {
                if (arguments.length) return void 0 === e ? this : this.each(function(t) {
                    b.offset.setOffset(this, e, t)
                });
                var t, n, i = this[0];
                return i ? i.getClientRects().length ? (t = i.getBoundingClientRect(), n = i.ownerDocument.defaultView, {
                    top: t.top + n.pageYOffset,
                    left: t.left + n.pageXOffset
                }) : {
                    top: 0,
                    left: 0
                } : void 0
            },
            position: function() {
                if (this[0]) {
                    var e, t, n, i = this[0],
                        s = {
                            top: 0,
                            left: 0
                        };
                    if ("fixed" === b.css(i, "position")) t = i.getBoundingClientRect();
                    else {
                        for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === b.css(e, "position");) e = e.parentNode;
                        e && e !== i && 1 === e.nodeType && ((s = b(e).offset()).top += b.css(e, "borderTopWidth", !0), s.left += b.css(e, "borderLeftWidth", !0))
                    }
                    return {
                        top: t.top - s.top - b.css(i, "marginTop", !0),
                        left: t.left - s.left - b.css(i, "marginLeft", !0)
                    }
                }
            },
            offsetParent: function() {
                return this.map(function() {
                    for (var e = this.offsetParent; e && "static" === b.css(e, "position");) e = e.offsetParent;
                    return e || ae
                })
            }
        }), b.each({
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset"
        }, function(e, t) {
            var n = "pageYOffset" === t;
            b.fn[e] = function(i) {
                return q(this, function(e, i, s) {
                    var a;
                    if (y(e) ? a = e : 9 === e.nodeType && (a = e.defaultView), void 0 === s) return a ? a[t] : e[i];
                    a ? a.scrollTo(n ? a.pageXOffset : s, n ? s : a.pageYOffset) : e[i] = s
                }, e, i, arguments.length)
            }
        }), b.each(["top", "left"], function(e, t) {
            b.cssHooks[t] = Re(p.pixelPosition, function(e, n) {
                if (n) return n = ze(e, t), Fe.test(n) ? b(e).position()[t] + "px" : n
            })
        }), b.each({
            Height: "height",
            Width: "width"
        }, function(e, t) {
            b.each({
                padding: "inner" + e,
                content: t,
                "": "outer" + e
            }, function(n, i) {
                b.fn[i] = function(s, a) {
                    var o = arguments.length && (n || "boolean" != typeof s),
                        r = n || (!0 === s || !0 === a ? "margin" : "border");
                    return q(this, function(t, n, s) {
                        var a;
                        return y(t) ? 0 === i.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (a = t.documentElement, Math.max(t.body["scroll" + e], a["scroll" + e], t.body["offset" + e], a["offset" + e], a["client" + e])) : void 0 === s ? b.css(t, n, r) : b.style(t, n, s, r)
                    }, t, o ? s : void 0, o)
                }
            })
        }), b.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
            b.fn[t] = function(e) {
                return this.on(t, e)
            }
        }), b.fn.extend({
            bind: function(e, t, n) {
                return this.on(e, null, t, n)
            },
            unbind: function(e, t) {
                return this.off(e, null, t)
            },
            delegate: function(e, t, n, i) {
                return this.on(t, e, n, i)
            },
            undelegate: function(e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
            },
            hover: function(e, t) {
                return this.mouseenter(e).mouseleave(t || e)
            }
        }), b.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
            b.fn[t] = function(e, n) {
                return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
            }
        });
        var Bt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        b.proxy = function(e, t) {
            var n, i, s;
            if ("string" == typeof t && (n = e[t], t = e, e = n), g(e)) return i = r.call(arguments, 2), (s = function() {
                return e.apply(t || this, i.concat(r.call(arguments)))
            }).guid = e.guid = e.guid || b.guid++, s
        }, b.holdReady = function(e) {
            e ? b.readyWait++ : b.ready(!0)
        }, b.isArray = Array.isArray, b.parseJSON = JSON.parse, b.nodeName = x, b.isFunction = g, b.isWindow = y, b.camelCase = V, b.type = w, b.now = Date.now, b.isNumeric = function(e) {
            var t = b.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
        }, b.trim = function(e) {
            return null == e ? "" : (e + "").replace(Bt, "")
        }, void 0 === (i = function() {
            return b
        }.apply(t, [])) || (e.exports = i);
        var Ut = n.jQuery,
            Jt = n.$;
        return b.noConflict = function(e) {
            return n.$ === b && (n.$ = Jt), e && n.jQuery === b && (n.jQuery = Ut), b
        }, void 0 === s && (n.jQuery = n.$ = b), b
    })
}, function(e, t, n) {
    var i = n(152);
    e.exports = new i
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    t.bp = {
        maxMobile: 480,
        Tablet: 768,
        minDesktop: 1024
    }, t.debounce = function(e, t, n) {
        var i;
        return function() {
            var s = this,
                a = arguments,
                o = n && !i;
            clearTimeout(i), i = setTimeout(function() {
                i = null, n || e.apply(s, a)
            }, t), o && e.apply(s, a)
        }
    }, t.animateFigure = function(e) {
        var t, n = parseFloat(e.data("figure"));
        (e = e.find(".figure")).text("0000");
        var i = n / 20;
        n > 0 && i < 1 && (i = 1), t = setInterval(function() {
            var s = parseFloat(e.text());
            s += i, s = Math.round(s), e.text(s), parseFloat(s + i) >= n && (e.text(n), clearInterval(t))
        }, 50)
    }
}, function(e, t, n) {
    var i, s, a;
    ! function(o) {
        "use strict";
        s = [n(1)], void 0 === (a = "function" == typeof(i = function(e) {
            var t = window.Slick || {};
            (t = function() {
                var t = 0;
                return function(n, i) {
                    var s, a = this;
                    a.defaults = {
                        accessibility: !0,
                        adaptiveHeight: !1,
                        appendArrows: e(n),
                        appendDots: e(n),
                        arrows: !0,
                        asNavFor: null,
                        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                        autoplay: !1,
                        autoplaySpeed: 3e3,
                        centerMode: !1,
                        centerPadding: "50px",
                        cssEase: "ease",
                        customPaging: function(t, n) {
                            return e('<button type="button" />').text(n + 1)
                        },
                        dots: !1,
                        dotsClass: "slick-dots",
                        draggable: !0,
                        easing: "linear",
                        edgeFriction: .35,
                        fade: !1,
                        focusOnSelect: !1,
                        focusOnChange: !1,
                        infinite: !0,
                        initialSlide: 0,
                        lazyLoad: "ondemand",
                        mobileFirst: !1,
                        pauseOnHover: !0,
                        pauseOnFocus: !0,
                        pauseOnDotsHover: !1,
                        respondTo: "window",
                        responsive: null,
                        rows: 1,
                        rtl: !1,
                        slide: "",
                        slidesPerRow: 1,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 500,
                        swipe: !0,
                        swipeToSlide: !1,
                        touchMove: !0,
                        touchThreshold: 5,
                        useCSS: !0,
                        useTransform: !0,
                        variableWidth: !1,
                        vertical: !1,
                        verticalSwiping: !1,
                        waitForAnimate: !0,
                        zIndex: 1e3
                    }, a.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        scrolling: !1,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        swiping: !1,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1
                    }, e.extend(a, a.initials), a.activeBreakpoint = null, a.animType = null, a.animProp = null, a.breakpoints = [], a.breakpointSettings = [], a.cssTransitions = !1, a.focussed = !1, a.interrupted = !1, a.hidden = "hidden", a.paused = !0, a.positionProp = null, a.respondTo = null, a.rowCount = 1, a.shouldClick = !0, a.$slider = e(n), a.$slidesCache = null, a.transformType = null, a.transitionType = null, a.visibilityChange = "visibilitychange", a.windowWidth = 0, a.windowTimer = null, s = e(n).data("slick") || {}, a.options = e.extend({}, a.defaults, i, s), a.currentSlide = a.options.initialSlide, a.originalSettings = a.options, void 0 !== document.mozHidden ? (a.hidden = "mozHidden", a.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (a.hidden = "webkitHidden", a.visibilityChange = "webkitvisibilitychange");
                    a.autoPlay = e.proxy(a.autoPlay, a), a.autoPlayClear = e.proxy(a.autoPlayClear, a), a.autoPlayIterator = e.proxy(a.autoPlayIterator, a), a.changeSlide = e.proxy(a.changeSlide, a), a.clickHandler = e.proxy(a.clickHandler, a), a.selectHandler = e.proxy(a.selectHandler, a), a.setPosition = e.proxy(a.setPosition, a), a.swipeHandler = e.proxy(a.swipeHandler, a), a.dragHandler = e.proxy(a.dragHandler, a), a.keyHandler = e.proxy(a.keyHandler, a), a.instanceUid = t++, a.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, a.registerBreakpoints(), a.init(!0)
                }
            }()).prototype.activateADA = function() {
                this.$slideTrack.find(".slick-active").attr({
                    "aria-hidden": "false"
                }).find("a, input, button, select").attr({
                    tabindex: "0"
                })
            }, t.prototype.addSlide = t.prototype.slickAdd = function(t, n, i) {
                var s = this;
                if ("boolean" == typeof n) i = n, n = null;
                else if (n < 0 || n >= s.slideCount) return !1;
                s.unload(), "number" == typeof n ? 0 === n && 0 === s.$slides.length ? e(t).appendTo(s.$slideTrack) : i ? e(t).insertBefore(s.$slides.eq(n)) : e(t).insertAfter(s.$slides.eq(n)) : !0 === i ? e(t).prependTo(s.$slideTrack) : e(t).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function(t, n) {
                    e(n).attr("data-slick-index", t)
                }), s.$slidesCache = s.$slides, s.reinit()
            }, t.prototype.animateHeight = function() {
                var e = this;
                if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                    var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                    e.$list.animate({
                        height: t
                    }, e.options.speed)
                }
            }, t.prototype.animateSlide = function(t, n) {
                var i = {},
                    s = this;
                s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (t = -t), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
                    left: t
                }, s.options.speed, s.options.easing, n) : s.$slideTrack.animate({
                    top: t
                }, s.options.speed, s.options.easing, n) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), e({
                    animStart: s.currentLeft
                }).animate({
                    animStart: t
                }, {
                    duration: s.options.speed,
                    easing: s.options.easing,
                    step: function(e) {
                        e = Math.ceil(e), !1 === s.options.vertical ? (i[s.animType] = "translate(" + e + "px, 0px)", s.$slideTrack.css(i)) : (i[s.animType] = "translate(0px," + e + "px)", s.$slideTrack.css(i))
                    },
                    complete: function() {
                        n && n.call()
                    }
                })) : (s.applyTransition(), t = Math.ceil(t), !1 === s.options.vertical ? i[s.animType] = "translate3d(" + t + "px, 0px, 0px)" : i[s.animType] = "translate3d(0px," + t + "px, 0px)", s.$slideTrack.css(i), n && setTimeout(function() {
                    s.disableTransition(), n.call()
                }, s.options.speed))
            }, t.prototype.getNavTarget = function() {
                var t = this.options.asNavFor;
                return t && null !== t && (t = e(t).not(this.$slider)), t
            }, t.prototype.asNavFor = function(t) {
                var n = this.getNavTarget();
                null !== n && "object" == typeof n && n.each(function() {
                    var n = e(this).slick("getSlick");
                    n.unslicked || n.slideHandler(t, !0)
                })
            }, t.prototype.applyTransition = function(e) {
                var t = this,
                    n = {};
                !1 === t.options.fade ? n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase, !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
            }, t.prototype.autoPlay = function() {
                var e = this;
                e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
            }, t.prototype.autoPlayClear = function() {
                this.autoPlayTimer && clearInterval(this.autoPlayTimer)
            }, t.prototype.autoPlayIterator = function() {
                var e = this,
                    t = e.currentSlide + e.options.slidesToScroll;
                e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t))
            }, t.prototype.buildArrows = function() {
                var t = this;
                !0 === t.options.arrows && (t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow"), t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow"), t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows), !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
                    "aria-disabled": "true",
                    tabindex: "-1"
                }))
            }, t.prototype.buildDots = function() {
                var t, n, i = this;
                if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
                    for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
                    i.$dots = n.appendTo(i.options.appendDots), i.$dots.find("li").first().addClass("slick-active")
                }
            }, t.prototype.buildOut = function() {
                var t = this;
                t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), t.slideCount = t.$slides.length, t.$slides.each(function(t, n) {
                    e(n).attr("data-slick-index", t).data("originalStyling", e(n).attr("style") || "")
                }), t.$slider.addClass("slick-slider"), t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(), t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent(), t.$slideTrack.css("opacity", 0), !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1), e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"), t.setupInfinite(), t.buildArrows(), t.buildDots(), t.updateDots(), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), !0 === t.options.draggable && t.$list.addClass("draggable")
            }, t.prototype.buildRows = function() {
                var e, t, n, i, s, a, o, r = this;
                if (i = document.createDocumentFragment(), a = r.$slider.children(), r.options.rows > 0) {
                    for (o = r.options.slidesPerRow * r.options.rows, s = Math.ceil(a.length / o), e = 0; e < s; e++) {
                        var d = document.createElement("div");
                        for (t = 0; t < r.options.rows; t++) {
                            var l = document.createElement("div");
                            for (n = 0; n < r.options.slidesPerRow; n++) {
                                var u = e * o + (t * r.options.slidesPerRow + n);
                                a.get(u) && l.appendChild(a.get(u))
                            }
                            d.appendChild(l)
                        }
                        i.appendChild(d)
                    }
                    r.$slider.empty().append(i), r.$slider.children().children().children().css({
                        width: 100 / r.options.slidesPerRow + "%",
                        display: "inline-block"
                    })
                }
            }, t.prototype.checkResponsive = function(t, n) {
                var i, s, a, o = this,
                    r = !1,
                    d = o.$slider.width(),
                    l = window.innerWidth || e(window).width();
                if ("window" === o.respondTo ? a = l : "slider" === o.respondTo ? a = d : "min" === o.respondTo && (a = Math.min(l, d)), o.options.responsive && o.options.responsive.length && null !== o.options.responsive) {
                    for (i in s = null, o.breakpoints) o.breakpoints.hasOwnProperty(i) && (!1 === o.originalSettings.mobileFirst ? a < o.breakpoints[i] && (s = o.breakpoints[i]) : a > o.breakpoints[i] && (s = o.breakpoints[i]));
                    null !== s ? null !== o.activeBreakpoint ? (s !== o.activeBreakpoint || n) && (o.activeBreakpoint = s, "unslick" === o.breakpointSettings[s] ? o.unslick(s) : (o.options = e.extend({}, o.originalSettings, o.breakpointSettings[s]), !0 === t && (o.currentSlide = o.options.initialSlide), o.refresh(t)), r = s) : (o.activeBreakpoint = s, "unslick" === o.breakpointSettings[s] ? o.unslick(s) : (o.options = e.extend({}, o.originalSettings, o.breakpointSettings[s]), !0 === t && (o.currentSlide = o.options.initialSlide), o.refresh(t)), r = s) : null !== o.activeBreakpoint && (o.activeBreakpoint = null, o.options = o.originalSettings, !0 === t && (o.currentSlide = o.options.initialSlide), o.refresh(t), r = s), t || !1 === r || o.$slider.trigger("breakpoint", [o, r])
                }
            }, t.prototype.changeSlide = function(t, n) {
                var i, s, a, o = this,
                    r = e(t.currentTarget);
                switch (r.is("a") && t.preventDefault(), r.is("li") || (r = r.closest("li")), a = o.slideCount % o.options.slidesToScroll != 0, i = a ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll, t.data.message) {
                    case "previous":
                        s = 0 === i ? o.options.slidesToScroll : o.options.slidesToShow - i, o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - s, !1, n);
                        break;
                    case "next":
                        s = 0 === i ? o.options.slidesToScroll : i, o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + s, !1, n);
                        break;
                    case "index":
                        var d = 0 === t.data.index ? 0 : t.data.index || r.index() * o.options.slidesToScroll;
                        o.slideHandler(o.checkNavigable(d), !1, n), r.children().trigger("focus");
                        break;
                    default:
                        return
                }
            }, t.prototype.checkNavigable = function(e) {
                var t, n;
                if (t = this.getNavigableIndexes(), n = 0, e > t[t.length - 1]) e = t[t.length - 1];
                else
                    for (var i in t) {
                        if (e < t[i]) {
                            e = n;
                            break
                        }
                        n = t[i]
                    }
                return e
            }, t.prototype.cleanUpEvents = function() {
                var t = this;
                t.options.dots && null !== t.$dots && (e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)), !0 === t.options.accessibility && t.$dots.off("keydown.slick", t.keyHandler)), t.$slider.off("focus.slick blur.slick"), !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide), !0 === t.options.accessibility && (t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler), t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler))), t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler), t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler), t.$list.off("touchend.slick mouseup.slick", t.swipeHandler), t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler), t.$list.off("click.slick", t.clickHandler), e(document).off(t.visibilityChange, t.visibility), t.cleanUpSlideEvents(), !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler), e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange), e(window).off("resize.slick.slick-" + t.instanceUid, t.resize), e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault), e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition)
            }, t.prototype.cleanUpSlideEvents = function() {
                var t = this;
                t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1))
            }, t.prototype.cleanUpRows = function() {
                var e, t = this;
                t.options.rows > 0 && ((e = t.$slides.children().children()).removeAttr("style"), t.$slider.empty().append(e))
            }, t.prototype.clickHandler = function(e) {
                !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault())
            }, t.prototype.destroy = function(t) {
                var n = this;
                n.autoPlayClear(), n.touchObject = {}, n.cleanUpEvents(), e(".slick-cloned", n.$slider).detach(), n.$dots && n.$dots.remove(), n.$prevArrow && n.$prevArrow.length && (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()), n.$nextArrow && n.$nextArrow.length && (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()), n.$slides && (n.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
                    e(this).attr("style", e(this).data("originalStyling"))
                }), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.detach(), n.$list.detach(), n.$slider.append(n.$slides)), n.cleanUpRows(), n.$slider.removeClass("slick-slider"), n.$slider.removeClass("slick-initialized"), n.$slider.removeClass("slick-dotted"), n.unslicked = !0, t || n.$slider.trigger("destroy", [n])
            }, t.prototype.disableTransition = function(e) {
                var t = this,
                    n = {};
                n[t.transitionType] = "", !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
            }, t.prototype.fadeSlide = function(e, t) {
                var n = this;
                !1 === n.cssTransitions ? (n.$slides.eq(e).css({
                    zIndex: n.options.zIndex
                }), n.$slides.eq(e).animate({
                    opacity: 1
                }, n.options.speed, n.options.easing, t)) : (n.applyTransition(e), n.$slides.eq(e).css({
                    opacity: 1,
                    zIndex: n.options.zIndex
                }), t && setTimeout(function() {
                    n.disableTransition(e), t.call()
                }, n.options.speed))
            }, t.prototype.fadeSlideOut = function(e) {
                var t = this;
                !1 === t.cssTransitions ? t.$slides.eq(e).animate({
                    opacity: 0,
                    zIndex: t.options.zIndex - 2
                }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({
                    opacity: 0,
                    zIndex: t.options.zIndex - 2
                }))
            }, t.prototype.filterSlides = t.prototype.slickFilter = function(e) {
                var t = this;
                null !== e && (t.$slidesCache = t.$slides, t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit())
            }, t.prototype.focusHandler = function() {
                var t = this;
                t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(n) {
                    n.stopImmediatePropagation();
                    var i = e(this);
                    setTimeout(function() {
                        t.options.pauseOnFocus && (t.focussed = i.is(":focus"), t.autoPlay())
                    }, 0)
                })
            }, t.prototype.getCurrent = t.prototype.slickCurrentSlide = function() {
                return this.currentSlide
            }, t.prototype.getDotCount = function() {
                var e = this,
                    t = 0,
                    n = 0,
                    i = 0;
                if (!0 === e.options.infinite)
                    if (e.slideCount <= e.options.slidesToShow) ++i;
                    else
                        for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
                else if (!0 === e.options.centerMode) i = e.slideCount;
                else if (e.options.asNavFor)
                    for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
                else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                return i - 1
            }, t.prototype.getLeft = function(e) {
                var t, n, i, s, a = this,
                    o = 0;
                return a.slideOffset = 0, n = a.$slides.first().outerHeight(!0), !0 === a.options.infinite ? (a.slideCount > a.options.slidesToShow && (a.slideOffset = a.slideWidth * a.options.slidesToShow * -1, s = -1, !0 === a.options.vertical && !0 === a.options.centerMode && (2 === a.options.slidesToShow ? s = -1.5 : 1 === a.options.slidesToShow && (s = -2)), o = n * a.options.slidesToShow * s), a.slideCount % a.options.slidesToScroll != 0 && e + a.options.slidesToScroll > a.slideCount && a.slideCount > a.options.slidesToShow && (e > a.slideCount ? (a.slideOffset = (a.options.slidesToShow - (e - a.slideCount)) * a.slideWidth * -1, o = (a.options.slidesToShow - (e - a.slideCount)) * n * -1) : (a.slideOffset = a.slideCount % a.options.slidesToScroll * a.slideWidth * -1, o = a.slideCount % a.options.slidesToScroll * n * -1))) : e + a.options.slidesToShow > a.slideCount && (a.slideOffset = (e + a.options.slidesToShow - a.slideCount) * a.slideWidth, o = (e + a.options.slidesToShow - a.slideCount) * n), a.slideCount <= a.options.slidesToShow && (a.slideOffset = 0, o = 0), !0 === a.options.centerMode && a.slideCount <= a.options.slidesToShow ? a.slideOffset = a.slideWidth * Math.floor(a.options.slidesToShow) / 2 - a.slideWidth * a.slideCount / 2 : !0 === a.options.centerMode && !0 === a.options.infinite ? a.slideOffset += a.slideWidth * Math.floor(a.options.slidesToShow / 2) - a.slideWidth : !0 === a.options.centerMode && (a.slideOffset = 0, a.slideOffset += a.slideWidth * Math.floor(a.options.slidesToShow / 2)), t = !1 === a.options.vertical ? e * a.slideWidth * -1 + a.slideOffset : e * n * -1 + o, !0 === a.options.variableWidth && (i = a.slideCount <= a.options.slidesToShow || !1 === a.options.infinite ? a.$slideTrack.children(".slick-slide").eq(e) : a.$slideTrack.children(".slick-slide").eq(e + a.options.slidesToShow), t = !0 === a.options.rtl ? i[0] ? -1 * (a.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, !0 === a.options.centerMode && (i = a.slideCount <= a.options.slidesToShow || !1 === a.options.infinite ? a.$slideTrack.children(".slick-slide").eq(e) : a.$slideTrack.children(".slick-slide").eq(e + a.options.slidesToShow + 1), t = !0 === a.options.rtl ? i[0] ? -1 * (a.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, t += (a.$list.width() - i.outerWidth()) / 2)), t
            }, t.prototype.getOption = t.prototype.slickGetOption = function(e) {
                return this.options[e]
            }, t.prototype.getNavigableIndexes = function() {
                var e, t = this,
                    n = 0,
                    i = 0,
                    s = [];
                for (!1 === t.options.infinite ? e = t.slideCount : (n = -1 * t.options.slidesToScroll, i = -1 * t.options.slidesToScroll, e = 2 * t.slideCount); n < e;) s.push(n), n = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
                return s
            }, t.prototype.getSlick = function() {
                return this
            }, t.prototype.getSlideCount = function() {
                var t, n, i = this;
                return n = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0, !0 === i.options.swipeToSlide ? (i.$slideTrack.find(".slick-slide").each(function(s, a) {
                    if (a.offsetLeft - n + e(a).outerWidth() / 2 > -1 * i.swipeLeft) return t = a, !1
                }), Math.abs(e(t).attr("data-slick-index") - i.currentSlide) || 1) : i.options.slidesToScroll
            }, t.prototype.goTo = t.prototype.slickGoTo = function(e, t) {
                this.changeSlide({
                    data: {
                        message: "index",
                        index: parseInt(e)
                    }
                }, t)
            }, t.prototype.init = function(t) {
                var n = this;
                e(n.$slider).hasClass("slick-initialized") || (e(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()), t && n.$slider.trigger("init", [n]), !0 === n.options.accessibility && n.initADA(), n.options.autoplay && (n.paused = !1, n.autoPlay())
            }, t.prototype.initADA = function() {
                var t = this,
                    n = Math.ceil(t.slideCount / t.options.slidesToShow),
                    i = t.getNavigableIndexes().filter(function(e) {
                        return e >= 0 && e < t.slideCount
                    });
                t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
                    "aria-hidden": "true",
                    tabindex: "-1"
                }).find("a, input, button, select").attr({
                    tabindex: "-1"
                }), null !== t.$dots && (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(n) {
                    var s = i.indexOf(n);
                    if (e(this).attr({
                            role: "tabpanel",
                            id: "slick-slide" + t.instanceUid + n,
                            tabindex: -1
                        }), -1 !== s) {
                        var a = "slick-slide-control" + t.instanceUid + s;
                        e("#" + a).length && e(this).attr({
                            "aria-describedby": a
                        })
                    }
                }), t.$dots.attr("role", "tablist").find("li").each(function(s) {
                    var a = i[s];
                    e(this).attr({
                        role: "presentation"
                    }), e(this).find("button").first().attr({
                        role: "tab",
                        id: "slick-slide-control" + t.instanceUid + s,
                        "aria-controls": "slick-slide" + t.instanceUid + a,
                        "aria-label": s + 1 + " of " + n,
                        "aria-selected": null,
                        tabindex: "-1"
                    })
                }).eq(t.currentSlide).find("button").attr({
                    "aria-selected": "true",
                    tabindex: "0"
                }).end());
                for (var s = t.currentSlide, a = s + t.options.slidesToShow; s < a; s++) t.options.focusOnChange ? t.$slides.eq(s).attr({
                    tabindex: "0"
                }) : t.$slides.eq(s).removeAttr("tabindex");
                t.activateADA()
            }, t.prototype.initArrowEvents = function() {
                var e = this;
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", {
                    message: "previous"
                }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", {
                    message: "next"
                }, e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)))
            }, t.prototype.initDotEvents = function() {
                var t = this;
                !0 === t.options.dots && t.slideCount > t.options.slidesToShow && (e("li", t.$dots).on("click.slick", {
                    message: "index"
                }, t.changeSlide), !0 === t.options.accessibility && t.$dots.on("keydown.slick", t.keyHandler)), !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && t.slideCount > t.options.slidesToShow && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1))
            }, t.prototype.initSlideEvents = function() {
                var t = this;
                t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)))
            }, t.prototype.initializeEvents = function() {
                var t = this;
                t.initArrowEvents(), t.initDotEvents(), t.initSlideEvents(), t.$list.on("touchstart.slick mousedown.slick", {
                    action: "start"
                }, t.swipeHandler), t.$list.on("touchmove.slick mousemove.slick", {
                    action: "move"
                }, t.swipeHandler), t.$list.on("touchend.slick mouseup.slick", {
                    action: "end"
                }, t.swipeHandler), t.$list.on("touchcancel.slick mouseleave.slick", {
                    action: "end"
                }, t.swipeHandler), t.$list.on("click.slick", t.clickHandler), e(document).on(t.visibilityChange, e.proxy(t.visibility, t)), !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)), e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)), e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault), e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition), e(t.setPosition)
            }, t.prototype.initUI = function() {
                var e = this;
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show()
            }, t.prototype.keyHandler = function(e) {
                var t = this;
                e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({
                    data: {
                        message: !0 === t.options.rtl ? "next" : "previous"
                    }
                }) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({
                    data: {
                        message: !0 === t.options.rtl ? "previous" : "next"
                    }
                }))
            }, t.prototype.lazyLoad = function() {
                var t, n, i, s = this;

                function a(t) {
                    e("img[data-lazy]", t).each(function() {
                        var t = e(this),
                            n = e(this).attr("data-lazy"),
                            i = e(this).attr("data-srcset"),
                            a = e(this).attr("data-sizes") || s.$slider.attr("data-sizes"),
                            o = document.createElement("img");
                        o.onload = function() {
                            t.animate({
                                opacity: 0
                            }, 100, function() {
                                i && (t.attr("srcset", i), a && t.attr("sizes", a)), t.attr("src", n).animate({
                                    opacity: 1
                                }, 200, function() {
                                    t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                                }), s.$slider.trigger("lazyLoaded", [s, t, n])
                            })
                        }, o.onerror = function() {
                            t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, t, n])
                        }, o.src = n
                    })
                }
                if (!0 === s.options.centerMode ? !0 === s.options.infinite ? (n = s.currentSlide + (s.options.slidesToShow / 2 + 1), i = n + s.options.slidesToShow + 2) : (n = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1)), i = s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide) : (n = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide, i = Math.ceil(n + s.options.slidesToShow), !0 === s.options.fade && (n > 0 && n--, i <= s.slideCount && i++)), t = s.$slider.find(".slick-slide").slice(n, i), "anticipated" === s.options.lazyLoad)
                    for (var o = n - 1, r = i, d = s.$slider.find(".slick-slide"), l = 0; l < s.options.slidesToScroll; l++) o < 0 && (o = s.slideCount - 1), t = (t = t.add(d.eq(o))).add(d.eq(r)), o--, r++;
                a(t), s.slideCount <= s.options.slidesToShow ? a(s.$slider.find(".slick-slide")) : s.currentSlide >= s.slideCount - s.options.slidesToShow ? a(s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow)) : 0 === s.currentSlide && a(s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow))
            }, t.prototype.loadSlider = function() {
                var e = this;
                e.setPosition(), e.$slideTrack.css({
                    opacity: 1
                }), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad()
            }, t.prototype.next = t.prototype.slickNext = function() {
                this.changeSlide({
                    data: {
                        message: "next"
                    }
                })
            }, t.prototype.orientationChange = function() {
                this.checkResponsive(), this.setPosition()
            }, t.prototype.pause = t.prototype.slickPause = function() {
                this.autoPlayClear(), this.paused = !0
            }, t.prototype.play = t.prototype.slickPlay = function() {
                var e = this;
                e.autoPlay(), e.options.autoplay = !0, e.paused = !1, e.focussed = !1, e.interrupted = !1
            }, t.prototype.postSlide = function(t) {
                var n = this;
                if (!n.unslicked && (n.$slider.trigger("afterChange", [n, t]), n.animating = !1, n.slideCount > n.options.slidesToShow && n.setPosition(), n.swipeLeft = null, n.options.autoplay && n.autoPlay(), !0 === n.options.accessibility && (n.initADA(), n.options.focusOnChange))) {
                    var i = e(n.$slides.get(n.currentSlide));
                    i.attr("tabindex", 0).focus()
                }
            }, t.prototype.prev = t.prototype.slickPrev = function() {
                this.changeSlide({
                    data: {
                        message: "previous"
                    }
                })
            }, t.prototype.preventDefault = function(e) {
                e.preventDefault()
            }, t.prototype.progressiveLazyLoad = function(t) {
                t = t || 1;
                var n, i, s, a, o, r = this,
                    d = e("img[data-lazy]", r.$slider);
                d.length ? (n = d.first(), i = n.attr("data-lazy"), s = n.attr("data-srcset"), a = n.attr("data-sizes") || r.$slider.attr("data-sizes"), (o = document.createElement("img")).onload = function() {
                    s && (n.attr("srcset", s), a && n.attr("sizes", a)), n.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === r.options.adaptiveHeight && r.setPosition(), r.$slider.trigger("lazyLoaded", [r, n, i]), r.progressiveLazyLoad()
                }, o.onerror = function() {
                    t < 3 ? setTimeout(function() {
                        r.progressiveLazyLoad(t + 1)
                    }, 500) : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, n, i]), r.progressiveLazyLoad())
                }, o.src = i) : r.$slider.trigger("allImagesLoaded", [r])
            }, t.prototype.refresh = function(t) {
                var n, i, s = this;
                i = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > i && (s.currentSlide = i), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), n = s.currentSlide, s.destroy(!0), e.extend(s, s.initials, {
                    currentSlide: n
                }), s.init(), t || s.changeSlide({
                    data: {
                        message: "index",
                        index: n
                    }
                }, !1)
            }, t.prototype.registerBreakpoints = function() {
                var t, n, i, s = this,
                    a = s.options.responsive || null;
                if ("array" === e.type(a) && a.length) {
                    for (t in s.respondTo = s.options.respondTo || "window", a)
                        if (i = s.breakpoints.length - 1, a.hasOwnProperty(t)) {
                            for (n = a[t].breakpoint; i >= 0;) s.breakpoints[i] && s.breakpoints[i] === n && s.breakpoints.splice(i, 1), i--;
                            s.breakpoints.push(n), s.breakpointSettings[n] = a[t].settings
                        } s.breakpoints.sort(function(e, t) {
                        return s.options.mobileFirst ? e - t : t - e
                    })
                }
            }, t.prototype.reinit = function() {
                var t = this;
                t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"), t.slideCount = t.$slides.length, t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll), t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0), t.registerBreakpoints(), t.setProps(), t.setupInfinite(), t.buildArrows(), t.updateArrows(), t.initArrowEvents(), t.buildDots(), t.updateDots(), t.initDotEvents(), t.cleanUpSlideEvents(), t.initSlideEvents(), t.checkResponsive(!1, !0), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), t.setPosition(), t.focusHandler(), t.paused = !t.options.autoplay, t.autoPlay(), t.$slider.trigger("reInit", [t])
            }, t.prototype.resize = function() {
                var t = this;
                e(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay), t.windowDelay = window.setTimeout(function() {
                    t.windowWidth = e(window).width(), t.checkResponsive(), t.unslicked || t.setPosition()
                }, 50))
            }, t.prototype.removeSlide = t.prototype.slickRemove = function(e, t, n) {
                var i = this;
                if (e = "boolean" == typeof e ? !0 === (t = e) ? 0 : i.slideCount - 1 : !0 === t ? --e : e, i.slideCount < 1 || e < 0 || e > i.slideCount - 1) return !1;
                i.unload(), !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(), i.$slides = i.$slideTrack.children(this.options.slide), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.append(i.$slides), i.$slidesCache = i.$slides, i.reinit()
            }, t.prototype.setCSS = function(e) {
                var t, n, i = this,
                    s = {};
                !0 === i.options.rtl && (e = -e), t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px", n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px", s[i.positionProp] = e, !1 === i.transformsEnabled ? i.$slideTrack.css(s) : (s = {}, !1 === i.cssTransitions ? (s[i.animType] = "translate(" + t + ", " + n + ")", i.$slideTrack.css(s)) : (s[i.animType] = "translate3d(" + t + ", " + n + ", 0px)", i.$slideTrack.css(s)))
            }, t.prototype.setDimensions = function() {
                var e = this;
                !1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
                    padding: "0px " + e.options.centerPadding
                }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({
                    padding: e.options.centerPadding + " 0px"
                })), e.listWidth = e.$list.width(), e.listHeight = e.$list.height(), !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
                var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
            }, t.prototype.setFade = function() {
                var t, n = this;
                n.$slides.each(function(i, s) {
                    t = n.slideWidth * i * -1, !0 === n.options.rtl ? e(s).css({
                        position: "relative",
                        right: t,
                        top: 0,
                        zIndex: n.options.zIndex - 2,
                        opacity: 0
                    }) : e(s).css({
                        position: "relative",
                        left: t,
                        top: 0,
                        zIndex: n.options.zIndex - 2,
                        opacity: 0
                    })
                }), n.$slides.eq(n.currentSlide).css({
                    zIndex: n.options.zIndex - 1,
                    opacity: 1
                })
            }, t.prototype.setHeight = function() {
                var e = this;
                if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                    var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                    e.$list.css("height", t)
                }
            }, t.prototype.setOption = t.prototype.slickSetOption = function() {
                var t, n, i, s, a, o = this,
                    r = !1;
                if ("object" === e.type(arguments[0]) ? (i = arguments[0], r = arguments[1], a = "multiple") : "string" === e.type(arguments[0]) && (i = arguments[0], s = arguments[1], r = arguments[2], "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? a = "responsive" : void 0 !== arguments[1] && (a = "single")), "single" === a) o.options[i] = s;
                else if ("multiple" === a) e.each(i, function(e, t) {
                    o.options[e] = t
                });
                else if ("responsive" === a)
                    for (n in s)
                        if ("array" !== e.type(o.options.responsive)) o.options.responsive = [s[n]];
                        else {
                            for (t = o.options.responsive.length - 1; t >= 0;) o.options.responsive[t].breakpoint === s[n].breakpoint && o.options.responsive.splice(t, 1), t--;
                            o.options.responsive.push(s[n])
                        } r && (o.unload(), o.reinit())
            }, t.prototype.setPosition = function() {
                var e = this;
                e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e])
            }, t.prototype.setProps = function() {
                var e = this,
                    t = document.body.style;
                e.positionProp = !0 === e.options.vertical ? "top" : "left", "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"), void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 === e.options.useCSS && (e.cssTransitions = !0), e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex), void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform", e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)), void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)), void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"), e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
            }, t.prototype.setSlideClasses = function(e) {
                var t, n, i, s, a = this;
                if (n = a.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), a.$slides.eq(e).addClass("slick-current"), !0 === a.options.centerMode) {
                    var o = a.options.slidesToShow % 2 == 0 ? 1 : 0;
                    t = Math.floor(a.options.slidesToShow / 2), !0 === a.options.infinite && (e >= t && e <= a.slideCount - 1 - t ? a.$slides.slice(e - t + o, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = a.options.slidesToShow + e, n.slice(i - t + 1 + o, i + t + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? n.eq(n.length - 1 - a.options.slidesToShow).addClass("slick-center") : e === a.slideCount - 1 && n.eq(a.options.slidesToShow).addClass("slick-center")), a.$slides.eq(e).addClass("slick-center")
                } else e >= 0 && e <= a.slideCount - a.options.slidesToShow ? a.$slides.slice(e, e + a.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= a.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (s = a.slideCount % a.options.slidesToShow, i = !0 === a.options.infinite ? a.options.slidesToShow + e : e, a.options.slidesToShow == a.options.slidesToScroll && a.slideCount - e < a.options.slidesToShow ? n.slice(i - (a.options.slidesToShow - s), i + s).addClass("slick-active").attr("aria-hidden", "false") : n.slice(i, i + a.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
                "ondemand" !== a.options.lazyLoad && "anticipated" !== a.options.lazyLoad || a.lazyLoad()
            }, t.prototype.setupInfinite = function() {
                var t, n, i, s = this;
                if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (n = null, s.slideCount > s.options.slidesToShow)) {
                    for (i = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, t = s.slideCount; t > s.slideCount - i; t -= 1) n = t - 1, e(s.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
                    for (t = 0; t < i + s.slideCount; t += 1) n = t, e(s.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
                    s.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                        e(this).attr("id", "")
                    })
                }
            }, t.prototype.interrupt = function(e) {
                e || this.autoPlay(), this.interrupted = e
            }, t.prototype.selectHandler = function(t) {
                var n = this,
                    i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
                    s = parseInt(i.attr("data-slick-index"));
                s || (s = 0), n.slideCount <= n.options.slidesToShow ? n.slideHandler(s, !1, !0) : n.slideHandler(s)
            }, t.prototype.slideHandler = function(e, t, n) {
                var i, s, a, o, r, d = null,
                    l = this;
                if (t = t || !1, !(!0 === l.animating && !0 === l.options.waitForAnimate || !0 === l.options.fade && l.currentSlide === e))
                    if (!1 === t && l.asNavFor(e), i = e, d = l.getLeft(i), o = l.getLeft(l.currentSlide), l.currentLeft = null === l.swipeLeft ? o : l.swipeLeft, !1 === l.options.infinite && !1 === l.options.centerMode && (e < 0 || e > l.getDotCount() * l.options.slidesToScroll)) !1 === l.options.fade && (i = l.currentSlide, !0 !== n && l.slideCount > l.options.slidesToShow ? l.animateSlide(o, function() {
                        l.postSlide(i)
                    }) : l.postSlide(i));
                    else if (!1 === l.options.infinite && !0 === l.options.centerMode && (e < 0 || e > l.slideCount - l.options.slidesToScroll)) !1 === l.options.fade && (i = l.currentSlide, !0 !== n && l.slideCount > l.options.slidesToShow ? l.animateSlide(o, function() {
                    l.postSlide(i)
                }) : l.postSlide(i));
                else {
                    if (l.options.autoplay && clearInterval(l.autoPlayTimer), s = i < 0 ? l.slideCount % l.options.slidesToScroll != 0 ? l.slideCount - l.slideCount % l.options.slidesToScroll : l.slideCount + i : i >= l.slideCount ? l.slideCount % l.options.slidesToScroll != 0 ? 0 : i - l.slideCount : i, l.animating = !0, l.$slider.trigger("beforeChange", [l, l.currentSlide, s]), a = l.currentSlide, l.currentSlide = s, l.setSlideClasses(l.currentSlide), l.options.asNavFor && (r = (r = l.getNavTarget()).slick("getSlick")).slideCount <= r.options.slidesToShow && r.setSlideClasses(l.currentSlide), l.updateDots(), l.updateArrows(), !0 === l.options.fade) return !0 !== n ? (l.fadeSlideOut(a), l.fadeSlide(s, function() {
                        l.postSlide(s)
                    })) : l.postSlide(s), void l.animateHeight();
                    !0 !== n && l.slideCount > l.options.slidesToShow ? l.animateSlide(d, function() {
                        l.postSlide(s)
                    }) : l.postSlide(s)
                }
            }, t.prototype.startLoad = function() {
                var e = this;
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(), e.$slider.addClass("slick-loading")
            }, t.prototype.swipeDirection = function() {
                var e, t, n, i, s = this;
                return e = s.touchObject.startX - s.touchObject.curX, t = s.touchObject.startY - s.touchObject.curY, n = Math.atan2(t, e), (i = Math.round(180 * n / Math.PI)) < 0 && (i = 360 - Math.abs(i)), i <= 45 && i >= 0 ? !1 === s.options.rtl ? "left" : "right" : i <= 360 && i >= 315 ? !1 === s.options.rtl ? "left" : "right" : i >= 135 && i <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? i >= 35 && i <= 135 ? "down" : "up" : "vertical"
            }, t.prototype.swipeEnd = function(e) {
                var t, n, i = this;
                if (i.dragging = !1, i.swiping = !1, i.scrolling) return i.scrolling = !1, !1;
                if (i.interrupted = !1, i.shouldClick = !(i.touchObject.swipeLength > 10), void 0 === i.touchObject.curX) return !1;
                if (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) {
                    switch (n = i.swipeDirection()) {
                        case "left":
                        case "down":
                            t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(), i.currentDirection = 0;
                            break;
                        case "right":
                        case "up":
                            t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(), i.currentDirection = 1
                    }
                    "vertical" != n && (i.slideHandler(t), i.touchObject = {}, i.$slider.trigger("swipe", [i, n]))
                } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {})
            }, t.prototype.swipeHandler = function(e) {
                var t = this;
                if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))) switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {
                    case "start":
                        t.swipeStart(e);
                        break;
                    case "move":
                        t.swipeMove(e);
                        break;
                    case "end":
                        t.swipeEnd(e)
                }
            }, t.prototype.swipeMove = function(e) {
                var t, n, i, s, a, o, r = this;
                return a = void 0 !== e.originalEvent ? e.originalEvent.touches : null, !(!r.dragging || r.scrolling || a && 1 !== a.length) && (t = r.getLeft(r.currentSlide), r.touchObject.curX = void 0 !== a ? a[0].pageX : e.clientX, r.touchObject.curY = void 0 !== a ? a[0].pageY : e.clientY, r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))), o = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2))), !r.options.verticalSwiping && !r.swiping && o > 4 ? (r.scrolling = !0, !1) : (!0 === r.options.verticalSwiping && (r.touchObject.swipeLength = o), n = r.swipeDirection(), void 0 !== e.originalEvent && r.touchObject.swipeLength > 4 && (r.swiping = !0, e.preventDefault()), s = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1), !0 === r.options.verticalSwiping && (s = r.touchObject.curY > r.touchObject.startY ? 1 : -1), i = r.touchObject.swipeLength, r.touchObject.edgeHit = !1, !1 === r.options.infinite && (0 === r.currentSlide && "right" === n || r.currentSlide >= r.getDotCount() && "left" === n) && (i = r.touchObject.swipeLength * r.options.edgeFriction, r.touchObject.edgeHit = !0), !1 === r.options.vertical ? r.swipeLeft = t + i * s : r.swipeLeft = t + i * (r.$list.height() / r.listWidth) * s, !0 === r.options.verticalSwiping && (r.swipeLeft = t + i * s), !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? (r.swipeLeft = null, !1) : void r.setCSS(r.swipeLeft))))
            }, t.prototype.swipeStart = function(e) {
                var t, n = this;
                if (n.interrupted = !0, 1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow) return n.touchObject = {}, !1;
                void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]), n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX, n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY, n.dragging = !0
            }, t.prototype.unfilterSlides = t.prototype.slickUnfilter = function() {
                var e = this;
                null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit())
            }, t.prototype.unload = function() {
                var t = this;
                e(".slick-cloned", t.$slider).remove(), t.$dots && t.$dots.remove(), t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(), t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(), t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
            }, t.prototype.unslick = function(e) {
                var t = this;
                t.$slider.trigger("unslick", [t, e]), t.destroy()
            }, t.prototype.updateArrows = function() {
                var e = this;
                Math.floor(e.options.slidesToShow / 2), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
            }, t.prototype.updateDots = function() {
                var e = this;
                null !== e.$dots && (e.$dots.find("li").removeClass("slick-active").end(), e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active"))
            }, t.prototype.visibility = function() {
                var e = this;
                e.options.autoplay && (document[e.hidden] ? e.interrupted = !0 : e.interrupted = !1)
            }, e.fn.slick = function() {
                var e, n, i = this,
                    s = arguments[0],
                    a = Array.prototype.slice.call(arguments, 1),
                    o = i.length;
                for (e = 0; e < o; e++)
                    if ("object" == typeof s || void 0 === s ? i[e].slick = new t(i[e], s) : n = i[e].slick[s].apply(i[e].slick, a), void 0 !== n) return n;
                return i
            }
        }) ? i.apply(t, s) : i) || (e.exports = a)
    }()
}, function(e, t, n) {
    var i, s;
    void 0 === (s = "function" == typeof(i = function() {
        "use strict";
        var e = function() {
            i.log(2, "(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use 'new ScrollMagic.Controller()' to create a new controller instance. Use 'new ScrollMagic.Scene()' to instance a scene.")
        };
        e.version = "2.0.8", "undefined" != typeof window && window.addEventListener("mousewheel", void 0), e.Controller = function(n) {
            var s, a, o = "ScrollMagic.Controller",
                r = t.defaults,
                d = this,
                l = i.extend({}, r, n),
                u = [],
                c = !1,
                h = 0,
                m = "PAUSED",
                f = !0,
                _ = 0,
                p = !0,
                g = function() {
                    l.refreshInterval > 0 && (a = window.setTimeout(k, l.refreshInterval))
                },
                y = function() {
                    return l.vertical ? i.get.scrollTop(l.container) : i.get.scrollLeft(l.container)
                },
                v = function() {
                    return l.vertical ? i.get.height(l.container) : i.get.width(l.container)
                },
                M = this._setScrollPos = function(e) {
                    l.vertical ? f ? window.scrollTo(i.get.scrollLeft(), e) : l.container.scrollTop = e : f ? window.scrollTo(e, i.get.scrollTop()) : l.container.scrollLeft = e
                },
                L = function() {
                    if (p && c) {
                        var e = i.type.Array(c) ? c : u.slice(0);
                        c = !1;
                        var t = h,
                            n = (h = d.scrollPos()) - t;
                        0 !== n && (m = n > 0 ? "FORWARD" : "REVERSE"), "REVERSE" === m && e.reverse(), e.forEach(function(t, n) {
                            Y(3, "updating Scene " + (n + 1) + "/" + e.length + " (" + u.length + " total)"), t.update(!0)
                        }), 0 === e.length && l.loglevel >= 3 && Y(3, "updating 0 Scenes (nothing added to controller)")
                    }
                },
                w = function() {
                    s = i.rAF(L)
                },
                b = function(e) {
                    Y(3, "event fired causing an update:", e.type), "resize" == e.type && (_ = v(), m = "PAUSED"), !0 !== c && (c = !0, w())
                },
                k = function() {
                    if (!f && _ != v()) {
                        var e;
                        try {
                            e = new Event("resize", {
                                bubbles: !1,
                                cancelable: !1
                            })
                        } catch (t) {
                            (e = document.createEvent("Event")).initEvent("resize", !1, !1)
                        }
                        l.container.dispatchEvent(e)
                    }
                    u.forEach(function(e, t) {
                        e.refresh()
                    }), g()
                },
                Y = this._log = function(e, t) {
                    l.loglevel >= e && (Array.prototype.splice.call(arguments, 1, 0, "(" + o + ") ->"), i.log.apply(window, arguments))
                };
            this._options = l;
            var T = function(e) {
                if (e.length <= 1) return e;
                var t = e.slice(0);
                return t.sort(function(e, t) {
                    return e.scrollOffset() > t.scrollOffset() ? 1 : -1
                }), t
            };
            return this.addScene = function(t) {
                    if (i.type.Array(t)) t.forEach(function(e, t) {
                        d.addScene(e)
                    });
                    else if (t instanceof e.Scene) {
                        if (t.controller() !== d) t.addTo(d);
                        else if (u.indexOf(t) < 0) {
                            for (var n in u.push(t), u = T(u), t.on("shift.controller_sort", function() {
                                    u = T(u)
                                }), l.globalSceneOptions) t[n] && t[n].call(t, l.globalSceneOptions[n]);
                            Y(3, "adding Scene (now " + u.length + " total)")
                        }
                    } else Y(1, "ERROR: invalid argument supplied for '.addScene()'");
                    return d
                }, this.removeScene = function(e) {
                    if (i.type.Array(e)) e.forEach(function(e, t) {
                        d.removeScene(e)
                    });
                    else {
                        var t = u.indexOf(e);
                        t > -1 && (e.off("shift.controller_sort"), u.splice(t, 1), Y(3, "removing Scene (now " + u.length + " left)"), e.remove())
                    }
                    return d
                }, this.updateScene = function(t, n) {
                    return i.type.Array(t) ? t.forEach(function(e, t) {
                        d.updateScene(e, n)
                    }) : n ? t.update(!0) : !0 !== c && t instanceof e.Scene && (-1 == (c = c || []).indexOf(t) && c.push(t), c = T(c), w()), d
                }, this.update = function(e) {
                    return b({
                        type: "resize"
                    }), e && L(), d
                }, this.scrollTo = function(t, n) {
                    if (i.type.Number(t)) M.call(l.container, t, n);
                    else if (t instanceof e.Scene) t.controller() === d ? d.scrollTo(t.scrollOffset(), n) : Y(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", t);
                    else if (i.type.Function(t)) M = t;
                    else {
                        var s = i.get.elements(t)[0];
                        if (s) {
                            for (; s.parentNode.hasAttribute("data-scrollmagic-pin-spacer");) s = s.parentNode;
                            var a = l.vertical ? "top" : "left",
                                o = i.get.offset(l.container),
                                r = i.get.offset(s);
                            f || (o[a] -= d.scrollPos()), d.scrollTo(r[a] - o[a], n)
                        } else Y(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", t)
                    }
                    return d
                }, this.scrollPos = function(e) {
                    return arguments.length ? (i.type.Function(e) ? y = e : Y(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'."), d) : y.call(d)
                }, this.info = function(e) {
                    var t = {
                        size: _,
                        vertical: l.vertical,
                        scrollPos: h,
                        scrollDirection: m,
                        container: l.container,
                        isDocument: f
                    };
                    return arguments.length ? void 0 !== t[e] ? t[e] : void Y(1, 'ERROR: option "' + e + '" is not available') : t
                }, this.loglevel = function(e) {
                    return arguments.length ? (l.loglevel != e && (l.loglevel = e), d) : l.loglevel
                }, this.enabled = function(e) {
                    return arguments.length ? (p != e && (p = !!e, d.updateScene(u, !0)), d) : p
                }, this.destroy = function(e) {
                    window.clearTimeout(a);
                    for (var t = u.length; t--;) u[t].destroy(e);
                    return l.container.removeEventListener("resize", b), l.container.removeEventListener("scroll", b), i.cAF(s), Y(3, "destroyed " + o + " (reset: " + (e ? "true" : "false") + ")"), null
                },
                function() {
                    for (var t in l) r.hasOwnProperty(t) || (Y(2, 'WARNING: Unknown option "' + t + '"'), delete l[t]);
                    if (l.container = i.get.elements(l.container)[0], !l.container) throw Y(1, "ERROR creating object " + o + ": No valid scroll container supplied"), o + " init failed.";
                    (f = l.container === window || l.container === document.body || !document.body.contains(l.container)) && (l.container = window), _ = v(), l.container.addEventListener("resize", b), l.container.addEventListener("scroll", b);
                    var n = parseInt(l.refreshInterval, 10);
                    l.refreshInterval = i.type.Number(n) ? n : r.refreshInterval, g(), Y(3, "added new " + o + " controller (v" + e.version + ")")
                }(), d
        };
        var t = {
            defaults: {
                container: window,
                vertical: !0,
                globalSceneOptions: {},
                loglevel: 2,
                refreshInterval: 100
            }
        };
        e.Controller.addOption = function(e, n) {
            t.defaults[e] = n
        }, e.Controller.extend = function(t) {
            var n = this;
            e.Controller = function() {
                return n.apply(this, arguments), this.$super = i.extend({}, this), t.apply(this, arguments) || this
            }, i.extend(e.Controller, n), e.Controller.prototype = n.prototype, e.Controller.prototype.constructor = e.Controller
        }, e.Scene = function(t) {
            var s, a, o = "ScrollMagic.Scene",
                r = n.defaults,
                d = this,
                l = i.extend({}, r, t),
                u = "BEFORE",
                c = 0,
                h = {
                    start: 0,
                    end: 0
                },
                m = 0,
                f = !0,
                _ = {};
            this.on = function(e, t) {
                return i.type.Function(t) ? (e = e.trim().split(" ")).forEach(function(e) {
                    var n = e.split("."),
                        i = n[0],
                        s = n[1];
                    "*" != i && (_[i] || (_[i] = []), _[i].push({
                        namespace: s || "",
                        callback: t
                    }))
                }) : p(1, "ERROR when calling '.on()': Supplied callback for '" + e + "' is not a valid function!"), d
            }, this.off = function(e, t) {
                return e ? ((e = e.trim().split(" ")).forEach(function(e, n) {
                    var i = e.split("."),
                        s = i[0],
                        a = i[1] || "",
                        o = "*" === s ? Object.keys(_) : [s];
                    o.forEach(function(e) {
                        for (var n = _[e] || [], i = n.length; i--;) {
                            var s = n[i];
                            !s || a !== s.namespace && "*" !== a || t && t != s.callback || n.splice(i, 1)
                        }
                        n.length || delete _[e]
                    })
                }), d) : (p(1, "ERROR: Invalid event name supplied."), d)
            }, this.trigger = function(t, n) {
                if (t) {
                    var i = t.trim().split("."),
                        s = i[0],
                        a = i[1],
                        o = _[s];
                    p(3, "event fired:", s, n ? "->" : "", n || ""), o && o.forEach(function(t, i) {
                        a && a !== t.namespace || t.callback.call(d, new e.Event(s, t.namespace, d, n))
                    })
                } else p(1, "ERROR: Invalid event name supplied.");
                return d
            }, d.on("change.internal", function(e) {
                "loglevel" !== e.what && "tweenChanges" !== e.what && ("triggerElement" === e.what ? L() : "reverse" === e.what && d.update())
            }).on("shift.internal", function(e) {
                v(), d.update()
            });
            var p = this._log = function(e, t) {
                l.loglevel >= e && (Array.prototype.splice.call(arguments, 1, 0, "(" + o + ") ->"), i.log.apply(window, arguments))
            };
            this.addTo = function(t) {
                return t instanceof e.Controller ? a != t && (a && a.removeScene(d), a = t, k(), M(!0), L(!0), v(), a.info("container").addEventListener("resize", w), t.addScene(d), d.trigger("add", {
                    controller: a
                }), p(3, "added " + o + " to controller"), d.update()) : p(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller"), d
            }, this.enabled = function(e) {
                return arguments.length ? (f != e && (f = !!e, d.update(!0)), d) : f
            }, this.remove = function() {
                if (a) {
                    a.info("container").removeEventListener("resize", w);
                    var e = a;
                    a = void 0, e.removeScene(d), d.trigger("remove"), p(3, "removed " + o + " from controller")
                }
                return d
            }, this.destroy = function(e) {
                return d.trigger("destroy", {
                    reset: e
                }), d.remove(), d.off("*.*"), p(3, "destroyed " + o + " (reset: " + (e ? "true" : "false") + ")"), null
            }, this.update = function(e) {
                if (a)
                    if (e)
                        if (a.enabled() && f) {
                            var t, n = a.info("scrollPos");
                            t = l.duration > 0 ? (n - h.start) / (h.end - h.start) : n >= h.start ? 1 : 0, d.trigger("update", {
                                startPos: h.start,
                                endPos: h.end,
                                scrollPos: n
                            }), d.progress(t)
                        } else g && "DURING" === u && D(!0);
                else a.updateScene(d, !1);
                return d
            }, this.refresh = function() {
                return M(), L(), d
            }, this.progress = function(e) {
                if (arguments.length) {
                    var t = !1,
                        n = u,
                        i = a ? a.info("scrollDirection") : "PAUSED",
                        s = l.reverse || e >= c;
                    if (0 === l.duration ? (t = c != e, u = 0 == (c = e < 1 && s ? 0 : 1) ? "BEFORE" : "DURING") : e < 0 && "BEFORE" !== u && s ? (c = 0, u = "BEFORE", t = !0) : e >= 0 && e < 1 && s ? (c = e, u = "DURING", t = !0) : e >= 1 && "AFTER" !== u ? (c = 1, u = "AFTER", t = !0) : "DURING" !== u || s || D(), t) {
                        var o = {
                                progress: c,
                                state: u,
                                scrollDirection: i
                            },
                            r = u != n,
                            h = function(e) {
                                d.trigger(e, o)
                            };
                        r && "DURING" !== n && (h("enter"), h("BEFORE" === n ? "start" : "end")), h("progress"), r && "DURING" !== u && (h("BEFORE" === u ? "start" : "end"), h("leave"))
                    }
                    return d
                }
                return c
            };
            var g, y, v = function() {
                    h = {
                        start: m + l.offset
                    }, a && l.triggerElement && (h.start -= a.info("size") * l.triggerHook), h.end = h.start + l.duration
                },
                M = function(e) {
                    s && Y("duration", s.call(d)) && !e && (d.trigger("change", {
                        what: "duration",
                        newval: l.duration
                    }), d.trigger("shift", {
                        reason: "duration"
                    }))
                },
                L = function(e) {
                    var t = 0,
                        n = l.triggerElement;
                    if (a && (n || m > 0)) {
                        if (n)
                            if (n.parentNode) {
                                for (var s = a.info(), o = i.get.offset(s.container), r = s.vertical ? "top" : "left"; n.parentNode.hasAttribute("data-scrollmagic-pin-spacer");) n = n.parentNode;
                                var u = i.get.offset(n);
                                s.isDocument || (o[r] -= a.scrollPos()), t = u[r] - o[r]
                            } else p(2, "WARNING: triggerElement was removed from DOM and will be reset to", void 0), d.triggerElement(void 0);
                        var c = t != m;
                        m = t, c && !e && d.trigger("shift", {
                            reason: "triggerElementPosition"
                        })
                    }
                },
                w = function(e) {
                    l.triggerHook > 0 && d.trigger("shift", {
                        reason: "containerResize"
                    })
                },
                b = i.extend(n.validate, {
                    duration: function(e) {
                        if (i.type.String(e) && e.match(/^(\.|\d)*\d+%$/)) {
                            var t = parseFloat(e) / 100;
                            e = function() {
                                return a ? a.info("size") * t : 0
                            }
                        }
                        if (i.type.Function(e)) {
                            s = e;
                            try {
                                e = parseFloat(s.call(d))
                            } catch (t) {
                                e = -1
                            }
                        }
                        if (e = parseFloat(e), !i.type.Number(e) || e < 0) throw s ? (s = void 0, ['Invalid return value of supplied function for option "duration":', e]) : ['Invalid value for option "duration":', e];
                        return e
                    }
                }),
                k = function(e) {
                    (e = arguments.length ? [e] : Object.keys(b)).forEach(function(e, t) {
                        var n;
                        if (b[e]) try {
                            n = b[e](l[e])
                        } catch (t) {
                            n = r[e];
                            var s = i.type.String(t) ? [t] : t;
                            i.type.Array(s) ? (s[0] = "ERROR: " + s[0], s.unshift(1), p.apply(this, s)) : p(1, "ERROR: Problem executing validation callback for option '" + e + "':", t.message)
                        } finally {
                            l[e] = n
                        }
                    })
                },
                Y = function(e, t) {
                    var n = !1,
                        i = l[e];
                    return l[e] != t && (l[e] = t, k(e), n = i != l[e]), n
                },
                T = function(e) {
                    d[e] || (d[e] = function(t) {
                        return arguments.length ? ("duration" === e && (s = void 0), Y(e, t) && (d.trigger("change", {
                            what: e,
                            newval: l[e]
                        }), n.shifts.indexOf(e) > -1 && d.trigger("shift", {
                            reason: e
                        })), d) : l[e]
                    })
                };
            this.controller = function() {
                return a
            }, this.state = function() {
                return u
            }, this.scrollOffset = function() {
                return h.start
            }, this.triggerPosition = function() {
                var e = l.offset;
                return a && (l.triggerElement ? e += m : e += a.info("size") * d.triggerHook()), e
            }, d.on("shift.internal", function(e) {
                var t = "duration" === e.reason;
                ("AFTER" === u && t || "DURING" === u && 0 === l.duration) && D(), t && S()
            }).on("progress.internal", function(e) {
                D()
            }).on("add.internal", function(e) {
                S()
            }).on("destroy.internal", function(e) {
                d.removePin(e.reset)
            });
            var D = function(e) {
                    if (g && a) {
                        var t = a.info(),
                            n = y.spacer.firstChild;
                        if (e || "DURING" !== u) {
                            var s = {
                                    position: y.inFlow ? "relative" : "absolute",
                                    top: 0,
                                    left: 0
                                },
                                o = i.css(n, "position") != s.position;
                            y.pushFollowers ? l.duration > 0 && ("AFTER" === u && 0 === parseFloat(i.css(y.spacer, "padding-top")) ? o = !0 : "BEFORE" === u && 0 === parseFloat(i.css(y.spacer, "padding-bottom")) && (o = !0)) : s[t.vertical ? "top" : "left"] = l.duration * c, i.css(n, s), o && S()
                        } else {
                            "fixed" != i.css(n, "position") && (i.css(n, {
                                position: "fixed"
                            }), S());
                            var r = i.get.offset(y.spacer, !0),
                                d = l.reverse || 0 === l.duration ? t.scrollPos - h.start : Math.round(c * l.duration * 10) / 10;
                            r[t.vertical ? "top" : "left"] += d, i.css(y.spacer.firstChild, {
                                top: r.top,
                                left: r.left
                            })
                        }
                    }
                },
                S = function() {
                    if (g && a && y.inFlow) {
                        var e = "DURING" === u,
                            t = a.info("vertical"),
                            n = y.spacer.firstChild,
                            s = i.isMarginCollapseType(i.css(y.spacer, "display")),
                            o = {};
                        y.relSize.width || y.relSize.autoFullWidth ? e ? i.css(g, {
                            width: i.get.width(y.spacer)
                        }) : i.css(g, {
                            width: "100%"
                        }) : (o["min-width"] = i.get.width(t ? g : n, !0, !0), o.width = e ? o["min-width"] : "auto"), y.relSize.height ? e ? i.css(g, {
                            height: i.get.height(y.spacer) - (y.pushFollowers ? l.duration : 0)
                        }) : i.css(g, {
                            height: "100%"
                        }) : (o["min-height"] = i.get.height(t ? n : g, !0, !s), o.height = e ? o["min-height"] : "auto"), y.pushFollowers && (o["padding" + (t ? "Top" : "Left")] = l.duration * c, o["padding" + (t ? "Bottom" : "Right")] = l.duration * (1 - c)), i.css(y.spacer, o)
                    }
                },
                x = function() {
                    a && g && "DURING" === u && !a.info("isDocument") && D()
                },
                H = function() {
                    a && g && "DURING" === u && ((y.relSize.width || y.relSize.autoFullWidth) && i.get.width(window) != i.get.width(y.spacer.parentNode) || y.relSize.height && i.get.height(window) != i.get.height(y.spacer.parentNode)) && S()
                },
                j = function(e) {
                    a && g && "DURING" === u && !a.info("isDocument") && (e.preventDefault(), a._setScrollPos(a.info("scrollPos") - ((e.wheelDelta || e[a.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || 30 * -e.detail)))
                };
            this.setPin = function(e, t) {
                var n = t && t.hasOwnProperty("pushFollowers");
                if (t = i.extend({}, {
                        pushFollowers: !0,
                        spacerClass: "scrollmagic-pin-spacer"
                    }, t), !(e = i.get.elements(e)[0])) return p(1, "ERROR calling method 'setPin()': Invalid pin element supplied."), d;
                if ("fixed" === i.css(e, "position")) return p(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'."), d;
                if (g) {
                    if (g === e) return d;
                    d.removePin()
                }
                var s = (g = e).parentNode.style.display,
                    a = ["top", "left", "bottom", "right", "margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];
                g.parentNode.style.display = "none";
                var o = "absolute" != i.css(g, "position"),
                    r = i.css(g, a.concat(["display"])),
                    u = i.css(g, ["width", "height"]);
                g.parentNode.style.display = s, !o && t.pushFollowers && (p(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled."), t.pushFollowers = !1), window.setTimeout(function() {
                    g && 0 === l.duration && n && t.pushFollowers && p(2, "WARNING: pushFollowers =", !0, "has no effect, when scene duration is 0.")
                }, 0);
                var c = g.parentNode.insertBefore(document.createElement("div"), g),
                    h = i.extend(r, {
                        position: o ? "relative" : "absolute",
                        boxSizing: "content-box",
                        mozBoxSizing: "content-box",
                        webkitBoxSizing: "content-box"
                    });
                if (o || i.extend(h, i.css(g, ["width", "height"])), i.css(c, h), c.setAttribute("data-scrollmagic-pin-spacer", ""), i.addClass(c, t.spacerClass), y = {
                        spacer: c,
                        relSize: {
                            width: "%" === u.width.slice(-1),
                            height: "%" === u.height.slice(-1),
                            autoFullWidth: "auto" === u.width && o && i.isMarginCollapseType(r.display)
                        },
                        pushFollowers: t.pushFollowers,
                        inFlow: o
                    }, !g.___origStyle) {
                    g.___origStyle = {};
                    var m = g.style,
                        f = a.concat(["width", "height", "position", "boxSizing", "mozBoxSizing", "webkitBoxSizing"]);
                    f.forEach(function(e) {
                        g.___origStyle[e] = m[e] || ""
                    })
                }
                return y.relSize.width && i.css(c, {
                    width: u.width
                }), y.relSize.height && i.css(c, {
                    height: u.height
                }), c.appendChild(g), i.css(g, {
                    position: o ? "relative" : "absolute",
                    margin: "auto",
                    top: "auto",
                    left: "auto",
                    bottom: "auto",
                    right: "auto"
                }), (y.relSize.width || y.relSize.autoFullWidth) && i.css(g, {
                    boxSizing: "border-box",
                    mozBoxSizing: "border-box",
                    webkitBoxSizing: "border-box"
                }), window.addEventListener("scroll", x), window.addEventListener("resize", x), window.addEventListener("resize", H), g.addEventListener("mousewheel", j), g.addEventListener("DOMMouseScroll", j), p(3, "added pin"), D(), d
            }, this.removePin = function(e) {
                if (g) {
                    if ("DURING" === u && D(!0), e || !a) {
                        var t = y.spacer.firstChild;
                        if (t.hasAttribute("data-scrollmagic-pin-spacer")) {
                            var n = y.spacer.style,
                                s = {};
                            ["margin", "marginLeft", "marginRight", "marginTop", "marginBottom"].forEach(function(e) {
                                s[e] = n[e] || ""
                            }), i.css(t, s)
                        }
                        y.spacer.parentNode.insertBefore(t, y.spacer), y.spacer.parentNode.removeChild(y.spacer), g.parentNode.hasAttribute("data-scrollmagic-pin-spacer") || (i.css(g, g.___origStyle), delete g.___origStyle)
                    }
                    window.removeEventListener("scroll", x), window.removeEventListener("resize", x), window.removeEventListener("resize", H), g.removeEventListener("mousewheel", j), g.removeEventListener("DOMMouseScroll", j), g = void 0, p(3, "removed pin (reset: " + (e ? "true" : "false") + ")")
                }
                return d
            };
            var C, P = [];
            return d.on("destroy.internal", function(e) {
                    d.removeClassToggle(e.reset)
                }), this.setClassToggle = function(e, t) {
                    var n = i.get.elements(e);
                    return 0 !== n.length && i.type.String(t) ? (P.length > 0 && d.removeClassToggle(), C = t, P = n, d.on("enter.internal_class leave.internal_class", function(e) {
                        var t = "enter" === e.type ? i.addClass : i.removeClass;
                        P.forEach(function(e, n) {
                            t(e, C)
                        })
                    }), d) : (p(1, "ERROR calling method 'setClassToggle()': Invalid " + (0 === n.length ? "element" : "classes") + " supplied."), d)
                }, this.removeClassToggle = function(e) {
                    return e && P.forEach(function(e, t) {
                        i.removeClass(e, C)
                    }), d.off("start.internal_class end.internal_class"), C = void 0, P = [], d
                },
                function() {
                    for (var e in l) r.hasOwnProperty(e) || (p(2, 'WARNING: Unknown option "' + e + '"'), delete l[e]);
                    for (var t in r) T(t);
                    k()
                }(), d
        };
        var n = {
            defaults: {
                duration: 0,
                offset: 0,
                triggerElement: void 0,
                triggerHook: .5,
                reverse: !0,
                loglevel: 2
            },
            validate: {
                offset: function(e) {
                    if (e = parseFloat(e), !i.type.Number(e)) throw ['Invalid value for option "offset":', e];
                    return e
                },
                triggerElement: function(e) {
                    if (e = e || void 0) {
                        var t = i.get.elements(e)[0];
                        if (!t || !t.parentNode) throw ['Element defined in option "triggerElement" was not found:', e];
                        e = t
                    }
                    return e
                },
                triggerHook: function(e) {
                    var t = {
                        onCenter: .5,
                        onEnter: 1,
                        onLeave: 0
                    };
                    if (i.type.Number(e)) e = Math.max(0, Math.min(parseFloat(e), 1));
                    else {
                        if (!(e in t)) throw ['Invalid value for option "triggerHook": ', e];
                        e = t[e]
                    }
                    return e
                },
                reverse: function(e) {
                    return !!e
                },
                loglevel: function(e) {
                    if (e = parseInt(e), !i.type.Number(e) || e < 0 || e > 3) throw ['Invalid value for option "loglevel":', e];
                    return e
                }
            },
            shifts: ["duration", "offset", "triggerHook"]
        };
        e.Scene.addOption = function(t, i, s, a) {
            t in n.defaults ? e._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + t + "', because it already exists.") : (n.defaults[t] = i, n.validate[t] = s, a && n.shifts.push(t))
        }, e.Scene.extend = function(t) {
            var n = this;
            e.Scene = function() {
                return n.apply(this, arguments), this.$super = i.extend({}, this), t.apply(this, arguments) || this
            }, i.extend(e.Scene, n), e.Scene.prototype = n.prototype, e.Scene.prototype.constructor = e.Scene
        }, e.Event = function(e, t, n, i) {
            for (var s in i = i || {}) this[s] = i[s];
            return this.type = e, this.target = this.currentTarget = n, this.namespace = t || "", this.timeStamp = this.timestamp = Date.now(), this
        };
        var i = e._util = function(e) {
            var t, n = {},
                i = function(e) {
                    return parseFloat(e) || 0
                },
                s = function(t) {
                    return t.currentStyle ? t.currentStyle : e.getComputedStyle(t)
                },
                a = function(t, n, a, o) {
                    if ((n = n === document ? e : n) === e) o = !1;
                    else if (!f.DomElement(n)) return 0;
                    t = t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
                    var r = (a ? n["offset" + t] || n["outer" + t] : n["client" + t] || n["inner" + t]) || 0;
                    if (a && o) {
                        var d = s(n);
                        r += "Height" === t ? i(d.marginTop) + i(d.marginBottom) : i(d.marginLeft) + i(d.marginRight)
                    }
                    return r
                },
                o = function(e) {
                    return e.replace(/^[^a-z]+([a-z])/g, "$1").replace(/-([a-z])/g, function(e) {
                        return e[1].toUpperCase()
                    })
                };
            n.extend = function(e) {
                for (e = e || {}, t = 1; t < arguments.length; t++)
                    if (arguments[t])
                        for (var n in arguments[t]) arguments[t].hasOwnProperty(n) && (e[n] = arguments[t][n]);
                return e
            }, n.isMarginCollapseType = function(e) {
                return ["block", "flex", "list-item", "table", "-webkit-box"].indexOf(e) > -1
            };
            var r = 0,
                d = ["ms", "moz", "webkit", "o"],
                l = e.requestAnimationFrame,
                u = e.cancelAnimationFrame;
            for (t = 0; !l && t < d.length; ++t) l = e[d[t] + "RequestAnimationFrame"], u = e[d[t] + "CancelAnimationFrame"] || e[d[t] + "CancelRequestAnimationFrame"];
            l || (l = function(t) {
                var n = (new Date).getTime(),
                    i = Math.max(0, 16 - (n - r)),
                    s = e.setTimeout(function() {
                        t(n + i)
                    }, i);
                return r = n + i, s
            }), u || (u = function(t) {
                e.clearTimeout(t)
            }), n.rAF = l.bind(e), n.cAF = u.bind(e);
            var c = ["error", "warn", "log"],
                h = e.console || {};
            for (h.log = h.log || function() {}, t = 0; t < c.length; t++) {
                var m = c[t];
                h[m] || (h[m] = h.log)
            }
            n.log = function(e) {
                (e > c.length || e <= 0) && (e = c.length);
                var t = new Date,
                    n = ("0" + t.getHours()).slice(-2) + ":" + ("0" + t.getMinutes()).slice(-2) + ":" + ("0" + t.getSeconds()).slice(-2) + ":" + ("00" + t.getMilliseconds()).slice(-3),
                    i = c[e - 1],
                    s = Array.prototype.splice.call(arguments, 1),
                    a = Function.prototype.bind.call(h[i], h);
                s.unshift(n), a.apply(h, s)
            };
            var f = n.type = function(e) {
                return Object.prototype.toString.call(e).replace(/^\[object (.+)\]$/, "$1").toLowerCase()
            };
            f.String = function(e) {
                return "string" === f(e)
            }, f.Function = function(e) {
                return "function" === f(e)
            }, f.Array = function(e) {
                return Array.isArray(e)
            }, f.Number = function(e) {
                return !f.Array(e) && e - parseFloat(e) + 1 >= 0
            }, f.DomElement = function(e) {
                return "object" == typeof HTMLElement || "function" == typeof HTMLElement ? e instanceof HTMLElement || e instanceof SVGElement : e && "object" == typeof e && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
            };
            var _ = n.get = {};
            return _.elements = function(t) {
                var n = [];
                if (f.String(t)) try {
                    t = document.querySelectorAll(t)
                } catch (e) {
                    return n
                }
                if ("nodelist" === f(t) || f.Array(t) || t instanceof NodeList)
                    for (var i = 0, s = n.length = t.length; i < s; i++) {
                        var a = t[i];
                        n[i] = f.DomElement(a) ? a : _.elements(a)
                    } else(f.DomElement(t) || t === document || t === e) && (n = [t]);
                return n
            }, _.scrollTop = function(t) {
                return t && "number" == typeof t.scrollTop ? t.scrollTop : e.pageYOffset || 0
            }, _.scrollLeft = function(t) {
                return t && "number" == typeof t.scrollLeft ? t.scrollLeft : e.pageXOffset || 0
            }, _.width = function(e, t, n) {
                return a("width", e, t, n)
            }, _.height = function(e, t, n) {
                return a("height", e, t, n)
            }, _.offset = function(e, t) {
                var n = {
                    top: 0,
                    left: 0
                };
                if (e && e.getBoundingClientRect) {
                    var i = e.getBoundingClientRect();
                    n.top = i.top, n.left = i.left, t || (n.top += _.scrollTop(), n.left += _.scrollLeft())
                }
                return n
            }, n.addClass = function(e, t) {
                t && (e.classList ? e.classList.add(t) : e.className += " " + t)
            }, n.removeClass = function(e, t) {
                t && (e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " "))
            }, n.css = function(e, t) {
                if (f.String(t)) return s(e)[o(t)];
                if (f.Array(t)) {
                    var n = {},
                        i = s(e);
                    return t.forEach(function(e, t) {
                        n[e] = i[o(e)]
                    }), n
                }
                for (var a in t) {
                    var r = t[a];
                    r == parseFloat(r) && (r += "px"), e.style[o(a)] = r
                }
            }, n
        }(window || {});
        return e.Scene.prototype.addIndicators = function() {
            return e._util.log(1, "(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js"), this
        }, e.Scene.prototype.removeIndicators = function() {
            return e._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js"), this
        }, e.Scene.prototype.setTween = function() {
            return e._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js"), this
        }, e.Scene.prototype.removeTween = function() {
            return e._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js"), this
        }, e.Scene.prototype.setVelocity = function() {
            return e._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js"), this
        }, e.Scene.prototype.removeVelocity = function() {
            return e._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js"), this
        }, e
    }) ? i.call(t, n, t, e) : i) || (e.exports = s)
}, function(e, t, n) {
    var i = n(1),
        s = i(document),
        a = {},
        o = !1;
    i.event.special.clickout = {
        setup: function(e, t, n) {
            o || (s.on("click.clickout-handler", function(e) {
                i.each(a, function(t, n) {
                    var s = !0;
                    i.each(n.elements, function(t, n) {
                        i(e.target).closest(n).length && (s = !1)
                    }), s && n.handler.call(i(n.elements), e)
                })
            }), o = !0)
        },
        teardown: function() {
            a || (s.off("click.clickout-handler"), o = !1)
        },
        add: function(e) {
            var t = e.guid;
            a.hasOwnProperty(t) ? a[t].elements.push(this) : a[t] = {
                elements: [this],
                handler: e.handler
            }
        },
        remove: function(e) {
            delete a[e.guid]
        }
    }
}, function(e, t) {
    e.exports = {
        isFunction: function(e) {
            return "function" == typeof e
        },
        isArray: function(e) {
            return "[object Array]" === Object.prototype.toString.apply(e)
        },
        each: function(e, t) {
            for (var n = 0, i = e.length; n < i && !1 !== t(e[n], n); n++);
        }
    }
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("af", {
            months: "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),
            monthsShort: "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
            weekdays: "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),
            weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
            weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
            meridiemParse: /vm|nm/i,
            isPM: function(e) {
                return /^nm$/i.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 12 ? n ? "vm" : "VM" : n ? "nm" : "NM"
            },
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Vandag om] LT",
                nextDay: "[Môre om] LT",
                nextWeek: "dddd [om] LT",
                lastDay: "[Gister om] LT",
                lastWeek: "[Laas] dddd [om] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "oor %s",
                past: "%s gelede",
                s: "'n paar sekondes",
                ss: "%d sekondes",
                m: "'n minuut",
                mm: "%d minute",
                h: "'n uur",
                hh: "%d ure",
                d: "'n dag",
                dd: "%d dae",
                M: "'n maand",
                MM: "%d maande",
                y: "'n jaar",
                yy: "%d jaar"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function(e) {
                return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de")
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "١",
                2: "٢",
                3: "٣",
                4: "٤",
                5: "٥",
                6: "٦",
                7: "٧",
                8: "٨",
                9: "٩",
                0: "٠"
            },
            n = {
                "١": "1",
                "٢": "2",
                "٣": "3",
                "٤": "4",
                "٥": "5",
                "٦": "6",
                "٧": "7",
                "٨": "8",
                "٩": "9",
                "٠": "0"
            },
            i = function(e) {
                return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5
            },
            s = {
                s: ["أقل من ثانية", "ثانية واحدة", ["ثانيتان", "ثانيتين"], "%d ثوان", "%d ثانية", "%d ثانية"],
                m: ["أقل من دقيقة", "دقيقة واحدة", ["دقيقتان", "دقيقتين"], "%d دقائق", "%d دقيقة", "%d دقيقة"],
                h: ["أقل من ساعة", "ساعة واحدة", ["ساعتان", "ساعتين"], "%d ساعات", "%d ساعة", "%d ساعة"],
                d: ["أقل من يوم", "يوم واحد", ["يومان", "يومين"], "%d أيام", "%d يومًا", "%d يوم"],
                M: ["أقل من شهر", "شهر واحد", ["شهران", "شهرين"], "%d أشهر", "%d شهرا", "%d شهر"],
                y: ["أقل من عام", "عام واحد", ["عامان", "عامين"], "%d أعوام", "%d عامًا", "%d عام"]
            },
            a = function(e) {
                return function(t, n, a, o) {
                    var r = i(t),
                        d = s[e][i(t)];
                    return 2 === r && (d = d[n ? 0 : 1]), d.replace(/%d/i, t)
                }
            },
            o = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
        e.defineLocale("ar", {
            months: o,
            monthsShort: o,
            weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "D/‏M/‏YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            meridiemParse: /ص|م/,
            isPM: function(e) {
                return "م" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "ص" : "م"
            },
            calendar: {
                sameDay: "[اليوم عند الساعة] LT",
                nextDay: "[غدًا عند الساعة] LT",
                nextWeek: "dddd [عند الساعة] LT",
                lastDay: "[أمس عند الساعة] LT",
                lastWeek: "dddd [عند الساعة] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "بعد %s",
                past: "منذ %s",
                s: a("s"),
                ss: a("s"),
                m: a("m"),
                mm: a("m"),
                h: a("h"),
                hh: a("h"),
                d: a("d"),
                dd: a("d"),
                M: a("M"),
                MM: a("M"),
                y: a("y"),
                yy: a("y")
            },
            preparse: function(e) {
                return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(e) {
                    return n[e]
                }).replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                }).replace(/,/g, "،")
            },
            week: {
                dow: 6,
                doy: 12
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = function(e) {
                return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5
            },
            n = {
                s: ["أقل من ثانية", "ثانية واحدة", ["ثانيتان", "ثانيتين"], "%d ثوان", "%d ثانية", "%d ثانية"],
                m: ["أقل من دقيقة", "دقيقة واحدة", ["دقيقتان", "دقيقتين"], "%d دقائق", "%d دقيقة", "%d دقيقة"],
                h: ["أقل من ساعة", "ساعة واحدة", ["ساعتان", "ساعتين"], "%d ساعات", "%d ساعة", "%d ساعة"],
                d: ["أقل من يوم", "يوم واحد", ["يومان", "يومين"], "%d أيام", "%d يومًا", "%d يوم"],
                M: ["أقل من شهر", "شهر واحد", ["شهران", "شهرين"], "%d أشهر", "%d شهرا", "%d شهر"],
                y: ["أقل من عام", "عام واحد", ["عامان", "عامين"], "%d أعوام", "%d عامًا", "%d عام"]
            },
            i = function(e) {
                return function(i, s, a, o) {
                    var r = t(i),
                        d = n[e][t(i)];
                    return 2 === r && (d = d[s ? 0 : 1]), d.replace(/%d/i, i)
                }
            },
            s = ["جانفي", "فيفري", "مارس", "أفريل", "ماي", "جوان", "جويلية", "أوت", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
        e.defineLocale("ar-dz", {
            months: s,
            monthsShort: s,
            weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "D/‏M/‏YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            meridiemParse: /ص|م/,
            isPM: function(e) {
                return "م" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "ص" : "م"
            },
            calendar: {
                sameDay: "[اليوم عند الساعة] LT",
                nextDay: "[غدًا عند الساعة] LT",
                nextWeek: "dddd [عند الساعة] LT",
                lastDay: "[أمس عند الساعة] LT",
                lastWeek: "dddd [عند الساعة] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "بعد %s",
                past: "منذ %s",
                s: i("s"),
                ss: i("s"),
                m: i("m"),
                mm: i("m"),
                h: i("h"),
                hh: i("h"),
                d: i("d"),
                dd: i("d"),
                M: i("M"),
                MM: i("M"),
                y: i("y"),
                yy: i("y")
            },
            postformat: function(e) {
                return e.replace(/,/g, "،")
            },
            week: {
                dow: 0,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ar-kw", {
            months: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
            monthsShort: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
            weekdays: "الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[اليوم على الساعة] LT",
                nextDay: "[غدا على الساعة] LT",
                nextWeek: "dddd [على الساعة] LT",
                lastDay: "[أمس على الساعة] LT",
                lastWeek: "dddd [على الساعة] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "في %s",
                past: "منذ %s",
                s: "ثوان",
                ss: "%d ثانية",
                m: "دقيقة",
                mm: "%d دقائق",
                h: "ساعة",
                hh: "%d ساعات",
                d: "يوم",
                dd: "%d أيام",
                M: "شهر",
                MM: "%d أشهر",
                y: "سنة",
                yy: "%d سنوات"
            },
            week: {
                dow: 0,
                doy: 12
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "1",
                2: "2",
                3: "3",
                4: "4",
                5: "5",
                6: "6",
                7: "7",
                8: "8",
                9: "9",
                0: "0"
            },
            n = function(e) {
                return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5
            },
            i = {
                s: ["أقل من ثانية", "ثانية واحدة", ["ثانيتان", "ثانيتين"], "%d ثوان", "%d ثانية", "%d ثانية"],
                m: ["أقل من دقيقة", "دقيقة واحدة", ["دقيقتان", "دقيقتين"], "%d دقائق", "%d دقيقة", "%d دقيقة"],
                h: ["أقل من ساعة", "ساعة واحدة", ["ساعتان", "ساعتين"], "%d ساعات", "%d ساعة", "%d ساعة"],
                d: ["أقل من يوم", "يوم واحد", ["يومان", "يومين"], "%d أيام", "%d يومًا", "%d يوم"],
                M: ["أقل من شهر", "شهر واحد", ["شهران", "شهرين"], "%d أشهر", "%d شهرا", "%d شهر"],
                y: ["أقل من عام", "عام واحد", ["عامان", "عامين"], "%d أعوام", "%d عامًا", "%d عام"]
            },
            s = function(e) {
                return function(t, s, a, o) {
                    var r = n(t),
                        d = i[e][n(t)];
                    return 2 === r && (d = d[s ? 0 : 1]), d.replace(/%d/i, t)
                }
            },
            a = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
        e.defineLocale("ar-ly", {
            months: a,
            monthsShort: a,
            weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "D/‏M/‏YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            meridiemParse: /ص|م/,
            isPM: function(e) {
                return "م" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "ص" : "م"
            },
            calendar: {
                sameDay: "[اليوم عند الساعة] LT",
                nextDay: "[غدًا عند الساعة] LT",
                nextWeek: "dddd [عند الساعة] LT",
                lastDay: "[أمس عند الساعة] LT",
                lastWeek: "dddd [عند الساعة] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "بعد %s",
                past: "منذ %s",
                s: s("s"),
                ss: s("s"),
                m: s("m"),
                mm: s("m"),
                h: s("h"),
                hh: s("h"),
                d: s("d"),
                dd: s("d"),
                M: s("M"),
                MM: s("M"),
                y: s("y"),
                yy: s("y")
            },
            preparse: function(e) {
                return e.replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                }).replace(/,/g, "،")
            },
            week: {
                dow: 6,
                doy: 12
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ar-ma", {
            months: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
            monthsShort: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
            weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[اليوم على الساعة] LT",
                nextDay: "[غدا على الساعة] LT",
                nextWeek: "dddd [على الساعة] LT",
                lastDay: "[أمس على الساعة] LT",
                lastWeek: "dddd [على الساعة] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "في %s",
                past: "منذ %s",
                s: "ثوان",
                ss: "%d ثانية",
                m: "دقيقة",
                mm: "%d دقائق",
                h: "ساعة",
                hh: "%d ساعات",
                d: "يوم",
                dd: "%d أيام",
                M: "شهر",
                MM: "%d أشهر",
                y: "سنة",
                yy: "%d سنوات"
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "١",
                2: "٢",
                3: "٣",
                4: "٤",
                5: "٥",
                6: "٦",
                7: "٧",
                8: "٨",
                9: "٩",
                0: "٠"
            },
            n = {
                "١": "1",
                "٢": "2",
                "٣": "3",
                "٤": "4",
                "٥": "5",
                "٦": "6",
                "٧": "7",
                "٨": "8",
                "٩": "9",
                "٠": "0"
            };
        e.defineLocale("ar-sa", {
            months: "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
            monthsShort: "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
            weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            meridiemParse: /ص|م/,
            isPM: function(e) {
                return "م" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "ص" : "م"
            },
            calendar: {
                sameDay: "[اليوم على الساعة] LT",
                nextDay: "[غدا على الساعة] LT",
                nextWeek: "dddd [على الساعة] LT",
                lastDay: "[أمس على الساعة] LT",
                lastWeek: "dddd [على الساعة] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "في %s",
                past: "منذ %s",
                s: "ثوان",
                ss: "%d ثانية",
                m: "دقيقة",
                mm: "%d دقائق",
                h: "ساعة",
                hh: "%d ساعات",
                d: "يوم",
                dd: "%d أيام",
                M: "شهر",
                MM: "%d أشهر",
                y: "سنة",
                yy: "%d سنوات"
            },
            preparse: function(e) {
                return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(e) {
                    return n[e]
                }).replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                }).replace(/,/g, "،")
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ar-tn", {
            months: "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
            monthsShort: "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
            weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[اليوم على الساعة] LT",
                nextDay: "[غدا على الساعة] LT",
                nextWeek: "dddd [على الساعة] LT",
                lastDay: "[أمس على الساعة] LT",
                lastWeek: "dddd [على الساعة] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "في %s",
                past: "منذ %s",
                s: "ثوان",
                ss: "%d ثانية",
                m: "دقيقة",
                mm: "%d دقائق",
                h: "ساعة",
                hh: "%d ساعات",
                d: "يوم",
                dd: "%d أيام",
                M: "شهر",
                MM: "%d أشهر",
                y: "سنة",
                yy: "%d سنوات"
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            1: "-inci",
            5: "-inci",
            8: "-inci",
            70: "-inci",
            80: "-inci",
            2: "-nci",
            7: "-nci",
            20: "-nci",
            50: "-nci",
            3: "-üncü",
            4: "-üncü",
            100: "-üncü",
            6: "-ncı",
            9: "-uncu",
            10: "-uncu",
            30: "-uncu",
            60: "-ıncı",
            90: "-ıncı"
        };
        e.defineLocale("az", {
            months: "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),
            monthsShort: "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),
            weekdays: "Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə".split("_"),
            weekdaysShort: "Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən".split("_"),
            weekdaysMin: "Bz_BE_ÇA_Çə_CA_Cü_Şə".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[bugün saat] LT",
                nextDay: "[sabah saat] LT",
                nextWeek: "[gələn həftə] dddd [saat] LT",
                lastDay: "[dünən] LT",
                lastWeek: "[keçən həftə] dddd [saat] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s sonra",
                past: "%s əvvəl",
                s: "bir neçə saniyə",
                ss: "%d saniyə",
                m: "bir dəqiqə",
                mm: "%d dəqiqə",
                h: "bir saat",
                hh: "%d saat",
                d: "bir gün",
                dd: "%d gün",
                M: "bir ay",
                MM: "%d ay",
                y: "bir il",
                yy: "%d il"
            },
            meridiemParse: /gecə|səhər|gündüz|axşam/,
            isPM: function(e) {
                return /^(gündüz|axşam)$/.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "gecə" : e < 12 ? "səhər" : e < 17 ? "gündüz" : "axşam"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
            ordinal: function(e) {
                if (0 === e) return e + "-ıncı";
                var n = e % 10,
                    i = e % 100 - n,
                    s = e >= 100 ? 100 : null;
                return e + (t[n] || t[i] || t[s])
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n) {
            var i = {
                ss: t ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
                mm: t ? "хвіліна_хвіліны_хвілін" : "хвіліну_хвіліны_хвілін",
                hh: t ? "гадзіна_гадзіны_гадзін" : "гадзіну_гадзіны_гадзін",
                dd: "дзень_дні_дзён",
                MM: "месяц_месяцы_месяцаў",
                yy: "год_гады_гадоў"
            };
            return "m" === n ? t ? "хвіліна" : "хвіліну" : "h" === n ? t ? "гадзіна" : "гадзіну" : e + " " + function(e, t) {
                var n = e.split("_");
                return t % 10 == 1 && t % 100 != 11 ? n[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? n[1] : n[2]
            }(i[n], +e)
        }
        e.defineLocale("be", {
            months: {
                format: "студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня".split("_"),
                standalone: "студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань".split("_")
            },
            monthsShort: "студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж".split("_"),
            weekdays: {
                format: "нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу".split("_"),
                standalone: "нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота".split("_"),
                isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
            },
            weekdaysShort: "нд_пн_ат_ср_чц_пт_сб".split("_"),
            weekdaysMin: "нд_пн_ат_ср_чц_пт_сб".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY г.",
                LLL: "D MMMM YYYY г., HH:mm",
                LLLL: "dddd, D MMMM YYYY г., HH:mm"
            },
            calendar: {
                sameDay: "[Сёння ў] LT",
                nextDay: "[Заўтра ў] LT",
                lastDay: "[Учора ў] LT",
                nextWeek: function() {
                    return "[У] dddd [ў] LT"
                },
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                        case 3:
                        case 5:
                        case 6:
                            return "[У мінулую] dddd [ў] LT";
                        case 1:
                        case 2:
                        case 4:
                            return "[У мінулы] dddd [ў] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "праз %s",
                past: "%s таму",
                s: "некалькі секунд",
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: "дзень",
                dd: t,
                M: "месяц",
                MM: t,
                y: "год",
                yy: t
            },
            meridiemParse: /ночы|раніцы|дня|вечара/,
            isPM: function(e) {
                return /^(дня|вечара)$/.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "ночы" : e < 12 ? "раніцы" : e < 17 ? "дня" : "вечара"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "M":
                    case "d":
                    case "DDD":
                    case "w":
                    case "W":
                        return e % 10 != 2 && e % 10 != 3 || e % 100 == 12 || e % 100 == 13 ? e + "-ы" : e + "-і";
                    case "D":
                        return e + "-га";
                    default:
                        return e
                }
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("bg", {
            months: "януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),
            monthsShort: "яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),
            weekdays: "неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),
            weekdaysShort: "нед_пон_вто_сря_чет_пет_съб".split("_"),
            weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "D.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY H:mm",
                LLLL: "dddd, D MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[Днес в] LT",
                nextDay: "[Утре в] LT",
                nextWeek: "dddd [в] LT",
                lastDay: "[Вчера в] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                        case 3:
                        case 6:
                            return "[Миналата] dddd [в] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[Миналия] dddd [в] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "след %s",
                past: "преди %s",
                s: "няколко секунди",
                ss: "%d секунди",
                m: "минута",
                mm: "%d минути",
                h: "час",
                hh: "%d часа",
                d: "ден",
                dd: "%d дена",
                w: "седмица",
                ww: "%d седмици",
                M: "месец",
                MM: "%d месеца",
                y: "година",
                yy: "%d години"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = e % 100;
                return 0 === e ? e + "-ев" : 0 === n ? e + "-ен" : n > 10 && n < 20 ? e + "-ти" : 1 === t ? e + "-ви" : 2 === t ? e + "-ри" : 7 === t || 8 === t ? e + "-ми" : e + "-ти"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("bm", {
            months: "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo".split("_"),
            monthsShort: "Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des".split("_"),
            weekdays: "Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),
            weekdaysShort: "Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib".split("_"),
            weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "MMMM [tile] D [san] YYYY",
                LLL: "MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm",
                LLLL: "dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm"
            },
            calendar: {
                sameDay: "[Bi lɛrɛ] LT",
                nextDay: "[Sini lɛrɛ] LT",
                nextWeek: "dddd [don lɛrɛ] LT",
                lastDay: "[Kunu lɛrɛ] LT",
                lastWeek: "dddd [tɛmɛnen lɛrɛ] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s kɔnɔ",
                past: "a bɛ %s bɔ",
                s: "sanga dama dama",
                ss: "sekondi %d",
                m: "miniti kelen",
                mm: "miniti %d",
                h: "lɛrɛ kelen",
                hh: "lɛrɛ %d",
                d: "tile kelen",
                dd: "tile %d",
                M: "kalo kelen",
                MM: "kalo %d",
                y: "san kelen",
                yy: "san %d"
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "১",
                2: "২",
                3: "৩",
                4: "৪",
                5: "৫",
                6: "৬",
                7: "৭",
                8: "৮",
                9: "৯",
                0: "০"
            },
            n = {
                "১": "1",
                "২": "2",
                "৩": "3",
                "৪": "4",
                "৫": "5",
                "৬": "6",
                "৭": "7",
                "৮": "8",
                "৯": "9",
                "০": "0"
            };
        e.defineLocale("bn", {
            months: "জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),
            monthsShort: "জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),
            weekdays: "রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),
            weekdaysShort: "রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),
            weekdaysMin: "রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),
            longDateFormat: {
                LT: "A h:mm সময়",
                LTS: "A h:mm:ss সময়",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm সময়",
                LLLL: "dddd, D MMMM YYYY, A h:mm সময়"
            },
            calendar: {
                sameDay: "[আজ] LT",
                nextDay: "[আগামীকাল] LT",
                nextWeek: "dddd, LT",
                lastDay: "[গতকাল] LT",
                lastWeek: "[গত] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s পরে",
                past: "%s আগে",
                s: "কয়েক সেকেন্ড",
                ss: "%d সেকেন্ড",
                m: "এক মিনিট",
                mm: "%d মিনিট",
                h: "এক ঘন্টা",
                hh: "%d ঘন্টা",
                d: "এক দিন",
                dd: "%d দিন",
                M: "এক মাস",
                MM: "%d মাস",
                y: "এক বছর",
                yy: "%d বছর"
            },
            preparse: function(e) {
                return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "রাত" === t && e >= 4 || "দুপুর" === t && e < 5 || "বিকাল" === t ? e + 12 : e
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "রাত" : e < 10 ? "সকাল" : e < 17 ? "দুপুর" : e < 20 ? "বিকাল" : "রাত"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "১",
                2: "২",
                3: "৩",
                4: "৪",
                5: "৫",
                6: "৬",
                7: "৭",
                8: "৮",
                9: "৯",
                0: "০"
            },
            n = {
                "১": "1",
                "২": "2",
                "৩": "3",
                "৪": "4",
                "৫": "5",
                "৬": "6",
                "৭": "7",
                "৮": "8",
                "৯": "9",
                "০": "0"
            };
        e.defineLocale("bn-bd", {
            months: "জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),
            monthsShort: "জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),
            weekdays: "রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),
            weekdaysShort: "রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),
            weekdaysMin: "রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),
            longDateFormat: {
                LT: "A h:mm সময়",
                LTS: "A h:mm:ss সময়",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm সময়",
                LLLL: "dddd, D MMMM YYYY, A h:mm সময়"
            },
            calendar: {
                sameDay: "[আজ] LT",
                nextDay: "[আগামীকাল] LT",
                nextWeek: "dddd, LT",
                lastDay: "[গতকাল] LT",
                lastWeek: "[গত] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s পরে",
                past: "%s আগে",
                s: "কয়েক সেকেন্ড",
                ss: "%d সেকেন্ড",
                m: "এক মিনিট",
                mm: "%d মিনিট",
                h: "এক ঘন্টা",
                hh: "%d ঘন্টা",
                d: "এক দিন",
                dd: "%d দিন",
                M: "এক মাস",
                MM: "%d মাস",
                y: "এক বছর",
                yy: "%d বছর"
            },
            preparse: function(e) {
                return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "রাত" === t ? e < 4 ? e : e + 12 : "ভোর" === t ? e : "সকাল" === t ? e : "দুপুর" === t ? e >= 3 ? e : e + 12 : "বিকাল" === t ? e + 12 : "সন্ধ্যা" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "রাত" : e < 6 ? "ভোর" : e < 12 ? "সকাল" : e < 15 ? "দুপুর" : e < 18 ? "বিকাল" : e < 20 ? "সন্ধ্যা" : "রাত"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "༡",
                2: "༢",
                3: "༣",
                4: "༤",
                5: "༥",
                6: "༦",
                7: "༧",
                8: "༨",
                9: "༩",
                0: "༠"
            },
            n = {
                "༡": "1",
                "༢": "2",
                "༣": "3",
                "༤": "4",
                "༥": "5",
                "༦": "6",
                "༧": "7",
                "༨": "8",
                "༩": "9",
                "༠": "0"
            };
        e.defineLocale("bo", {
            months: "ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),
            monthsShort: "ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12".split("_"),
            monthsShortRegex: /^(ཟླ་\d{1,2})/,
            monthsParseExact: !0,
            weekdays: "གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་".split("_"),
            weekdaysShort: "ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),
            weekdaysMin: "ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན".split("_"),
            longDateFormat: {
                LT: "A h:mm",
                LTS: "A h:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm",
                LLLL: "dddd, D MMMM YYYY, A h:mm"
            },
            calendar: {
                sameDay: "[དི་རིང] LT",
                nextDay: "[སང་ཉིན] LT",
                nextWeek: "[བདུན་ཕྲག་རྗེས་མ], LT",
                lastDay: "[ཁ་སང] LT",
                lastWeek: "[བདུན་ཕྲག་མཐའ་མ] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s ལ་",
                past: "%s སྔན་ལ",
                s: "ལམ་སང",
                ss: "%d སྐར་ཆ།",
                m: "སྐར་མ་གཅིག",
                mm: "%d སྐར་མ",
                h: "ཆུ་ཚོད་གཅིག",
                hh: "%d ཆུ་ཚོད",
                d: "ཉིན་གཅིག",
                dd: "%d ཉིན་",
                M: "ཟླ་བ་གཅིག",
                MM: "%d ཟླ་བ",
                y: "ལོ་གཅིག",
                yy: "%d ལོ"
            },
            preparse: function(e) {
                return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "མཚན་མོ" === t && e >= 4 || "ཉིན་གུང" === t && e < 5 || "དགོང་དག" === t ? e + 12 : e
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "མཚན་མོ" : e < 10 ? "ཞོགས་ཀས" : e < 17 ? "ཉིན་གུང" : e < 20 ? "དགོང་དག" : "མཚན་མོ"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n) {
            return e + " " + function(e, t) {
                return 2 === t ? function(e) {
                    var t = {
                        m: "v",
                        b: "v",
                        d: "z"
                    };
                    return void 0 === t[e.charAt(0)] ? e : t[e.charAt(0)] + e.substring(1)
                }(e) : e
            }({
                mm: "munutenn",
                MM: "miz",
                dd: "devezh"
            } [n], e)
        }
        var n = [/^gen/i, /^c[ʼ\']hwe/i, /^meu/i, /^ebr/i, /^mae/i, /^(mez|eve)/i, /^gou/i, /^eos/i, /^gwe/i, /^her/i, /^du/i, /^ker/i],
            i = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
            s = [/^Su/i, /^Lu/i, /^Me([^r]|$)/i, /^Mer/i, /^Ya/i, /^Gw/i, /^Sa/i];
        e.defineLocale("br", {
            months: "Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),
            monthsShort: "Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
            weekdays: "Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn".split("_"),
            weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
            weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
            weekdaysParse: s,
            fullWeekdaysParse: [/^sul/i, /^lun/i, /^meurzh/i, /^merc[ʼ\']her/i, /^yaou/i, /^gwener/i, /^sadorn/i],
            shortWeekdaysParse: [/^Sul/i, /^Lun/i, /^Meu/i, /^Mer/i, /^Yao/i, /^Gwe/i, /^Sad/i],
            minWeekdaysParse: s,
            monthsRegex: i,
            monthsShortRegex: i,
            monthsStrictRegex: /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
            monthsShortStrictRegex: /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
            monthsParse: n,
            longMonthsParse: n,
            shortMonthsParse: n,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [a viz] MMMM YYYY",
                LLL: "D [a viz] MMMM YYYY HH:mm",
                LLLL: "dddd, D [a viz] MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Hiziv da] LT",
                nextDay: "[Warcʼhoazh da] LT",
                nextWeek: "dddd [da] LT",
                lastDay: "[Decʼh da] LT",
                lastWeek: "dddd [paset da] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "a-benn %s",
                past: "%s ʼzo",
                s: "un nebeud segondennoù",
                ss: "%d eilenn",
                m: "ur vunutenn",
                mm: t,
                h: "un eur",
                hh: "%d eur",
                d: "un devezh",
                dd: t,
                M: "ur miz",
                MM: t,
                y: "ur bloaz",
                yy: function(e) {
                    switch (function e(t) {
                            return t > 9 ? e(t % 10) : t
                        }(e)) {
                        case 1:
                        case 3:
                        case 4:
                        case 5:
                        case 9:
                            return e + " bloaz";
                        default:
                            return e + " vloaz"
                    }
                }
            },
            dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
            ordinal: function(e) {
                var t = 1 === e ? "añ" : "vet";
                return e + t
            },
            week: {
                dow: 1,
                doy: 4
            },
            meridiemParse: /a.m.|g.m./,
            isPM: function(e) {
                return "g.m." === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "a.m." : "g.m."
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n) {
            var i = e + " ";
            switch (n) {
                case "ss":
                    return i += 1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi";
                case "m":
                    return t ? "jedna minuta" : "jedne minute";
                case "mm":
                    return i += 1 === e ? "minuta" : 2 === e || 3 === e || 4 === e ? "minute" : "minuta";
                case "h":
                    return t ? "jedan sat" : "jednog sata";
                case "hh":
                    return i += 1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati";
                case "dd":
                    return i += 1 === e ? "dan" : "dana";
                case "MM":
                    return i += 1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci";
                case "yy":
                    return i += 1 === e ? "godina" : 2 === e || 3 === e || 4 === e ? "godine" : "godina"
            }
        }
        e.defineLocale("bs", {
            months: "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),
            monthsShort: "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),
            monthsParseExact: !0,
            weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
            weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd, D. MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[danas u] LT",
                nextDay: "[sutra u] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[u] [nedjelju] [u] LT";
                        case 3:
                            return "[u] [srijedu] [u] LT";
                        case 6:
                            return "[u] [subotu] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[u] dddd [u] LT"
                    }
                },
                lastDay: "[jučer u] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                        case 3:
                            return "[prošlu] dddd [u] LT";
                        case 6:
                            return "[prošle] [subote] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[prošli] dddd [u] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "za %s",
                past: "prije %s",
                s: "par sekundi",
                ss: t,
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: "dan",
                dd: t,
                M: "mjesec",
                MM: t,
                y: "godinu",
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ca", {
            months: {
                standalone: "gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),
                format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),
                isFormat: /D[oD]?(\s)+MMMM/
            },
            monthsShort: "gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),
            monthsParseExact: !0,
            weekdays: "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),
            weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
            weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM [de] YYYY",
                ll: "D MMM YYYY",
                LLL: "D MMMM [de] YYYY [a les] H:mm",
                lll: "D MMM YYYY, H:mm",
                LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
                llll: "ddd D MMM YYYY, H:mm"
            },
            calendar: {
                sameDay: function() {
                    return "[avui a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                },
                nextDay: function() {
                    return "[demà a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                },
                nextWeek: function() {
                    return "dddd [a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                },
                lastDay: function() {
                    return "[ahir a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                },
                lastWeek: function() {
                    return "[el] dddd [passat a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "d'aquí %s",
                past: "fa %s",
                s: "uns segons",
                ss: "%d segons",
                m: "un minut",
                mm: "%d minuts",
                h: "una hora",
                hh: "%d hores",
                d: "un dia",
                dd: "%d dies",
                M: "un mes",
                MM: "%d mesos",
                y: "un any",
                yy: "%d anys"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
            ordinal: function(e, t) {
                var n = 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "è";
                return "w" !== t && "W" !== t || (n = "a"), e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),
            n = "led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),
            i = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i],
            s = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

        function a(e) {
            return e > 1 && e < 5 && 1 != ~~(e / 10)
        }

        function o(e, t, n, i) {
            var s = e + " ";
            switch (n) {
                case "s":
                    return t || i ? "pár sekund" : "pár sekundami";
                case "ss":
                    return t || i ? s + (a(e) ? "sekundy" : "sekund") : s + "sekundami";
                case "m":
                    return t ? "minuta" : i ? "minutu" : "minutou";
                case "mm":
                    return t || i ? s + (a(e) ? "minuty" : "minut") : s + "minutami";
                case "h":
                    return t ? "hodina" : i ? "hodinu" : "hodinou";
                case "hh":
                    return t || i ? s + (a(e) ? "hodiny" : "hodin") : s + "hodinami";
                case "d":
                    return t || i ? "den" : "dnem";
                case "dd":
                    return t || i ? s + (a(e) ? "dny" : "dní") : s + "dny";
                case "M":
                    return t || i ? "měsíc" : "měsícem";
                case "MM":
                    return t || i ? s + (a(e) ? "měsíce" : "měsíců") : s + "měsíci";
                case "y":
                    return t || i ? "rok" : "rokem";
                case "yy":
                    return t || i ? s + (a(e) ? "roky" : "let") : s + "lety"
            }
        }
        e.defineLocale("cs", {
            months: t,
            monthsShort: n,
            monthsRegex: s,
            monthsShortRegex: s,
            monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
            monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),
            weekdaysShort: "ne_po_út_st_čt_pá_so".split("_"),
            weekdaysMin: "ne_po_út_st_čt_pá_so".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd D. MMMM YYYY H:mm",
                l: "D. M. YYYY"
            },
            calendar: {
                sameDay: "[dnes v] LT",
                nextDay: "[zítra v] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[v neděli v] LT";
                        case 1:
                        case 2:
                            return "[v] dddd [v] LT";
                        case 3:
                            return "[ve středu v] LT";
                        case 4:
                            return "[ve čtvrtek v] LT";
                        case 5:
                            return "[v pátek v] LT";
                        case 6:
                            return "[v sobotu v] LT"
                    }
                },
                lastDay: "[včera v] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[minulou neděli v] LT";
                        case 1:
                        case 2:
                            return "[minulé] dddd [v] LT";
                        case 3:
                            return "[minulou středu v] LT";
                        case 4:
                        case 5:
                            return "[minulý] dddd [v] LT";
                        case 6:
                            return "[minulou sobotu v] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "za %s",
                past: "před %s",
                s: o,
                ss: o,
                m: o,
                mm: o,
                h: o,
                hh: o,
                d: o,
                dd: o,
                M: o,
                MM: o,
                y: o,
                yy: o
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("cv", {
            months: "кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав".split("_"),
            monthsShort: "кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш".split("_"),
            weekdays: "вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун".split("_"),
            weekdaysShort: "выр_тун_ытл_юн_кӗҫ_эрн_шӑм".split("_"),
            weekdaysMin: "вр_тн_ыт_юн_кҫ_эр_шм".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD-MM-YYYY",
                LL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]",
                LLL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",
                LLLL: "dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm"
            },
            calendar: {
                sameDay: "[Паян] LT [сехетре]",
                nextDay: "[Ыран] LT [сехетре]",
                lastDay: "[Ӗнер] LT [сехетре]",
                nextWeek: "[Ҫитес] dddd LT [сехетре]",
                lastWeek: "[Иртнӗ] dddd LT [сехетре]",
                sameElse: "L"
            },
            relativeTime: {
                future: function(e) {
                    var t = /сехет$/i.exec(e) ? "рен" : /ҫул$/i.exec(e) ? "тан" : "ран";
                    return e + t
                },
                past: "%s каялла",
                s: "пӗр-ик ҫеккунт",
                ss: "%d ҫеккунт",
                m: "пӗр минут",
                mm: "%d минут",
                h: "пӗр сехет",
                hh: "%d сехет",
                d: "пӗр кун",
                dd: "%d кун",
                M: "пӗр уйӑх",
                MM: "%d уйӑх",
                y: "пӗр ҫул",
                yy: "%d ҫул"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
            ordinal: "%d-мӗш",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("cy", {
            months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),
            monthsShort: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
            weekdays: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),
            weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
            weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Heddiw am] LT",
                nextDay: "[Yfory am] LT",
                nextWeek: "dddd [am] LT",
                lastDay: "[Ddoe am] LT",
                lastWeek: "dddd [diwethaf am] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "mewn %s",
                past: "%s yn ôl",
                s: "ychydig eiliadau",
                ss: "%d eiliad",
                m: "munud",
                mm: "%d munud",
                h: "awr",
                hh: "%d awr",
                d: "diwrnod",
                dd: "%d diwrnod",
                M: "mis",
                MM: "%d mis",
                y: "blwyddyn",
                yy: "%d flynedd"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
            ordinal: function(e) {
                var t = e,
                    n = "";
                return t > 20 ? n = 40 === t || 50 === t || 60 === t || 80 === t || 100 === t ? "fed" : "ain" : t > 0 && (n = ["", "af", "il", "ydd", "ydd", "ed", "ed", "ed", "fed", "fed", "fed", "eg", "fed", "eg", "eg", "fed", "eg", "eg", "fed", "eg", "fed"][t]), e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("da", {
            months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
            monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
            weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
            weekdaysShort: "søn_man_tir_ons_tor_fre_lør".split("_"),
            weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm"
            },
            calendar: {
                sameDay: "[i dag kl.] LT",
                nextDay: "[i morgen kl.] LT",
                nextWeek: "på dddd [kl.] LT",
                lastDay: "[i går kl.] LT",
                lastWeek: "[i] dddd[s kl.] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "om %s",
                past: "%s siden",
                s: "få sekunder",
                ss: "%d sekunder",
                m: "et minut",
                mm: "%d minutter",
                h: "en time",
                hh: "%d timer",
                d: "en dag",
                dd: "%d dage",
                M: "en måned",
                MM: "%d måneder",
                y: "et år",
                yy: "%d år"
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = {
                m: ["eine Minute", "einer Minute"],
                h: ["eine Stunde", "einer Stunde"],
                d: ["ein Tag", "einem Tag"],
                dd: [e + " Tage", e + " Tagen"],
                w: ["eine Woche", "einer Woche"],
                M: ["ein Monat", "einem Monat"],
                MM: [e + " Monate", e + " Monaten"],
                y: ["ein Jahr", "einem Jahr"],
                yy: [e + " Jahre", e + " Jahren"]
            };
            return t ? s[n][0] : s[n][1]
        }
        e.defineLocale("de", {
            months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
            monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
            monthsParseExact: !0,
            weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
            weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd, D. MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[heute um] LT [Uhr]",
                sameElse: "L",
                nextDay: "[morgen um] LT [Uhr]",
                nextWeek: "dddd [um] LT [Uhr]",
                lastDay: "[gestern um] LT [Uhr]",
                lastWeek: "[letzten] dddd [um] LT [Uhr]"
            },
            relativeTime: {
                future: "in %s",
                past: "vor %s",
                s: "ein paar Sekunden",
                ss: "%d Sekunden",
                m: t,
                mm: "%d Minuten",
                h: t,
                hh: "%d Stunden",
                d: t,
                dd: t,
                w: t,
                ww: "%d Wochen",
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = {
                m: ["eine Minute", "einer Minute"],
                h: ["eine Stunde", "einer Stunde"],
                d: ["ein Tag", "einem Tag"],
                dd: [e + " Tage", e + " Tagen"],
                w: ["eine Woche", "einer Woche"],
                M: ["ein Monat", "einem Monat"],
                MM: [e + " Monate", e + " Monaten"],
                y: ["ein Jahr", "einem Jahr"],
                yy: [e + " Jahre", e + " Jahren"]
            };
            return t ? s[n][0] : s[n][1]
        }
        e.defineLocale("de-at", {
            months: "Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
            monthsShort: "Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
            monthsParseExact: !0,
            weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
            weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd, D. MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[heute um] LT [Uhr]",
                sameElse: "L",
                nextDay: "[morgen um] LT [Uhr]",
                nextWeek: "dddd [um] LT [Uhr]",
                lastDay: "[gestern um] LT [Uhr]",
                lastWeek: "[letzten] dddd [um] LT [Uhr]"
            },
            relativeTime: {
                future: "in %s",
                past: "vor %s",
                s: "ein paar Sekunden",
                ss: "%d Sekunden",
                m: t,
                mm: "%d Minuten",
                h: t,
                hh: "%d Stunden",
                d: t,
                dd: t,
                w: t,
                ww: "%d Wochen",
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = {
                m: ["eine Minute", "einer Minute"],
                h: ["eine Stunde", "einer Stunde"],
                d: ["ein Tag", "einem Tag"],
                dd: [e + " Tage", e + " Tagen"],
                w: ["eine Woche", "einer Woche"],
                M: ["ein Monat", "einem Monat"],
                MM: [e + " Monate", e + " Monaten"],
                y: ["ein Jahr", "einem Jahr"],
                yy: [e + " Jahre", e + " Jahren"]
            };
            return t ? s[n][0] : s[n][1]
        }
        e.defineLocale("de-ch", {
            months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
            monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
            monthsParseExact: !0,
            weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
            weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd, D. MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[heute um] LT [Uhr]",
                sameElse: "L",
                nextDay: "[morgen um] LT [Uhr]",
                nextWeek: "dddd [um] LT [Uhr]",
                lastDay: "[gestern um] LT [Uhr]",
                lastWeek: "[letzten] dddd [um] LT [Uhr]"
            },
            relativeTime: {
                future: "in %s",
                past: "vor %s",
                s: "ein paar Sekunden",
                ss: "%d Sekunden",
                m: t,
                mm: "%d Minuten",
                h: t,
                hh: "%d Stunden",
                d: t,
                dd: t,
                w: t,
                ww: "%d Wochen",
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = ["ޖެނުއަރީ", "ފެބްރުއަރީ", "މާރިޗު", "އޭޕްރީލު", "މޭ", "ޖޫން", "ޖުލައި", "އޯގަސްޓު", "ސެޕްޓެމްބަރު", "އޮކްޓޯބަރު", "ނޮވެމްބަރު", "ޑިސެމްބަރު"],
            n = ["އާދިއްތަ", "ހޯމަ", "އަންގާރަ", "ބުދަ", "ބުރާސްފަތި", "ހުކުރު", "ހޮނިހިރު"];
        e.defineLocale("dv", {
            months: t,
            monthsShort: t,
            weekdays: n,
            weekdaysShort: n,
            weekdaysMin: "އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "D/M/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            meridiemParse: /މކ|މފ/,
            isPM: function(e) {
                return "މފ" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "މކ" : "މފ"
            },
            calendar: {
                sameDay: "[މިއަދު] LT",
                nextDay: "[މާދަމާ] LT",
                nextWeek: "dddd LT",
                lastDay: "[އިއްޔެ] LT",
                lastWeek: "[ފާއިތުވި] dddd LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "ތެރޭގައި %s",
                past: "ކުރިން %s",
                s: "ސިކުންތުކޮޅެއް",
                ss: "d% ސިކުންތު",
                m: "މިނިޓެއް",
                mm: "މިނިޓު %d",
                h: "ގަޑިއިރެއް",
                hh: "ގަޑިއިރު %d",
                d: "ދުވަހެއް",
                dd: "ދުވަސް %d",
                M: "މަހެއް",
                MM: "މަސް %d",
                y: "އަހަރެއް",
                yy: "އަހަރު %d"
            },
            preparse: function(e) {
                return e.replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/,/g, "،")
            },
            week: {
                dow: 7,
                doy: 12
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("el", {
            monthsNominativeEl: "Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),
            monthsGenitiveEl: "Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),
            months: function(e, t) {
                return e ? "string" == typeof t && /D/.test(t.substring(0, t.indexOf("MMMM"))) ? this._monthsGenitiveEl[e.month()] : this._monthsNominativeEl[e.month()] : this._monthsNominativeEl
            },
            monthsShort: "Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),
            weekdays: "Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),
            weekdaysShort: "Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),
            weekdaysMin: "Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),
            meridiem: function(e, t, n) {
                return e > 11 ? n ? "μμ" : "ΜΜ" : n ? "πμ" : "ΠΜ"
            },
            isPM: function(e) {
                return "μ" === (e + "").toLowerCase()[0]
            },
            meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A"
            },
            calendarEl: {
                sameDay: "[Σήμερα {}] LT",
                nextDay: "[Αύριο {}] LT",
                nextWeek: "dddd [{}] LT",
                lastDay: "[Χθες {}] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 6:
                            return "[το προηγούμενο] dddd [{}] LT";
                        default:
                            return "[την προηγούμενη] dddd [{}] LT"
                    }
                },
                sameElse: "L"
            },
            calendar: function(e, t) {
                var n = this._calendarEl[e],
                    i = t && t.hours();
                return function(e) {
                    return "undefined" != typeof Function && e instanceof Function || "[object Function]" === Object.prototype.toString.call(e)
                }(n) && (n = n.apply(t)), n.replace("{}", i % 12 == 1 ? "στη" : "στις")
            },
            relativeTime: {
                future: "σε %s",
                past: "%s πριν",
                s: "λίγα δευτερόλεπτα",
                ss: "%d δευτερόλεπτα",
                m: "ένα λεπτό",
                mm: "%d λεπτά",
                h: "μία ώρα",
                hh: "%d ώρες",
                d: "μία μέρα",
                dd: "%d μέρες",
                M: "ένας μήνας",
                MM: "%d μήνες",
                y: "ένας χρόνος",
                yy: "%d χρόνια"
            },
            dayOfMonthOrdinalParse: /\d{1,2}η/,
            ordinal: "%dη",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("en-au", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A"
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            },
            week: {
                dow: 0,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("en-ca", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "YYYY-MM-DD",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY h:mm A",
                LLLL: "dddd, MMMM D, YYYY h:mm A"
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("en-gb", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("en-ie", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("en-il", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("en-in", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A"
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("en-nz", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A"
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("en-sg", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("eo", {
            months: "januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split("_"),
            monthsShort: "jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec".split("_"),
            weekdays: "dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato".split("_"),
            weekdaysShort: "dim_lun_mard_merk_ĵaŭ_ven_sab".split("_"),
            weekdaysMin: "di_lu_ma_me_ĵa_ve_sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "[la] D[-an de] MMMM, YYYY",
                LLL: "[la] D[-an de] MMMM, YYYY HH:mm",
                LLLL: "dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",
                llll: "ddd, [la] D[-an de] MMM, YYYY HH:mm"
            },
            meridiemParse: /[ap]\.t\.m/i,
            isPM: function(e) {
                return "p" === e.charAt(0).toLowerCase()
            },
            meridiem: function(e, t, n) {
                return e > 11 ? n ? "p.t.m." : "P.T.M." : n ? "a.t.m." : "A.T.M."
            },
            calendar: {
                sameDay: "[Hodiaŭ je] LT",
                nextDay: "[Morgaŭ je] LT",
                nextWeek: "dddd[n je] LT",
                lastDay: "[Hieraŭ je] LT",
                lastWeek: "[pasintan] dddd[n je] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "post %s",
                past: "antaŭ %s",
                s: "kelkaj sekundoj",
                ss: "%d sekundoj",
                m: "unu minuto",
                mm: "%d minutoj",
                h: "unu horo",
                hh: "%d horoj",
                d: "unu tago",
                dd: "%d tagoj",
                M: "unu monato",
                MM: "%d monatoj",
                y: "unu jaro",
                yy: "%d jaroj"
            },
            dayOfMonthOrdinalParse: /\d{1,2}a/,
            ordinal: "%da",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
            n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
            i = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
            s = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        e.defineLocale("es", {
            months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
            monthsShort: function(e, i) {
                return e ? /-MMM-/.test(i) ? n[e.month()] : t[e.month()] : t
            },
            monthsRegex: s,
            monthsShortRegex: s,
            monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY H:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
            },
            calendar: {
                sameDay: function() {
                    return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                nextDay: function() {
                    return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                nextWeek: function() {
                    return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                lastDay: function() {
                    return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                lastWeek: function() {
                    return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "en %s",
                past: "hace %s",
                s: "unos segundos",
                ss: "%d segundos",
                m: "un minuto",
                mm: "%d minutos",
                h: "una hora",
                hh: "%d horas",
                d: "un día",
                dd: "%d días",
                w: "una semana",
                ww: "%d semanas",
                M: "un mes",
                MM: "%d meses",
                y: "un año",
                yy: "%d años"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 1,
                doy: 4
            },
            invalidDate: "Fecha inválida"
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
            n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
            i = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
            s = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        e.defineLocale("es-do", {
            months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
            monthsShort: function(e, i) {
                return e ? /-MMM-/.test(i) ? n[e.month()] : t[e.month()] : t
            },
            monthsRegex: s,
            monthsShortRegex: s,
            monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY h:mm A",
                LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
            },
            calendar: {
                sameDay: function() {
                    return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                nextDay: function() {
                    return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                nextWeek: function() {
                    return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                lastDay: function() {
                    return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                lastWeek: function() {
                    return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "en %s",
                past: "hace %s",
                s: "unos segundos",
                ss: "%d segundos",
                m: "un minuto",
                mm: "%d minutos",
                h: "una hora",
                hh: "%d horas",
                d: "un día",
                dd: "%d días",
                w: "una semana",
                ww: "%d semanas",
                M: "un mes",
                MM: "%d meses",
                y: "un año",
                yy: "%d años"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
            n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
            i = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
            s = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        e.defineLocale("es-mx", {
            months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
            monthsShort: function(e, i) {
                return e ? /-MMM-/.test(i) ? n[e.month()] : t[e.month()] : t
            },
            monthsRegex: s,
            monthsShortRegex: s,
            monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY H:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
            },
            calendar: {
                sameDay: function() {
                    return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                nextDay: function() {
                    return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                nextWeek: function() {
                    return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                lastDay: function() {
                    return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                lastWeek: function() {
                    return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "en %s",
                past: "hace %s",
                s: "unos segundos",
                ss: "%d segundos",
                m: "un minuto",
                mm: "%d minutos",
                h: "una hora",
                hh: "%d horas",
                d: "un día",
                dd: "%d días",
                w: "una semana",
                ww: "%d semanas",
                M: "un mes",
                MM: "%d meses",
                y: "un año",
                yy: "%d años"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 0,
                doy: 4
            },
            invalidDate: "Fecha inválida"
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
            n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
            i = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
            s = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        e.defineLocale("es-us", {
            months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
            monthsShort: function(e, i) {
                return e ? /-MMM-/.test(i) ? n[e.month()] : t[e.month()] : t
            },
            monthsRegex: s,
            monthsShortRegex: s,
            monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "MM/DD/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY h:mm A",
                LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
            },
            calendar: {
                sameDay: function() {
                    return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                nextDay: function() {
                    return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                nextWeek: function() {
                    return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                lastDay: function() {
                    return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                lastWeek: function() {
                    return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "en %s",
                past: "hace %s",
                s: "unos segundos",
                ss: "%d segundos",
                m: "un minuto",
                mm: "%d minutos",
                h: "una hora",
                hh: "%d horas",
                d: "un día",
                dd: "%d días",
                w: "una semana",
                ww: "%d semanas",
                M: "un mes",
                MM: "%d meses",
                y: "un año",
                yy: "%d años"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = {
                s: ["mõne sekundi", "mõni sekund", "paar sekundit"],
                ss: [e + "sekundi", e + "sekundit"],
                m: ["ühe minuti", "üks minut"],
                mm: [e + " minuti", e + " minutit"],
                h: ["ühe tunni", "tund aega", "üks tund"],
                hh: [e + " tunni", e + " tundi"],
                d: ["ühe päeva", "üks päev"],
                M: ["kuu aja", "kuu aega", "üks kuu"],
                MM: [e + " kuu", e + " kuud"],
                y: ["ühe aasta", "aasta", "üks aasta"],
                yy: [e + " aasta", e + " aastat"]
            };
            return t ? s[n][2] ? s[n][2] : s[n][1] : i ? s[n][0] : s[n][1]
        }
        e.defineLocale("et", {
            months: "jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),
            monthsShort: "jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
            weekdays: "pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),
            weekdaysShort: "P_E_T_K_N_R_L".split("_"),
            weekdaysMin: "P_E_T_K_N_R_L".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd, D. MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[Täna,] LT",
                nextDay: "[Homme,] LT",
                nextWeek: "[Järgmine] dddd LT",
                lastDay: "[Eile,] LT",
                lastWeek: "[Eelmine] dddd LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s pärast",
                past: "%s tagasi",
                s: t,
                ss: t,
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: t,
                dd: "%d päeva",
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("eu", {
            months: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),
            monthsShort: "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),
            monthsParseExact: !0,
            weekdays: "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),
            weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
            weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "YYYY[ko] MMMM[ren] D[a]",
                LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
                LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
                l: "YYYY-M-D",
                ll: "YYYY[ko] MMM D[a]",
                lll: "YYYY[ko] MMM D[a] HH:mm",
                llll: "ddd, YYYY[ko] MMM D[a] HH:mm"
            },
            calendar: {
                sameDay: "[gaur] LT[etan]",
                nextDay: "[bihar] LT[etan]",
                nextWeek: "dddd LT[etan]",
                lastDay: "[atzo] LT[etan]",
                lastWeek: "[aurreko] dddd LT[etan]",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s barru",
                past: "duela %s",
                s: "segundo batzuk",
                ss: "%d segundo",
                m: "minutu bat",
                mm: "%d minutu",
                h: "ordu bat",
                hh: "%d ordu",
                d: "egun bat",
                dd: "%d egun",
                M: "hilabete bat",
                MM: "%d hilabete",
                y: "urte bat",
                yy: "%d urte"
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "۱",
                2: "۲",
                3: "۳",
                4: "۴",
                5: "۵",
                6: "۶",
                7: "۷",
                8: "۸",
                9: "۹",
                0: "۰"
            },
            n = {
                "۱": "1",
                "۲": "2",
                "۳": "3",
                "۴": "4",
                "۵": "5",
                "۶": "6",
                "۷": "7",
                "۸": "8",
                "۹": "9",
                "۰": "0"
            };
        e.defineLocale("fa", {
            months: "ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),
            monthsShort: "ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),
            weekdays: "یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),
            weekdaysShort: "یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),
            weekdaysMin: "ی_د_س_چ_پ_ج_ش".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            meridiemParse: /قبل از ظهر|بعد از ظهر/,
            isPM: function(e) {
                return /بعد از ظهر/.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "قبل از ظهر" : "بعد از ظهر"
            },
            calendar: {
                sameDay: "[امروز ساعت] LT",
                nextDay: "[فردا ساعت] LT",
                nextWeek: "dddd [ساعت] LT",
                lastDay: "[دیروز ساعت] LT",
                lastWeek: "dddd [پیش] [ساعت] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "در %s",
                past: "%s پیش",
                s: "چند ثانیه",
                ss: "%d ثانیه",
                m: "یک دقیقه",
                mm: "%d دقیقه",
                h: "یک ساعت",
                hh: "%d ساعت",
                d: "یک روز",
                dd: "%d روز",
                M: "یک ماه",
                MM: "%d ماه",
                y: "یک سال",
                yy: "%d سال"
            },
            preparse: function(e) {
                return e.replace(/[۰-۹]/g, function(e) {
                    return n[e]
                }).replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                }).replace(/,/g, "،")
            },
            dayOfMonthOrdinalParse: /\d{1,2}م/,
            ordinal: "%dم",
            week: {
                dow: 6,
                doy: 12
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),
            n = ["nolla", "yhden", "kahden", "kolmen", "neljän", "viiden", "kuuden", t[7], t[8], t[9]];

        function i(e, i, s, a) {
            var o = "";
            switch (s) {
                case "s":
                    return a ? "muutaman sekunnin" : "muutama sekunti";
                case "ss":
                    o = a ? "sekunnin" : "sekuntia";
                    break;
                case "m":
                    return a ? "minuutin" : "minuutti";
                case "mm":
                    o = a ? "minuutin" : "minuuttia";
                    break;
                case "h":
                    return a ? "tunnin" : "tunti";
                case "hh":
                    o = a ? "tunnin" : "tuntia";
                    break;
                case "d":
                    return a ? "päivän" : "päivä";
                case "dd":
                    o = a ? "päivän" : "päivää";
                    break;
                case "M":
                    return a ? "kuukauden" : "kuukausi";
                case "MM":
                    o = a ? "kuukauden" : "kuukautta";
                    break;
                case "y":
                    return a ? "vuoden" : "vuosi";
                case "yy":
                    o = a ? "vuoden" : "vuotta"
            }
            return o = function(e, i) {
                return e < 10 ? i ? n[e] : t[e] : e
            }(e, a) + " " + o
        }
        e.defineLocale("fi", {
            months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),
            monthsShort: "tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),
            weekdays: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),
            weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
            weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD.MM.YYYY",
                LL: "Do MMMM[ta] YYYY",
                LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
                LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
                l: "D.M.YYYY",
                ll: "Do MMM YYYY",
                lll: "Do MMM YYYY, [klo] HH.mm",
                llll: "ddd, Do MMM YYYY, [klo] HH.mm"
            },
            calendar: {
                sameDay: "[tänään] [klo] LT",
                nextDay: "[huomenna] [klo] LT",
                nextWeek: "dddd [klo] LT",
                lastDay: "[eilen] [klo] LT",
                lastWeek: "[viime] dddd[na] [klo] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s päästä",
                past: "%s sitten",
                s: i,
                ss: i,
                m: i,
                mm: i,
                h: i,
                hh: i,
                d: i,
                dd: i,
                M: i,
                MM: i,
                y: i,
                yy: i
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("fil", {
            months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
            monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
            weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
            weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
            weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "MM/D/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY HH:mm",
                LLLL: "dddd, MMMM DD, YYYY HH:mm"
            },
            calendar: {
                sameDay: "LT [ngayong araw]",
                nextDay: "[Bukas ng] LT",
                nextWeek: "LT [sa susunod na] dddd",
                lastDay: "LT [kahapon]",
                lastWeek: "LT [noong nakaraang] dddd",
                sameElse: "L"
            },
            relativeTime: {
                future: "sa loob ng %s",
                past: "%s ang nakalipas",
                s: "ilang segundo",
                ss: "%d segundo",
                m: "isang minuto",
                mm: "%d minuto",
                h: "isang oras",
                hh: "%d oras",
                d: "isang araw",
                dd: "%d araw",
                M: "isang buwan",
                MM: "%d buwan",
                y: "isang taon",
                yy: "%d taon"
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: function(e) {
                return e
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("fo", {
            months: "januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split("_"),
            monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
            weekdays: "sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split("_"),
            weekdaysShort: "sun_mán_týs_mik_hós_frí_ley".split("_"),
            weekdaysMin: "su_má_tý_mi_hó_fr_le".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D. MMMM, YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Í dag kl.] LT",
                nextDay: "[Í morgin kl.] LT",
                nextWeek: "dddd [kl.] LT",
                lastDay: "[Í gjár kl.] LT",
                lastWeek: "[síðstu] dddd [kl] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "um %s",
                past: "%s síðani",
                s: "fá sekund",
                ss: "%d sekundir",
                m: "ein minuttur",
                mm: "%d minuttir",
                h: "ein tími",
                hh: "%d tímar",
                d: "ein dagur",
                dd: "%d dagar",
                M: "ein mánaður",
                MM: "%d mánaðir",
                y: "eitt ár",
                yy: "%d ár"
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
            n = [/^janv/i, /^févr/i, /^mars/i, /^avr/i, /^mai/i, /^juin/i, /^juil/i, /^août/i, /^sept/i, /^oct/i, /^nov/i, /^déc/i];
        e.defineLocale("fr", {
            months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
            monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
            monthsRegex: t,
            monthsShortRegex: t,
            monthsStrictRegex: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
            monthsShortStrictRegex: /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
            monthsParse: n,
            longMonthsParse: n,
            shortMonthsParse: n,
            weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Aujourd’hui à] LT",
                nextDay: "[Demain à] LT",
                nextWeek: "dddd [à] LT",
                lastDay: "[Hier à] LT",
                lastWeek: "dddd [dernier à] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "dans %s",
                past: "il y a %s",
                s: "quelques secondes",
                ss: "%d secondes",
                m: "une minute",
                mm: "%d minutes",
                h: "une heure",
                hh: "%d heures",
                d: "un jour",
                dd: "%d jours",
                w: "une semaine",
                ww: "%d semaines",
                M: "un mois",
                MM: "%d mois",
                y: "un an",
                yy: "%d ans"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "D":
                        return e + (1 === e ? "er" : "");
                    default:
                    case "M":
                    case "Q":
                    case "DDD":
                    case "d":
                        return e + (1 === e ? "er" : "e");
                    case "w":
                    case "W":
                        return e + (1 === e ? "re" : "e")
                }
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("fr-ca", {
            months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
            monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
            monthsParseExact: !0,
            weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Aujourd’hui à] LT",
                nextDay: "[Demain à] LT",
                nextWeek: "dddd [à] LT",
                lastDay: "[Hier à] LT",
                lastWeek: "dddd [dernier à] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "dans %s",
                past: "il y a %s",
                s: "quelques secondes",
                ss: "%d secondes",
                m: "une minute",
                mm: "%d minutes",
                h: "une heure",
                hh: "%d heures",
                d: "un jour",
                dd: "%d jours",
                M: "un mois",
                MM: "%d mois",
                y: "un an",
                yy: "%d ans"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
            ordinal: function(e, t) {
                switch (t) {
                    default:
                    case "M":
                    case "Q":
                    case "D":
                    case "DDD":
                    case "d":
                        return e + (1 === e ? "er" : "e");
                    case "w":
                    case "W":
                        return e + (1 === e ? "re" : "e")
                }
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("fr-ch", {
            months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
            monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
            monthsParseExact: !0,
            weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Aujourd’hui à] LT",
                nextDay: "[Demain à] LT",
                nextWeek: "dddd [à] LT",
                lastDay: "[Hier à] LT",
                lastWeek: "dddd [dernier à] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "dans %s",
                past: "il y a %s",
                s: "quelques secondes",
                ss: "%d secondes",
                m: "une minute",
                mm: "%d minutes",
                h: "une heure",
                hh: "%d heures",
                d: "un jour",
                dd: "%d jours",
                M: "un mois",
                MM: "%d mois",
                y: "un an",
                yy: "%d ans"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
            ordinal: function(e, t) {
                switch (t) {
                    default:
                    case "M":
                    case "Q":
                    case "D":
                    case "DDD":
                    case "d":
                        return e + (1 === e ? "er" : "e");
                    case "w":
                    case "W":
                        return e + (1 === e ? "re" : "e")
                }
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),
            n = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
        e.defineLocale("fy", {
            months: "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),
            monthsShort: function(e, i) {
                return e ? /-MMM-/.test(i) ? n[e.month()] : t[e.month()] : t
            },
            monthsParseExact: !0,
            weekdays: "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),
            weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
            weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD-MM-YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[hjoed om] LT",
                nextDay: "[moarn om] LT",
                nextWeek: "dddd [om] LT",
                lastDay: "[juster om] LT",
                lastWeek: "[ôfrûne] dddd [om] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "oer %s",
                past: "%s lyn",
                s: "in pear sekonden",
                ss: "%d sekonden",
                m: "ien minút",
                mm: "%d minuten",
                h: "ien oere",
                hh: "%d oeren",
                d: "ien dei",
                dd: "%d dagen",
                M: "ien moanne",
                MM: "%d moannen",
                y: "ien jier",
                yy: "%d jierren"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function(e) {
                return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de")
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ga", {
            months: ["Eanáir", "Feabhra", "Márta", "Aibreán", "Bealtaine", "Meitheamh", "Iúil", "Lúnasa", "Meán Fómhair", "Deireadh Fómhair", "Samhain", "Nollaig"],
            monthsShort: ["Ean", "Feabh", "Márt", "Aib", "Beal", "Meith", "Iúil", "Lún", "M.F.", "D.F.", "Samh", "Noll"],
            monthsParseExact: !0,
            weekdays: ["Dé Domhnaigh", "Dé Luain", "Dé Máirt", "Dé Céadaoin", "Déardaoin", "Dé hAoine", "Dé Sathairn"],
            weekdaysShort: ["Domh", "Luan", "Máirt", "Céad", "Déar", "Aoine", "Sath"],
            weekdaysMin: ["Do", "Lu", "Má", "Cé", "Dé", "A", "Sa"],
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Inniu ag] LT",
                nextDay: "[Amárach ag] LT",
                nextWeek: "dddd [ag] LT",
                lastDay: "[Inné ag] LT",
                lastWeek: "dddd [seo caite] [ag] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "i %s",
                past: "%s ó shin",
                s: "cúpla soicind",
                ss: "%d soicind",
                m: "nóiméad",
                mm: "%d nóiméad",
                h: "uair an chloig",
                hh: "%d uair an chloig",
                d: "lá",
                dd: "%d lá",
                M: "mí",
                MM: "%d míonna",
                y: "bliain",
                yy: "%d bliain"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
            ordinal: function(e) {
                var t = 1 === e ? "d" : e % 10 == 2 ? "na" : "mh";
                return e + t
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("gd", {
            months: ["Am Faoilleach", "An Gearran", "Am Màrt", "An Giblean", "An Cèitean", "An t-Ògmhios", "An t-Iuchar", "An Lùnastal", "An t-Sultain", "An Dàmhair", "An t-Samhain", "An Dùbhlachd"],
            monthsShort: ["Faoi", "Gear", "Màrt", "Gibl", "Cèit", "Ògmh", "Iuch", "Lùn", "Sult", "Dàmh", "Samh", "Dùbh"],
            monthsParseExact: !0,
            weekdays: ["Didòmhnaich", "Diluain", "Dimàirt", "Diciadain", "Diardaoin", "Dihaoine", "Disathairne"],
            weekdaysShort: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
            weekdaysMin: ["Dò", "Lu", "Mà", "Ci", "Ar", "Ha", "Sa"],
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[An-diugh aig] LT",
                nextDay: "[A-màireach aig] LT",
                nextWeek: "dddd [aig] LT",
                lastDay: "[An-dè aig] LT",
                lastWeek: "dddd [seo chaidh] [aig] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "ann an %s",
                past: "bho chionn %s",
                s: "beagan diogan",
                ss: "%d diogan",
                m: "mionaid",
                mm: "%d mionaidean",
                h: "uair",
                hh: "%d uairean",
                d: "latha",
                dd: "%d latha",
                M: "mìos",
                MM: "%d mìosan",
                y: "bliadhna",
                yy: "%d bliadhna"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
            ordinal: function(e) {
                var t = 1 === e ? "d" : e % 10 == 2 ? "na" : "mh";
                return e + t
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("gl", {
            months: "xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),
            monthsShort: "xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split("_"),
            monthsParseExact: !0,
            weekdays: "domingo_luns_martes_mércores_xoves_venres_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mér._xov._ven._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mé_xo_ve_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY H:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
            },
            calendar: {
                sameDay: function() {
                    return "[hoxe " + (1 !== this.hours() ? "ás" : "á") + "] LT"
                },
                nextDay: function() {
                    return "[mañá " + (1 !== this.hours() ? "ás" : "á") + "] LT"
                },
                nextWeek: function() {
                    return "dddd [" + (1 !== this.hours() ? "ás" : "a") + "] LT"
                },
                lastDay: function() {
                    return "[onte " + (1 !== this.hours() ? "á" : "a") + "] LT"
                },
                lastWeek: function() {
                    return "[o] dddd [pasado " + (1 !== this.hours() ? "ás" : "a") + "] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: function(e) {
                    return 0 === e.indexOf("un") ? "n" + e : "en " + e
                },
                past: "hai %s",
                s: "uns segundos",
                ss: "%d segundos",
                m: "un minuto",
                mm: "%d minutos",
                h: "unha hora",
                hh: "%d horas",
                d: "un día",
                dd: "%d días",
                M: "un mes",
                MM: "%d meses",
                y: "un ano",
                yy: "%d anos"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = {
                s: ["थोडया सॅकंडांनी", "थोडे सॅकंड"],
                ss: [e + " सॅकंडांनी", e + " सॅकंड"],
                m: ["एका मिणटान", "एक मिनूट"],
                mm: [e + " मिणटांनी", e + " मिणटां"],
                h: ["एका वरान", "एक वर"],
                hh: [e + " वरांनी", e + " वरां"],
                d: ["एका दिसान", "एक दीस"],
                dd: [e + " दिसांनी", e + " दीस"],
                M: ["एका म्हयन्यान", "एक म्हयनो"],
                MM: [e + " म्हयन्यानी", e + " म्हयने"],
                y: ["एका वर्सान", "एक वर्स"],
                yy: [e + " वर्सांनी", e + " वर्सां"]
            };
            return i ? s[n][0] : s[n][1]
        }
        e.defineLocale("gom-deva", {
            months: {
                standalone: "जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),
                format: "जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या".split("_"),
                isFormat: /MMMM(\s)+D[oD]?/
            },
            monthsShort: "जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),
            monthsParseExact: !0,
            weekdays: "आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार".split("_"),
            weekdaysShort: "आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.".split("_"),
            weekdaysMin: "आ_सो_मं_बु_ब्रे_सु_शे".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "A h:mm [वाजतां]",
                LTS: "A h:mm:ss [वाजतां]",
                L: "DD-MM-YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY A h:mm [वाजतां]",
                LLLL: "dddd, MMMM Do, YYYY, A h:mm [वाजतां]",
                llll: "ddd, D MMM YYYY, A h:mm [वाजतां]"
            },
            calendar: {
                sameDay: "[आयज] LT",
                nextDay: "[फाल्यां] LT",
                nextWeek: "[फुडलो] dddd[,] LT",
                lastDay: "[काल] LT",
                lastWeek: "[फाटलो] dddd[,] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s",
                past: "%s आदीं",
                s: t,
                ss: t,
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: t,
                dd: t,
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "D":
                        return e + "वेर";
                    default:
                    case "M":
                    case "Q":
                    case "DDD":
                    case "d":
                    case "w":
                    case "W":
                        return e
                }
            },
            week: {
                dow: 0,
                doy: 3
            },
            meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "राती" === t ? e < 4 ? e : e + 12 : "सकाळीं" === t ? e : "दनपारां" === t ? e > 12 ? e : e + 12 : "सांजे" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "राती" : e < 12 ? "सकाळीं" : e < 16 ? "दनपारां" : e < 20 ? "सांजे" : "राती"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = {
                s: ["thoddea sekondamni", "thodde sekond"],
                ss: [e + " sekondamni", e + " sekond"],
                m: ["eka mintan", "ek minut"],
                mm: [e + " mintamni", e + " mintam"],
                h: ["eka voran", "ek vor"],
                hh: [e + " voramni", e + " voram"],
                d: ["eka disan", "ek dis"],
                dd: [e + " disamni", e + " dis"],
                M: ["eka mhoinean", "ek mhoino"],
                MM: [e + " mhoineamni", e + " mhoine"],
                y: ["eka vorsan", "ek voros"],
                yy: [e + " vorsamni", e + " vorsam"]
            };
            return i ? s[n][0] : s[n][1]
        }
        e.defineLocale("gom-latn", {
            months: {
                standalone: "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),
                format: "Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split("_"),
                isFormat: /MMMM(\s)+D[oD]?/
            },
            monthsShort: "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),
            monthsParseExact: !0,
            weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),
            weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
            weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "A h:mm [vazta]",
                LTS: "A h:mm:ss [vazta]",
                L: "DD-MM-YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY A h:mm [vazta]",
                LLLL: "dddd, MMMM Do, YYYY, A h:mm [vazta]",
                llll: "ddd, D MMM YYYY, A h:mm [vazta]"
            },
            calendar: {
                sameDay: "[Aiz] LT",
                nextDay: "[Faleam] LT",
                nextWeek: "[Fuddlo] dddd[,] LT",
                lastDay: "[Kal] LT",
                lastWeek: "[Fattlo] dddd[,] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s",
                past: "%s adim",
                s: t,
                ss: t,
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: t,
                dd: t,
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "D":
                        return e + "er";
                    default:
                    case "M":
                    case "Q":
                    case "DDD":
                    case "d":
                    case "w":
                    case "W":
                        return e
                }
            },
            week: {
                dow: 0,
                doy: 3
            },
            meridiemParse: /rati|sokallim|donparam|sanje/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "rati" === t ? e < 4 ? e : e + 12 : "sokallim" === t ? e : "donparam" === t ? e > 12 ? e : e + 12 : "sanje" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "rati" : e < 12 ? "sokallim" : e < 16 ? "donparam" : e < 20 ? "sanje" : "rati"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "૧",
                2: "૨",
                3: "૩",
                4: "૪",
                5: "૫",
                6: "૬",
                7: "૭",
                8: "૮",
                9: "૯",
                0: "૦"
            },
            n = {
                "૧": "1",
                "૨": "2",
                "૩": "3",
                "૪": "4",
                "૫": "5",
                "૬": "6",
                "૭": "7",
                "૮": "8",
                "૯": "9",
                "૦": "0"
            };
        e.defineLocale("gu", {
            months: "જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર".split("_"),
            monthsShort: "જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.".split("_"),
            monthsParseExact: !0,
            weekdays: "રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર".split("_"),
            weekdaysShort: "રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ".split("_"),
            weekdaysMin: "ર_સો_મં_બુ_ગુ_શુ_શ".split("_"),
            longDateFormat: {
                LT: "A h:mm વાગ્યે",
                LTS: "A h:mm:ss વાગ્યે",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm વાગ્યે",
                LLLL: "dddd, D MMMM YYYY, A h:mm વાગ્યે"
            },
            calendar: {
                sameDay: "[આજ] LT",
                nextDay: "[કાલે] LT",
                nextWeek: "dddd, LT",
                lastDay: "[ગઇકાલે] LT",
                lastWeek: "[પાછલા] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s મા",
                past: "%s પહેલા",
                s: "અમુક પળો",
                ss: "%d સેકંડ",
                m: "એક મિનિટ",
                mm: "%d મિનિટ",
                h: "એક કલાક",
                hh: "%d કલાક",
                d: "એક દિવસ",
                dd: "%d દિવસ",
                M: "એક મહિનો",
                MM: "%d મહિનો",
                y: "એક વર્ષ",
                yy: "%d વર્ષ"
            },
            preparse: function(e) {
                return e.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "રાત" === t ? e < 4 ? e : e + 12 : "સવાર" === t ? e : "બપોર" === t ? e >= 10 ? e : e + 12 : "સાંજ" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "રાત" : e < 10 ? "સવાર" : e < 17 ? "બપોર" : e < 20 ? "સાંજ" : "રાત"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("he", {
            months: "ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),
            monthsShort: "ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),
            weekdays: "ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),
            weekdaysShort: "א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),
            weekdaysMin: "א_ב_ג_ד_ה_ו_ש".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [ב]MMMM YYYY",
                LLL: "D [ב]MMMM YYYY HH:mm",
                LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
                l: "D/M/YYYY",
                ll: "D MMM YYYY",
                lll: "D MMM YYYY HH:mm",
                llll: "ddd, D MMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[היום ב־]LT",
                nextDay: "[מחר ב־]LT",
                nextWeek: "dddd [בשעה] LT",
                lastDay: "[אתמול ב־]LT",
                lastWeek: "[ביום] dddd [האחרון בשעה] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "בעוד %s",
                past: "לפני %s",
                s: "מספר שניות",
                ss: "%d שניות",
                m: "דקה",
                mm: "%d דקות",
                h: "שעה",
                hh: function(e) {
                    return 2 === e ? "שעתיים" : e + " שעות"
                },
                d: "יום",
                dd: function(e) {
                    return 2 === e ? "יומיים" : e + " ימים"
                },
                M: "חודש",
                MM: function(e) {
                    return 2 === e ? "חודשיים" : e + " חודשים"
                },
                y: "שנה",
                yy: function(e) {
                    return 2 === e ? "שנתיים" : e % 10 == 0 && 10 !== e ? e + " שנה" : e + " שנים"
                }
            },
            meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
            isPM: function(e) {
                return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 5 ? "לפנות בוקר" : e < 10 ? "בבוקר" : e < 12 ? n ? 'לפנה"צ' : "לפני הצהריים" : e < 18 ? n ? 'אחה"צ' : "אחרי הצהריים" : "בערב"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "१",
                2: "२",
                3: "३",
                4: "४",
                5: "५",
                6: "६",
                7: "७",
                8: "८",
                9: "९",
                0: "०"
            },
            n = {
                "१": "1",
                "२": "2",
                "३": "3",
                "४": "4",
                "५": "5",
                "६": "6",
                "७": "7",
                "८": "8",
                "९": "9",
                "०": "0"
            },
            i = [/^जन/i, /^फ़र|फर/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सितं|सित/i, /^अक्टू/i, /^नव|नवं/i, /^दिसं|दिस/i];
        e.defineLocale("hi", {
            months: {
                format: "जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),
                standalone: "जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर".split("_")
            },
            monthsShort: "जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),
            weekdays: "रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),
            weekdaysShort: "रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),
            weekdaysMin: "र_सो_मं_बु_गु_शु_श".split("_"),
            longDateFormat: {
                LT: "A h:mm बजे",
                LTS: "A h:mm:ss बजे",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm बजे",
                LLLL: "dddd, D MMMM YYYY, A h:mm बजे"
            },
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: [/^जन/i, /^फ़र/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सित/i, /^अक्टू/i, /^नव/i, /^दिस/i],
            monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
            monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
            monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
            monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
            calendar: {
                sameDay: "[आज] LT",
                nextDay: "[कल] LT",
                nextWeek: "dddd, LT",
                lastDay: "[कल] LT",
                lastWeek: "[पिछले] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s में",
                past: "%s पहले",
                s: "कुछ ही क्षण",
                ss: "%d सेकंड",
                m: "एक मिनट",
                mm: "%d मिनट",
                h: "एक घंटा",
                hh: "%d घंटे",
                d: "एक दिन",
                dd: "%d दिन",
                M: "एक महीने",
                MM: "%d महीने",
                y: "एक वर्ष",
                yy: "%d वर्ष"
            },
            preparse: function(e) {
                return e.replace(/[१२३४५६७८९०]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /रात|सुबह|दोपहर|शाम/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "रात" === t ? e < 4 ? e : e + 12 : "सुबह" === t ? e : "दोपहर" === t ? e >= 10 ? e : e + 12 : "शाम" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "रात" : e < 10 ? "सुबह" : e < 17 ? "दोपहर" : e < 20 ? "शाम" : "रात"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n) {
            var i = e + " ";
            switch (n) {
                case "ss":
                    return i += 1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi";
                case "m":
                    return t ? "jedna minuta" : "jedne minute";
                case "mm":
                    return i += 1 === e ? "minuta" : 2 === e || 3 === e || 4 === e ? "minute" : "minuta";
                case "h":
                    return t ? "jedan sat" : "jednog sata";
                case "hh":
                    return i += 1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati";
                case "dd":
                    return i += 1 === e ? "dan" : "dana";
                case "MM":
                    return i += 1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci";
                case "yy":
                    return i += 1 === e ? "godina" : 2 === e || 3 === e || 4 === e ? "godine" : "godina"
            }
        }
        e.defineLocale("hr", {
            months: {
                format: "siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),
                standalone: "siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")
            },
            monthsShort: "sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),
            monthsParseExact: !0,
            weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
            weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "Do MMMM YYYY",
                LLL: "Do MMMM YYYY H:mm",
                LLLL: "dddd, Do MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[danas u] LT",
                nextDay: "[sutra u] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[u] [nedjelju] [u] LT";
                        case 3:
                            return "[u] [srijedu] [u] LT";
                        case 6:
                            return "[u] [subotu] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[u] dddd [u] LT"
                    }
                },
                lastDay: "[jučer u] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[prošlu] [nedjelju] [u] LT";
                        case 3:
                            return "[prošlu] [srijedu] [u] LT";
                        case 6:
                            return "[prošle] [subote] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[prošli] dddd [u] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "za %s",
                past: "prije %s",
                s: "par sekundi",
                ss: t,
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: "dan",
                dd: t,
                M: "mjesec",
                MM: t,
                y: "godinu",
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" ");

        function n(e, t, n, i) {
            var s = e;
            switch (n) {
                case "s":
                    return i || t ? "néhány másodperc" : "néhány másodperce";
                case "ss":
                    return s + (i || t) ? " másodperc" : " másodperce";
                case "m":
                    return "egy" + (i || t ? " perc" : " perce");
                case "mm":
                    return s + (i || t ? " perc" : " perce");
                case "h":
                    return "egy" + (i || t ? " óra" : " órája");
                case "hh":
                    return s + (i || t ? " óra" : " órája");
                case "d":
                    return "egy" + (i || t ? " nap" : " napja");
                case "dd":
                    return s + (i || t ? " nap" : " napja");
                case "M":
                    return "egy" + (i || t ? " hónap" : " hónapja");
                case "MM":
                    return s + (i || t ? " hónap" : " hónapja");
                case "y":
                    return "egy" + (i || t ? " év" : " éve");
                case "yy":
                    return s + (i || t ? " év" : " éve")
            }
            return ""
        }

        function i(e) {
            return (e ? "" : "[múlt] ") + "[" + t[this.day()] + "] LT[-kor]"
        }
        e.defineLocale("hu", {
            months: "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),
            monthsShort: "jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.".split("_"),
            monthsParseExact: !0,
            weekdays: "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),
            weekdaysShort: "vas_hét_kedd_sze_csüt_pén_szo".split("_"),
            weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "YYYY.MM.DD.",
                LL: "YYYY. MMMM D.",
                LLL: "YYYY. MMMM D. H:mm",
                LLLL: "YYYY. MMMM D., dddd H:mm"
            },
            meridiemParse: /de|du/i,
            isPM: function(e) {
                return "u" === e.charAt(1).toLowerCase()
            },
            meridiem: function(e, t, n) {
                return e < 12 ? !0 === n ? "de" : "DE" : !0 === n ? "du" : "DU"
            },
            calendar: {
                sameDay: "[ma] LT[-kor]",
                nextDay: "[holnap] LT[-kor]",
                nextWeek: function() {
                    return i.call(this, !0)
                },
                lastDay: "[tegnap] LT[-kor]",
                lastWeek: function() {
                    return i.call(this, !1)
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "%s múlva",
                past: "%s",
                s: n,
                ss: n,
                m: n,
                mm: n,
                h: n,
                hh: n,
                d: n,
                dd: n,
                M: n,
                MM: n,
                y: n,
                yy: n
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("hy-am", {
            months: {
                format: "հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի".split("_"),
                standalone: "հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր".split("_")
            },
            monthsShort: "հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ".split("_"),
            weekdays: "կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ".split("_"),
            weekdaysShort: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
            weekdaysMin: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY թ.",
                LLL: "D MMMM YYYY թ., HH:mm",
                LLLL: "dddd, D MMMM YYYY թ., HH:mm"
            },
            calendar: {
                sameDay: "[այսօր] LT",
                nextDay: "[վաղը] LT",
                lastDay: "[երեկ] LT",
                nextWeek: function() {
                    return "dddd [օրը ժամը] LT"
                },
                lastWeek: function() {
                    return "[անցած] dddd [օրը ժամը] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "%s հետո",
                past: "%s առաջ",
                s: "մի քանի վայրկյան",
                ss: "%d վայրկյան",
                m: "րոպե",
                mm: "%d րոպե",
                h: "ժամ",
                hh: "%d ժամ",
                d: "օր",
                dd: "%d օր",
                M: "ամիս",
                MM: "%d ամիս",
                y: "տարի",
                yy: "%d տարի"
            },
            meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
            isPM: function(e) {
                return /^(ցերեկվա|երեկոյան)$/.test(e)
            },
            meridiem: function(e) {
                return e < 4 ? "գիշերվա" : e < 12 ? "առավոտվա" : e < 17 ? "ցերեկվա" : "երեկոյան"
            },
            dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "DDD":
                    case "w":
                    case "W":
                    case "DDDo":
                        return 1 === e ? e + "-ին" : e + "-րդ";
                    default:
                        return e
                }
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("id", {
            months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
            weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
            weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
            weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [pukul] HH.mm",
                LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
            },
            meridiemParse: /pagi|siang|sore|malam/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "pagi" === t ? e : "siang" === t ? e >= 11 ? e : e + 12 : "sore" === t || "malam" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 11 ? "pagi" : e < 15 ? "siang" : e < 19 ? "sore" : "malam"
            },
            calendar: {
                sameDay: "[Hari ini pukul] LT",
                nextDay: "[Besok pukul] LT",
                nextWeek: "dddd [pukul] LT",
                lastDay: "[Kemarin pukul] LT",
                lastWeek: "dddd [lalu pukul] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "dalam %s",
                past: "%s yang lalu",
                s: "beberapa detik",
                ss: "%d detik",
                m: "semenit",
                mm: "%d menit",
                h: "sejam",
                hh: "%d jam",
                d: "sehari",
                dd: "%d hari",
                M: "sebulan",
                MM: "%d bulan",
                y: "setahun",
                yy: "%d tahun"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e) {
            return e % 100 == 11 || e % 10 != 1
        }

        function n(e, n, i, s) {
            var a = e + " ";
            switch (i) {
                case "s":
                    return n || s ? "nokkrar sekúndur" : "nokkrum sekúndum";
                case "ss":
                    return t(e) ? a + (n || s ? "sekúndur" : "sekúndum") : a + "sekúnda";
                case "m":
                    return n ? "mínúta" : "mínútu";
                case "mm":
                    return t(e) ? a + (n || s ? "mínútur" : "mínútum") : n ? a + "mínúta" : a + "mínútu";
                case "hh":
                    return t(e) ? a + (n || s ? "klukkustundir" : "klukkustundum") : a + "klukkustund";
                case "d":
                    return n ? "dagur" : s ? "dag" : "degi";
                case "dd":
                    return t(e) ? n ? a + "dagar" : a + (s ? "daga" : "dögum") : n ? a + "dagur" : a + (s ? "dag" : "degi");
                case "M":
                    return n ? "mánuður" : s ? "mánuð" : "mánuði";
                case "MM":
                    return t(e) ? n ? a + "mánuðir" : a + (s ? "mánuði" : "mánuðum") : n ? a + "mánuður" : a + (s ? "mánuð" : "mánuði");
                case "y":
                    return n || s ? "ár" : "ári";
                case "yy":
                    return t(e) ? a + (n || s ? "ár" : "árum") : a + (n || s ? "ár" : "ári")
            }
        }
        e.defineLocale("is", {
            months: "janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),
            monthsShort: "jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),
            weekdays: "sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),
            weekdaysShort: "sun_mán_þri_mið_fim_fös_lau".split("_"),
            weekdaysMin: "Su_Má_Þr_Mi_Fi_Fö_La".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY [kl.] H:mm",
                LLLL: "dddd, D. MMMM YYYY [kl.] H:mm"
            },
            calendar: {
                sameDay: "[í dag kl.] LT",
                nextDay: "[á morgun kl.] LT",
                nextWeek: "dddd [kl.] LT",
                lastDay: "[í gær kl.] LT",
                lastWeek: "[síðasta] dddd [kl.] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "eftir %s",
                past: "fyrir %s síðan",
                s: n,
                ss: n,
                m: n,
                mm: n,
                h: "klukkustund",
                hh: n,
                d: n,
                dd: n,
                M: n,
                MM: n,
                y: n,
                yy: n
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("it", {
            months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
            monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
            weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
            weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
            weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: function() {
                    return "[Oggi a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT"
                },
                nextDay: function() {
                    return "[Domani a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT"
                },
                nextWeek: function() {
                    return "dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT"
                },
                lastDay: function() {
                    return "[Ieri a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT"
                },
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[La scorsa] dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
                        default:
                            return "[Lo scorso] dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "tra %s",
                past: "%s fa",
                s: "alcuni secondi",
                ss: "%d secondi",
                m: "un minuto",
                mm: "%d minuti",
                h: "un'ora",
                hh: "%d ore",
                d: "un giorno",
                dd: "%d giorni",
                w: "una settimana",
                ww: "%d settimane",
                M: "un mese",
                MM: "%d mesi",
                y: "un anno",
                yy: "%d anni"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("it-ch", {
            months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
            monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
            weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
            weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
            weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Oggi alle] LT",
                nextDay: "[Domani alle] LT",
                nextWeek: "dddd [alle] LT",
                lastDay: "[Ieri alle] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[la scorsa] dddd [alle] LT";
                        default:
                            return "[lo scorso] dddd [alle] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: function(e) {
                    return (/^[0-9].+$/.test(e) ? "tra" : "in") + " " + e
                },
                past: "%s fa",
                s: "alcuni secondi",
                ss: "%d secondi",
                m: "un minuto",
                mm: "%d minuti",
                h: "un'ora",
                hh: "%d ore",
                d: "un giorno",
                dd: "%d giorni",
                M: "un mese",
                MM: "%d mesi",
                y: "un anno",
                yy: "%d anni"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ja", {
            eras: [{
                since: "2019-05-01",
                offset: 1,
                name: "令和",
                narrow: "㋿",
                abbr: "R"
            }, {
                since: "1989-01-08",
                until: "2019-04-30",
                offset: 1,
                name: "平成",
                narrow: "㍻",
                abbr: "H"
            }, {
                since: "1926-12-25",
                until: "1989-01-07",
                offset: 1,
                name: "昭和",
                narrow: "㍼",
                abbr: "S"
            }, {
                since: "1912-07-30",
                until: "1926-12-24",
                offset: 1,
                name: "大正",
                narrow: "㍽",
                abbr: "T"
            }, {
                since: "1873-01-01",
                until: "1912-07-29",
                offset: 6,
                name: "明治",
                narrow: "㍾",
                abbr: "M"
            }, {
                since: "0001-01-01",
                until: "1873-12-31",
                offset: 1,
                name: "西暦",
                narrow: "AD",
                abbr: "AD"
            }, {
                since: "0000-12-31",
                until: -1 / 0,
                offset: 1,
                name: "紀元前",
                narrow: "BC",
                abbr: "BC"
            }],
            eraYearOrdinalRegex: /(元|\d+)年/,
            eraYearOrdinalParse: function(e, t) {
                return "元" === t[1] ? 1 : parseInt(t[1] || e, 10)
            },
            months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),
            weekdaysShort: "日_月_火_水_木_金_土".split("_"),
            weekdaysMin: "日_月_火_水_木_金_土".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY年M月D日",
                LLL: "YYYY年M月D日 HH:mm",
                LLLL: "YYYY年M月D日 dddd HH:mm",
                l: "YYYY/MM/DD",
                ll: "YYYY年M月D日",
                lll: "YYYY年M月D日 HH:mm",
                llll: "YYYY年M月D日(ddd) HH:mm"
            },
            meridiemParse: /午前|午後/i,
            isPM: function(e) {
                return "午後" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "午前" : "午後"
            },
            calendar: {
                sameDay: "[今日] LT",
                nextDay: "[明日] LT",
                nextWeek: function(e) {
                    return e.week() !== this.week() ? "[来週]dddd LT" : "dddd LT"
                },
                lastDay: "[昨日] LT",
                lastWeek: function(e) {
                    return this.week() !== e.week() ? "[先週]dddd LT" : "dddd LT"
                },
                sameElse: "L"
            },
            dayOfMonthOrdinalParse: /\d{1,2}日/,
            ordinal: function(e, t) {
                switch (t) {
                    case "y":
                        return 1 === e ? "元年" : e + "年";
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "日";
                    default:
                        return e
                }
            },
            relativeTime: {
                future: "%s後",
                past: "%s前",
                s: "数秒",
                ss: "%d秒",
                m: "1分",
                mm: "%d分",
                h: "1時間",
                hh: "%d時間",
                d: "1日",
                dd: "%d日",
                M: "1ヶ月",
                MM: "%dヶ月",
                y: "1年",
                yy: "%d年"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("jv", {
            months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
            weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
            weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
            weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [pukul] HH.mm",
                LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
            },
            meridiemParse: /enjing|siyang|sonten|ndalu/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "enjing" === t ? e : "siyang" === t ? e >= 11 ? e : e + 12 : "sonten" === t || "ndalu" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 11 ? "enjing" : e < 15 ? "siyang" : e < 19 ? "sonten" : "ndalu"
            },
            calendar: {
                sameDay: "[Dinten puniko pukul] LT",
                nextDay: "[Mbenjang pukul] LT",
                nextWeek: "dddd [pukul] LT",
                lastDay: "[Kala wingi pukul] LT",
                lastWeek: "dddd [kepengker pukul] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "wonten ing %s",
                past: "%s ingkang kepengker",
                s: "sawetawis detik",
                ss: "%d detik",
                m: "setunggal menit",
                mm: "%d menit",
                h: "setunggal jam",
                hh: "%d jam",
                d: "sedinten",
                dd: "%d dinten",
                M: "sewulan",
                MM: "%d wulan",
                y: "setaun",
                yy: "%d taun"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ka", {
            months: "იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),
            monthsShort: "იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),
            weekdays: {
                standalone: "კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),
                format: "კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split("_"),
                isFormat: /(წინა|შემდეგ)/
            },
            weekdaysShort: "კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),
            weekdaysMin: "კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[დღეს] LT[-ზე]",
                nextDay: "[ხვალ] LT[-ზე]",
                lastDay: "[გუშინ] LT[-ზე]",
                nextWeek: "[შემდეგ] dddd LT[-ზე]",
                lastWeek: "[წინა] dddd LT-ზე",
                sameElse: "L"
            },
            relativeTime: {
                future: function(e) {
                    return e.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function(e, t, n) {
                        return "ი" === n ? t + "ში" : t + n + "ში"
                    })
                },
                past: function(e) {
                    return /(წამი|წუთი|საათი|დღე|თვე)/.test(e) ? e.replace(/(ი|ე)$/, "ის წინ") : /წელი/.test(e) ? e.replace(/წელი$/, "წლის წინ") : e
                },
                s: "რამდენიმე წამი",
                ss: "%d წამი",
                m: "წუთი",
                mm: "%d წუთი",
                h: "საათი",
                hh: "%d საათი",
                d: "დღე",
                dd: "%d დღე",
                M: "თვე",
                MM: "%d თვე",
                y: "წელი",
                yy: "%d წელი"
            },
            dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
            ordinal: function(e) {
                return 0 === e ? e : 1 === e ? e + "-ლი" : e < 20 || e <= 100 && e % 20 == 0 || e % 100 == 0 ? "მე-" + e : e + "-ე"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            0: "-ші",
            1: "-ші",
            2: "-ші",
            3: "-ші",
            4: "-ші",
            5: "-ші",
            6: "-шы",
            7: "-ші",
            8: "-ші",
            9: "-шы",
            10: "-шы",
            20: "-шы",
            30: "-шы",
            40: "-шы",
            50: "-ші",
            60: "-шы",
            70: "-ші",
            80: "-ші",
            90: "-шы",
            100: "-ші"
        };
        e.defineLocale("kk", {
            months: "қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split("_"),
            monthsShort: "қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),
            weekdays: "жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split("_"),
            weekdaysShort: "жек_дүй_сей_сәр_бей_жұм_сен".split("_"),
            weekdaysMin: "жк_дй_сй_ср_бй_жм_сн".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Бүгін сағат] LT",
                nextDay: "[Ертең сағат] LT",
                nextWeek: "dddd [сағат] LT",
                lastDay: "[Кеше сағат] LT",
                lastWeek: "[Өткен аптаның] dddd [сағат] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s ішінде",
                past: "%s бұрын",
                s: "бірнеше секунд",
                ss: "%d секунд",
                m: "бір минут",
                mm: "%d минут",
                h: "бір сағат",
                hh: "%d сағат",
                d: "бір күн",
                dd: "%d күн",
                M: "бір ай",
                MM: "%d ай",
                y: "бір жыл",
                yy: "%d жыл"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
            ordinal: function(e) {
                var n = e % 10,
                    i = e >= 100 ? 100 : null;
                return e + (t[e] || t[n] || t[i])
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "១",
                2: "២",
                3: "៣",
                4: "៤",
                5: "៥",
                6: "៦",
                7: "៧",
                8: "៨",
                9: "៩",
                0: "០"
            },
            n = {
                "១": "1",
                "២": "2",
                "៣": "3",
                "៤": "4",
                "៥": "5",
                "៦": "6",
                "៧": "7",
                "៨": "8",
                "៩": "9",
                "០": "0"
            };
        e.defineLocale("km", {
            months: "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
            monthsShort: "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
            weekdays: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
            weekdaysShort: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
            weekdaysMin: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            meridiemParse: /ព្រឹក|ល្ងាច/,
            isPM: function(e) {
                return "ល្ងាច" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "ព្រឹក" : "ល្ងាច"
            },
            calendar: {
                sameDay: "[ថ្ងៃនេះ ម៉ោង] LT",
                nextDay: "[ស្អែក ម៉ោង] LT",
                nextWeek: "dddd [ម៉ោង] LT",
                lastDay: "[ម្សិលមិញ ម៉ោង] LT",
                lastWeek: "dddd [សប្តាហ៍មុន] [ម៉ោង] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%sទៀត",
                past: "%sមុន",
                s: "ប៉ុន្មានវិនាទី",
                ss: "%d វិនាទី",
                m: "មួយនាទី",
                mm: "%d នាទី",
                h: "មួយម៉ោង",
                hh: "%d ម៉ោង",
                d: "មួយថ្ងៃ",
                dd: "%d ថ្ងៃ",
                M: "មួយខែ",
                MM: "%d ខែ",
                y: "មួយឆ្នាំ",
                yy: "%d ឆ្នាំ"
            },
            dayOfMonthOrdinalParse: /ទី\d{1,2}/,
            ordinal: "ទី%d",
            preparse: function(e) {
                return e.replace(/[១២៣៤៥៦៧៨៩០]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "೧",
                2: "೨",
                3: "೩",
                4: "೪",
                5: "೫",
                6: "೬",
                7: "೭",
                8: "೮",
                9: "೯",
                0: "೦"
            },
            n = {
                "೧": "1",
                "೨": "2",
                "೩": "3",
                "೪": "4",
                "೫": "5",
                "೬": "6",
                "೭": "7",
                "೮": "8",
                "೯": "9",
                "೦": "0"
            };
        e.defineLocale("kn", {
            months: "ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್".split("_"),
            monthsShort: "ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ".split("_"),
            monthsParseExact: !0,
            weekdays: "ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ".split("_"),
            weekdaysShort: "ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ".split("_"),
            weekdaysMin: "ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ".split("_"),
            longDateFormat: {
                LT: "A h:mm",
                LTS: "A h:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm",
                LLLL: "dddd, D MMMM YYYY, A h:mm"
            },
            calendar: {
                sameDay: "[ಇಂದು] LT",
                nextDay: "[ನಾಳೆ] LT",
                nextWeek: "dddd, LT",
                lastDay: "[ನಿನ್ನೆ] LT",
                lastWeek: "[ಕೊನೆಯ] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s ನಂತರ",
                past: "%s ಹಿಂದೆ",
                s: "ಕೆಲವು ಕ್ಷಣಗಳು",
                ss: "%d ಸೆಕೆಂಡುಗಳು",
                m: "ಒಂದು ನಿಮಿಷ",
                mm: "%d ನಿಮಿಷ",
                h: "ಒಂದು ಗಂಟೆ",
                hh: "%d ಗಂಟೆ",
                d: "ಒಂದು ದಿನ",
                dd: "%d ದಿನ",
                M: "ಒಂದು ತಿಂಗಳು",
                MM: "%d ತಿಂಗಳು",
                y: "ಒಂದು ವರ್ಷ",
                yy: "%d ವರ್ಷ"
            },
            preparse: function(e) {
                return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "ರಾತ್ರಿ" === t ? e < 4 ? e : e + 12 : "ಬೆಳಿಗ್ಗೆ" === t ? e : "ಮಧ್ಯಾಹ್ನ" === t ? e >= 10 ? e : e + 12 : "ಸಂಜೆ" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "ರಾತ್ರಿ" : e < 10 ? "ಬೆಳಿಗ್ಗೆ" : e < 17 ? "ಮಧ್ಯಾಹ್ನ" : e < 20 ? "ಸಂಜೆ" : "ರಾತ್ರಿ"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
            ordinal: function(e) {
                return e + "ನೇ"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ko", {
            months: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
            monthsShort: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
            weekdays: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),
            weekdaysShort: "일_월_화_수_목_금_토".split("_"),
            weekdaysMin: "일_월_화_수_목_금_토".split("_"),
            longDateFormat: {
                LT: "A h:mm",
                LTS: "A h:mm:ss",
                L: "YYYY.MM.DD.",
                LL: "YYYY년 MMMM D일",
                LLL: "YYYY년 MMMM D일 A h:mm",
                LLLL: "YYYY년 MMMM D일 dddd A h:mm",
                l: "YYYY.MM.DD.",
                ll: "YYYY년 MMMM D일",
                lll: "YYYY년 MMMM D일 A h:mm",
                llll: "YYYY년 MMMM D일 dddd A h:mm"
            },
            calendar: {
                sameDay: "오늘 LT",
                nextDay: "내일 LT",
                nextWeek: "dddd LT",
                lastDay: "어제 LT",
                lastWeek: "지난주 dddd LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s 후",
                past: "%s 전",
                s: "몇 초",
                ss: "%d초",
                m: "1분",
                mm: "%d분",
                h: "한 시간",
                hh: "%d시간",
                d: "하루",
                dd: "%d일",
                M: "한 달",
                MM: "%d달",
                y: "일 년",
                yy: "%d년"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "일";
                    case "M":
                        return e + "월";
                    case "w":
                    case "W":
                        return e + "주";
                    default:
                        return e
                }
            },
            meridiemParse: /오전|오후/,
            isPM: function(e) {
                return "오후" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "오전" : "오후"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "١",
                2: "٢",
                3: "٣",
                4: "٤",
                5: "٥",
                6: "٦",
                7: "٧",
                8: "٨",
                9: "٩",
                0: "٠"
            },
            n = {
                "١": "1",
                "٢": "2",
                "٣": "3",
                "٤": "4",
                "٥": "5",
                "٦": "6",
                "٧": "7",
                "٨": "8",
                "٩": "9",
                "٠": "0"
            },
            i = ["کانونی دووەم", "شوبات", "ئازار", "نیسان", "ئایار", "حوزەیران", "تەمموز", "ئاب", "ئەیلوول", "تشرینی یەكەم", "تشرینی دووەم", "كانونی یەکەم"];
        e.defineLocale("ku", {
            months: i,
            monthsShort: i,
            weekdays: "یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌".split("_"),
            weekdaysShort: "یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌".split("_"),
            weekdaysMin: "ی_د_س_چ_پ_ه_ش".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            meridiemParse: /ئێواره‌|به‌یانی/,
            isPM: function(e) {
                return /ئێواره‌/.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "به‌یانی" : "ئێواره‌"
            },
            calendar: {
                sameDay: "[ئه‌مرۆ كاتژمێر] LT",
                nextDay: "[به‌یانی كاتژمێر] LT",
                nextWeek: "dddd [كاتژمێر] LT",
                lastDay: "[دوێنێ كاتژمێر] LT",
                lastWeek: "dddd [كاتژمێر] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "له‌ %s",
                past: "%s",
                s: "چه‌ند چركه‌یه‌ك",
                ss: "چركه‌ %d",
                m: "یه‌ك خوله‌ك",
                mm: "%d خوله‌ك",
                h: "یه‌ك كاتژمێر",
                hh: "%d كاتژمێر",
                d: "یه‌ك ڕۆژ",
                dd: "%d ڕۆژ",
                M: "یه‌ك مانگ",
                MM: "%d مانگ",
                y: "یه‌ك ساڵ",
                yy: "%d ساڵ"
            },
            preparse: function(e) {
                return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(e) {
                    return n[e]
                }).replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                }).replace(/,/g, "،")
            },
            week: {
                dow: 6,
                doy: 12
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            0: "-чү",
            1: "-чи",
            2: "-чи",
            3: "-чү",
            4: "-чү",
            5: "-чи",
            6: "-чы",
            7: "-чи",
            8: "-чи",
            9: "-чу",
            10: "-чу",
            20: "-чы",
            30: "-чу",
            40: "-чы",
            50: "-чү",
            60: "-чы",
            70: "-чи",
            80: "-чи",
            90: "-чу",
            100: "-чү"
        };
        e.defineLocale("ky", {
            months: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),
            monthsShort: "янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек".split("_"),
            weekdays: "Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби".split("_"),
            weekdaysShort: "Жек_Дүй_Шей_Шар_Бей_Жум_Ише".split("_"),
            weekdaysMin: "Жк_Дй_Шй_Шр_Бй_Жм_Иш".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Бүгүн саат] LT",
                nextDay: "[Эртең саат] LT",
                nextWeek: "dddd [саат] LT",
                lastDay: "[Кечээ саат] LT",
                lastWeek: "[Өткөн аптанын] dddd [күнү] [саат] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s ичинде",
                past: "%s мурун",
                s: "бирнече секунд",
                ss: "%d секунд",
                m: "бир мүнөт",
                mm: "%d мүнөт",
                h: "бир саат",
                hh: "%d саат",
                d: "бир күн",
                dd: "%d күн",
                M: "бир ай",
                MM: "%d ай",
                y: "бир жыл",
                yy: "%d жыл"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
            ordinal: function(e) {
                var n = e % 10,
                    i = e >= 100 ? 100 : null;
                return e + (t[e] || t[n] || t[i])
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = {
                m: ["eng Minutt", "enger Minutt"],
                h: ["eng Stonn", "enger Stonn"],
                d: ["een Dag", "engem Dag"],
                M: ["ee Mount", "engem Mount"],
                y: ["ee Joer", "engem Joer"]
            };
            return t ? s[n][0] : s[n][1]
        }

        function n(e) {
            if (e = parseInt(e, 10), isNaN(e)) return !1;
            if (e < 0) return !0;
            if (e < 10) return 4 <= e && e <= 7;
            if (e < 100) {
                var t = e % 10,
                    i = e / 10;
                return n(0 === t ? i : t)
            }
            if (e < 1e4) {
                for (; e >= 10;) e /= 10;
                return n(e)
            }
            return n(e /= 1e3)
        }
        e.defineLocale("lb", {
            months: "Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
            monthsShort: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
            monthsParseExact: !0,
            weekdays: "Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),
            weekdaysShort: "So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mé_Dë_Më_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm [Auer]",
                LTS: "H:mm:ss [Auer]",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm [Auer]",
                LLLL: "dddd, D. MMMM YYYY H:mm [Auer]"
            },
            calendar: {
                sameDay: "[Haut um] LT",
                sameElse: "L",
                nextDay: "[Muer um] LT",
                nextWeek: "dddd [um] LT",
                lastDay: "[Gëschter um] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 2:
                        case 4:
                            return "[Leschten] dddd [um] LT";
                        default:
                            return "[Leschte] dddd [um] LT"
                    }
                }
            },
            relativeTime: {
                future: function(e) {
                    return n(e.substr(0, e.indexOf(" "))) ? "a " + e : "an " + e
                },
                past: function(e) {
                    return n(e.substr(0, e.indexOf(" "))) ? "viru " + e : "virun " + e
                },
                s: "e puer Sekonnen",
                ss: "%d Sekonnen",
                m: t,
                mm: "%d Minutten",
                h: t,
                hh: "%d Stonnen",
                d: t,
                dd: "%d Deeg",
                M: t,
                MM: "%d Méint",
                y: t,
                yy: "%d Joer"
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("lo", {
            months: "ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),
            monthsShort: "ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),
            weekdays: "ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),
            weekdaysShort: "ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),
            weekdaysMin: "ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "ວັນdddd D MMMM YYYY HH:mm"
            },
            meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
            isPM: function(e) {
                return "ຕອນແລງ" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "ຕອນເຊົ້າ" : "ຕອນແລງ"
            },
            calendar: {
                sameDay: "[ມື້ນີ້ເວລາ] LT",
                nextDay: "[ມື້ອື່ນເວລາ] LT",
                nextWeek: "[ວັນ]dddd[ໜ້າເວລາ] LT",
                lastDay: "[ມື້ວານນີ້ເວລາ] LT",
                lastWeek: "[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "ອີກ %s",
                past: "%sຜ່ານມາ",
                s: "ບໍ່ເທົ່າໃດວິນາທີ",
                ss: "%d ວິນາທີ",
                m: "1 ນາທີ",
                mm: "%d ນາທີ",
                h: "1 ຊົ່ວໂມງ",
                hh: "%d ຊົ່ວໂມງ",
                d: "1 ມື້",
                dd: "%d ມື້",
                M: "1 ເດືອນ",
                MM: "%d ເດືອນ",
                y: "1 ປີ",
                yy: "%d ປີ"
            },
            dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
            ordinal: function(e) {
                return "ທີ່" + e
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            ss: "sekundė_sekundžių_sekundes",
            m: "minutė_minutės_minutę",
            mm: "minutės_minučių_minutes",
            h: "valanda_valandos_valandą",
            hh: "valandos_valandų_valandas",
            d: "diena_dienos_dieną",
            dd: "dienos_dienų_dienas",
            M: "mėnuo_mėnesio_mėnesį",
            MM: "mėnesiai_mėnesių_mėnesius",
            y: "metai_metų_metus",
            yy: "metai_metų_metus"
        };

        function n(e, t, n, i) {
            return t ? s(n)[0] : i ? s(n)[1] : s(n)[2]
        }

        function i(e) {
            return e % 10 == 0 || e > 10 && e < 20
        }

        function s(e) {
            return t[e].split("_")
        }

        function a(e, t, a, o) {
            var r = e + " ";
            return 1 === e ? r + n(0, t, a[0], o) : t ? r + (i(e) ? s(a)[1] : s(a)[0]) : o ? r + s(a)[1] : r + (i(e) ? s(a)[1] : s(a)[2])
        }
        e.defineLocale("lt", {
            months: {
                format: "sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),
                standalone: "sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),
                isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
            },
            monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
            weekdays: {
                format: "sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),
                standalone: "sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),
                isFormat: /dddd HH:mm/
            },
            weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),
            weekdaysMin: "S_P_A_T_K_Pn_Š".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "YYYY [m.] MMMM D [d.]",
                LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
                LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
                l: "YYYY-MM-DD",
                ll: "YYYY [m.] MMMM D [d.]",
                lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
                llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
            },
            calendar: {
                sameDay: "[Šiandien] LT",
                nextDay: "[Rytoj] LT",
                nextWeek: "dddd LT",
                lastDay: "[Vakar] LT",
                lastWeek: "[Praėjusį] dddd LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "po %s",
                past: "prieš %s",
                s: function(e, t, n, i) {
                    return t ? "kelios sekundės" : i ? "kelių sekundžių" : "kelias sekundes"
                },
                ss: a,
                m: n,
                mm: a,
                h: n,
                hh: a,
                d: n,
                dd: a,
                M: n,
                MM: a,
                y: n,
                yy: a
            },
            dayOfMonthOrdinalParse: /\d{1,2}-oji/,
            ordinal: function(e) {
                return e + "-oji"
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            ss: "sekundes_sekundēm_sekunde_sekundes".split("_"),
            m: "minūtes_minūtēm_minūte_minūtes".split("_"),
            mm: "minūtes_minūtēm_minūte_minūtes".split("_"),
            h: "stundas_stundām_stunda_stundas".split("_"),
            hh: "stundas_stundām_stunda_stundas".split("_"),
            d: "dienas_dienām_diena_dienas".split("_"),
            dd: "dienas_dienām_diena_dienas".split("_"),
            M: "mēneša_mēnešiem_mēnesis_mēneši".split("_"),
            MM: "mēneša_mēnešiem_mēnesis_mēneši".split("_"),
            y: "gada_gadiem_gads_gadi".split("_"),
            yy: "gada_gadiem_gads_gadi".split("_")
        };

        function n(e, t, n) {
            return n ? t % 10 == 1 && t % 100 != 11 ? e[2] : e[3] : t % 10 == 1 && t % 100 != 11 ? e[0] : e[1]
        }

        function i(e, i, s) {
            return e + " " + n(t[s], e, i)
        }

        function s(e, i, s) {
            return n(t[s], e, i)
        }
        e.defineLocale("lv", {
            months: "janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),
            monthsShort: "jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),
            weekdays: "svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),
            weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
            weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY.",
                LL: "YYYY. [gada] D. MMMM",
                LLL: "YYYY. [gada] D. MMMM, HH:mm",
                LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm"
            },
            calendar: {
                sameDay: "[Šodien pulksten] LT",
                nextDay: "[Rīt pulksten] LT",
                nextWeek: "dddd [pulksten] LT",
                lastDay: "[Vakar pulksten] LT",
                lastWeek: "[Pagājušā] dddd [pulksten] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "pēc %s",
                past: "pirms %s",
                s: function(e, t) {
                    return t ? "dažas sekundes" : "dažām sekundēm"
                },
                ss: i,
                m: s,
                mm: i,
                h: s,
                hh: i,
                d: s,
                dd: i,
                M: s,
                MM: i,
                y: s,
                yy: i
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            words: {
                ss: ["sekund", "sekunda", "sekundi"],
                m: ["jedan minut", "jednog minuta"],
                mm: ["minut", "minuta", "minuta"],
                h: ["jedan sat", "jednog sata"],
                hh: ["sat", "sata", "sati"],
                dd: ["dan", "dana", "dana"],
                MM: ["mjesec", "mjeseca", "mjeseci"],
                yy: ["godina", "godine", "godina"]
            },
            correctGrammaticalCase: function(e, t) {
                return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2]
            },
            translate: function(e, n, i) {
                var s = t.words[i];
                return 1 === i.length ? n ? s[0] : s[1] : e + " " + t.correctGrammaticalCase(e, s)
            }
        };
        e.defineLocale("me", {
            months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
            monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
            monthsParseExact: !0,
            weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
            weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd, D. MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[danas u] LT",
                nextDay: "[sjutra u] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[u] [nedjelju] [u] LT";
                        case 3:
                            return "[u] [srijedu] [u] LT";
                        case 6:
                            return "[u] [subotu] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[u] dddd [u] LT"
                    }
                },
                lastDay: "[juče u] LT",
                lastWeek: function() {
                    return ["[prošle] [nedjelje] [u] LT", "[prošlog] [ponedjeljka] [u] LT", "[prošlog] [utorka] [u] LT", "[prošle] [srijede] [u] LT", "[prošlog] [četvrtka] [u] LT", "[prošlog] [petka] [u] LT", "[prošle] [subote] [u] LT"][this.day()]
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "za %s",
                past: "prije %s",
                s: "nekoliko sekundi",
                ss: t.translate,
                m: t.translate,
                mm: t.translate,
                h: t.translate,
                hh: t.translate,
                d: "dan",
                dd: t.translate,
                M: "mjesec",
                MM: t.translate,
                y: "godinu",
                yy: t.translate
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("mi", {
            months: "Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea".split("_"),
            monthsShort: "Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),
            monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
            weekdays: "Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei".split("_"),
            weekdaysShort: "Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),
            weekdaysMin: "Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [i] HH:mm",
                LLLL: "dddd, D MMMM YYYY [i] HH:mm"
            },
            calendar: {
                sameDay: "[i teie mahana, i] LT",
                nextDay: "[apopo i] LT",
                nextWeek: "dddd [i] LT",
                lastDay: "[inanahi i] LT",
                lastWeek: "dddd [whakamutunga i] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "i roto i %s",
                past: "%s i mua",
                s: "te hēkona ruarua",
                ss: "%d hēkona",
                m: "he meneti",
                mm: "%d meneti",
                h: "te haora",
                hh: "%d haora",
                d: "he ra",
                dd: "%d ra",
                M: "he marama",
                MM: "%d marama",
                y: "he tau",
                yy: "%d tau"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("mk", {
            months: "јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),
            monthsShort: "јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),
            weekdays: "недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),
            weekdaysShort: "нед_пон_вто_сре_чет_пет_саб".split("_"),
            weekdaysMin: "нe_пo_вт_ср_че_пе_сa".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "D.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY H:mm",
                LLLL: "dddd, D MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[Денес во] LT",
                nextDay: "[Утре во] LT",
                nextWeek: "[Во] dddd [во] LT",
                lastDay: "[Вчера во] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                        case 3:
                        case 6:
                            return "[Изминатата] dddd [во] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[Изминатиот] dddd [во] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "за %s",
                past: "пред %s",
                s: "неколку секунди",
                ss: "%d секунди",
                m: "една минута",
                mm: "%d минути",
                h: "еден час",
                hh: "%d часа",
                d: "еден ден",
                dd: "%d дена",
                M: "еден месец",
                MM: "%d месеци",
                y: "една година",
                yy: "%d години"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = e % 100;
                return 0 === e ? e + "-ев" : 0 === n ? e + "-ен" : n > 10 && n < 20 ? e + "-ти" : 1 === t ? e + "-ви" : 2 === t ? e + "-ри" : 7 === t || 8 === t ? e + "-ми" : e + "-ти"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ml", {
            months: "ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ".split("_"),
            monthsShort: "ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.".split("_"),
            monthsParseExact: !0,
            weekdays: "ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച".split("_"),
            weekdaysShort: "ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി".split("_"),
            weekdaysMin: "ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ".split("_"),
            longDateFormat: {
                LT: "A h:mm -നു",
                LTS: "A h:mm:ss -നു",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm -നു",
                LLLL: "dddd, D MMMM YYYY, A h:mm -നു"
            },
            calendar: {
                sameDay: "[ഇന്ന്] LT",
                nextDay: "[നാളെ] LT",
                nextWeek: "dddd, LT",
                lastDay: "[ഇന്നലെ] LT",
                lastWeek: "[കഴിഞ്ഞ] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s കഴിഞ്ഞ്",
                past: "%s മുൻപ്",
                s: "അൽപ നിമിഷങ്ങൾ",
                ss: "%d സെക്കൻഡ്",
                m: "ഒരു മിനിറ്റ്",
                mm: "%d മിനിറ്റ്",
                h: "ഒരു മണിക്കൂർ",
                hh: "%d മണിക്കൂർ",
                d: "ഒരു ദിവസം",
                dd: "%d ദിവസം",
                M: "ഒരു മാസം",
                MM: "%d മാസം",
                y: "ഒരു വർഷം",
                yy: "%d വർഷം"
            },
            meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "രാത്രി" === t && e >= 4 || "ഉച്ച കഴിഞ്ഞ്" === t || "വൈകുന്നേരം" === t ? e + 12 : e
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "രാത്രി" : e < 12 ? "രാവിലെ" : e < 17 ? "ഉച്ച കഴിഞ്ഞ്" : e < 20 ? "വൈകുന്നേരം" : "രാത്രി"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            switch (n) {
                case "s":
                    return t ? "хэдхэн секунд" : "хэдхэн секундын";
                case "ss":
                    return e + (t ? " секунд" : " секундын");
                case "m":
                case "mm":
                    return e + (t ? " минут" : " минутын");
                case "h":
                case "hh":
                    return e + (t ? " цаг" : " цагийн");
                case "d":
                case "dd":
                    return e + (t ? " өдөр" : " өдрийн");
                case "M":
                case "MM":
                    return e + (t ? " сар" : " сарын");
                case "y":
                case "yy":
                    return e + (t ? " жил" : " жилийн");
                default:
                    return e
            }
        }
        e.defineLocale("mn", {
            months: "Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар".split("_"),
            monthsShort: "1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар".split("_"),
            monthsParseExact: !0,
            weekdays: "Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба".split("_"),
            weekdaysShort: "Ням_Дав_Мяг_Лха_Пүр_Баа_Бям".split("_"),
            weekdaysMin: "Ня_Да_Мя_Лх_Пү_Ба_Бя".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "YYYY оны MMMMын D",
                LLL: "YYYY оны MMMMын D HH:mm",
                LLLL: "dddd, YYYY оны MMMMын D HH:mm"
            },
            meridiemParse: /ҮӨ|ҮХ/i,
            isPM: function(e) {
                return "ҮХ" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "ҮӨ" : "ҮХ"
            },
            calendar: {
                sameDay: "[Өнөөдөр] LT",
                nextDay: "[Маргааш] LT",
                nextWeek: "[Ирэх] dddd LT",
                lastDay: "[Өчигдөр] LT",
                lastWeek: "[Өнгөрсөн] dddd LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s дараа",
                past: "%s өмнө",
                s: t,
                ss: t,
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: t,
                dd: t,
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
            ordinal: function(e, t) {
                switch (t) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + " өдөр";
                    default:
                        return e
                }
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "१",
                2: "२",
                3: "३",
                4: "४",
                5: "५",
                6: "६",
                7: "७",
                8: "८",
                9: "९",
                0: "०"
            },
            n = {
                "१": "1",
                "२": "2",
                "३": "3",
                "४": "4",
                "५": "5",
                "६": "6",
                "७": "7",
                "८": "8",
                "९": "9",
                "०": "0"
            };

        function i(e, t, n, i) {
            var s = "";
            if (t) switch (n) {
                case "s":
                    s = "काही सेकंद";
                    break;
                case "ss":
                    s = "%d सेकंद";
                    break;
                case "m":
                    s = "एक मिनिट";
                    break;
                case "mm":
                    s = "%d मिनिटे";
                    break;
                case "h":
                    s = "एक तास";
                    break;
                case "hh":
                    s = "%d तास";
                    break;
                case "d":
                    s = "एक दिवस";
                    break;
                case "dd":
                    s = "%d दिवस";
                    break;
                case "M":
                    s = "एक महिना";
                    break;
                case "MM":
                    s = "%d महिने";
                    break;
                case "y":
                    s = "एक वर्ष";
                    break;
                case "yy":
                    s = "%d वर्षे"
            } else switch (n) {
                case "s":
                    s = "काही सेकंदां";
                    break;
                case "ss":
                    s = "%d सेकंदां";
                    break;
                case "m":
                    s = "एका मिनिटा";
                    break;
                case "mm":
                    s = "%d मिनिटां";
                    break;
                case "h":
                    s = "एका तासा";
                    break;
                case "hh":
                    s = "%d तासां";
                    break;
                case "d":
                    s = "एका दिवसा";
                    break;
                case "dd":
                    s = "%d दिवसां";
                    break;
                case "M":
                    s = "एका महिन्या";
                    break;
                case "MM":
                    s = "%d महिन्यां";
                    break;
                case "y":
                    s = "एका वर्षा";
                    break;
                case "yy":
                    s = "%d वर्षां"
            }
            return s.replace(/%d/i, e)
        }
        e.defineLocale("mr", {
            months: "जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),
            monthsShort: "जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),
            monthsParseExact: !0,
            weekdays: "रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),
            weekdaysShort: "रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि".split("_"),
            weekdaysMin: "र_सो_मं_बु_गु_शु_श".split("_"),
            longDateFormat: {
                LT: "A h:mm वाजता",
                LTS: "A h:mm:ss वाजता",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm वाजता",
                LLLL: "dddd, D MMMM YYYY, A h:mm वाजता"
            },
            calendar: {
                sameDay: "[आज] LT",
                nextDay: "[उद्या] LT",
                nextWeek: "dddd, LT",
                lastDay: "[काल] LT",
                lastWeek: "[मागील] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%sमध्ये",
                past: "%sपूर्वी",
                s: i,
                ss: i,
                m: i,
                mm: i,
                h: i,
                hh: i,
                d: i,
                dd: i,
                M: i,
                MM: i,
                y: i,
                yy: i
            },
            preparse: function(e) {
                return e.replace(/[१२३४५६७८९०]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "पहाटे" === t || "सकाळी" === t ? e : "दुपारी" === t || "सायंकाळी" === t || "रात्री" === t ? e >= 12 ? e : e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e >= 0 && e < 6 ? "पहाटे" : e < 12 ? "सकाळी" : e < 17 ? "दुपारी" : e < 20 ? "सायंकाळी" : "रात्री"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ms", {
            months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
            monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
            weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
            weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
            weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [pukul] HH.mm",
                LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
            },
            meridiemParse: /pagi|tengahari|petang|malam/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "pagi" === t ? e : "tengahari" === t ? e >= 11 ? e : e + 12 : "petang" === t || "malam" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam"
            },
            calendar: {
                sameDay: "[Hari ini pukul] LT",
                nextDay: "[Esok pukul] LT",
                nextWeek: "dddd [pukul] LT",
                lastDay: "[Kelmarin pukul] LT",
                lastWeek: "dddd [lepas pukul] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "dalam %s",
                past: "%s yang lepas",
                s: "beberapa saat",
                ss: "%d saat",
                m: "seminit",
                mm: "%d minit",
                h: "sejam",
                hh: "%d jam",
                d: "sehari",
                dd: "%d hari",
                M: "sebulan",
                MM: "%d bulan",
                y: "setahun",
                yy: "%d tahun"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ms-my", {
            months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
            monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
            weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
            weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
            weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [pukul] HH.mm",
                LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
            },
            meridiemParse: /pagi|tengahari|petang|malam/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "pagi" === t ? e : "tengahari" === t ? e >= 11 ? e : e + 12 : "petang" === t || "malam" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam"
            },
            calendar: {
                sameDay: "[Hari ini pukul] LT",
                nextDay: "[Esok pukul] LT",
                nextWeek: "dddd [pukul] LT",
                lastDay: "[Kelmarin pukul] LT",
                lastWeek: "dddd [lepas pukul] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "dalam %s",
                past: "%s yang lepas",
                s: "beberapa saat",
                ss: "%d saat",
                m: "seminit",
                mm: "%d minit",
                h: "sejam",
                hh: "%d jam",
                d: "sehari",
                dd: "%d hari",
                M: "sebulan",
                MM: "%d bulan",
                y: "setahun",
                yy: "%d tahun"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("mt", {
            months: "Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru".split("_"),
            monthsShort: "Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ".split("_"),
            weekdays: "Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt".split("_"),
            weekdaysShort: "Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib".split("_"),
            weekdaysMin: "Ħa_Tn_Tl_Er_Ħa_Ġi_Si".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Illum fil-]LT",
                nextDay: "[Għada fil-]LT",
                nextWeek: "dddd [fil-]LT",
                lastDay: "[Il-bieraħ fil-]LT",
                lastWeek: "dddd [li għadda] [fil-]LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "f’ %s",
                past: "%s ilu",
                s: "ftit sekondi",
                ss: "%d sekondi",
                m: "minuta",
                mm: "%d minuti",
                h: "siegħa",
                hh: "%d siegħat",
                d: "ġurnata",
                dd: "%d ġranet",
                M: "xahar",
                MM: "%d xhur",
                y: "sena",
                yy: "%d sni"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "၁",
                2: "၂",
                3: "၃",
                4: "၄",
                5: "၅",
                6: "၆",
                7: "၇",
                8: "၈",
                9: "၉",
                0: "၀"
            },
            n = {
                "၁": "1",
                "၂": "2",
                "၃": "3",
                "၄": "4",
                "၅": "5",
                "၆": "6",
                "၇": "7",
                "၈": "8",
                "၉": "9",
                "၀": "0"
            };
        e.defineLocale("my", {
            months: "ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ".split("_"),
            monthsShort: "ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ".split("_"),
            weekdays: "တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ".split("_"),
            weekdaysShort: "နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),
            weekdaysMin: "နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[ယနေ.] LT [မှာ]",
                nextDay: "[မနက်ဖြန်] LT [မှာ]",
                nextWeek: "dddd LT [မှာ]",
                lastDay: "[မနေ.က] LT [မှာ]",
                lastWeek: "[ပြီးခဲ့သော] dddd LT [မှာ]",
                sameElse: "L"
            },
            relativeTime: {
                future: "လာမည့် %s မှာ",
                past: "လွန်ခဲ့သော %s က",
                s: "စက္ကန်.အနည်းငယ်",
                ss: "%d စက္ကန့်",
                m: "တစ်မိနစ်",
                mm: "%d မိနစ်",
                h: "တစ်နာရီ",
                hh: "%d နာရီ",
                d: "တစ်ရက်",
                dd: "%d ရက်",
                M: "တစ်လ",
                MM: "%d လ",
                y: "တစ်နှစ်",
                yy: "%d နှစ်"
            },
            preparse: function(e) {
                return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("nb", {
            months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
            monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
            monthsParseExact: !0,
            weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
            weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"),
            weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY [kl.] HH:mm",
                LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
            },
            calendar: {
                sameDay: "[i dag kl.] LT",
                nextDay: "[i morgen kl.] LT",
                nextWeek: "dddd [kl.] LT",
                lastDay: "[i går kl.] LT",
                lastWeek: "[forrige] dddd [kl.] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "om %s",
                past: "%s siden",
                s: "noen sekunder",
                ss: "%d sekunder",
                m: "ett minutt",
                mm: "%d minutter",
                h: "en time",
                hh: "%d timer",
                d: "en dag",
                dd: "%d dager",
                w: "en uke",
                ww: "%d uker",
                M: "en måned",
                MM: "%d måneder",
                y: "ett år",
                yy: "%d år"
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "१",
                2: "२",
                3: "३",
                4: "४",
                5: "५",
                6: "६",
                7: "७",
                8: "८",
                9: "९",
                0: "०"
            },
            n = {
                "१": "1",
                "२": "2",
                "३": "3",
                "४": "4",
                "५": "5",
                "६": "6",
                "७": "7",
                "८": "8",
                "९": "9",
                "०": "0"
            };
        e.defineLocale("ne", {
            months: "जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर".split("_"),
            monthsShort: "जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.".split("_"),
            monthsParseExact: !0,
            weekdays: "आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार".split("_"),
            weekdaysShort: "आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.".split("_"),
            weekdaysMin: "आ._सो._मं._बु._बि._शु._श.".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "Aको h:mm बजे",
                LTS: "Aको h:mm:ss बजे",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, Aको h:mm बजे",
                LLLL: "dddd, D MMMM YYYY, Aको h:mm बजे"
            },
            preparse: function(e) {
                return e.replace(/[१२३४५६७८९०]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "राति" === t ? e < 4 ? e : e + 12 : "बिहान" === t ? e : "दिउँसो" === t ? e >= 10 ? e : e + 12 : "साँझ" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 3 ? "राति" : e < 12 ? "बिहान" : e < 16 ? "दिउँसो" : e < 20 ? "साँझ" : "राति"
            },
            calendar: {
                sameDay: "[आज] LT",
                nextDay: "[भोलि] LT",
                nextWeek: "[आउँदो] dddd[,] LT",
                lastDay: "[हिजो] LT",
                lastWeek: "[गएको] dddd[,] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%sमा",
                past: "%s अगाडि",
                s: "केही क्षण",
                ss: "%d सेकेण्ड",
                m: "एक मिनेट",
                mm: "%d मिनेट",
                h: "एक घण्टा",
                hh: "%d घण्टा",
                d: "एक दिन",
                dd: "%d दिन",
                M: "एक महिना",
                MM: "%d महिना",
                y: "एक बर्ष",
                yy: "%d बर्ष"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
            n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
            i = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
            s = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
        e.defineLocale("nl", {
            months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
            monthsShort: function(e, i) {
                return e ? /-MMM-/.test(i) ? n[e.month()] : t[e.month()] : t
            },
            monthsRegex: s,
            monthsShortRegex: s,
            monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
            monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
            weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
            weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD-MM-YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[vandaag om] LT",
                nextDay: "[morgen om] LT",
                nextWeek: "dddd [om] LT",
                lastDay: "[gisteren om] LT",
                lastWeek: "[afgelopen] dddd [om] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "over %s",
                past: "%s geleden",
                s: "een paar seconden",
                ss: "%d seconden",
                m: "één minuut",
                mm: "%d minuten",
                h: "één uur",
                hh: "%d uur",
                d: "één dag",
                dd: "%d dagen",
                w: "één week",
                ww: "%d weken",
                M: "één maand",
                MM: "%d maanden",
                y: "één jaar",
                yy: "%d jaar"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function(e) {
                return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de")
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
            n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
            i = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
            s = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
        e.defineLocale("nl-be", {
            months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
            monthsShort: function(e, i) {
                return e ? /-MMM-/.test(i) ? n[e.month()] : t[e.month()] : t
            },
            monthsRegex: s,
            monthsShortRegex: s,
            monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
            monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
            weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
            weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[vandaag om] LT",
                nextDay: "[morgen om] LT",
                nextWeek: "dddd [om] LT",
                lastDay: "[gisteren om] LT",
                lastWeek: "[afgelopen] dddd [om] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "over %s",
                past: "%s geleden",
                s: "een paar seconden",
                ss: "%d seconden",
                m: "één minuut",
                mm: "%d minuten",
                h: "één uur",
                hh: "%d uur",
                d: "één dag",
                dd: "%d dagen",
                M: "één maand",
                MM: "%d maanden",
                y: "één jaar",
                yy: "%d jaar"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function(e) {
                return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de")
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("nn", {
            months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
            monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
            monthsParseExact: !0,
            weekdays: "sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
            weekdaysShort: "su._må._ty._on._to._fr._lau.".split("_"),
            weekdaysMin: "su_må_ty_on_to_fr_la".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY [kl.] H:mm",
                LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
            },
            calendar: {
                sameDay: "[I dag klokka] LT",
                nextDay: "[I morgon klokka] LT",
                nextWeek: "dddd [klokka] LT",
                lastDay: "[I går klokka] LT",
                lastWeek: "[Føregåande] dddd [klokka] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "om %s",
                past: "%s sidan",
                s: "nokre sekund",
                ss: "%d sekund",
                m: "eit minutt",
                mm: "%d minutt",
                h: "ein time",
                hh: "%d timar",
                d: "ein dag",
                dd: "%d dagar",
                w: "ei veke",
                ww: "%d veker",
                M: "ein månad",
                MM: "%d månader",
                y: "eit år",
                yy: "%d år"
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("oc-lnc", {
            months: {
                standalone: "genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre".split("_"),
                format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split("_"),
                isFormat: /D[oD]?(\s)+MMMM/
            },
            monthsShort: "gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),
            monthsParseExact: !0,
            weekdays: "dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte".split("_"),
            weekdaysShort: "dg._dl._dm._dc._dj._dv._ds.".split("_"),
            weekdaysMin: "dg_dl_dm_dc_dj_dv_ds".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM [de] YYYY",
                ll: "D MMM YYYY",
                LLL: "D MMMM [de] YYYY [a] H:mm",
                lll: "D MMM YYYY, H:mm",
                LLLL: "dddd D MMMM [de] YYYY [a] H:mm",
                llll: "ddd D MMM YYYY, H:mm"
            },
            calendar: {
                sameDay: "[uèi a] LT",
                nextDay: "[deman a] LT",
                nextWeek: "dddd [a] LT",
                lastDay: "[ièr a] LT",
                lastWeek: "dddd [passat a] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "d'aquí %s",
                past: "fa %s",
                s: "unas segondas",
                ss: "%d segondas",
                m: "una minuta",
                mm: "%d minutas",
                h: "una ora",
                hh: "%d oras",
                d: "un jorn",
                dd: "%d jorns",
                M: "un mes",
                MM: "%d meses",
                y: "un an",
                yy: "%d ans"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
            ordinal: function(e, t) {
                var n = 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "è";
                return "w" !== t && "W" !== t || (n = "a"), e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "੧",
                2: "੨",
                3: "੩",
                4: "੪",
                5: "੫",
                6: "੬",
                7: "੭",
                8: "੮",
                9: "੯",
                0: "੦"
            },
            n = {
                "੧": "1",
                "੨": "2",
                "੩": "3",
                "੪": "4",
                "੫": "5",
                "੬": "6",
                "੭": "7",
                "੮": "8",
                "੯": "9",
                "੦": "0"
            };
        e.defineLocale("pa-in", {
            months: "ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),
            monthsShort: "ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),
            weekdays: "ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ".split("_"),
            weekdaysShort: "ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),
            weekdaysMin: "ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),
            longDateFormat: {
                LT: "A h:mm ਵਜੇ",
                LTS: "A h:mm:ss ਵਜੇ",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm ਵਜੇ",
                LLLL: "dddd, D MMMM YYYY, A h:mm ਵਜੇ"
            },
            calendar: {
                sameDay: "[ਅਜ] LT",
                nextDay: "[ਕਲ] LT",
                nextWeek: "[ਅਗਲਾ] dddd, LT",
                lastDay: "[ਕਲ] LT",
                lastWeek: "[ਪਿਛਲੇ] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s ਵਿੱਚ",
                past: "%s ਪਿਛਲੇ",
                s: "ਕੁਝ ਸਕਿੰਟ",
                ss: "%d ਸਕਿੰਟ",
                m: "ਇਕ ਮਿੰਟ",
                mm: "%d ਮਿੰਟ",
                h: "ਇੱਕ ਘੰਟਾ",
                hh: "%d ਘੰਟੇ",
                d: "ਇੱਕ ਦਿਨ",
                dd: "%d ਦਿਨ",
                M: "ਇੱਕ ਮਹੀਨਾ",
                MM: "%d ਮਹੀਨੇ",
                y: "ਇੱਕ ਸਾਲ",
                yy: "%d ਸਾਲ"
            },
            preparse: function(e) {
                return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "ਰਾਤ" === t ? e < 4 ? e : e + 12 : "ਸਵੇਰ" === t ? e : "ਦੁਪਹਿਰ" === t ? e >= 10 ? e : e + 12 : "ਸ਼ਾਮ" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "ਰਾਤ" : e < 10 ? "ਸਵੇਰ" : e < 17 ? "ਦੁਪਹਿਰ" : e < 20 ? "ਸ਼ਾਮ" : "ਰਾਤ"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),
            n = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),
            i = [/^sty/i, /^lut/i, /^mar/i, /^kwi/i, /^maj/i, /^cze/i, /^lip/i, /^sie/i, /^wrz/i, /^paź/i, /^lis/i, /^gru/i];

        function s(e) {
            return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 != 1
        }

        function a(e, t, n) {
            var i = e + " ";
            switch (n) {
                case "ss":
                    return i + (s(e) ? "sekundy" : "sekund");
                case "m":
                    return t ? "minuta" : "minutę";
                case "mm":
                    return i + (s(e) ? "minuty" : "minut");
                case "h":
                    return t ? "godzina" : "godzinę";
                case "hh":
                    return i + (s(e) ? "godziny" : "godzin");
                case "ww":
                    return i + (s(e) ? "tygodnie" : "tygodni");
                case "MM":
                    return i + (s(e) ? "miesiące" : "miesięcy");
                case "yy":
                    return i + (s(e) ? "lata" : "lat")
            }
        }
        e.defineLocale("pl", {
            months: function(e, i) {
                return e ? /D MMMM/.test(i) ? n[e.month()] : t[e.month()] : t
            },
            monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),
            weekdaysShort: "ndz_pon_wt_śr_czw_pt_sob".split("_"),
            weekdaysMin: "Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Dziś o] LT",
                nextDay: "[Jutro o] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[W niedzielę o] LT";
                        case 2:
                            return "[We wtorek o] LT";
                        case 3:
                            return "[W środę o] LT";
                        case 6:
                            return "[W sobotę o] LT";
                        default:
                            return "[W] dddd [o] LT"
                    }
                },
                lastDay: "[Wczoraj o] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[W zeszłą niedzielę o] LT";
                        case 3:
                            return "[W zeszłą środę o] LT";
                        case 6:
                            return "[W zeszłą sobotę o] LT";
                        default:
                            return "[W zeszły] dddd [o] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "za %s",
                past: "%s temu",
                s: "kilka sekund",
                ss: a,
                m: a,
                mm: a,
                h: a,
                hh: a,
                d: "1 dzień",
                dd: "%d dni",
                w: "tydzień",
                ww: a,
                M: "miesiąc",
                MM: a,
                y: "rok",
                yy: a
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("pt", {
            months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
            monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
            weekdays: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),
            weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
            weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY HH:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Hoje às] LT",
                nextDay: "[Amanhã às] LT",
                nextWeek: "dddd [às] LT",
                lastDay: "[Ontem às] LT",
                lastWeek: function() {
                    return 0 === this.day() || 6 === this.day() ? "[Último] dddd [às] LT" : "[Última] dddd [às] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "em %s",
                past: "há %s",
                s: "segundos",
                ss: "%d segundos",
                m: "um minuto",
                mm: "%d minutos",
                h: "uma hora",
                hh: "%d horas",
                d: "um dia",
                dd: "%d dias",
                w: "uma semana",
                ww: "%d semanas",
                M: "um mês",
                MM: "%d meses",
                y: "um ano",
                yy: "%d anos"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("pt-br", {
            months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
            monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
            weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),
            weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"),
            weekdaysMin: "do_2ª_3ª_4ª_5ª_6ª_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY [às] HH:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm"
            },
            calendar: {
                sameDay: "[Hoje às] LT",
                nextDay: "[Amanhã às] LT",
                nextWeek: "dddd [às] LT",
                lastDay: "[Ontem às] LT",
                lastWeek: function() {
                    return 0 === this.day() || 6 === this.day() ? "[Último] dddd [às] LT" : "[Última] dddd [às] LT"
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "em %s",
                past: "há %s",
                s: "poucos segundos",
                ss: "%d segundos",
                m: "um minuto",
                mm: "%d minutos",
                h: "uma hora",
                hh: "%d horas",
                d: "um dia",
                dd: "%d dias",
                M: "um mês",
                MM: "%d meses",
                y: "um ano",
                yy: "%d anos"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            invalidDate: "Data inválida"
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n) {
            var i = " ";
            return (e % 100 >= 20 || e >= 100 && e % 100 == 0) && (i = " de "), e + i + {
                ss: "secunde",
                mm: "minute",
                hh: "ore",
                dd: "zile",
                ww: "săptămâni",
                MM: "luni",
                yy: "ani"
            } [n]
        }
        e.defineLocale("ro", {
            months: "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),
            monthsShort: "ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),
            monthsParseExact: !0,
            weekdays: "duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),
            weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),
            weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY H:mm",
                LLLL: "dddd, D MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[azi la] LT",
                nextDay: "[mâine la] LT",
                nextWeek: "dddd [la] LT",
                lastDay: "[ieri la] LT",
                lastWeek: "[fosta] dddd [la] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "peste %s",
                past: "%s în urmă",
                s: "câteva secunde",
                ss: t,
                m: "un minut",
                mm: t,
                h: "o oră",
                hh: t,
                d: "o zi",
                dd: t,
                w: "o săptămână",
                ww: t,
                M: "o lună",
                MM: t,
                y: "un an",
                yy: t
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n) {
            var i = {
                ss: t ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
                mm: t ? "минута_минуты_минут" : "минуту_минуты_минут",
                hh: "час_часа_часов",
                dd: "день_дня_дней",
                ww: "неделя_недели_недель",
                MM: "месяц_месяца_месяцев",
                yy: "год_года_лет"
            };
            return "m" === n ? t ? "минута" : "минуту" : e + " " + function(e, t) {
                var n = e.split("_");
                return t % 10 == 1 && t % 100 != 11 ? n[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? n[1] : n[2]
            }(i[n], +e)
        }
        var n = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
        e.defineLocale("ru", {
            months: {
                format: "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),
                standalone: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")
            },
            monthsShort: {
                format: "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),
                standalone: "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")
            },
            weekdays: {
                standalone: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),
                format: "воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),
                isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
            },
            weekdaysShort: "вс_пн_вт_ср_чт_пт_сб".split("_"),
            weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
            monthsParse: n,
            longMonthsParse: n,
            shortMonthsParse: n,
            monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
            monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
            monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
            monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY г.",
                LLL: "D MMMM YYYY г., H:mm",
                LLLL: "dddd, D MMMM YYYY г., H:mm"
            },
            calendar: {
                sameDay: "[Сегодня, в] LT",
                nextDay: "[Завтра, в] LT",
                lastDay: "[Вчера, в] LT",
                nextWeek: function(e) {
                    if (e.week() === this.week()) return 2 === this.day() ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
                    switch (this.day()) {
                        case 0:
                            return "[В следующее] dddd, [в] LT";
                        case 1:
                        case 2:
                        case 4:
                            return "[В следующий] dddd, [в] LT";
                        case 3:
                        case 5:
                        case 6:
                            return "[В следующую] dddd, [в] LT"
                    }
                },
                lastWeek: function(e) {
                    if (e.week() === this.week()) return 2 === this.day() ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
                    switch (this.day()) {
                        case 0:
                            return "[В прошлое] dddd, [в] LT";
                        case 1:
                        case 2:
                        case 4:
                            return "[В прошлый] dddd, [в] LT";
                        case 3:
                        case 5:
                        case 6:
                            return "[В прошлую] dddd, [в] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "через %s",
                past: "%s назад",
                s: "несколько секунд",
                ss: t,
                m: t,
                mm: t,
                h: "час",
                hh: t,
                d: "день",
                dd: t,
                w: "неделя",
                ww: t,
                M: "месяц",
                MM: t,
                y: "год",
                yy: t
            },
            meridiemParse: /ночи|утра|дня|вечера/i,
            isPM: function(e) {
                return /^(дня|вечера)$/.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "ночи" : e < 12 ? "утра" : e < 17 ? "дня" : "вечера"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "M":
                    case "d":
                    case "DDD":
                        return e + "-й";
                    case "D":
                        return e + "-го";
                    case "w":
                    case "W":
                        return e + "-я";
                    default:
                        return e
                }
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = ["جنوري", "فيبروري", "مارچ", "اپريل", "مئي", "جون", "جولاءِ", "آگسٽ", "سيپٽمبر", "آڪٽوبر", "نومبر", "ڊسمبر"],
            n = ["آچر", "سومر", "اڱارو", "اربع", "خميس", "جمع", "ڇنڇر"];
        e.defineLocale("sd", {
            months: t,
            monthsShort: t,
            weekdays: n,
            weekdaysShort: n,
            weekdaysMin: n,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd، D MMMM YYYY HH:mm"
            },
            meridiemParse: /صبح|شام/,
            isPM: function(e) {
                return "شام" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "صبح" : "شام"
            },
            calendar: {
                sameDay: "[اڄ] LT",
                nextDay: "[سڀاڻي] LT",
                nextWeek: "dddd [اڳين هفتي تي] LT",
                lastDay: "[ڪالهه] LT",
                lastWeek: "[گزريل هفتي] dddd [تي] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s پوء",
                past: "%s اڳ",
                s: "چند سيڪنڊ",
                ss: "%d سيڪنڊ",
                m: "هڪ منٽ",
                mm: "%d منٽ",
                h: "هڪ ڪلاڪ",
                hh: "%d ڪلاڪ",
                d: "هڪ ڏينهن",
                dd: "%d ڏينهن",
                M: "هڪ مهينو",
                MM: "%d مهينا",
                y: "هڪ سال",
                yy: "%d سال"
            },
            preparse: function(e) {
                return e.replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/,/g, "،")
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("se", {
            months: "ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu".split("_"),
            monthsShort: "ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov".split("_"),
            weekdays: "sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat".split("_"),
            weekdaysShort: "sotn_vuos_maŋ_gask_duor_bear_láv".split("_"),
            weekdaysMin: "s_v_m_g_d_b_L".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "MMMM D. [b.] YYYY",
                LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
                LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm"
            },
            calendar: {
                sameDay: "[otne ti] LT",
                nextDay: "[ihttin ti] LT",
                nextWeek: "dddd [ti] LT",
                lastDay: "[ikte ti] LT",
                lastWeek: "[ovddit] dddd [ti] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s geažes",
                past: "maŋit %s",
                s: "moadde sekunddat",
                ss: "%d sekunddat",
                m: "okta minuhta",
                mm: "%d minuhtat",
                h: "okta diimmu",
                hh: "%d diimmut",
                d: "okta beaivi",
                dd: "%d beaivvit",
                M: "okta mánnu",
                MM: "%d mánut",
                y: "okta jahki",
                yy: "%d jagit"
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("si", {
            months: "ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්".split("_"),
            monthsShort: "ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ".split("_"),
            weekdays: "ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා".split("_"),
            weekdaysShort: "ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන".split("_"),
            weekdaysMin: "ඉ_ස_අ_බ_බ්‍ර_සි_සෙ".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "a h:mm",
                LTS: "a h:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY MMMM D",
                LLL: "YYYY MMMM D, a h:mm",
                LLLL: "YYYY MMMM D [වැනි] dddd, a h:mm:ss"
            },
            calendar: {
                sameDay: "[අද] LT[ට]",
                nextDay: "[හෙට] LT[ට]",
                nextWeek: "dddd LT[ට]",
                lastDay: "[ඊයේ] LT[ට]",
                lastWeek: "[පසුගිය] dddd LT[ට]",
                sameElse: "L"
            },
            relativeTime: {
                future: "%sකින්",
                past: "%sකට පෙර",
                s: "තත්පර කිහිපය",
                ss: "තත්පර %d",
                m: "මිනිත්තුව",
                mm: "මිනිත්තු %d",
                h: "පැය",
                hh: "පැය %d",
                d: "දිනය",
                dd: "දින %d",
                M: "මාසය",
                MM: "මාස %d",
                y: "වසර",
                yy: "වසර %d"
            },
            dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
            ordinal: function(e) {
                return e + " වැනි"
            },
            meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
            isPM: function(e) {
                return "ප.ව." === e || "පස් වරු" === e
            },
            meridiem: function(e, t, n) {
                return e > 11 ? n ? "ප.ව." : "පස් වරු" : n ? "පෙ.ව." : "පෙර වරු"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),
            n = "jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");

        function i(e) {
            return e > 1 && e < 5
        }

        function s(e, t, n, s) {
            var a = e + " ";
            switch (n) {
                case "s":
                    return t || s ? "pár sekúnd" : "pár sekundami";
                case "ss":
                    return t || s ? a + (i(e) ? "sekundy" : "sekúnd") : a + "sekundami";
                case "m":
                    return t ? "minúta" : s ? "minútu" : "minútou";
                case "mm":
                    return t || s ? a + (i(e) ? "minúty" : "minút") : a + "minútami";
                case "h":
                    return t ? "hodina" : s ? "hodinu" : "hodinou";
                case "hh":
                    return t || s ? a + (i(e) ? "hodiny" : "hodín") : a + "hodinami";
                case "d":
                    return t || s ? "deň" : "dňom";
                case "dd":
                    return t || s ? a + (i(e) ? "dni" : "dní") : a + "dňami";
                case "M":
                    return t || s ? "mesiac" : "mesiacom";
                case "MM":
                    return t || s ? a + (i(e) ? "mesiace" : "mesiacov") : a + "mesiacmi";
                case "y":
                    return t || s ? "rok" : "rokom";
                case "yy":
                    return t || s ? a + (i(e) ? "roky" : "rokov") : a + "rokmi"
            }
        }
        e.defineLocale("sk", {
            months: t,
            monthsShort: n,
            weekdays: "nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),
            weekdaysShort: "ne_po_ut_st_št_pi_so".split("_"),
            weekdaysMin: "ne_po_ut_st_št_pi_so".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd D. MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[dnes o] LT",
                nextDay: "[zajtra o] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[v nedeľu o] LT";
                        case 1:
                        case 2:
                            return "[v] dddd [o] LT";
                        case 3:
                            return "[v stredu o] LT";
                        case 4:
                            return "[vo štvrtok o] LT";
                        case 5:
                            return "[v piatok o] LT";
                        case 6:
                            return "[v sobotu o] LT"
                    }
                },
                lastDay: "[včera o] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[minulú nedeľu o] LT";
                        case 1:
                        case 2:
                            return "[minulý] dddd [o] LT";
                        case 3:
                            return "[minulú stredu o] LT";
                        case 4:
                        case 5:
                            return "[minulý] dddd [o] LT";
                        case 6:
                            return "[minulú sobotu o] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "za %s",
                past: "pred %s",
                s: s,
                ss: s,
                m: s,
                mm: s,
                h: s,
                hh: s,
                d: s,
                dd: s,
                M: s,
                MM: s,
                y: s,
                yy: s
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = e + " ";
            switch (n) {
                case "s":
                    return t || i ? "nekaj sekund" : "nekaj sekundami";
                case "ss":
                    return s += 1 === e ? t ? "sekundo" : "sekundi" : 2 === e ? t || i ? "sekundi" : "sekundah" : e < 5 ? t || i ? "sekunde" : "sekundah" : "sekund";
                case "m":
                    return t ? "ena minuta" : "eno minuto";
                case "mm":
                    return s += 1 === e ? t ? "minuta" : "minuto" : 2 === e ? t || i ? "minuti" : "minutama" : e < 5 ? t || i ? "minute" : "minutami" : t || i ? "minut" : "minutami";
                case "h":
                    return t ? "ena ura" : "eno uro";
                case "hh":
                    return s += 1 === e ? t ? "ura" : "uro" : 2 === e ? t || i ? "uri" : "urama" : e < 5 ? t || i ? "ure" : "urami" : t || i ? "ur" : "urami";
                case "d":
                    return t || i ? "en dan" : "enim dnem";
                case "dd":
                    return s += 1 === e ? t || i ? "dan" : "dnem" : 2 === e ? t || i ? "dni" : "dnevoma" : t || i ? "dni" : "dnevi";
                case "M":
                    return t || i ? "en mesec" : "enim mesecem";
                case "MM":
                    return s += 1 === e ? t || i ? "mesec" : "mesecem" : 2 === e ? t || i ? "meseca" : "mesecema" : e < 5 ? t || i ? "mesece" : "meseci" : t || i ? "mesecev" : "meseci";
                case "y":
                    return t || i ? "eno leto" : "enim letom";
                case "yy":
                    return s += 1 === e ? t || i ? "leto" : "letom" : 2 === e ? t || i ? "leti" : "letoma" : e < 5 ? t || i ? "leta" : "leti" : t || i ? "let" : "leti"
            }
        }
        e.defineLocale("sl", {
            months: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),
            monthsShort: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
            monthsParseExact: !0,
            weekdays: "nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),
            weekdaysShort: "ned._pon._tor._sre._čet._pet._sob.".split("_"),
            weekdaysMin: "ne_po_to_sr_če_pe_so".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD. MM. YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd, D. MMMM YYYY H:mm"
            },
            calendar: {
                sameDay: "[danes ob] LT",
                nextDay: "[jutri ob] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[v] [nedeljo] [ob] LT";
                        case 3:
                            return "[v] [sredo] [ob] LT";
                        case 6:
                            return "[v] [soboto] [ob] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[v] dddd [ob] LT"
                    }
                },
                lastDay: "[včeraj ob] LT",
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[prejšnjo] [nedeljo] [ob] LT";
                        case 3:
                            return "[prejšnjo] [sredo] [ob] LT";
                        case 6:
                            return "[prejšnjo] [soboto] [ob] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[prejšnji] dddd [ob] LT"
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "čez %s",
                past: "pred %s",
                s: t,
                ss: t,
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: t,
                dd: t,
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("sq", {
            months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),
            monthsShort: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),
            weekdays: "E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),
            weekdaysShort: "Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),
            weekdaysMin: "D_H_Ma_Më_E_P_Sh".split("_"),
            weekdaysParseExact: !0,
            meridiemParse: /PD|MD/,
            isPM: function(e) {
                return "M" === e.charAt(0)
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "PD" : "MD"
            },
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Sot në] LT",
                nextDay: "[Nesër në] LT",
                nextWeek: "dddd [në] LT",
                lastDay: "[Dje në] LT",
                lastWeek: "dddd [e kaluar në] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "në %s",
                past: "%s më parë",
                s: "disa sekonda",
                ss: "%d sekonda",
                m: "një minutë",
                mm: "%d minuta",
                h: "një orë",
                hh: "%d orë",
                d: "një ditë",
                dd: "%d ditë",
                M: "një muaj",
                MM: "%d muaj",
                y: "një vit",
                yy: "%d vite"
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            words: {
                ss: ["sekunda", "sekunde", "sekundi"],
                m: ["jedan minut", "jedne minute"],
                mm: ["minut", "minute", "minuta"],
                h: ["jedan sat", "jednog sata"],
                hh: ["sat", "sata", "sati"],
                dd: ["dan", "dana", "dana"],
                MM: ["mesec", "meseca", "meseci"],
                yy: ["godina", "godine", "godina"]
            },
            correctGrammaticalCase: function(e, t) {
                return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2]
            },
            translate: function(e, n, i) {
                var s = t.words[i];
                return 1 === i.length ? n ? s[0] : s[1] : e + " " + t.correctGrammaticalCase(e, s)
            }
        };
        e.defineLocale("sr", {
            months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
            monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
            monthsParseExact: !0,
            weekdays: "nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),
            weekdaysShort: "ned._pon._uto._sre._čet._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "D. M. YYYY.",
                LL: "D. MMMM YYYY.",
                LLL: "D. MMMM YYYY. H:mm",
                LLLL: "dddd, D. MMMM YYYY. H:mm"
            },
            calendar: {
                sameDay: "[danas u] LT",
                nextDay: "[sutra u] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[u] [nedelju] [u] LT";
                        case 3:
                            return "[u] [sredu] [u] LT";
                        case 6:
                            return "[u] [subotu] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[u] dddd [u] LT"
                    }
                },
                lastDay: "[juče u] LT",
                lastWeek: function() {
                    return ["[prošle] [nedelje] [u] LT", "[prošlog] [ponedeljka] [u] LT", "[prošlog] [utorka] [u] LT", "[prošle] [srede] [u] LT", "[prošlog] [četvrtka] [u] LT", "[prošlog] [petka] [u] LT", "[prošle] [subote] [u] LT"][this.day()]
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "za %s",
                past: "pre %s",
                s: "nekoliko sekundi",
                ss: t.translate,
                m: t.translate,
                mm: t.translate,
                h: t.translate,
                hh: t.translate,
                d: "dan",
                dd: t.translate,
                M: "mesec",
                MM: t.translate,
                y: "godinu",
                yy: t.translate
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            words: {
                ss: ["секунда", "секунде", "секунди"],
                m: ["један минут", "једне минуте"],
                mm: ["минут", "минуте", "минута"],
                h: ["један сат", "једног сата"],
                hh: ["сат", "сата", "сати"],
                dd: ["дан", "дана", "дана"],
                MM: ["месец", "месеца", "месеци"],
                yy: ["година", "године", "година"]
            },
            correctGrammaticalCase: function(e, t) {
                return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2]
            },
            translate: function(e, n, i) {
                var s = t.words[i];
                return 1 === i.length ? n ? s[0] : s[1] : e + " " + t.correctGrammaticalCase(e, s)
            }
        };
        e.defineLocale("sr-cyrl", {
            months: "јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),
            monthsShort: "јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),
            monthsParseExact: !0,
            weekdays: "недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),
            weekdaysShort: "нед._пон._уто._сре._чет._пет._суб.".split("_"),
            weekdaysMin: "не_по_ут_ср_че_пе_су".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "D. M. YYYY.",
                LL: "D. MMMM YYYY.",
                LLL: "D. MMMM YYYY. H:mm",
                LLLL: "dddd, D. MMMM YYYY. H:mm"
            },
            calendar: {
                sameDay: "[данас у] LT",
                nextDay: "[сутра у] LT",
                nextWeek: function() {
                    switch (this.day()) {
                        case 0:
                            return "[у] [недељу] [у] LT";
                        case 3:
                            return "[у] [среду] [у] LT";
                        case 6:
                            return "[у] [суботу] [у] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[у] dddd [у] LT"
                    }
                },
                lastDay: "[јуче у] LT",
                lastWeek: function() {
                    return ["[прошле] [недеље] [у] LT", "[прошлог] [понедељка] [у] LT", "[прошлог] [уторка] [у] LT", "[прошле] [среде] [у] LT", "[прошлог] [четвртка] [у] LT", "[прошлог] [петка] [у] LT", "[прошле] [суботе] [у] LT"][this.day()]
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "за %s",
                past: "пре %s",
                s: "неколико секунди",
                ss: t.translate,
                m: t.translate,
                mm: t.translate,
                h: t.translate,
                hh: t.translate,
                d: "дан",
                dd: t.translate,
                M: "месец",
                MM: t.translate,
                y: "годину",
                yy: t.translate
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ss", {
            months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),
            monthsShort: "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
            weekdays: "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),
            weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
            weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A"
            },
            calendar: {
                sameDay: "[Namuhla nga] LT",
                nextDay: "[Kusasa nga] LT",
                nextWeek: "dddd [nga] LT",
                lastDay: "[Itolo nga] LT",
                lastWeek: "dddd [leliphelile] [nga] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "nga %s",
                past: "wenteka nga %s",
                s: "emizuzwana lomcane",
                ss: "%d mzuzwana",
                m: "umzuzu",
                mm: "%d emizuzu",
                h: "lihora",
                hh: "%d emahora",
                d: "lilanga",
                dd: "%d emalanga",
                M: "inyanga",
                MM: "%d tinyanga",
                y: "umnyaka",
                yy: "%d iminyaka"
            },
            meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
            meridiem: function(e, t, n) {
                return e < 11 ? "ekuseni" : e < 15 ? "emini" : e < 19 ? "entsambama" : "ebusuku"
            },
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "ekuseni" === t ? e : "emini" === t ? e >= 11 ? e : e + 12 : "entsambama" === t || "ebusuku" === t ? 0 === e ? 0 : e + 12 : void 0
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: "%d",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("sv", {
            months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
            monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
            weekdays: "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),
            weekdaysShort: "sön_mån_tis_ons_tor_fre_lör".split("_"),
            weekdaysMin: "sö_må_ti_on_to_fr_lö".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [kl.] HH:mm",
                LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
                lll: "D MMM YYYY HH:mm",
                llll: "ddd D MMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Idag] LT",
                nextDay: "[Imorgon] LT",
                lastDay: "[Igår] LT",
                nextWeek: "[På] dddd LT",
                lastWeek: "[I] dddd[s] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "om %s",
                past: "för %s sedan",
                s: "några sekunder",
                ss: "%d sekunder",
                m: "en minut",
                mm: "%d minuter",
                h: "en timme",
                hh: "%d timmar",
                d: "en dag",
                dd: "%d dagar",
                M: "en månad",
                MM: "%d månader",
                y: "ett år",
                yy: "%d år"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? ":e" : 1 === t ? ":a" : 2 === t ? ":a" : ":e";
                return e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("sw", {
            months: "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),
            monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),
            weekdays: "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),
            weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
            weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "hh:mm A",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[leo saa] LT",
                nextDay: "[kesho saa] LT",
                nextWeek: "[wiki ijayo] dddd [saat] LT",
                lastDay: "[jana] LT",
                lastWeek: "[wiki iliyopita] dddd [saat] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s baadaye",
                past: "tokea %s",
                s: "hivi punde",
                ss: "sekunde %d",
                m: "dakika moja",
                mm: "dakika %d",
                h: "saa limoja",
                hh: "masaa %d",
                d: "siku moja",
                dd: "siku %d",
                M: "mwezi mmoja",
                MM: "miezi %d",
                y: "mwaka mmoja",
                yy: "miaka %d"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
                1: "௧",
                2: "௨",
                3: "௩",
                4: "௪",
                5: "௫",
                6: "௬",
                7: "௭",
                8: "௮",
                9: "௯",
                0: "௦"
            },
            n = {
                "௧": "1",
                "௨": "2",
                "௩": "3",
                "௪": "4",
                "௫": "5",
                "௬": "6",
                "௭": "7",
                "௮": "8",
                "௯": "9",
                "௦": "0"
            };
        e.defineLocale("ta", {
            months: "ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),
            monthsShort: "ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),
            weekdays: "ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை".split("_"),
            weekdaysShort: "ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி".split("_"),
            weekdaysMin: "ஞா_தி_செ_பு_வி_வெ_ச".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, HH:mm",
                LLLL: "dddd, D MMMM YYYY, HH:mm"
            },
            calendar: {
                sameDay: "[இன்று] LT",
                nextDay: "[நாளை] LT",
                nextWeek: "dddd, LT",
                lastDay: "[நேற்று] LT",
                lastWeek: "[கடந்த வாரம்] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s இல்",
                past: "%s முன்",
                s: "ஒரு சில விநாடிகள்",
                ss: "%d விநாடிகள்",
                m: "ஒரு நிமிடம்",
                mm: "%d நிமிடங்கள்",
                h: "ஒரு மணி நேரம்",
                hh: "%d மணி நேரம்",
                d: "ஒரு நாள்",
                dd: "%d நாட்கள்",
                M: "ஒரு மாதம்",
                MM: "%d மாதங்கள்",
                y: "ஒரு வருடம்",
                yy: "%d ஆண்டுகள்"
            },
            dayOfMonthOrdinalParse: /\d{1,2}வது/,
            ordinal: function(e) {
                return e + "வது"
            },
            preparse: function(e) {
                return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function(e) {
                    return n[e]
                })
            },
            postformat: function(e) {
                return e.replace(/\d/g, function(e) {
                    return t[e]
                })
            },
            meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
            meridiem: function(e, t, n) {
                return e < 2 ? " யாமம்" : e < 6 ? " வைகறை" : e < 10 ? " காலை" : e < 14 ? " நண்பகல்" : e < 18 ? " எற்பாடு" : e < 22 ? " மாலை" : " யாமம்"
            },
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "யாமம்" === t ? e < 2 ? e : e + 12 : "வைகறை" === t || "காலை" === t ? e : "நண்பகல்" === t && e >= 10 ? e : e + 12
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("te", {
            months: "జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్".split("_"),
            monthsShort: "జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.".split("_"),
            monthsParseExact: !0,
            weekdays: "ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం".split("_"),
            weekdaysShort: "ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని".split("_"),
            weekdaysMin: "ఆ_సో_మం_బు_గు_శు_శ".split("_"),
            longDateFormat: {
                LT: "A h:mm",
                LTS: "A h:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm",
                LLLL: "dddd, D MMMM YYYY, A h:mm"
            },
            calendar: {
                sameDay: "[నేడు] LT",
                nextDay: "[రేపు] LT",
                nextWeek: "dddd, LT",
                lastDay: "[నిన్న] LT",
                lastWeek: "[గత] dddd, LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s లో",
                past: "%s క్రితం",
                s: "కొన్ని క్షణాలు",
                ss: "%d సెకన్లు",
                m: "ఒక నిమిషం",
                mm: "%d నిమిషాలు",
                h: "ఒక గంట",
                hh: "%d గంటలు",
                d: "ఒక రోజు",
                dd: "%d రోజులు",
                M: "ఒక నెల",
                MM: "%d నెలలు",
                y: "ఒక సంవత్సరం",
                yy: "%d సంవత్సరాలు"
            },
            dayOfMonthOrdinalParse: /\d{1,2}వ/,
            ordinal: "%dవ",
            meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "రాత్రి" === t ? e < 4 ? e : e + 12 : "ఉదయం" === t ? e : "మధ్యాహ్నం" === t ? e >= 10 ? e : e + 12 : "సాయంత్రం" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "రాత్రి" : e < 10 ? "ఉదయం" : e < 17 ? "మధ్యాహ్నం" : e < 20 ? "సాయంత్రం" : "రాత్రి"
            },
            week: {
                dow: 0,
                doy: 6
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("tet", {
            months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),
            monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
            weekdays: "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),
            weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
            weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Ohin iha] LT",
                nextDay: "[Aban iha] LT",
                nextWeek: "dddd [iha] LT",
                lastDay: "[Horiseik iha] LT",
                lastWeek: "dddd [semana kotuk] [iha] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "iha %s",
                past: "%s liuba",
                s: "segundu balun",
                ss: "segundu %d",
                m: "minutu ida",
                mm: "minutu %d",
                h: "oras ida",
                hh: "oras %d",
                d: "loron ida",
                dd: "loron %d",
                M: "fulan ida",
                MM: "fulan %d",
                y: "tinan ida",
                yy: "tinan %d"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            0: "-ум",
            1: "-ум",
            2: "-юм",
            3: "-юм",
            4: "-ум",
            5: "-ум",
            6: "-ум",
            7: "-ум",
            8: "-ум",
            9: "-ум",
            10: "-ум",
            12: "-ум",
            13: "-ум",
            20: "-ум",
            30: "-юм",
            40: "-ум",
            50: "-ум",
            60: "-ум",
            70: "-ум",
            80: "-ум",
            90: "-ум",
            100: "-ум"
        };
        e.defineLocale("tg", {
            months: {
                format: "январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри".split("_"),
                standalone: "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_")
            },
            monthsShort: "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
            weekdays: "якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе".split("_"),
            weekdaysShort: "яшб_дшб_сшб_чшб_пшб_ҷум_шнб".split("_"),
            weekdaysMin: "яш_дш_сш_чш_пш_ҷм_шб".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Имрӯз соати] LT",
                nextDay: "[Фардо соати] LT",
                lastDay: "[Дирӯз соати] LT",
                nextWeek: "dddd[и] [ҳафтаи оянда соати] LT",
                lastWeek: "dddd[и] [ҳафтаи гузашта соати] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "баъди %s",
                past: "%s пеш",
                s: "якчанд сония",
                m: "як дақиқа",
                mm: "%d дақиқа",
                h: "як соат",
                hh: "%d соат",
                d: "як рӯз",
                dd: "%d рӯз",
                M: "як моҳ",
                MM: "%d моҳ",
                y: "як сол",
                yy: "%d сол"
            },
            meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "шаб" === t ? e < 4 ? e : e + 12 : "субҳ" === t ? e : "рӯз" === t ? e >= 11 ? e : e + 12 : "бегоҳ" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "шаб" : e < 11 ? "субҳ" : e < 16 ? "рӯз" : e < 19 ? "бегоҳ" : "шаб"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
            ordinal: function(e) {
                var n = e % 10,
                    i = e >= 100 ? 100 : null;
                return e + (t[e] || t[n] || t[i])
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("th", {
            months: "มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),
            monthsShort: "ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),
            monthsParseExact: !0,
            weekdays: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),
            weekdaysShort: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),
            weekdaysMin: "อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY เวลา H:mm",
                LLLL: "วันddddที่ D MMMM YYYY เวลา H:mm"
            },
            meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
            isPM: function(e) {
                return "หลังเที่ยง" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "ก่อนเที่ยง" : "หลังเที่ยง"
            },
            calendar: {
                sameDay: "[วันนี้ เวลา] LT",
                nextDay: "[พรุ่งนี้ เวลา] LT",
                nextWeek: "dddd[หน้า เวลา] LT",
                lastDay: "[เมื่อวานนี้ เวลา] LT",
                lastWeek: "[วัน]dddd[ที่แล้ว เวลา] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "อีก %s",
                past: "%sที่แล้ว",
                s: "ไม่กี่วินาที",
                ss: "%d วินาที",
                m: "1 นาที",
                mm: "%d นาที",
                h: "1 ชั่วโมง",
                hh: "%d ชั่วโมง",
                d: "1 วัน",
                dd: "%d วัน",
                w: "1 สัปดาห์",
                ww: "%d สัปดาห์",
                M: "1 เดือน",
                MM: "%d เดือน",
                y: "1 ปี",
                yy: "%d ปี"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            1: "'inji",
            5: "'inji",
            8: "'inji",
            70: "'inji",
            80: "'inji",
            2: "'nji",
            7: "'nji",
            20: "'nji",
            50: "'nji",
            3: "'ünji",
            4: "'ünji",
            100: "'ünji",
            6: "'njy",
            9: "'unjy",
            10: "'unjy",
            30: "'unjy",
            60: "'ynjy",
            90: "'ynjy"
        };
        e.defineLocale("tk", {
            months: "Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr".split("_"),
            monthsShort: "Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek".split("_"),
            weekdays: "Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe".split("_"),
            weekdaysShort: "Ýek_Duş_Siş_Çar_Pen_Ann_Şen".split("_"),
            weekdaysMin: "Ýk_Dş_Sş_Çr_Pn_An_Şn".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[bugün sagat] LT",
                nextDay: "[ertir sagat] LT",
                nextWeek: "[indiki] dddd [sagat] LT",
                lastDay: "[düýn] LT",
                lastWeek: "[geçen] dddd [sagat] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s soň",
                past: "%s öň",
                s: "birnäçe sekunt",
                m: "bir minut",
                mm: "%d minut",
                h: "bir sagat",
                hh: "%d sagat",
                d: "bir gün",
                dd: "%d gün",
                M: "bir aý",
                MM: "%d aý",
                y: "bir ýyl",
                yy: "%d ýyl"
            },
            ordinal: function(e, n) {
                switch (n) {
                    case "d":
                    case "D":
                    case "Do":
                    case "DD":
                        return e;
                    default:
                        if (0 === e) return e + "'unjy";
                        var i = e % 10,
                            s = e % 100 - i,
                            a = e >= 100 ? 100 : null;
                        return e + (t[i] || t[s] || t[a])
                }
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("tl-ph", {
            months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
            monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
            weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
            weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
            weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "MM/D/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY HH:mm",
                LLLL: "dddd, MMMM DD, YYYY HH:mm"
            },
            calendar: {
                sameDay: "LT [ngayong araw]",
                nextDay: "[Bukas ng] LT",
                nextWeek: "LT [sa susunod na] dddd",
                lastDay: "LT [kahapon]",
                lastWeek: "LT [noong nakaraang] dddd",
                sameElse: "L"
            },
            relativeTime: {
                future: "sa loob ng %s",
                past: "%s ang nakalipas",
                s: "ilang segundo",
                ss: "%d segundo",
                m: "isang minuto",
                mm: "%d minuto",
                h: "isang oras",
                hh: "%d oras",
                d: "isang araw",
                dd: "%d araw",
                M: "isang buwan",
                MM: "%d buwan",
                y: "isang taon",
                yy: "%d taon"
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: function(e) {
                return e
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = "pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");

        function n(e, n, i, s) {
            var a = function(e) {
                var n = Math.floor(e % 1e3 / 100),
                    i = Math.floor(e % 100 / 10),
                    s = e % 10,
                    a = "";
                return n > 0 && (a += t[n] + "vatlh"), i > 0 && (a += ("" !== a ? " " : "") + t[i] + "maH"), s > 0 && (a += ("" !== a ? " " : "") + t[s]), "" === a ? "pagh" : a
            }(e);
            switch (i) {
                case "ss":
                    return a + " lup";
                case "mm":
                    return a + " tup";
                case "hh":
                    return a + " rep";
                case "dd":
                    return a + " jaj";
                case "MM":
                    return a + " jar";
                case "yy":
                    return a + " DIS"
            }
        }
        e.defineLocale("tlh", {
            months: "tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’".split("_"),
            monthsShort: "jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’".split("_"),
            monthsParseExact: !0,
            weekdays: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
            weekdaysShort: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
            weekdaysMin: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[DaHjaj] LT",
                nextDay: "[wa’leS] LT",
                nextWeek: "LLL",
                lastDay: "[wa’Hu’] LT",
                lastWeek: "LLL",
                sameElse: "L"
            },
            relativeTime: {
                future: function(e) {
                    var t = e;
                    return t = -1 !== e.indexOf("jaj") ? t.slice(0, -3) + "leS" : -1 !== e.indexOf("jar") ? t.slice(0, -3) + "waQ" : -1 !== e.indexOf("DIS") ? t.slice(0, -3) + "nem" : t + " pIq"
                },
                past: function(e) {
                    var t = e;
                    return t = -1 !== e.indexOf("jaj") ? t.slice(0, -3) + "Hu’" : -1 !== e.indexOf("jar") ? t.slice(0, -3) + "wen" : -1 !== e.indexOf("DIS") ? t.slice(0, -3) + "ben" : t + " ret"
                },
                s: "puS lup",
                ss: n,
                m: "wa’ tup",
                mm: n,
                h: "wa’ rep",
                hh: n,
                d: "wa’ jaj",
                dd: n,
                M: "wa’ jar",
                MM: n,
                y: "wa’ DIS",
                yy: n
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = {
            1: "'inci",
            5: "'inci",
            8: "'inci",
            70: "'inci",
            80: "'inci",
            2: "'nci",
            7: "'nci",
            20: "'nci",
            50: "'nci",
            3: "'üncü",
            4: "'üncü",
            100: "'üncü",
            6: "'ncı",
            9: "'uncu",
            10: "'uncu",
            30: "'uncu",
            60: "'ıncı",
            90: "'ıncı"
        };
        e.defineLocale("tr", {
            months: "Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),
            monthsShort: "Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),
            weekdays: "Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),
            weekdaysShort: "Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),
            weekdaysMin: "Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),
            meridiem: function(e, t, n) {
                return e < 12 ? n ? "öö" : "ÖÖ" : n ? "ös" : "ÖS"
            },
            meridiemParse: /öö|ÖÖ|ös|ÖS/,
            isPM: function(e) {
                return "ös" === e || "ÖS" === e
            },
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[bugün saat] LT",
                nextDay: "[yarın saat] LT",
                nextWeek: "[gelecek] dddd [saat] LT",
                lastDay: "[dün] LT",
                lastWeek: "[geçen] dddd [saat] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s sonra",
                past: "%s önce",
                s: "birkaç saniye",
                ss: "%d saniye",
                m: "bir dakika",
                mm: "%d dakika",
                h: "bir saat",
                hh: "%d saat",
                d: "bir gün",
                dd: "%d gün",
                w: "bir hafta",
                ww: "%d hafta",
                M: "bir ay",
                MM: "%d ay",
                y: "bir yıl",
                yy: "%d yıl"
            },
            ordinal: function(e, n) {
                switch (n) {
                    case "d":
                    case "D":
                    case "Do":
                    case "DD":
                        return e;
                    default:
                        if (0 === e) return e + "'ıncı";
                        var i = e % 10,
                            s = e % 100 - i,
                            a = e >= 100 ? 100 : null;
                        return e + (t[i] || t[s] || t[a])
                }
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n, i) {
            var s = {
                s: ["viensas secunds", "'iensas secunds"],
                ss: [e + " secunds", e + " secunds"],
                m: ["'n míut", "'iens míut"],
                mm: [e + " míuts", e + " míuts"],
                h: ["'n þora", "'iensa þora"],
                hh: [e + " þoras", e + " þoras"],
                d: ["'n ziua", "'iensa ziua"],
                dd: [e + " ziuas", e + " ziuas"],
                M: ["'n mes", "'iens mes"],
                MM: [e + " mesen", e + " mesen"],
                y: ["'n ar", "'iens ar"],
                yy: [e + " ars", e + " ars"]
            };
            return i ? s[n][0] : t ? s[n][0] : s[n][1]
        }
        e.defineLocale("tzl", {
            months: "Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar".split("_"),
            monthsShort: "Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
            weekdays: "Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi".split("_"),
            weekdaysShort: "Súl_Lún_Mai_Már_Xhú_Vié_Sát".split("_"),
            weekdaysMin: "Sú_Lú_Ma_Má_Xh_Vi_Sá".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM [dallas] YYYY",
                LLL: "D. MMMM [dallas] YYYY HH.mm",
                LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm"
            },
            meridiemParse: /d\'o|d\'a/i,
            isPM: function(e) {
                return "d'o" === e.toLowerCase()
            },
            meridiem: function(e, t, n) {
                return e > 11 ? n ? "d'o" : "D'O" : n ? "d'a" : "D'A"
            },
            calendar: {
                sameDay: "[oxhi à] LT",
                nextDay: "[demà à] LT",
                nextWeek: "dddd [à] LT",
                lastDay: "[ieiri à] LT",
                lastWeek: "[sür el] dddd [lasteu à] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "osprei %s",
                past: "ja%s",
                s: t,
                ss: t,
                m: t,
                mm: t,
                h: t,
                hh: t,
                d: t,
                dd: t,
                M: t,
                MM: t,
                y: t,
                yy: t
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("tzm", {
            months: "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
            monthsShort: "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
            weekdays: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
            weekdaysShort: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
            weekdaysMin: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[ⴰⵙⴷⵅ ⴴ] LT",
                nextDay: "[ⴰⵙⴽⴰ ⴴ] LT",
                nextWeek: "dddd [ⴴ] LT",
                lastDay: "[ⴰⵚⴰⵏⵜ ⴴ] LT",
                lastWeek: "dddd [ⴴ] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s",
                past: "ⵢⴰⵏ %s",
                s: "ⵉⵎⵉⴽ",
                ss: "%d ⵉⵎⵉⴽ",
                m: "ⵎⵉⵏⵓⴺ",
                mm: "%d ⵎⵉⵏⵓⴺ",
                h: "ⵙⴰⵄⴰ",
                hh: "%d ⵜⴰⵙⵙⴰⵄⵉⵏ",
                d: "ⴰⵙⵙ",
                dd: "%d oⵙⵙⴰⵏ",
                M: "ⴰⵢoⵓⵔ",
                MM: "%d ⵉⵢⵢⵉⵔⵏ",
                y: "ⴰⵙⴳⴰⵙ",
                yy: "%d ⵉⵙⴳⴰⵙⵏ"
            },
            week: {
                dow: 6,
                doy: 12
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("tzm-latn", {
            months: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
            monthsShort: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
            weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
            weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
            weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[asdkh g] LT",
                nextDay: "[aska g] LT",
                nextWeek: "dddd [g] LT",
                lastDay: "[assant g] LT",
                lastWeek: "dddd [g] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "dadkh s yan %s",
                past: "yan %s",
                s: "imik",
                ss: "%d imik",
                m: "minuḍ",
                mm: "%d minuḍ",
                h: "saɛa",
                hh: "%d tassaɛin",
                d: "ass",
                dd: "%d ossan",
                M: "ayowr",
                MM: "%d iyyirn",
                y: "asgas",
                yy: "%d isgasn"
            },
            week: {
                dow: 6,
                doy: 12
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("ug-cn", {
            months: "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),
            monthsShort: "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),
            weekdays: "يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە".split("_"),
            weekdaysShort: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
            weekdaysMin: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "YYYY-يىلىM-ئاينىڭD-كۈنى",
                LLL: "YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm",
                LLLL: "dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm"
            },
            meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "يېرىم كېچە" === t || "سەھەر" === t || "چۈشتىن بۇرۇن" === t ? e : "چۈشتىن كېيىن" === t || "كەچ" === t ? e + 12 : e >= 11 ? e : e + 12
            },
            meridiem: function(e, t, n) {
                var i = 100 * e + t;
                return i < 600 ? "يېرىم كېچە" : i < 900 ? "سەھەر" : i < 1130 ? "چۈشتىن بۇرۇن" : i < 1230 ? "چۈش" : i < 1800 ? "چۈشتىن كېيىن" : "كەچ"
            },
            calendar: {
                sameDay: "[بۈگۈن سائەت] LT",
                nextDay: "[ئەتە سائەت] LT",
                nextWeek: "[كېلەركى] dddd [سائەت] LT",
                lastDay: "[تۆنۈگۈن] LT",
                lastWeek: "[ئالدىنقى] dddd [سائەت] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s كېيىن",
                past: "%s بۇرۇن",
                s: "نەچچە سېكونت",
                ss: "%d سېكونت",
                m: "بىر مىنۇت",
                mm: "%d مىنۇت",
                h: "بىر سائەت",
                hh: "%d سائەت",
                d: "بىر كۈن",
                dd: "%d كۈن",
                M: "بىر ئاي",
                MM: "%d ئاي",
                y: "بىر يىل",
                yy: "%d يىل"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "-كۈنى";
                    case "w":
                    case "W":
                        return e + "-ھەپتە";
                    default:
                        return e
                }
            },
            preparse: function(e) {
                return e.replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/,/g, "،")
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";

        function t(e, t, n) {
            var i = {
                ss: t ? "секунда_секунди_секунд" : "секунду_секунди_секунд",
                mm: t ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин",
                hh: t ? "година_години_годин" : "годину_години_годин",
                dd: "день_дні_днів",
                MM: "місяць_місяці_місяців",
                yy: "рік_роки_років"
            };
            return "m" === n ? t ? "хвилина" : "хвилину" : "h" === n ? t ? "година" : "годину" : e + " " + function(e, t) {
                var n = e.split("_");
                return t % 10 == 1 && t % 100 != 11 ? n[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? n[1] : n[2]
            }(i[n], +e)
        }

        function n(e) {
            return function() {
                return e + "о" + (11 === this.hours() ? "б" : "") + "] LT"
            }
        }
        e.defineLocale("uk", {
            months: {
                format: "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),
                standalone: "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")
            },
            monthsShort: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),
            weekdays: function(e, t) {
                var n, i = {
                    nominative: "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),
                    accusative: "неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),
                    genitive: "неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")
                };
                return !0 === e ? i.nominative.slice(1, 7).concat(i.nominative.slice(0, 1)) : e ? (n = /(\[[ВвУу]\]) ?dddd/.test(t) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t) ? "genitive" : "nominative", i[n][e.day()]) : i.nominative
            },
            weekdaysShort: "нд_пн_вт_ср_чт_пт_сб".split("_"),
            weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY р.",
                LLL: "D MMMM YYYY р., HH:mm",
                LLLL: "dddd, D MMMM YYYY р., HH:mm"
            },
            calendar: {
                sameDay: n("[Сьогодні "),
                nextDay: n("[Завтра "),
                lastDay: n("[Вчора "),
                nextWeek: n("[У] dddd ["),
                lastWeek: function() {
                    switch (this.day()) {
                        case 0:
                        case 3:
                        case 5:
                        case 6:
                            return n("[Минулої] dddd [").call(this);
                        case 1:
                        case 2:
                        case 4:
                            return n("[Минулого] dddd [").call(this)
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "за %s",
                past: "%s тому",
                s: "декілька секунд",
                ss: t,
                m: t,
                mm: t,
                h: "годину",
                hh: t,
                d: "день",
                dd: t,
                M: "місяць",
                MM: t,
                y: "рік",
                yy: t
            },
            meridiemParse: /ночі|ранку|дня|вечора/,
            isPM: function(e) {
                return /^(дня|вечора)$/.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 4 ? "ночі" : e < 12 ? "ранку" : e < 17 ? "дня" : "вечора"
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "M":
                    case "d":
                    case "DDD":
                    case "w":
                    case "W":
                        return e + "-й";
                    case "D":
                        return e + "-го";
                    default:
                        return e
                }
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        var t = ["جنوری", "فروری", "مارچ", "اپریل", "مئی", "جون", "جولائی", "اگست", "ستمبر", "اکتوبر", "نومبر", "دسمبر"],
            n = ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"];
        e.defineLocale("ur", {
            months: t,
            monthsShort: t,
            weekdays: n,
            weekdaysShort: n,
            weekdaysMin: n,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd، D MMMM YYYY HH:mm"
            },
            meridiemParse: /صبح|شام/,
            isPM: function(e) {
                return "شام" === e
            },
            meridiem: function(e, t, n) {
                return e < 12 ? "صبح" : "شام"
            },
            calendar: {
                sameDay: "[آج بوقت] LT",
                nextDay: "[کل بوقت] LT",
                nextWeek: "dddd [بوقت] LT",
                lastDay: "[گذشتہ روز بوقت] LT",
                lastWeek: "[گذشتہ] dddd [بوقت] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s بعد",
                past: "%s قبل",
                s: "چند سیکنڈ",
                ss: "%d سیکنڈ",
                m: "ایک منٹ",
                mm: "%d منٹ",
                h: "ایک گھنٹہ",
                hh: "%d گھنٹے",
                d: "ایک دن",
                dd: "%d دن",
                M: "ایک ماہ",
                MM: "%d ماہ",
                y: "ایک سال",
                yy: "%d سال"
            },
            preparse: function(e) {
                return e.replace(/،/g, ",")
            },
            postformat: function(e) {
                return e.replace(/,/g, "،")
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("uz", {
            months: "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_"),
            monthsShort: "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
            weekdays: "Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),
            weekdaysShort: "Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),
            weekdaysMin: "Як_Ду_Се_Чо_Па_Жу_Ша".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "D MMMM YYYY, dddd HH:mm"
            },
            calendar: {
                sameDay: "[Бугун соат] LT [да]",
                nextDay: "[Эртага] LT [да]",
                nextWeek: "dddd [куни соат] LT [да]",
                lastDay: "[Кеча соат] LT [да]",
                lastWeek: "[Утган] dddd [куни соат] LT [да]",
                sameElse: "L"
            },
            relativeTime: {
                future: "Якин %s ичида",
                past: "Бир неча %s олдин",
                s: "фурсат",
                ss: "%d фурсат",
                m: "бир дакика",
                mm: "%d дакика",
                h: "бир соат",
                hh: "%d соат",
                d: "бир кун",
                dd: "%d кун",
                M: "бир ой",
                MM: "%d ой",
                y: "бир йил",
                yy: "%d йил"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("uz-latn", {
            months: "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),
            monthsShort: "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
            weekdays: "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),
            weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
            weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "D MMMM YYYY, dddd HH:mm"
            },
            calendar: {
                sameDay: "[Bugun soat] LT [da]",
                nextDay: "[Ertaga] LT [da]",
                nextWeek: "dddd [kuni soat] LT [da]",
                lastDay: "[Kecha soat] LT [da]",
                lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
                sameElse: "L"
            },
            relativeTime: {
                future: "Yaqin %s ichida",
                past: "Bir necha %s oldin",
                s: "soniya",
                ss: "%d soniya",
                m: "bir daqiqa",
                mm: "%d daqiqa",
                h: "bir soat",
                hh: "%d soat",
                d: "bir kun",
                dd: "%d kun",
                M: "bir oy",
                MM: "%d oy",
                y: "bir yil",
                yy: "%d yil"
            },
            week: {
                dow: 1,
                doy: 7
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("vi", {
            months: "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),
            monthsShort: "Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),
            monthsParseExact: !0,
            weekdays: "chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),
            weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
            weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
            weekdaysParseExact: !0,
            meridiemParse: /sa|ch/i,
            isPM: function(e) {
                return /^ch$/i.test(e)
            },
            meridiem: function(e, t, n) {
                return e < 12 ? n ? "sa" : "SA" : n ? "ch" : "CH"
            },
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM [năm] YYYY",
                LLL: "D MMMM [năm] YYYY HH:mm",
                LLLL: "dddd, D MMMM [năm] YYYY HH:mm",
                l: "DD/M/YYYY",
                ll: "D MMM YYYY",
                lll: "D MMM YYYY HH:mm",
                llll: "ddd, D MMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Hôm nay lúc] LT",
                nextDay: "[Ngày mai lúc] LT",
                nextWeek: "dddd [tuần tới lúc] LT",
                lastDay: "[Hôm qua lúc] LT",
                lastWeek: "dddd [tuần trước lúc] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "%s tới",
                past: "%s trước",
                s: "vài giây",
                ss: "%d giây",
                m: "một phút",
                mm: "%d phút",
                h: "một giờ",
                hh: "%d giờ",
                d: "một ngày",
                dd: "%d ngày",
                w: "một tuần",
                ww: "%d tuần",
                M: "một tháng",
                MM: "%d tháng",
                y: "một năm",
                yy: "%d năm"
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: function(e) {
                return e
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("x-pseudo", {
            months: "J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér".split("_"),
            monthsShort: "J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc".split("_"),
            monthsParseExact: !0,
            weekdays: "S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý".split("_"),
            weekdaysShort: "S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát".split("_"),
            weekdaysMin: "S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[T~ódá~ý át] LT",
                nextDay: "[T~ómó~rró~w át] LT",
                nextWeek: "dddd [át] LT",
                lastDay: "[Ý~ést~érdá~ý át] LT",
                lastWeek: "[L~ást] dddd [át] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "í~ñ %s",
                past: "%s á~gó",
                s: "á ~féw ~sécó~ñds",
                ss: "%d s~écóñ~ds",
                m: "á ~míñ~úté",
                mm: "%d m~íñú~tés",
                h: "á~ñ hó~úr",
                hh: "%d h~óúrs",
                d: "á ~dáý",
                dd: "%d d~áýs",
                M: "á ~móñ~th",
                MM: "%d m~óñt~hs",
                y: "á ~ýéár",
                yy: "%d ý~éárs"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function(e) {
                var t = e % 10,
                    n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                return e + n
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("yo", {
            months: "Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀".split("_"),
            monthsShort: "Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀".split("_"),
            weekdays: "Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta".split("_"),
            weekdaysShort: "Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá".split("_"),
            weekdaysMin: "Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A"
            },
            calendar: {
                sameDay: "[Ònì ni] LT",
                nextDay: "[Ọ̀la ni] LT",
                nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
                lastDay: "[Àna ni] LT",
                lastWeek: "dddd [Ọsẹ̀ tólọ́] [ni] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "ní %s",
                past: "%s kọjá",
                s: "ìsẹjú aayá die",
                ss: "aayá %d",
                m: "ìsẹjú kan",
                mm: "ìsẹjú %d",
                h: "wákati kan",
                hh: "wákati %d",
                d: "ọjọ́ kan",
                dd: "ọjọ́ %d",
                M: "osù kan",
                MM: "osù %d",
                y: "ọdún kan",
                yy: "ọdún %d"
            },
            dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
            ordinal: "ọjọ́ %d",
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("zh-cn", {
            months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
            monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
            weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
            weekdaysMin: "日_一_二_三_四_五_六".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY年M月D日",
                LLL: "YYYY年M月D日Ah点mm分",
                LLLL: "YYYY年M月D日ddddAh点mm分",
                l: "YYYY/M/D",
                ll: "YYYY年M月D日",
                lll: "YYYY年M月D日 HH:mm",
                llll: "YYYY年M月D日dddd HH:mm"
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "下午" === t || "晚上" === t ? e + 12 : e >= 11 ? e : e + 12
            },
            meridiem: function(e, t, n) {
                var i = 100 * e + t;
                return i < 600 ? "凌晨" : i < 900 ? "早上" : i < 1130 ? "上午" : i < 1230 ? "中午" : i < 1800 ? "下午" : "晚上"
            },
            calendar: {
                sameDay: "[今天]LT",
                nextDay: "[明天]LT",
                nextWeek: function(e) {
                    return e.week() !== this.week() ? "[下]dddLT" : "[本]dddLT"
                },
                lastDay: "[昨天]LT",
                lastWeek: function(e) {
                    return this.week() !== e.week() ? "[上]dddLT" : "[本]dddLT"
                },
                sameElse: "L"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "日";
                    case "M":
                        return e + "月";
                    case "w":
                    case "W":
                        return e + "周";
                    default:
                        return e
                }
            },
            relativeTime: {
                future: "%s后",
                past: "%s前",
                s: "几秒",
                ss: "%d 秒",
                m: "1 分钟",
                mm: "%d 分钟",
                h: "1 小时",
                hh: "%d 小时",
                d: "1 天",
                dd: "%d 天",
                w: "1 周",
                ww: "%d 周",
                M: "1 个月",
                MM: "%d 个月",
                y: "1 年",
                yy: "%d 年"
            },
            week: {
                dow: 1,
                doy: 4
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("zh-hk", {
            months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
            monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
            weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
            weekdaysMin: "日_一_二_三_四_五_六".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY年M月D日",
                LLL: "YYYY年M月D日 HH:mm",
                LLLL: "YYYY年M月D日dddd HH:mm",
                l: "YYYY/M/D",
                ll: "YYYY年M月D日",
                lll: "YYYY年M月D日 HH:mm",
                llll: "YYYY年M月D日dddd HH:mm"
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "中午" === t ? e >= 11 ? e : e + 12 : "下午" === t || "晚上" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                var i = 100 * e + t;
                return i < 600 ? "凌晨" : i < 900 ? "早上" : i < 1200 ? "上午" : 1200 === i ? "中午" : i < 1800 ? "下午" : "晚上"
            },
            calendar: {
                sameDay: "[今天]LT",
                nextDay: "[明天]LT",
                nextWeek: "[下]ddddLT",
                lastDay: "[昨天]LT",
                lastWeek: "[上]ddddLT",
                sameElse: "L"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "日";
                    case "M":
                        return e + "月";
                    case "w":
                    case "W":
                        return e + "週";
                    default:
                        return e
                }
            },
            relativeTime: {
                future: "%s後",
                past: "%s前",
                s: "幾秒",
                ss: "%d 秒",
                m: "1 分鐘",
                mm: "%d 分鐘",
                h: "1 小時",
                hh: "%d 小時",
                d: "1 天",
                dd: "%d 天",
                M: "1 個月",
                MM: "%d 個月",
                y: "1 年",
                yy: "%d 年"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("zh-mo", {
            months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
            monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
            weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
            weekdaysMin: "日_一_二_三_四_五_六".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "YYYY年M月D日",
                LLL: "YYYY年M月D日 HH:mm",
                LLLL: "YYYY年M月D日dddd HH:mm",
                l: "D/M/YYYY",
                ll: "YYYY年M月D日",
                lll: "YYYY年M月D日 HH:mm",
                llll: "YYYY年M月D日dddd HH:mm"
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "中午" === t ? e >= 11 ? e : e + 12 : "下午" === t || "晚上" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                var i = 100 * e + t;
                return i < 600 ? "凌晨" : i < 900 ? "早上" : i < 1130 ? "上午" : i < 1230 ? "中午" : i < 1800 ? "下午" : "晚上"
            },
            calendar: {
                sameDay: "[今天] LT",
                nextDay: "[明天] LT",
                nextWeek: "[下]dddd LT",
                lastDay: "[昨天] LT",
                lastWeek: "[上]dddd LT",
                sameElse: "L"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "日";
                    case "M":
                        return e + "月";
                    case "w":
                    case "W":
                        return e + "週";
                    default:
                        return e
                }
            },
            relativeTime: {
                future: "%s內",
                past: "%s前",
                s: "幾秒",
                ss: "%d 秒",
                m: "1 分鐘",
                mm: "%d 分鐘",
                h: "1 小時",
                hh: "%d 小時",
                d: "1 天",
                dd: "%d 天",
                M: "1 個月",
                MM: "%d 個月",
                y: "1 年",
                yy: "%d 年"
            }
        })
    }(n(0))
}, function(e, t, n) {
    ! function(e) {
        "use strict";
        e.defineLocale("zh-tw", {
            months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
            monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
            weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
            weekdaysMin: "日_一_二_三_四_五_六".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY年M月D日",
                LLL: "YYYY年M月D日 HH:mm",
                LLLL: "YYYY年M月D日dddd HH:mm",
                l: "YYYY/M/D",
                ll: "YYYY年M月D日",
                lll: "YYYY年M月D日 HH:mm",
                llll: "YYYY年M月D日dddd HH:mm"
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function(e, t) {
                return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "中午" === t ? e >= 11 ? e : e + 12 : "下午" === t || "晚上" === t ? e + 12 : void 0
            },
            meridiem: function(e, t, n) {
                var i = 100 * e + t;
                return i < 600 ? "凌晨" : i < 900 ? "早上" : i < 1130 ? "上午" : i < 1230 ? "中午" : i < 1800 ? "下午" : "晚上"
            },
            calendar: {
                sameDay: "[今天] LT",
                nextDay: "[明天] LT",
                nextWeek: "[下]dddd LT",
                lastDay: "[昨天] LT",
                lastWeek: "[上]dddd LT",
                sameElse: "L"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
            ordinal: function(e, t) {
                switch (t) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "日";
                    case "M":
                        return e + "月";
                    case "w":
                    case "W":
                        return e + "週";
                    default:
                        return e
                }
            },
            relativeTime: {
                future: "%s後",
                past: "%s前",
                s: "幾秒",
                ss: "%d 秒",
                m: "1 分鐘",
                mm: "%d 分鐘",
                h: "1 小時",
                hh: "%d 小時",
                d: "1 天",
                dd: "%d 天",
                M: "1 個月",
                MM: "%d 個月",
                y: "1 年",
                yy: "%d 年"
            }
        })
    }(n(0))
}, function(e, t, n) {
    "use strict";
    n(144), n(145)
}, function(e, t, n) {}, function(e, t, n) {
    "use strict";
    (function(e) {
        var t = T(n(1));
        n(146), n(147);
        var i = T(n(148)),
            s = T(n(149)),
            a = T(n(150)),
            o = T(n(151)),
            r = T(n(156)),
            d = T(n(157)),
            l = (T(n(158)), T(n(159))),
            u = T(n(160)),
            c = T(n(161)),
            h = T(n(162)),
            m = T(n(163)),
            f = (T(n(164)), T(n(165))),
            _ = T(n(166)),
            p = T(n(167)),
            g = T(n(168)),
            y = T(n(169)),
            v = T(n(171)),
            M = T(n(172)),
            L = T(n(174)),
            w = T(n(175)),
            b = T(n(176)),
            k = T(n(179)),
            Y = T(n(183));

        function T(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }(0, t.default)(function() {
            window.emitter = new Y.default, (0, t.default)(".matchHeight").matchHeight(), (0, t.default)("img.lazy").lazyload(), new g.default, new s.default, new a.default, new r.default, new f.default, new o.default, new u.default, new m.default, new M.default, new L.default, new _.default, new c.default, new h.default, new w.default, new l.default, new p.default, new y.default, new b.default, new k.default, new d.default, new v.default, new i.default, (0, t.default)(".fancybox").fancybox({
                idleTime: !1,
                loop: !0
            }), (0, t.default)('[data-fancybox="about-seaco-video"]').fancybox({
                maxWidth    : 800,
                maxHeight   : 600,
                fitToView   : false,
                width       : '70%',
                height      : '70%',
                autoSize    : false,
                closeClick  : false,
                openEffect  : 'none',
                closeEffect : 'none'
            }), (0, t.default)('[data-fancybox="gallery"]').fancybox({
              loop: !0,
				afterLoad: function() {
						let viewportHeight = window.innerHeight;
						let fancybox_image = document.querySelector('.fancybox-slide--current .fancybox-image');
						let fancybox_toolbar = document.querySelector('.fancybox-toolbar');
						let fancybox_caption = document.querySelector('.fancybox-caption');
						let heigh_set = viewportHeight - fancybox_toolbar.offsetHeight - fancybox_caption.offsetHeight;
						fancybox_image.style.maxHeight = heigh_set+"px";
						
						let domRect1 = fancybox_caption.getBoundingClientRect();
						let domRect2 = fancybox_image.getBoundingClientRect();
						if(!(domRect1.top > domRect2.bottom ||
							domRect1.right < domRect2.left ||
							domRect1.bottom < domRect2.top ||
							domRect1.left > domRect2.right))
						{
							let fancybox_image_top = domRect1.top-domRect2.bottom;
							fancybox_image.style.marginTop = fancybox_image_top+"px"; 
						}                                          
					},
				afterShow: function() {
						let viewportHeight = window.innerHeight;
						let fancybox_image = document.querySelector('.fancybox-slide--current .fancybox-image');
						let fancybox_toolbar = document.querySelector('.fancybox-toolbar');
						let fancybox_caption = document.querySelector('.fancybox-caption');
						let heigh_set = viewportHeight - fancybox_toolbar.offsetHeight - fancybox_caption.offsetHeight;
						fancybox_image.style.maxHeight = heigh_set+"px";
							
						let domRect1 = fancybox_caption.getBoundingClientRect();
						let domRect2 = fancybox_image.getBoundingClientRect();
						if(!(domRect1.top > domRect2.bottom ||
							domRect1.right < domRect2.left ||
							domRect1.bottom < domRect2.top ||
							domRect1.left > domRect2.right))
						{
							let fancybox_image_top = domRect1.top-domRect2.bottom;
							if(fancybox_image_top!=0)
								fancybox_image.style.marginTop = fancybox_image_top+"px"; 
						}                                             
					}
			}), document.body.addEventListener("mousedown", function() {
                document.body.classList.add("using-mouse")
            }), document.body.addEventListener("keydown", function(e) {
                9 == e.which && document.body.classList.remove("using-mouse")
            }), (0, t.default)('a[href*="#"]:not([href*="news-listing#"]):not([href="#"])').click(function(e) {
                if (e.preventDefault(), location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") || location.hostname == this.hostname) {
                    var n = (0, t.default)(this.hash);
                    if ((n = n.length ? n : (0, t.default)("[name=" + this.hash.slice(1) + "]")).length) return (0, t.default)("html,body").animate({
                        scrollTop: n.offset().top
                    }, 1e3), !1
                }
            })
        }), e.event.special.touchstart = {
            setup: function(e, t, n) {
                this.addEventListener("touchstart", n, {
                    passive: !t.includes("noPreventDefault")
                })
            }
        }, e.event.special.touchmove = {
            setup: function(e, t, n) {
                this.addEventListener("touchmove", n, {
                    passive: !t.includes("noPreventDefault")
                })
            }
        }
    }).call(this, n(1))
}, function(e, t, n) {
    (function(e) {
        ! function(e, t, n, i) {
            "use strict";
            if (e.console = e.console || {
                    info: function(e) {}
                }, n)
                if (n.fn.fancybox) console.info("fancyBox already initialized");
                else {
                    var s = {
                            closeExisting: !1,
                            loop: !1,
                            gutter: 50,
                            keyboard: !0,
                            preventCaptionOverlap: !0,
                            arrows: !0,
                            infobar: !0,
                            smallBtn: "auto",
                            toolbar: "auto",
                            buttons: ["zoom", "slideShow", "thumbs", "close"],
                            idleTime: 3,
                            protect: !1,
                            modal: !1,
                            image: {
                                preload: !1
                            },
                            ajax: {
                                settings: {
                                    data: {
                                        fancybox: !0
                                    }
                                }
                            },
                            iframe: {
                                tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
                                preload: !0,
                                css: {},
                                attr: {
                                    scrolling: "auto"
                                }
                            },
                            video: {
                                tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
                                format: "",
                                autoStart: !0
                            },
                            defaultType: "image",
                            animationEffect: "zoom",
                            animationDuration: 366,
                            zoomOpacity: "auto",
                            transitionEffect: "fade",
                            transitionDuration: 366,
                            slideClass: "",
                            baseClass: "",
                            baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
                            spinnerTpl: '<div class="fancybox-loading"></div>',
                            errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
                            btnTpl: {
                                download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
                                zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
                                close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
                                arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
                                arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
                                smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'
                            },
                            parentEl: "body",
                            hideScrollbar: !0,
                            autoFocus: !0,
                            backFocus: !0,
                            trapFocus: !0,
                            fullScreen: {
                                autoStart: !1
                            },
                            touch: {
                                vertical: !0,
                                momentum: !0
                            },
                            hash: null,
                            media: {},
                            slideShow: {
                                autoStart: !1,
                                speed: 3e3
                            },
                            thumbs: {
                                autoStart: !1,
                                hideOnClose: !0,
                                parentEl: ".fancybox-container",
                                axis: "y"
                            },
                            wheel: "auto",
                            onInit: n.noop,
                            beforeLoad: n.noop,
                            afterLoad: n.noop,
                            beforeShow: n.noop,
                            afterShow: n.noop,
                            beforeClose: n.noop,
                            afterClose: n.noop,
                            onActivate: n.noop,
                            onDeactivate: n.noop,
                            clickContent: function(e, t) {
                                return "image" === e.type && "zoom"
                            },
                            clickSlide: "close",
                            clickOutside: "close",
                            dblclickContent: !1,
                            dblclickSlide: !1,
                            dblclickOutside: !1,
                            mobile: {
                                preventCaptionOverlap: !1,
                                idleTime: !1,
                                clickContent: function(e, t) {
                                    return "image" === e.type && "toggleControls"
                                },
                                clickSlide: function(e, t) {
                                    return "image" === e.type ? "toggleControls" : "close"
                                },
                                dblclickContent: function(e, t) {
                                    return "image" === e.type && "zoom"
                                },
                                dblclickSlide: function(e, t) {
                                    return "image" === e.type && "zoom"
                                }
                            },
                            lang: "en",
                            i18n: {
                                en: {
                                    CLOSE: "Close",
                                    NEXT: "Next",
                                    PREV: "Previous",
                                    ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                                    PLAY_START: "Start slideshow",
                                    PLAY_STOP: "Pause slideshow",
                                    FULL_SCREEN: "Full screen",
                                    THUMBS: "Thumbnails",
                                    DOWNLOAD: "Download",
                                    SHARE: "Share",
                                    ZOOM: "Zoom"
                                },
                                de: {
                                    CLOSE: "Schlie&szlig;en",
                                    NEXT: "Weiter",
                                    PREV: "Zur&uuml;ck",
                                    ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
                                    PLAY_START: "Diaschau starten",
                                    PLAY_STOP: "Diaschau beenden",
                                    FULL_SCREEN: "Vollbild",
                                    THUMBS: "Vorschaubilder",
                                    DOWNLOAD: "Herunterladen",
                                    SHARE: "Teilen",
                                    ZOOM: "Vergr&ouml;&szlig;ern"
                                }
                            }
                        },
                        a = n(e),
                        o = n(t),
                        r = 0,
                        d = e.requestAnimationFrame || e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || e.oRequestAnimationFrame || function(t) {
                            return e.setTimeout(t, 1e3 / 60)
                        },
                        l = e.cancelAnimationFrame || e.webkitCancelAnimationFrame || e.mozCancelAnimationFrame || e.oCancelAnimationFrame || function(t) {
                            e.clearTimeout(t)
                        },
                        u = function() {
                            var e, n = t.createElement("fakeelement"),
                                i = {
                                    transition: "transitionend",
                                    OTransition: "oTransitionEnd",
                                    MozTransition: "transitionend",
                                    WebkitTransition: "webkitTransitionEnd"
                                };
                            for (e in i)
                                if (void 0 !== n.style[e]) return i[e];
                            return "transitionend"
                        }(),
                        c = function(e) {
                            return e && e.length && e[0].offsetHeight
                        },
                        h = function(e, t) {
                            var i = n.extend(!0, {}, e, t);
                            return n.each(t, function(e, t) {
                                n.isArray(t) && (i[e] = t)
                            }), i
                        },
                        m = function(e, t, i) {
                            this.opts = h({
                                index: i
                            }, n.fancybox.defaults), n.isPlainObject(t) && (this.opts = h(this.opts, t)), n.fancybox.isMobile && (this.opts = h(this.opts, this.opts.mobile)), this.id = this.opts.id || ++r, this.currIndex = parseInt(this.opts.index, 10) || 0, this.prevIndex = null, this.prevPos = null, this.currPos = 0, this.firstRun = !0, this.group = [], this.slides = {}, this.addContent(e), this.group.length && this.init()
                        };
                    n.extend(m.prototype, {
                            init: function() {
                                var i, s, a = this,
                                    o = a.group[a.currIndex].opts;
                                o.closeExisting && n.fancybox.close(!0), n("body").addClass("fancybox-active"), !n.fancybox.getInstance() && !1 !== o.hideScrollbar && !n.fancybox.isMobile && t.body.scrollHeight > e.innerHeight && (n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (e.innerWidth - t.documentElement.clientWidth) + "px;}</style>"), n("body").addClass("compensate-for-scrollbar")), s = "", n.each(o.buttons, function(e, t) {
                                    s += o.btnTpl[t] || ""
                                }), i = n(a.translate(a, o.baseTpl.replace("{{buttons}}", s).replace("{{arrows}}", o.btnTpl.arrowLeft + o.btnTpl.arrowRight))).attr("id", "fancybox-container-" + a.id).addClass(o.baseClass).data("FancyBox", a).appendTo(o.parentEl), a.$refs = {
                                    container: i
                                }, ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach(function(e) {
                                    a.$refs[e] = i.find(".fancybox-" + e)
                                }), a.trigger("onInit"), a.activate(), a.jumpTo(a.currIndex)
                            },
                            translate: function(e, t) {
                                var n = e.opts.i18n[e.opts.lang] || e.opts.i18n.en;
                                return t.replace(/\{\{(\w+)\}\}/g, function(e, t) {
                                    return void 0 === n[t] ? e : n[t]
                                })
                            },
                            addContent: function(e) {
                                var t, i = this,
                                    s = n.makeArray(e);
                                n.each(s, function(e, t) {
                                    var s, a, o, r, d, l = {},
                                        u = {};
                                    n.isPlainObject(t) ? (l = t, u = t.opts || t) : "object" === n.type(t) && n(t).length ? (u = (s = n(t)).data() || {}, (u = n.extend(!0, {}, u, u.options)).$orig = s, l.src = i.opts.src || u.src || s.attr("href"), l.type || l.src || (l.type = "inline", l.src = t)) : l = {
                                        type: "html",
                                        src: t + ""
                                    }, l.opts = n.extend(!0, {}, i.opts, u), n.isArray(u.buttons) && (l.opts.buttons = u.buttons), n.fancybox.isMobile && l.opts.mobile && (l.opts = h(l.opts, l.opts.mobile)), a = l.type || l.opts.type, r = l.src || "", !a && r && ((o = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (a = "video", l.opts.video.format || (l.opts.video.format = "video/" + ("ogv" === o[1] ? "ogg" : o[1]))) : r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? a = "image" : r.match(/\.(pdf)((\?|#).*)?$/i) ? (a = "iframe", l = n.extend(!0, l, {
                                        contentType: "pdf",
                                        opts: {
                                            iframe: {
                                                preload: !1
                                            }
                                        }
                                    })) : "#" === r.charAt(0) && (a = "inline")), a ? l.type = a : i.trigger("objectNeedsType", l), l.contentType || (l.contentType = n.inArray(l.type, ["html", "inline", "ajax"]) > -1 ? "html" : l.type), l.index = i.group.length, "auto" == l.opts.smallBtn && (l.opts.smallBtn = n.inArray(l.type, ["html", "inline", "ajax"]) > -1), "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn), l.$thumb = l.opts.$thumb || null, l.opts.$trigger && l.index === i.opts.index && (l.$thumb = l.opts.$trigger.find("img:first"), l.$thumb.length && (l.opts.$orig = l.opts.$trigger)), l.$thumb && l.$thumb.length || !l.opts.$orig || (l.$thumb = l.opts.$orig.find("img:first")), l.$thumb && !l.$thumb.length && (l.$thumb = null), l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null), "function" === n.type(l.opts.caption) && (l.opts.caption = l.opts.caption.apply(t, [i, l])), "function" === n.type(i.opts.caption) && (l.opts.caption = i.opts.caption.apply(t, [i, l])), l.opts.caption instanceof n || (l.opts.caption = void 0 === l.opts.caption ? "" : l.opts.caption + ""), "ajax" === l.type && (d = r.split(/\s+/, 2)).length > 1 && (l.src = d.shift(), l.opts.filter = d.shift()), l.opts.modal && (l.opts = n.extend(!0, l.opts, {
                                        trapFocus: !0,
                                        infobar: 0,
                                        toolbar: 0,
                                        smallBtn: 0,
                                        keyboard: 0,
                                        slideShow: 0,
                                        fullScreen: 0,
                                        thumbs: 0,
                                        touch: 0,
                                        clickContent: !1,
                                        clickSlide: !1,
                                        clickOutside: !1,
                                        dblclickContent: !1,
                                        dblclickSlide: !1,
                                        dblclickOutside: !1
                                    })), i.group.push(l)
                                }), Object.keys(i.slides).length && (i.updateControls(), (t = i.Thumbs) && t.isActive && (t.create(), t.focus()))
                            },
                            addEvents: function() {
                                var t = this;
                                t.removeEvents(), t.$refs.container.on("click.fb-close", "[data-fancybox-close]", function(e) {
                                    e.stopPropagation(), e.preventDefault(), t.close(e)
                                }).on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function(e) {
                                    e.stopPropagation(), e.preventDefault(), t.previous()
                                }).on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function(e) {
                                    e.stopPropagation(), e.preventDefault(), t.next()
                                }).on("click.fb", "[data-fancybox-zoom]", function(e) {
                                    t[t.isScaledDown() ? "scaleToActual" : "scaleToFit"]()
                                }), a.on("orientationchange.fb resize.fb", function(e) {
                                    e && e.originalEvent && "resize" === e.originalEvent.type ? (t.requestId && l(t.requestId), t.requestId = d(function() {
                                        t.update(e)
                                    })) : (t.current && "iframe" === t.current.type && t.$refs.stage.hide(), setTimeout(function() {
                                        t.$refs.stage.show(), t.update(e)
                                    }, n.fancybox.isMobile ? 600 : 250))
                                }), o.on("keydown.fb", function(e) {
                                    var i = (n.fancybox ? n.fancybox.getInstance() : null).current,
                                        s = e.keyCode || e.which;
                                    if (9 != s) {
                                        if (!(!i.opts.keyboard || e.ctrlKey || e.altKey || e.shiftKey || n(e.target).is("input,textarea,video,audio,select"))) return 8 === s || 27 === s ? (e.preventDefault(), void t.close(e)) : 37 === s || 38 === s ? (e.preventDefault(), void t.previous()) : 39 === s || 40 === s ? (e.preventDefault(), void t.next()) : void t.trigger("afterKeydown", e, s)
                                    } else i.opts.trapFocus && t.focus(e)
                                }), t.group[t.currIndex].opts.idleTime && (t.idleSecondsCounter = 0, o.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function(e) {
                                    t.idleSecondsCounter = 0, t.isIdle && t.showControls(), t.isIdle = !1
                                }), t.idleInterval = e.setInterval(function() {
                                    t.idleSecondsCounter++, t.idleSecondsCounter >= t.group[t.currIndex].opts.idleTime && !t.isDragging && (t.isIdle = !0, t.idleSecondsCounter = 0, t.hideControls())
                                }, 1e3))
                            },
                            removeEvents: function() {
                                a.off("orientationchange.fb resize.fb"), o.off("keydown.fb .fb-idle"), this.$refs.container.off(".fb-close .fb-prev .fb-next"), this.idleInterval && (e.clearInterval(this.idleInterval), this.idleInterval = null)
                            },
                            previous: function(e) {
                                return this.jumpTo(this.currPos - 1, e)
                            },
                            next: function(e) {
                                return this.jumpTo(this.currPos + 1, e)
                            },
                            jumpTo: function(e, t) {
                                var i, s, a, o, r, d, l, u, h, m = this,
                                    f = m.group.length;
                                if (!(m.isDragging || m.isClosing || m.isAnimating && m.firstRun)) {
                                    if (e = parseInt(e, 10), !(a = m.current ? m.current.opts.loop : m.opts.loop) && (e < 0 || e >= f)) return !1;
                                    if (i = m.firstRun = !Object.keys(m.slides).length, r = m.current, m.prevIndex = m.currIndex, m.prevPos = m.currPos, o = m.createSlide(e), f > 1 && ((a || o.index < f - 1) && m.createSlide(e + 1), (a || o.index > 0) && m.createSlide(e - 1)), m.current = o, m.currIndex = o.index, m.currPos = o.pos, m.trigger("beforeShow", i), m.updateControls(), o.forcedDuration = void 0, n.isNumeric(t) ? o.forcedDuration = t : t = o.opts[i ? "animationDuration" : "transitionDuration"], t = parseInt(t, 10), s = m.isMoved(o), o.$slide.addClass("fancybox-slide--current"), i) return o.opts.animationEffect && t && m.$refs.container.css("transition-duration", t + "ms"), m.$refs.container.addClass("fancybox-is-open").trigger("focus"), m.loadSlide(o), void m.preload("image");
                                    d = n.fancybox.getTranslate(r.$slide), l = n.fancybox.getTranslate(m.$refs.stage), n.each(m.slides, function(e, t) {
                                        n.fancybox.stop(t.$slide, !0)
                                    }), r.pos !== o.pos && (r.isComplete = !1), r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"), s ? (h = d.left - (r.pos * d.width + r.pos * r.opts.gutter), n.each(m.slides, function(e, i) {
                                        i.$slide.removeClass("fancybox-animated").removeClass(function(e, t) {
                                            return (t.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ")
                                        });
                                        var s = i.pos * d.width + i.pos * i.opts.gutter;
                                        n.fancybox.setTranslate(i.$slide, {
                                            top: 0,
                                            left: s - l.left + h
                                        }), i.pos !== o.pos && i.$slide.addClass("fancybox-slide--" + (i.pos > o.pos ? "next" : "previous")), c(i.$slide), n.fancybox.animate(i.$slide, {
                                            top: 0,
                                            left: (i.pos - o.pos) * d.width + (i.pos - o.pos) * i.opts.gutter
                                        }, t, function() {
                                            i.$slide.css({
                                                transform: "",
                                                opacity: ""
                                            }).removeClass("fancybox-slide--next fancybox-slide--previous"), i.pos === m.currPos && m.complete()
                                        })
                                    })) : t && o.opts.transitionEffect && (u = "fancybox-animated fancybox-fx-" + o.opts.transitionEffect, r.$slide.addClass("fancybox-slide--" + (r.pos > o.pos ? "next" : "previous")), n.fancybox.animate(r.$slide, u, t, function() {
                                        r.$slide.removeClass(u).removeClass("fancybox-slide--next fancybox-slide--previous")
                                    }, !1)), o.isLoaded ? m.revealContent(o) : m.loadSlide(o), m.preload("image")
                                }
                            },
                            createSlide: function(e) {
                                var t, i;
                                return i = (i = e % this.group.length) < 0 ? this.group.length + i : i, !this.slides[e] && this.group[i] && (t = n('<div class="fancybox-slide"></div>').appendTo(this.$refs.stage), this.slides[e] = n.extend(!0, {}, this.group[i], {
                                    pos: e,
                                    $slide: t,
                                    isLoaded: !1
                                }), this.updateSlide(this.slides[e])), this.slides[e]
                            },
                            scaleToActual: function(e, t, i) {
                                var s, a, o, r, d, l = this,
                                    u = l.current,
                                    c = u.$content,
                                    h = n.fancybox.getTranslate(u.$slide).width,
                                    m = n.fancybox.getTranslate(u.$slide).height,
                                    f = u.width,
                                    _ = u.height;
                                l.isAnimating || l.isMoved() || !c || "image" != u.type || !u.isLoaded || u.hasError || (l.isAnimating = !0, n.fancybox.stop(c), e = void 0 === e ? .5 * h : e, t = void 0 === t ? .5 * m : t, (s = n.fancybox.getTranslate(c)).top -= n.fancybox.getTranslate(u.$slide).top, s.left -= n.fancybox.getTranslate(u.$slide).left, r = f / s.width, d = _ / s.height, a = .5 * h - .5 * f, o = .5 * m - .5 * _, f > h && ((a = s.left * r - (e * r - e)) > 0 && (a = 0), a < h - f && (a = h - f)), _ > m && ((o = s.top * d - (t * d - t)) > 0 && (o = 0), o < m - _ && (o = m - _)), l.updateCursor(f, _), n.fancybox.animate(c, {
                                    top: o,
                                    left: a,
                                    scaleX: r,
                                    scaleY: d
                                }, i || 366, function() {
                                    l.isAnimating = !1
                                }), l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop())
                            },
                            scaleToFit: function(e) {
                                var t, i = this,
                                    s = i.current,
                                    a = s.$content;
                                i.isAnimating || i.isMoved() || !a || "image" != s.type || !s.isLoaded || s.hasError || (i.isAnimating = !0, n.fancybox.stop(a), t = i.getFitPos(s), i.updateCursor(t.width, t.height), n.fancybox.animate(a, {
                                    top: t.top,
                                    left: t.left,
                                    scaleX: t.width / a.width(),
                                    scaleY: t.height / a.height()
                                }, e || 366, function() {
                                    i.isAnimating = !1
                                }))
                            },
                            getFitPos: function(e) {
                                var t, i, s, a, o = e.$content,
                                    r = e.$slide,
                                    d = e.width || e.opts.width,
                                    l = e.height || e.opts.height,
                                    u = {};
                                return !!(e.isLoaded && o && o.length) && (t = n.fancybox.getTranslate(this.$refs.stage).width, i = n.fancybox.getTranslate(this.$refs.stage).height, t -= parseFloat(r.css("paddingLeft")) + parseFloat(r.css("paddingRight")) + parseFloat(o.css("marginLeft")) + parseFloat(o.css("marginRight")), i -= parseFloat(r.css("paddingTop")) + parseFloat(r.css("paddingBottom")) + parseFloat(o.css("marginTop")) + parseFloat(o.css("marginBottom")), d && l || (d = t, l = i), l *= s = Math.min(1, t / d, i / l), (d *= s) > t - .5 && (d = t), l > i - .5 && (l = i), "image" === e.type ? (u.top = Math.floor(.5 * (i - l)) + parseFloat(r.css("paddingTop")), u.left = Math.floor(.5 * (t - d)) + parseFloat(r.css("paddingLeft"))) : "video" === e.contentType && (l > d / (a = e.opts.width && e.opts.height ? d / l : e.opts.ratio || 16 / 9) ? l = d / a : d > l * a && (d = l * a)), u.width = d, u.height = l, u)
                            },
                            update: function(e) {
                                var t = this;
                                n.each(t.slides, function(n, i) {
                                    t.updateSlide(i, e)
                                })
                            },
                            updateSlide: function(e, t) {
                                var i = e && e.$content,
                                    s = e.width || e.opts.width,
                                    a = e.height || e.opts.height,
                                    o = e.$slide;
                                this.adjustCaption(e), i && (s || a || "video" === e.contentType) && !e.hasError && (n.fancybox.stop(i), n.fancybox.setTranslate(i, this.getFitPos(e)), e.pos === this.currPos && (this.isAnimating = !1, this.updateCursor())), this.adjustLayout(e), o.length && (o.trigger("refresh"), e.pos === this.currPos && this.$refs.toolbar.add(this.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar", o.get(0).scrollHeight > o.get(0).clientHeight)), this.trigger("onUpdate", e, t)
                            },
                            centerSlide: function(e) {
                                var t = this,
                                    i = t.current,
                                    s = i.$slide;
                                !t.isClosing && i && (s.siblings().css({
                                    transform: "",
                                    opacity: ""
                                }), s.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"), n.fancybox.animate(s, {
                                    top: 0,
                                    left: 0,
                                    opacity: 1
                                }, void 0 === e ? 0 : e, function() {
                                    s.css({
                                        transform: "",
                                        opacity: ""
                                    }), i.isComplete || t.complete()
                                }, !1))
                            },
                            isMoved: function(e) {
                                var t, i, s = e || this.current;
                                return !!s && (i = n.fancybox.getTranslate(this.$refs.stage), t = n.fancybox.getTranslate(s.$slide), !s.$slide.hasClass("fancybox-animated") && (Math.abs(t.top - i.top) > .5 || Math.abs(t.left - i.left) > .5))
                            },
                            updateCursor: function(e, t) {
                                var i, s, a = this.current,
                                    o = this.$refs.container;
                                a && !this.isClosing && this.Guestures && (o.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"), s = !!(i = this.canPan(e, t)) || this.isZoomable(), o.toggleClass("fancybox-is-zoomable", s), n("[data-fancybox-zoom]").prop("disabled", !s), i ? o.addClass("fancybox-can-pan") : s && ("zoom" === a.opts.clickContent || n.isFunction(a.opts.clickContent) && "zoom" == a.opts.clickContent(a)) ? o.addClass("fancybox-can-zoomIn") : a.opts.touch && (a.opts.touch.vertical || this.group.length > 1) && "video" !== a.contentType && o.addClass("fancybox-can-swipe"))
                            },
                            isZoomable: function() {
                                var e, t = this.current;
                                if (t && !this.isClosing && "image" === t.type && !t.hasError) {
                                    if (!t.isLoaded) return !0;
                                    if ((e = this.getFitPos(t)) && (t.width > e.width || t.height > e.height)) return !0
                                }
                                return !1
                            },
                            isScaledDown: function(e, t) {
                                var i = !1,
                                    s = this.current,
                                    a = s.$content;
                                return void 0 !== e && void 0 !== t ? i = e < s.width && t < s.height : a && (i = (i = n.fancybox.getTranslate(a)).width < s.width && i.height < s.height), i
                            },
                            canPan: function(e, t) {
                                var i = this.current,
                                    s = null,
                                    a = !1;
                                return "image" === i.type && (i.isComplete || e && t) && !i.hasError && (a = this.getFitPos(i), void 0 !== e && void 0 !== t ? s = {
                                    width: e,
                                    height: t
                                } : i.isComplete && (s = n.fancybox.getTranslate(i.$content)), s && a && (a = Math.abs(s.width - a.width) > 1.5 || Math.abs(s.height - a.height) > 1.5)), a
                            },
                            loadSlide: function(e) {
                                var t, i, s, a = this;
                                if (!e.isLoading && !e.isLoaded) {
                                    if (e.isLoading = !0, !1 === a.trigger("beforeLoad", e)) return e.isLoading = !1, !1;
                                    switch (t = e.type, (i = e.$slide).off("refresh").trigger("onReset").addClass(e.opts.slideClass), t) {
                                        case "image":
                                            a.setImage(e);
                                            break;
                                        case "iframe":
                                            a.setIframe(e);
                                            break;
                                        case "html":
                                            a.setContent(e, e.src || e.content);
                                            break;
                                        case "video":
                                            a.setContent(e, e.opts.video.tpl.replace(/\{\{src\}\}/gi, e.src).replace("{{format}}", e.opts.videoFormat || e.opts.video.format || "").replace("{{poster}}", e.thumb || ""));
                                            break;
                                        case "inline":
                                            n(e.src).length ? a.setContent(e, n(e.src)) : a.setError(e);
                                            break;
                                        case "ajax":
                                            a.showLoading(e), s = n.ajax(n.extend({}, e.opts.ajax.settings, {
                                                url: e.src,
                                                success: function(t, n) {
                                                    "success" === n && a.setContent(e, t)
                                                },
                                                error: function(t, n) {
                                                    t && "abort" !== n && a.setError(e)
                                                }
                                            })), i.one("onReset", function() {
                                                s.abort()
                                            });
                                            break;
                                        default:
                                            a.setError(e)
                                    }
                                    return !0
                                }
                            },
                            setImage: function(e) {
                                var i, s = this;
                                setTimeout(function() {
                                    var t = e.$image;
                                    s.isClosing || !e.isLoading || t && t.length && t[0].complete || e.hasError || s.showLoading(e)
                                }, 50), s.checkSrcset(e), e.$content = n('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(e.$slide.addClass("fancybox-slide--image")), !1 !== e.opts.preload && e.opts.width && e.opts.height && e.thumb && (e.width = e.opts.width, e.height = e.opts.height, (i = t.createElement("img")).onerror = function() {
                                    n(this).remove(), e.$ghost = null
                                }, i.onload = function() {
                                    s.afterLoad(e)
                                  }, e.$ghost = n(i).addClass("fancybox-image").appendTo(e.$content).attr("src", e.thumb + '?t=' + new Date().getTime())), s.setBigImage(e)
                            },
                            checkSrcset: function(t) {
                                var n, i, s, a, o = t.opts.srcset || t.opts.image.srcset;
                                if (o) {
                                    s = e.devicePixelRatio || 1, a = e.innerWidth * s, (i = o.split(",").map(function(e) {
                                        var t = {};
                                        return e.trim().split(/\s+/).forEach(function(e, n) {
                                            var i = parseInt(e.substring(0, e.length - 1), 10);
                                            if (0 === n) return t.url = e;
                                            i && (t.value = i, t.postfix = e[e.length - 1])
                                        }), t
                                    })).sort(function(e, t) {
                                        return e.value - t.value
                                    });
                                    for (var r = 0; r < i.length; r++) {
                                        var d = i[r];
                                        if ("w" === d.postfix && d.value >= a || "x" === d.postfix && d.value >= s) {
                                            n = d;
                                            break
                                        }
                                    }!n && i.length && (n = i[i.length - 1]), n && (t.src = n.url, t.width && t.height && "w" == n.postfix && (t.height = t.width / t.height * n.value, t.width = n.value), t.opts.srcset = o)
                                }
                            },
                            setBigImage: function(e) {
                                var i = this,
                                    s = t.createElement("img"),
                                    o = n(s);
                                e.$image = o.one("error", function() {
                                    i.setError(e)
                                }).one("load", function() {
                                    var t;
                                    e.$ghost || (i.resolveImageSlideSize(e, this.naturalWidth, this.naturalHeight), i.afterLoad(e)), i.isClosing || (e.opts.srcset && ((t = e.opts.sizes) && "auto" !== t || (t = (e.width / e.height > 1 && a.width() / a.height() > 1 ? "100" : Math.round(e.width / e.height * 100)) + "vw"), o.attr("sizes", t).attr("srcset", e.opts.srcset)), e.$ghost && setTimeout(function() {
                                        e.$ghost && !i.isClosing && e.$ghost.hide()
                                    }, Math.min(300, Math.max(1e3, e.height / 1600))), i.hideLoading(e))
                                }).addClass("fancybox-image").attr("src", e.src + '?t=' +new Date().getTime()).appendTo(e.$content), (s.complete || "complete" == s.readyState) && o.naturalWidth && o.naturalHeight ? o.trigger("load") : s.error && o.trigger("error")
                            },
                            resolveImageSlideSize: function(e, t, n) {
                                var i = parseInt(e.opts.width, 10),
                                    s = parseInt(e.opts.height, 10);
                                e.width = t, e.height = n, i > 0 && (e.width = i, e.height = Math.floor(i * n / t)), s > 0 && (e.width = Math.floor(s * t / n), e.height = s)
                            },
                            setIframe: function(e) {
                                var t, i = this,
                                    s = e.opts.iframe,
                                    a = e.$slide;
                                e.$content = n('<div class="fancybox-content' + (s.preload ? " fancybox-is-hidden" : "") + '"></div>').css(s.css).appendTo(a), a.addClass("fancybox-slide--" + e.contentType), e.$iframe = t = n(s.tpl.replace(/\{rnd\}/g, (new Date).getTime())).attr(s.attr).appendTo(e.$content), s.preload ? (i.showLoading(e), t.on("load.fb error.fb", function(t) {
                                    this.isReady = 1, e.$slide.trigger("refresh"), i.afterLoad(e)
                                }), a.on("refresh.fb", function() {
                                    var n, i = e.$content,
                                        o = s.css.width,
                                        r = s.css.height;
                                    if (1 === t[0].isReady) {
                                        try {
                                            n = t.contents().find("body")
                                        } catch (e) {}
                                        n && n.length && n.children().length && (a.css("overflow", "visible"), i.css({
                                            width: "100%",
                                            "max-width": "100%",
                                            height: "9999px"
                                        }), void 0 === o && (o = Math.ceil(Math.max(n[0].clientWidth, n.outerWidth(!0)))), i.css("width", o || "").css("max-width", ""), void 0 === r && (r = Math.ceil(Math.max(n[0].clientHeight, n.outerHeight(!0)))), i.css("height", r || ""), a.css("overflow", "auto")), i.removeClass("fancybox-is-hidden")
                                    }
                                })) : i.afterLoad(e), t.attr("src", e.src), a.one("onReset", function() {
                                    try {
                                        n(this).find("iframe").hide().unbind().attr("src", "//about:blank")
                                    } catch (e) {}
                                    n(this).off("refresh.fb").empty(), e.isLoaded = !1, e.isRevealed = !1
                                })
                            },
                            setContent: function(e, t) {
                                this.isClosing || (this.hideLoading(e), e.$content && n.fancybox.stop(e.$content), e.$slide.empty(), function(e) {
                                    return e && e.hasOwnProperty && e instanceof n
                                }(t) && t.parent().length ? ((t.hasClass("fancybox-content") || t.parent().hasClass("fancybox-content")) && t.parents(".fancybox-slide").trigger("onReset"), e.$placeholder = n("<div>").hide().insertAfter(t), t.css("display", "inline-block")) : e.hasError || ("string" === n.type(t) && (t = n("<div>").append(n.trim(t)).contents()), e.opts.filter && (t = n("<div>").html(t).find(e.opts.filter))), e.$slide.one("onReset", function() {
                                    n(this).find("video,audio").trigger("pause"), e.$placeholder && (e.$placeholder.after(t.removeClass("fancybox-content").hide()).remove(), e.$placeholder = null), e.$smallBtn && (e.$smallBtn.remove(), e.$smallBtn = null), e.hasError || (n(this).empty(), e.isLoaded = !1, e.isRevealed = !1)
                                }), n(t).appendTo(e.$slide), n(t).is("video,audio") && (n(t).addClass("fancybox-video"), n(t).wrap("<div></div>"), e.contentType = "video", e.opts.width = e.opts.width || n(t).attr("width"), e.opts.height = e.opts.height || n(t).attr("height")), e.$content = e.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first(), e.$content.siblings().hide(), e.$content.length || (e.$content = e.$slide.wrapInner("<div></div>").children().first()), e.$content.addClass("fancybox-content"), e.$slide.addClass("fancybox-slide--" + e.contentType), this.afterLoad(e))
                            },
                            setError: function(e) {
                                e.hasError = !0, e.$slide.trigger("onReset").removeClass("fancybox-slide--" + e.contentType).addClass("fancybox-slide--error"), e.contentType = "html", this.setContent(e, this.translate(e, e.opts.errorTpl)), e.pos === this.currPos && (this.isAnimating = !1)
                            },
                            showLoading: function(e) {
                                (e = e || this.current) && !e.$spinner && (e.$spinner = n(this.translate(this, this.opts.spinnerTpl)).appendTo(e.$slide).hide().fadeIn("fast"))
                            },
                            hideLoading: function(e) {
                                (e = e || this.current) && e.$spinner && (e.$spinner.stop().remove(), delete e.$spinner)
                            },
                            afterLoad: function(e) {
                                this.isClosing || (e.isLoading = !1, e.isLoaded = !0, this.trigger("afterLoad", e), this.hideLoading(e), !e.opts.smallBtn || e.$smallBtn && e.$smallBtn.length || (e.$smallBtn = n(this.translate(e, e.opts.btnTpl.smallBtn)).appendTo(e.$content)), e.opts.protect && e.$content && !e.hasError && (e.$content.on("contextmenu.fb", function(e) {
                                    return 2 == e.button && e.preventDefault(), !0
                                }), "image" === e.type && n('<div class="fancybox-spaceball"></div>').appendTo(e.$content)), this.adjustCaption(e), this.adjustLayout(e), e.pos === this.currPos && this.updateCursor(), this.revealContent(e))
                            },
                            adjustCaption: function(e) {
                                var t, n = e || this.current,
                                    i = n.opts.caption,
                                    s = n.opts.preventCaptionOverlap,
                                    a = this.$refs.caption,
                                    o = !1;
                                a.toggleClass("fancybox-caption--separate", s), s && i && i.length && (n.pos !== this.currPos ? ((t = a.clone().appendTo(a.parent())).children().eq(0).empty().html(i), o = t.outerHeight(!0), t.empty().remove()) : this.$caption && (o = this.$caption.outerHeight(!0)), n.$slide.css("padding-bottom", o || ""))
                            },
                            adjustLayout: function(e) {
                                var t, n, i, s, a = e || this.current;
                                a.isLoaded && !0 !== a.opts.disableLayoutFix && (a.$content.css("margin-bottom", ""), a.$content.outerHeight() > a.$slide.height() + .5 && (i = a.$slide[0].style["padding-bottom"], s = a.$slide.css("padding-bottom"), parseFloat(s) > 0 && (t = a.$slide[0].scrollHeight, a.$slide.css("padding-bottom", 0), Math.abs(t - a.$slide[0].scrollHeight) < 1 && (n = s), a.$slide.css("padding-bottom", i))), a.$content.css("margin-bottom", n))
                            },
                            revealContent: function(e) {
                                var t, i, s, a, o = this,
                                    r = e.$slide,
                                    d = !1,
                                    l = !1,
                                    u = o.isMoved(e),
                                    h = e.isRevealed;
                                return e.isRevealed = !0, t = e.opts[o.firstRun ? "animationEffect" : "transitionEffect"], s = e.opts[o.firstRun ? "animationDuration" : "transitionDuration"], s = parseInt(void 0 === e.forcedDuration ? s : e.forcedDuration, 10), !u && e.pos === o.currPos && s || (t = !1), "zoom" === t && (e.pos === o.currPos && s && "image" === e.type && !e.hasError && (l = o.getThumbPos(e)) ? d = o.getFitPos(e) : t = "fade"), "zoom" === t ? (o.isAnimating = !0, d.scaleX = d.width / l.width, d.scaleY = d.height / l.height, "auto" == (a = e.opts.zoomOpacity) && (a = Math.abs(e.width / e.height - l.width / l.height) > .1), a && (l.opacity = .1, d.opacity = 1), n.fancybox.setTranslate(e.$content.removeClass("fancybox-is-hidden"), l), c(e.$content), void n.fancybox.animate(e.$content, d, s, function() {
                                    o.isAnimating = !1, o.complete()
                                })) : (o.updateSlide(e), t ? (n.fancybox.stop(r), i = "fancybox-slide--" + (e.pos >= o.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + t, r.addClass(i).removeClass("fancybox-slide--current"), e.$content.removeClass("fancybox-is-hidden"), c(r), "image" !== e.type && e.$content.hide().show(0), void n.fancybox.animate(r, "fancybox-slide--current", s, function() {
                                    r.removeClass(i).css({
                                        transform: "",
                                        opacity: ""
                                    }), e.pos === o.currPos && o.complete()
                                }, !0)) : (e.$content.removeClass("fancybox-is-hidden"), h || !u || "image" !== e.type || e.hasError || e.$content.hide().fadeIn("fast"), void(e.pos === o.currPos && o.complete())))
                            },
                            getThumbPos: function(e) {
                                var i, s, a, o, r, d, l = e.$thumb;
                                return !(!l || ! function(e) {
                                    var i, s;
                                    return !(!e || e.ownerDocument !== t) && (n(".fancybox-container").css("pointer-events", "none"), i = {
                                        x: e.getBoundingClientRect().left + e.offsetWidth / 2,
                                        y: e.getBoundingClientRect().top + e.offsetHeight / 2
                                    }, s = t.elementFromPoint(i.x, i.y) === e, n(".fancybox-container").css("pointer-events", ""), s)
                                }(l[0])) && (s = n.fancybox.getTranslate(l), a = parseFloat(l.css("border-top-width") || 0), o = parseFloat(l.css("border-right-width") || 0), r = parseFloat(l.css("border-bottom-width") || 0), d = parseFloat(l.css("border-left-width") || 0), i = {
                                    top: s.top + a,
                                    left: s.left + d,
                                    width: s.width - o - d,
                                    height: s.height - a - r,
                                    scaleX: 1,
                                    scaleY: 1
                                }, s.width > 0 && s.height > 0 && i)
                            },
                            complete: function() {
                                var e, t = this,
                                    i = t.current,
                                    s = {};
                                !t.isMoved() && i.isLoaded && (i.isComplete || (i.isComplete = !0, i.$slide.siblings().trigger("onReset"), t.preload("inline"), c(i.$slide), i.$slide.addClass("fancybox-slide--complete"), n.each(t.slides, function(e, i) {
                                    i.pos >= t.currPos - 1 && i.pos <= t.currPos + 1 ? s[i.pos] = i : i && (n.fancybox.stop(i.$slide), i.$slide.off().remove())
                                }), t.slides = s), t.isAnimating = !1, t.updateCursor(), t.trigger("afterShow"), i.opts.video.autoStart && i.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended", function() {
                                    Document.exitFullscreen ? Document.exitFullscreen() : this.webkitExitFullscreen && this.webkitExitFullscreen(), t.next()
                                }), i.opts.autoFocus && "html" === i.contentType && ((e = i.$content.find("input[autofocus]:enabled:visible:first")).length ? e.trigger("focus") : t.focus(null, !0)), i.$slide.scrollTop(0).scrollLeft(0))
                            },
                            preload: function(e) {
                                var t, n;
                                this.group.length < 2 || (n = this.slides[this.currPos + 1], (t = this.slides[this.currPos - 1]) && t.type === e && this.loadSlide(t), n && n.type === e && this.loadSlide(n))
                            },
                            focus: function(e, i) {
                                var s, a, o = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden])", "iframe", "object", "embed", "video", "audio", "[contenteditable]", '[tabindex]:not([tabindex^="-"])'].join(",");
                                this.isClosing || ((s = (s = !e && this.current && this.current.isComplete ? this.current.$slide.find("*:visible" + (i ? ":not(.fancybox-close-small)" : "")) : this.$refs.container.find("*:visible")).filter(o).filter(function() {
                                    return "hidden" !== n(this).css("visibility") && !n(this).hasClass("disabled")
                                })).length ? (a = s.index(t.activeElement), e && e.shiftKey ? (a < 0 || 0 == a) && (e.preventDefault(), s.eq(s.length - 1).trigger("focus")) : (a < 0 || a == s.length - 1) && (e && e.preventDefault(), s.eq(0).trigger("focus"))) : this.$refs.container.trigger("focus"))
                            },
                            activate: function() {
                                var e = this;
                                n(".fancybox-container").each(function() {
                                    var t = n(this).data("FancyBox");
                                    t && t.id !== e.id && !t.isClosing && (t.trigger("onDeactivate"), t.removeEvents(), t.isVisible = !1)
                                }), e.isVisible = !0, (e.current || e.isIdle) && (e.update(), e.updateControls()), e.trigger("onActivate"), e.addEvents()
                            },
                            close: function(e, t) {
                                var i, s, a, o, r, l, u, h = this,
                                    m = h.current,
                                    f = function() {
                                        h.cleanUp(e)
                                    };
                                return !h.isClosing && (h.isClosing = !0, !1 === h.trigger("beforeClose", e) ? (h.isClosing = !1, d(function() {
                                    h.update()
                                }), !1) : (h.removeEvents(), a = m.$content, i = m.opts.animationEffect, s = n.isNumeric(t) ? t : i ? m.opts.animationDuration : 0, m.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"), !0 !== e ? n.fancybox.stop(m.$slide) : i = !1, m.$slide.siblings().trigger("onReset").remove(), s && h.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration", s + "ms"), h.hideLoading(m), h.hideControls(!0), h.updateCursor(), "zoom" !== i || a && s && "image" === m.type && !h.isMoved() && !m.hasError && (u = h.getThumbPos(m)) || (i = "fade"), "zoom" === i ? (n.fancybox.stop(a), l = {
                                    top: (o = n.fancybox.getTranslate(a)).top,
                                    left: o.left,
                                    scaleX: o.width / u.width,
                                    scaleY: o.height / u.height,
                                    width: u.width,
                                    height: u.height
                                }, "auto" == (r = m.opts.zoomOpacity) && (r = Math.abs(m.width / m.height - u.width / u.height) > .1), r && (u.opacity = 0), n.fancybox.setTranslate(a, l), c(a), n.fancybox.animate(a, u, s, f), !0) : (i && s ? n.fancybox.animate(m.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"), "fancybox-animated fancybox-fx-" + i, s, f) : !0 === e ? setTimeout(f, s) : f(), !0)))
                            },
                            cleanUp: function(t) {
                                var i, s, a, o = this.current.opts.$orig;
                                this.current.$slide.trigger("onReset"), this.$refs.container.empty().remove(), this.trigger("afterClose", t), this.current.opts.backFocus && (o && o.length && o.is(":visible") || (o = this.$trigger), o && o.length && (s = e.scrollX, a = e.scrollY, o.trigger("focus"), n("html, body").scrollTop(a).scrollLeft(s))), this.current = null, (i = n.fancybox.getInstance()) ? i.activate() : (n("body").removeClass("fancybox-active compensate-for-scrollbar"), n("#fancybox-style-noscroll").remove())
                            },
                            trigger: function(e, t) {
                                var i, s = Array.prototype.slice.call(arguments, 1),
                                    a = t && t.opts ? t : this.current;
                                if (a ? s.unshift(a) : a = this, s.unshift(this), n.isFunction(a.opts[e]) && (i = a.opts[e].apply(a, s)), !1 === i) return i;
                                "afterClose" !== e && this.$refs ? this.$refs.container.trigger(e + ".fb", s) : o.trigger(e + ".fb", s)
                            },
                            updateControls: function() {
                                var e = this.current,
                                    i = e.index,
                                    s = this.$refs.container,
                                    a = this.$refs.caption,
                                    o = e.opts.caption;
                                e.$slide.trigger("refresh"), o && o.length ? (this.$caption = a, a.children().eq(0).html(o)) : this.$caption = null, this.hasHiddenControls || this.isIdle || this.showControls(), s.find("[data-fancybox-count]").html(this.group.length), s.find("[data-fancybox-index]").html(i + 1), s.find("[data-fancybox-prev]").prop("disabled", !e.opts.loop && i <= 0), s.find("[data-fancybox-next]").prop("disabled", !e.opts.loop && i >= this.group.length - 1), "image" === e.type ? s.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href", e.opts.image.src || e.src).show() : e.opts.toolbar && s.find("[data-fancybox-download],[data-fancybox-zoom]").hide(), n(t.activeElement).is(":hidden,[disabled]") && this.$refs.container.trigger("focus")
                            },
                            hideControls: function(e) {
                                var t = ["infobar", "toolbar", "nav"];
                                !e && this.current.opts.preventCaptionOverlap || t.push("caption"), this.$refs.container.removeClass(t.map(function(e) {
                                    return "fancybox-show-" + e
                                }).join(" ")), this.hasHiddenControls = !0
                            },
                            showControls: function() {
                                var e = this.current ? this.current.opts : this.opts,
                                    t = this.$refs.container;
                                this.hasHiddenControls = !1, this.idleSecondsCounter = 0, t.toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons)).toggleClass("fancybox-show-infobar", !!(e.infobar && this.group.length > 1)).toggleClass("fancybox-show-caption", !!this.$caption).toggleClass("fancybox-show-nav", !!(e.arrows && this.group.length > 1)).toggleClass("fancybox-is-modal", !!e.modal)
                            },
                            toggleControls: function() {
                                this.hasHiddenControls ? this.showControls() : this.hideControls()
                            }
                        }), n.fancybox = {
                            version: "3.5.7",
                            defaults: s,
                            getInstance: function(e) {
                                var t = n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),
                                    i = Array.prototype.slice.call(arguments, 1);
                                return t instanceof m && ("string" === n.type(e) ? t[e].apply(t, i) : "function" === n.type(e) && e.apply(t, i), t)
                            },
                            open: function(e, t, n) {
                                return new m(e, t, n)
                            },
                            close: function(e) {
                                var t = this.getInstance();
                                t && (t.close(), !0 === e && this.close(e))
                            },
                            destroy: function() {
                                this.close(!0), o.add("body").off("click.fb-start", "**")
                            },
                            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                            use3d: function() {
                                var n = t.createElement("div");
                                return e.getComputedStyle && e.getComputedStyle(n) && e.getComputedStyle(n).getPropertyValue("transform") && !(t.documentMode && t.documentMode < 11)
                            }(),
                            getTranslate: function(e) {
                                var t;
                                return !(!e || !e.length) && {
                                    top: (t = e[0].getBoundingClientRect()).top || 0,
                                    left: t.left || 0,
                                    width: t.width,
                                    height: t.height,
                                    opacity: parseFloat(e.css("opacity"))
                                }
                            },
                            setTranslate: function(e, t) {
                                var n = "",
                                    i = {};
                                if (e && t) return void 0 === t.left && void 0 === t.top || (n = (void 0 === t.left ? e.position().left : t.left) + "px, " + (void 0 === t.top ? e.position().top : t.top) + "px", n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")"), void 0 !== t.scaleX && void 0 !== t.scaleY ? n += " scale(" + t.scaleX + ", " + t.scaleY + ")" : void 0 !== t.scaleX && (n += " scaleX(" + t.scaleX + ")"), n.length && (i.transform = n), void 0 !== t.opacity && (i.opacity = t.opacity), void 0 !== t.width && (i.width = t.width), void 0 !== t.height && (i.height = t.height), e.css(i)
                            },
                            animate: function(e, t, i, s, a) {
                                var o, r = this;
                                n.isFunction(i) && (s = i, i = null), r.stop(e), o = r.getTranslate(e), e.on(u, function(d) {
                                    (!d || !d.originalEvent || e.is(d.originalEvent.target) && "z-index" != d.originalEvent.propertyName) && (r.stop(e), n.isNumeric(i) && e.css("transition-duration", ""), n.isPlainObject(t) ? void 0 !== t.scaleX && void 0 !== t.scaleY && r.setTranslate(e, {
                                        top: t.top,
                                        left: t.left,
                                        width: o.width * t.scaleX,
                                        height: o.height * t.scaleY,
                                        scaleX: 1,
                                        scaleY: 1
                                    }) : !0 !== a && e.removeClass(t), n.isFunction(s) && s(d))
                                }), n.isNumeric(i) && e.css("transition-duration", i + "ms"), n.isPlainObject(t) ? (void 0 !== t.scaleX && void 0 !== t.scaleY && (delete t.width, delete t.height, e.parent().hasClass("fancybox-slide--image") && e.parent().addClass("fancybox-is-scaling")), n.fancybox.setTranslate(e, t)) : e.addClass(t), e.data("timer", setTimeout(function() {
                                    e.trigger(u)
                                }, i + 33))
                            },
                            stop: function(e, t) {
                                e && e.length && (clearTimeout(e.data("timer")), t && e.trigger(u), e.off(u).css("transition-duration", ""), e.parent().removeClass("fancybox-is-scaling"))
                            }
                        }, n.fn.fancybox = function(e) {
                            var t;
                            return (t = (e = e || {}).selector || !1) ? n("body").off("click.fb-start", t).on("click.fb-start", t, {
                                options: e
                            }, f) : this.off("click.fb-start").on("click.fb-start", {
                                items: this,
                                options: e
                            }, f), this
                        }, o.on("click.fb-start", "[data-fancybox]", f), o.on("click.fb-start", "[data-fancybox-trigger]", function(e) {
                            n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]').eq(n(this).attr("data-fancybox-index") || 0).trigger("click.fb-start", {
                                $trigger: n(this)
                            })
                        }),
                        function() {
                            var e = null;
                            o.on("mousedown mouseup focus blur", ".fancybox-button", function(t) {
                                switch (t.type) {
                                    case "mousedown":
                                        e = n(this);
                                        break;
                                    case "mouseup":
                                        e = null;
                                        break;
                                    case "focusin":
                                        n(".fancybox-button").removeClass("fancybox-focus"), n(this).is(e) || n(this).is("[disabled]") || n(this).addClass("fancybox-focus");
                                        break;
                                    case "focusout":
                                        n(".fancybox-button").removeClass("fancybox-focus")
                                }
                            })
                        }()
                }
            function f(e, t) {
                var i, s, a, o = [],
                    r = 0;
                e && e.isDefaultPrevented() || (e.preventDefault(), t = t || {}, e && e.data && (t = h(e.data.options, t)), i = t.$target || n(e.currentTarget).trigger("blur"), (a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(i) || (o = t.selector ? n(t.selector) : (s = i.attr("data-fancybox") || "") ? (o = e.data ? e.data.items : []).length ? o.filter('[data-fancybox="' + s + '"]') : n('[data-fancybox="' + s + '"]') : [i], (r = n(o).index(i)) < 0 && (r = 0), (a = n.fancybox.open(o, t, r)).$trigger = i))
            }
        }(window, document, e),
        function(e) {
            "use strict";
            var t = {
                    youtube: {
                        matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
                        params: {
                            autoplay: 1,
                            autohide: 1,
                            fs: 1,
                            rel: 0,
                            hd: 1,
                            wmode: "transparent",
                            enablejsapi: 1,
                            html5: 1
                        },
                        paramPlace: 8,
                        type: "iframe",
                        url: "https://www.youtube-nocookie.com/embed/$4",
                        thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg"
                    },
                    vimeo: {
                        matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
                        params: {
                            autoplay: 1,
                            hd: 1,
                            show_title: 1,
                            show_byline: 1,
                            show_portrait: 0,
                            fullscreen: 1
                        },
                        paramPlace: 3,
                        type: "iframe",
                        url: "//player.vimeo.com/video/$2"
                    },
                    instagram: {
                        matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
                        type: "image",
                        url: "//$1/p/$2/media/?size=l"
                    },
                    gmap_place: {
                        matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
                        type: "iframe",
                        url: function(e) {
                            return "//maps.google." + e[2] + "/?ll=" + (e[9] ? e[9] + "&z=" + Math.floor(e[10]) + (e[12] ? e[12].replace(/^\//, "&") : "") : e[12] + "").replace(/\?/, "&") + "&output=" + (e[12] && e[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
                        }
                    },
                    gmap_search: {
                        matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
                        type: "iframe",
                        url: function(e) {
                            return "//maps.google." + e[2] + "/maps?q=" + e[5].replace("query=", "q=").replace("api=1", "") + "&output=embed"
                        }
                    }
                },
                n = function(t, n, i) {
                    if (t) return i = i || "", "object" === e.type(i) && (i = e.param(i, !0)), e.each(n, function(e, n) {
                        t = t.replace("$" + e, n || "")
                    }), i.length && (t += (t.indexOf("?") > 0 ? "&" : "?") + i), t
                };
            e(document).on("objectNeedsType.fb", function(i, s, a) {
                var o, r, d, l, u, c, h, m = a.src || "",
                    f = !1;
                o = e.extend(!0, {}, t, a.opts.media), e.each(o, function(t, i) {
                    if (d = m.match(i.matcher)) {
                        if (f = i.type, h = t, c = {}, i.paramPlace && d[i.paramPlace]) {
                            "?" == (u = d[i.paramPlace])[0] && (u = u.substring(1)), u = u.split("&");
                            for (var s = 0; s < u.length; ++s) {
                                var o = u[s].split("=", 2);
                                2 == o.length && (c[o[0]] = decodeURIComponent(o[1].replace(/\+/g, " ")))
                            }
                        }
                        return l = e.extend(!0, {}, i.params, a.opts[t], c), m = "function" === e.type(i.url) ? i.url.call(this, d, l, a) : n(i.url, d, l), r = "function" === e.type(i.thumb) ? i.thumb.call(this, d, l, a) : n(i.thumb, d), "youtube" === t ? m = m.replace(/&t=((\d+)m)?(\d+)s/, function(e, t, n, i) {
                            return "&start=" + ((n ? 60 * parseInt(n, 10) : 0) + parseInt(i, 10))
                        }) : "vimeo" === t && (m = m.replace("&%23", "#")), !1
                    }
                }), f ? (a.opts.thumb || a.opts.$thumb && a.opts.$thumb.length || (a.opts.thumb = r), "iframe" === f && (a.opts = e.extend(!0, a.opts, {
                    iframe: {
                        preload: !1,
                        attr: {
                            scrolling: "no"
                        }
                    }
                })), e.extend(a, {
                    type: f,
                    src: m,
                    origSrc: a.src,
                    contentSource: h,
                    contentType: "image" === f ? "image" : "gmap_place" == h || "gmap_search" == h ? "map" : "video"
                })) : m && (a.type = a.opts.defaultType)
            });
            var i = {
                youtube: {
                    src: "https://www.youtube.com/iframe_api",
                    class: "YT",
                    loading: !1,
                    loaded: !1
                },
                vimeo: {
                    src: "https://player.vimeo.com/api/player.js",
                    class: "Vimeo",
                    loading: !1,
                    loaded: !1
                },
                load: function(e) {
                    var t, n = this;
                    this[e].loaded ? setTimeout(function() {
                        n.done(e)
                    }) : this[e].loading || (this[e].loading = !0, (t = document.createElement("script")).type = "text/javascript", t.src = this[e].src, "youtube" === e ? window.onYouTubeIframeAPIReady = function() {
                        n[e].loaded = !0, n.done(e)
                    } : t.onload = function() {
                        n[e].loaded = !0, n.done(e)
                    }, document.body.appendChild(t))
                },
                done: function(t) {
                    var n, i;
                    "youtube" === t && delete window.onYouTubeIframeAPIReady, (n = e.fancybox.getInstance()) && (i = n.current.$content.find("iframe"), "youtube" === t && void 0 !== YT && YT ? new YT.Player(i.attr("id"), {
                        events: {
                            onStateChange: function(e) {
                                0 == e.data && n.next()
                            }
                        }
                    }) : "vimeo" === t && void 0 !== Vimeo && Vimeo && new Vimeo.Player(i).on("ended", function() {
                        n.next()
                    }))
                }
            };
            e(document).on({
                "afterShow.fb": function(e, t, n) {
                    t.group.length > 1 && ("youtube" === n.contentSource || "vimeo" === n.contentSource) && i.load(n.contentSource)
                }
            })
        }(e),
        function(e, t, n) {
            "use strict";
            var i = e.requestAnimationFrame || e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || e.oRequestAnimationFrame || function(t) {
                    return e.setTimeout(t, 1e3 / 60)
                },
                s = e.cancelAnimationFrame || e.webkitCancelAnimationFrame || e.mozCancelAnimationFrame || e.oCancelAnimationFrame || function(t) {
                    e.clearTimeout(t)
                },
                a = function(t) {
                    var n = [];
                    for (var i in t = (t = t.originalEvent || t || e.e).touches && t.touches.length ? t.touches : t.changedTouches && t.changedTouches.length ? t.changedTouches : [t]) t[i].pageX ? n.push({
                        x: t[i].pageX,
                        y: t[i].pageY
                    }) : t[i].clientX && n.push({
                        x: t[i].clientX,
                        y: t[i].clientY
                    });
                    return n
                },
                o = function(e, t, n) {
                    return t && e ? "x" === n ? e.x - t.x : "y" === n ? e.y - t.y : Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)) : 0
                },
                r = function(e) {
                    if (e.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') || n.isFunction(e.get(0).onclick) || e.data("selectable")) return !0;
                    for (var t = 0, i = e[0].attributes, s = i.length; t < s; t++)
                        if ("data-fancybox-" === i[t].nodeName.substr(0, 14)) return !0;
                    return !1
                },
                d = function(t) {
                    var n = e.getComputedStyle(t)["overflow-y"],
                        i = e.getComputedStyle(t)["overflow-x"],
                        s = ("scroll" === n || "auto" === n) && t.scrollHeight > t.clientHeight,
                        a = ("scroll" === i || "auto" === i) && t.scrollWidth > t.clientWidth;
                    return s || a
                },
                l = function(e) {
                    for (var t = !1; !(t = d(e.get(0))) && (e = e.parent()).length && !e.hasClass("fancybox-stage") && !e.is("body"););
                    return t
                },
                u = function(e) {
                    this.instance = e, this.$bg = e.$refs.bg, this.$stage = e.$refs.stage, this.$container = e.$refs.container, this.destroy(), this.$container.on("touchstart.fb.touch mousedown.fb.touch", n.proxy(this, "ontouchstart"))
                };
            u.prototype.destroy = function() {
                this.$container.off(".fb.touch"), n(t).off(".fb.touch"), this.requestId && (s(this.requestId), this.requestId = null), this.tapped && (clearTimeout(this.tapped), this.tapped = null)
            }, u.prototype.ontouchstart = function(i) {
                var s = n(i.target),
                    d = this.instance,
                    u = d.current,
                    c = u.$slide,
                    h = u.$content,
                    m = "touchstart" == i.type;
                if (m && this.$container.off("mousedown.fb.touch"), (!i.originalEvent || 2 != i.originalEvent.button) && c.length && s.length && !r(s) && !r(s.parent()) && (s.is("img") || !(i.originalEvent.clientX > s[0].clientWidth + s.offset().left))) {
                    if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated")) return i.stopPropagation(), void i.preventDefault();
                    this.realPoints = this.startPoints = a(i), this.startPoints.length && (u.touch && i.stopPropagation(), this.startEvent = i, this.canTap = !0, this.$target = s, this.$content = h, this.opts = u.opts.touch, this.isPanning = !1, this.isSwiping = !1, this.isZooming = !1, this.isScrolling = !1, this.canPan = d.canPan(), this.startTime = (new Date).getTime(), this.distanceX = this.distanceY = this.distance = 0, this.canvasWidth = Math.round(c[0].clientWidth), this.canvasHeight = Math.round(c[0].clientHeight), this.contentLastPos = null, this.contentStartPos = n.fancybox.getTranslate(this.$content) || {
                        top: 0,
                        left: 0
                    }, this.sliderStartPos = n.fancybox.getTranslate(c), this.stagePos = n.fancybox.getTranslate(d.$refs.stage), this.sliderStartPos.top -= this.stagePos.top, this.sliderStartPos.left -= this.stagePos.left, this.contentStartPos.top -= this.stagePos.top, this.contentStartPos.left -= this.stagePos.left, n(t).off(".fb.touch").on(m ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", n.proxy(this, "ontouchend")).on(m ? "touchmove.fb.touch" : "mousemove.fb.touch", n.proxy(this, "ontouchmove")), n.fancybox.isMobile && t.addEventListener("scroll", this.onscroll, !0), ((this.opts || this.canPan) && (s.is(this.$stage) || this.$stage.find(s).length) || (s.is(".fancybox-image") && i.preventDefault(), n.fancybox.isMobile && s.parents(".fancybox-caption").length)) && (this.isScrollable = l(s) || l(s.parent()), n.fancybox.isMobile && this.isScrollable || i.preventDefault(), (1 === this.startPoints.length || u.hasError) && (this.canPan ? (n.fancybox.stop(this.$content), this.isPanning = !0) : this.isSwiping = !0, this.$container.addClass("fancybox-is-grabbing")), 2 === this.startPoints.length && "image" === u.type && (u.isLoaded || u.$ghost) && (this.canTap = !1, this.isSwiping = !1, this.isPanning = !1, this.isZooming = !0, n.fancybox.stop(this.$content), this.centerPointStartX = .5 * (this.startPoints[0].x + this.startPoints[1].x) - n(e).scrollLeft(), this.centerPointStartY = .5 * (this.startPoints[0].y + this.startPoints[1].y) - n(e).scrollTop(), this.percentageOfImageAtPinchPointX = (this.centerPointStartX - this.contentStartPos.left) / this.contentStartPos.width, this.percentageOfImageAtPinchPointY = (this.centerPointStartY - this.contentStartPos.top) / this.contentStartPos.height, this.startDistanceBetweenFingers = o(this.startPoints[0], this.startPoints[1]))))
                }
            }, u.prototype.onscroll = function(e) {
                this.isScrolling = !0, t.removeEventListener("scroll", this.onscroll, !0)
            }, u.prototype.ontouchmove = function(e) {
                void 0 === e.originalEvent.buttons || 0 !== e.originalEvent.buttons ? this.isScrolling ? this.canTap = !1 : (this.newPoints = a(e), (this.opts || this.canPan) && this.newPoints.length && this.newPoints.length && (this.isSwiping && !0 === this.isSwiping || e.preventDefault(), this.distanceX = o(this.newPoints[0], this.startPoints[0], "x"), this.distanceY = o(this.newPoints[0], this.startPoints[0], "y"), this.distance = o(this.newPoints[0], this.startPoints[0]), this.distance > 0 && (this.isSwiping ? this.onSwipe(e) : this.isPanning ? this.onPan() : this.isZooming && this.onZoom()))) : this.ontouchend(e)
            }, u.prototype.onSwipe = function(t) {
                var a, o = this,
                    r = o.instance,
                    d = o.isSwiping,
                    l = o.sliderStartPos.left || 0;
                if (!0 !== d) "x" == d && (o.distanceX > 0 && (o.instance.group.length < 2 || 0 === o.instance.current.index && !o.instance.current.opts.loop) ? l += Math.pow(o.distanceX, .8) : o.distanceX < 0 && (o.instance.group.length < 2 || o.instance.current.index === o.instance.group.length - 1 && !o.instance.current.opts.loop) ? l -= Math.pow(-o.distanceX, .8) : l += o.distanceX), o.sliderLastPos = {
                    top: "x" == d ? 0 : o.sliderStartPos.top + o.distanceY,
                    left: l
                }, o.requestId && (s(o.requestId), o.requestId = null), o.requestId = i(function() {
                    o.sliderLastPos && (n.each(o.instance.slides, function(e, t) {
                        var i = t.pos - o.instance.currPos;
                        n.fancybox.setTranslate(t.$slide, {
                            top: o.sliderLastPos.top,
                            left: o.sliderLastPos.left + i * o.canvasWidth + i * t.opts.gutter
                        })
                    }), o.$container.addClass("fancybox-is-sliding"))
                });
                else if (Math.abs(o.distance) > 10) {
                    if (o.canTap = !1, r.group.length < 2 && o.opts.vertical ? o.isSwiping = "y" : r.isDragging || !1 === o.opts.vertical || "auto" === o.opts.vertical && n(e).width() > 800 ? o.isSwiping = "x" : (a = Math.abs(180 * Math.atan2(o.distanceY, o.distanceX) / Math.PI), o.isSwiping = a > 45 && a < 135 ? "y" : "x"), "y" === o.isSwiping && n.fancybox.isMobile && o.isScrollable) return void(o.isScrolling = !0);
                    r.isDragging = o.isSwiping, o.startPoints = o.newPoints, n.each(r.slides, function(e, t) {
                        var i, s;
                        n.fancybox.stop(t.$slide), i = n.fancybox.getTranslate(t.$slide), s = n.fancybox.getTranslate(r.$refs.stage), t.$slide.css({
                            transform: "",
                            opacity: "",
                            "transition-duration": ""
                        }).removeClass("fancybox-animated").removeClass(function(e, t) {
                            return (t.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ")
                        }), t.pos === r.current.pos && (o.sliderStartPos.top = i.top - s.top, o.sliderStartPos.left = i.left - s.left), n.fancybox.setTranslate(t.$slide, {
                            top: i.top - s.top,
                            left: i.left - s.left
                        })
                    }), r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop()
                }
            }, u.prototype.onPan = function() {
                var e = this;
                o(e.newPoints[0], e.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5) ? e.startPoints = e.newPoints : (e.canTap = !1, e.contentLastPos = e.limitMovement(), e.requestId && s(e.requestId), e.requestId = i(function() {
                    n.fancybox.setTranslate(e.$content, e.contentLastPos)
                }))
            }, u.prototype.limitMovement = function() {
                var e, t, n, i, s, a, o = this.canvasWidth,
                    r = this.canvasHeight,
                    d = this.distanceX,
                    l = this.distanceY,
                    u = this.contentStartPos,
                    c = u.left,
                    h = u.top,
                    m = u.width,
                    f = u.height;
                return s = m > o ? c + d : c, a = h + l, e = Math.max(0, .5 * o - .5 * m), t = Math.max(0, .5 * r - .5 * f), n = Math.min(o - m, .5 * o - .5 * m), i = Math.min(r - f, .5 * r - .5 * f), d > 0 && s > e && (s = e - 1 + Math.pow(-e + c + d, .8) || 0), d < 0 && s < n && (s = n + 1 - Math.pow(n - c - d, .8) || 0), l > 0 && a > t && (a = t - 1 + Math.pow(-t + h + l, .8) || 0), l < 0 && a < i && (a = i + 1 - Math.pow(i - h - l, .8) || 0), {
                    top: a,
                    left: s
                }
            }, u.prototype.limitPosition = function(e, t, n, i) {
                var s = this.canvasWidth,
                    a = this.canvasHeight;
                return e = n > s ? (e = e > 0 ? 0 : e) < s - n ? s - n : e : Math.max(0, s / 2 - n / 2), {
                    top: t = i > a ? (t = t > 0 ? 0 : t) < a - i ? a - i : t : Math.max(0, a / 2 - i / 2),
                    left: e
                }
            }, u.prototype.onZoom = function() {
                var t = this,
                    a = t.contentStartPos,
                    r = a.width,
                    d = a.height,
                    l = a.left,
                    u = a.top,
                    c = o(t.newPoints[0], t.newPoints[1]) / t.startDistanceBetweenFingers,
                    h = Math.floor(r * c),
                    m = Math.floor(d * c),
                    f = (r - h) * t.percentageOfImageAtPinchPointX,
                    _ = (d - m) * t.percentageOfImageAtPinchPointY,
                    p = (t.newPoints[0].x + t.newPoints[1].x) / 2 - n(e).scrollLeft(),
                    g = (t.newPoints[0].y + t.newPoints[1].y) / 2 - n(e).scrollTop(),
                    y = p - t.centerPointStartX,
                    v = {
                        top: u + (_ + (g - t.centerPointStartY)),
                        left: l + (f + y),
                        scaleX: c,
                        scaleY: c
                    };
                t.canTap = !1, t.newWidth = h, t.newHeight = m, t.contentLastPos = v, t.requestId && s(t.requestId), t.requestId = i(function() {
                    n.fancybox.setTranslate(t.$content, t.contentLastPos)
                })
            }, u.prototype.ontouchend = function(e) {
                var i = this.isSwiping,
                    o = this.isPanning,
                    r = this.isZooming,
                    d = this.isScrolling;
                if (this.endPoints = a(e), this.dMs = Math.max((new Date).getTime() - this.startTime, 1), this.$container.removeClass("fancybox-is-grabbing"), n(t).off(".fb.touch"), t.removeEventListener("scroll", this.onscroll, !0), this.requestId && (s(this.requestId), this.requestId = null), this.isSwiping = !1, this.isPanning = !1, this.isZooming = !1, this.isScrolling = !1, this.instance.isDragging = !1, this.canTap) return this.onTap(e);
                this.speed = 100, this.velocityX = this.distanceX / this.dMs * .5, this.velocityY = this.distanceY / this.dMs * .5, o ? this.endPanning() : r ? this.endZooming() : this.endSwiping(i, d)
            }, u.prototype.endSwiping = function(e, t) {
                var i = !1,
                    s = this.instance.group.length,
                    a = Math.abs(this.distanceX),
                    o = "x" == e && s > 1 && (this.dMs > 130 && a > 10 || a > 50);
                this.sliderLastPos = null, "y" == e && !t && Math.abs(this.distanceY) > 50 ? (n.fancybox.animate(this.instance.current.$slide, {
                    top: this.sliderStartPos.top + this.distanceY + 150 * this.velocityY,
                    opacity: 0
                }, 200), i = this.instance.close(!0, 250)) : o && this.distanceX > 0 ? i = this.instance.previous(300) : o && this.distanceX < 0 && (i = this.instance.next(300)), !1 !== i || "x" != e && "y" != e || this.instance.centerSlide(200), this.$container.removeClass("fancybox-is-sliding")
            }, u.prototype.endPanning = function() {
                var e, t, i;
                this.contentLastPos && (!1 === this.opts.momentum || this.dMs > 350 ? (e = this.contentLastPos.left, t = this.contentLastPos.top) : (e = this.contentLastPos.left + 500 * this.velocityX, t = this.contentLastPos.top + 500 * this.velocityY), (i = this.limitPosition(e, t, this.contentStartPos.width, this.contentStartPos.height)).width = this.contentStartPos.width, i.height = this.contentStartPos.height, n.fancybox.animate(this.$content, i, 366))
            }, u.prototype.endZooming = function() {
                var e, t, i, s, a = this.instance.current,
                    o = this.newWidth,
                    r = this.newHeight;
                this.contentLastPos && (e = this.contentLastPos.left, s = {
                    top: t = this.contentLastPos.top,
                    left: e,
                    width: o,
                    height: r,
                    scaleX: 1,
                    scaleY: 1
                }, n.fancybox.setTranslate(this.$content, s), o < this.canvasWidth && r < this.canvasHeight ? this.instance.scaleToFit(150) : o > a.width || r > a.height ? this.instance.scaleToActual(this.centerPointStartX, this.centerPointStartY, 150) : (i = this.limitPosition(e, t, o, r), n.fancybox.animate(this.$content, i, 150)))
            }, u.prototype.onTap = function(t) {
                var i, s = this,
                    o = n(t.target),
                    r = s.instance,
                    d = r.current,
                    l = t && a(t) || s.startPoints,
                    u = l[0] ? l[0].x - n(e).scrollLeft() - s.stagePos.left : 0,
                    c = l[0] ? l[0].y - n(e).scrollTop() - s.stagePos.top : 0,
                    h = function(e) {
                        var i = d.opts[e];
                        if (n.isFunction(i) && (i = i.apply(r, [d, t])), i) switch (i) {
                            case "close":
                                r.close(s.startEvent);
                                break;
                            case "toggleControls":
                                r.toggleControls();
                                break;
                            case "next":
                                r.next();
                                break;
                            case "nextOrClose":
                                r.group.length > 1 ? r.next() : r.close(s.startEvent);
                                break;
                            case "zoom":
                                "image" == d.type && (d.isLoaded || d.$ghost) && (r.canPan() ? r.scaleToFit() : r.isScaledDown() ? r.scaleToActual(u, c) : r.group.length < 2 && r.close(s.startEvent))
                        }
                    };
                if ((!t.originalEvent || 2 != t.originalEvent.button) && (o.is("img") || !(u > o[0].clientWidth + o.offset().left))) {
                    if (o.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) i = "Outside";
                    else if (o.is(".fancybox-slide")) i = "Slide";
                    else {
                        if (!r.current.$content || !r.current.$content.find(o).addBack().filter(o).length) return;
                        i = "Content"
                    }
                    if (s.tapped) {
                        if (clearTimeout(s.tapped), s.tapped = null, Math.abs(u - s.tapX) > 50 || Math.abs(c - s.tapY) > 50) return this;
                        h("dblclick" + i)
                    } else s.tapX = u, s.tapY = c, d.opts["dblclick" + i] && d.opts["dblclick" + i] !== d.opts["click" + i] ? s.tapped = setTimeout(function() {
                        s.tapped = null, r.isAnimating || h("click" + i)
                    }, 500) : h("click" + i);
                    return this
                }
            }, n(t).on("onActivate.fb", function(e, t) {
                t && !t.Guestures && (t.Guestures = new u(t))
            }).on("beforeClose.fb", function(e, t) {
                t && t.Guestures && t.Guestures.destroy()
            })
        }(window, document, e),
        function(e, t) {
            "use strict";
            t.extend(!0, t.fancybox.defaults, {
                btnTpl: {
                    slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'
                },
                slideShow: {
                    autoStart: !1,
                    speed: 3e3,
                    progress: !0
                }
            });
            var n = function(e) {
                this.instance = e, this.init()
            };
            t.extend(n.prototype, {
                timer: null,
                isActive: !1,
                $button: null,
                init: function() {
                    var e = this,
                        n = e.instance,
                        i = n.group[n.currIndex].opts.slideShow;
                    e.$button = n.$refs.toolbar.find("[data-fancybox-play]").on("click", function() {
                        e.toggle()
                    }), n.group.length < 2 || !i ? e.$button.hide() : i.progress && (e.$progress = t('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner))
                },
                set: function(e) {
                    var n = this.instance,
                        i = n.current;
                    i && (!0 === e || i.opts.loop || n.currIndex < n.group.length - 1) ? this.isActive && "video" !== i.contentType && (this.$progress && t.fancybox.animate(this.$progress.show(), {
                        scaleX: 1
                    }, i.opts.slideShow.speed), this.timer = setTimeout(function() {
                        n.current.opts.loop || n.current.index != n.group.length - 1 ? n.next() : n.jumpTo(0)
                    }, i.opts.slideShow.speed)) : (this.stop(), n.idleSecondsCounter = 0, n.showControls())
                },
                clear: function() {
                    clearTimeout(this.timer), this.timer = null, this.$progress && this.$progress.removeAttr("style").hide()
                },
                start: function() {
                    var e = this.instance.current;
                    e && (this.$button.attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause"), this.isActive = !0, e.isComplete && this.set(!0), this.instance.trigger("onSlideShowChange", !0))
                },
                stop: function() {
                    var e = this.instance.current;
                    this.clear(), this.$button.attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play"), this.isActive = !1, this.instance.trigger("onSlideShowChange", !1), this.$progress && this.$progress.removeAttr("style").hide()
                },
                toggle: function() {
                    this.isActive ? this.stop() : this.start()
                }
            }), t(e).on({
                "onInit.fb": function(e, t) {
                    t && !t.SlideShow && (t.SlideShow = new n(t))
                },
                "beforeShow.fb": function(e, t, n, i) {
                    var s = t && t.SlideShow;
                    i ? s && n.opts.slideShow.autoStart && s.start() : s && s.isActive && s.clear()
                },
                "afterShow.fb": function(e, t, n) {
                    var i = t && t.SlideShow;
                    i && i.isActive && i.set()
                },
                "afterKeydown.fb": function(n, i, s, a, o) {
                    var r = i && i.SlideShow;
                    !r || !s.opts.slideShow || 80 !== o && 32 !== o || t(e.activeElement).is("button,a,input") || (a.preventDefault(), r.toggle())
                },
                "beforeClose.fb onDeactivate.fb": function(e, t) {
                    var n = t && t.SlideShow;
                    n && n.stop()
                }
            }), t(e).on("visibilitychange", function() {
                var n = t.fancybox.getInstance(),
                    i = n && n.SlideShow;
                i && i.isActive && (e.hidden ? i.clear() : i.set())
            })
        }(document, e),
        function(e, t) {
            "use strict";
            var n = function() {
                for (var t = [
                        ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
                        ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
                        ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
                        ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
                        ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
                    ], n = {}, i = 0; i < t.length; i++) {
                    var s = t[i];
                    if (s && s[1] in e) {
                        for (var a = 0; a < s.length; a++) n[t[0][a]] = s[a];
                        return n
                    }
                }
                return !1
            }();
            if (n) {
                var i = {
                    request: function(t) {
                        (t = t || e.documentElement)[n.requestFullscreen](t.ALLOW_KEYBOARD_INPUT)
                    },
                    exit: function() {
                        e[n.exitFullscreen]()
                    },
                    toggle: function(t) {
                        t = t || e.documentElement, this.isFullscreen() ? this.exit() : this.request(t)
                    },
                    isFullscreen: function() {
                        return Boolean(e[n.fullscreenElement])
                    },
                    enabled: function() {
                        return Boolean(e[n.fullscreenEnabled])
                    }
                };
                t.extend(!0, t.fancybox.defaults, {
                    btnTpl: {
                        fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'
                    },
                    fullScreen: {
                        autoStart: !1
                    }
                }), t(e).on(n.fullscreenchange, function() {
                    var e = i.isFullscreen(),
                        n = t.fancybox.getInstance();
                    n && (n.current && "image" === n.current.type && n.isAnimating && (n.isAnimating = !1, n.update(!0, !0, 0), n.isComplete || n.complete()), n.trigger("onFullscreenChange", e), n.$refs.container.toggleClass("fancybox-is-fullscreen", e), n.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter", !e).toggleClass("fancybox-button--fsexit", e))
                })
            }
            t(e).on({
                "onInit.fb": function(e, t) {
                    n ? t && t.group[t.currIndex].opts.fullScreen ? (t.$refs.container.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function(e) {
                        e.stopPropagation(), e.preventDefault(), i.toggle()
                    }), t.opts.fullScreen && !0 === t.opts.fullScreen.autoStart && i.request(), t.FullScreen = i) : t && t.$refs.toolbar.find("[data-fancybox-fullscreen]").hide() : t.$refs.toolbar.find("[data-fancybox-fullscreen]").remove()
                },
                "afterKeydown.fb": function(e, t, n, i, s) {
                    t && t.FullScreen && 70 === s && (i.preventDefault(), t.FullScreen.toggle())
                },
                "beforeClose.fb": function(e, t) {
                    t && t.FullScreen && t.$refs.container.hasClass("fancybox-is-fullscreen") && i.exit()
                }
            })
        }(document, e),
        function(e, t) {
            "use strict";
            var n = "fancybox-thumbs";
            t.fancybox.defaults = t.extend(!0, {
                btnTpl: {
                    thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'
                },
                thumbs: {
                    autoStart: !1,
                    hideOnClose: !0,
                    parentEl: ".fancybox-container",
                    axis: "y"
                }
            }, t.fancybox.defaults);
            var i = function(e) {
                this.init(e)
            };
            t.extend(i.prototype, {
                $button: null,
                $grid: null,
                $list: null,
                isVisible: !1,
                isActive: !1,
                init: function(e) {
                    var t = this,
                        n = e.group,
                        i = 0;
                    t.instance = e, t.opts = n[e.currIndex].opts.thumbs, e.Thumbs = t, t.$button = e.$refs.toolbar.find("[data-fancybox-thumbs]");
                    for (var s = 0, a = n.length; s < a && (n[s].thumb && i++, !(i > 1)); s++);
                    i > 1 && t.opts ? (t.$button.removeAttr("style").on("click", function() {
                        t.toggle()
                    }), t.isActive = !0) : t.$button.hide()
                },
                create: function() {
                    var e, i = this.instance,
                        s = this.opts.parentEl,
                        a = [];
                    this.$grid || (this.$grid = t('<div class="' + n + " " + n + "-" + this.opts.axis + '"></div>').appendTo(i.$refs.container.find(s).addBack().filter(s)), this.$grid.on("click", "a", function() {
                        i.jumpTo(t(this).attr("data-index"))
                    })), this.$list || (this.$list = t('<div class="' + n + '__list">').appendTo(this.$grid)), t.each(i.group, function(t, n) {
                        (e = n.thumb) || "image" !== n.type || (e = n.src), a.push('<a href="javascript:;" tabindex="0" data-index="' + t + '"' + (e && e.length ? ' style="background-image:url(' + e + ')"' : 'class="fancybox-thumbs-missing"') + "></a>")
                    }), this.$list[0].innerHTML = a.join(""), "x" === this.opts.axis && this.$list.width(parseInt(this.$grid.css("padding-right"), 10) + i.group.length * this.$list.children().eq(0).outerWidth(!0))
                },
                focus: function(e) {
                    var t, n, i = this.$list,
                        s = this.$grid;
                    this.instance.current && (n = (t = i.children().removeClass("fancybox-thumbs-active").filter('[data-index="' + this.instance.current.index + '"]').addClass("fancybox-thumbs-active")).position(), "y" === this.opts.axis && (n.top < 0 || n.top > i.height() - t.outerHeight()) ? i.stop().animate({
                        scrollTop: i.scrollTop() + n.top
                    }, e) : "x" === this.opts.axis && (n.left < s.scrollLeft() || n.left > s.scrollLeft() + (s.width() - t.outerWidth())) && i.parent().stop().animate({
                        scrollLeft: n.left
                    }, e))
                },
                update: function() {
                    this.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible), this.isVisible ? (this.$grid || this.create(), this.instance.trigger("onThumbsShow"), this.focus(0)) : this.$grid && this.instance.trigger("onThumbsHide"), this.instance.update()
                },
                hide: function() {
                    this.isVisible = !1, this.update()
                },
                show: function() {
                    this.isVisible = !0, this.update()
                },
                toggle: function() {
                    this.isVisible = !this.isVisible, this.update()
                }
            }), t(e).on({
                "onInit.fb": function(e, t) {
                    var n;
                    t && !t.Thumbs && (n = new i(t)).isActive && !0 === n.opts.autoStart && n.show()
                },
                "beforeShow.fb": function(e, t, n, i) {
                    var s = t && t.Thumbs;
                    s && s.isVisible && s.focus(i ? 0 : 250)
                },
                "afterKeydown.fb": function(e, t, n, i, s) {
                    var a = t && t.Thumbs;
                    a && a.isActive && 71 === s && (i.preventDefault(), a.toggle())
                },
                "beforeClose.fb": function(e, t) {
                    var n = t && t.Thumbs;
                    n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide()
                }
            })
        }(document, e),
        function(e, t) {
            "use strict";
            t.extend(!0, t.fancybox.defaults, {
                btnTpl: {
                    share: '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'
                },
                share: {
                    url: function(e, t) {
                        return !e.currentHash && "inline" !== t.type && "html" !== t.type && (t.origSrc || t.src) || window.location
                    },
                    tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'
                }
            }), t(e).on("click", "[data-fancybox-share]", function() {
                var e, n, i = t.fancybox.getInstance(),
                    s = i.current || null;
                s && ("function" === t.type(s.opts.share.url) && (e = s.opts.share.url.apply(s, [i, s])), n = s.opts.share.tpl.replace(/\{\{media\}\}/g, "image" === s.type ? encodeURIComponent(s.src) : "").replace(/\{\{url\}\}/g, encodeURIComponent(e)).replace(/\{\{url_raw\}\}/g, function(e) {
                    var t = {
                        "&": "&amp;",
                        "<": "&lt;",
                        ">": "&gt;",
                        '"': "&quot;",
                        "'": "&#39;",
                        "/": "&#x2F;",
                        "`": "&#x60;",
                        "=": "&#x3D;"
                    };
                    return String(e).replace(/[&<>"'`=\/]/g, function(e) {
                        return t[e]
                    })
                }(e)).replace(/\{\{descr\}\}/g, i.$caption ? encodeURIComponent(i.$caption.text()) : ""), t.fancybox.open({
                    src: i.translate(i, n),
                    type: "html",
                    opts: {
                        touch: !1,
                        animationEffect: !1,
                        afterLoad: function(e, t) {
                            i.$refs.container.one("beforeClose.fb", function() {
                                e.close(null, 0)
                            }), t.$content.find(".fancybox-share__button").click(function() {
                                return window.open(this.href, "Share", "width=550, height=450"), !1
                            })
                        },
                        mobile: {
                            autoFocus: !1
                        }
                    }
                }))
            })
        }(document, e),
        function(e, t, n) {
            "use strict";

            function i() {
                var t = e.location.hash.substr(1),
                    n = t.split("-"),
                    i = n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) && parseInt(n.pop(-1), 10) || 1,
                    s = n.join("-");
                return {
                    hash: t,
                    index: i < 1 ? 1 : i,
                    gallery: s
                }
            }

            function s(e) {
                "" !== e.gallery && n("[data-fancybox='" + n.escapeSelector(e.gallery) + "']").eq(e.index - 1).focus().trigger("click.fb-start")
            }

            function a(e) {
                var t, n;
                return !!e && ("" !== (n = (t = e.current ? e.current.opts : e.opts).hash || (t.$orig ? t.$orig.data("fancybox") || t.$orig.data("fancybox-trigger") : "")) && n)
            }
            n.escapeSelector || (n.escapeSelector = function(e) {
                return (e + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function(e, t) {
                    return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
                })
            }), n(function() {
                !1 !== n.fancybox.defaults.hash && (n(t).on({
                    "onInit.fb": function(e, t) {
                        var n, s;
                        !1 !== t.group[t.currIndex].opts.hash && (n = i(), (s = a(t)) && n.gallery && s == n.gallery && (t.currIndex = n.index - 1))
                    },
                    "beforeShow.fb": function(n, i, s, o) {
                        var r;
                        s && !1 !== s.opts.hash && (r = a(i)) && (i.currentHash = r + (i.group.length > 1 ? "-" + (s.index + 1) : ""), e.location.hash !== "#" + i.currentHash && (o && !i.origHash && (i.origHash = e.location.hash), i.hashTimer && clearTimeout(i.hashTimer), i.hashTimer = setTimeout(function() {
                            "replaceState" in e.history ? (e.history[o ? "pushState" : "replaceState"]({}, t.title, e.location.pathname + e.location.search + "#" + i.currentHash), o && (i.hasCreatedHistory = !0)) : e.location.hash = i.currentHash, i.hashTimer = null
                        }, 300)))
                    },
                    "beforeClose.fb": function(n, i, s) {
                        s && !1 !== s.opts.hash && (clearTimeout(i.hashTimer), i.currentHash && i.hasCreatedHistory ? e.history.back() : i.currentHash && ("replaceState" in e.history ? e.history.replaceState({}, t.title, e.location.pathname + e.location.search + (i.origHash || "")) : e.location.hash = i.origHash), i.currentHash = null)
                    }
                }), n(e).on("hashchange.fb", function() {
                    var e = i(),
                        t = null;
                    n.each(n(".fancybox-container").get().reverse(), function(e, i) {
                        var s = n(i).data("FancyBox");
                        if (s && s.currentHash) return t = s, !1
                    }), t ? t.currentHash === e.gallery + "-" + e.index || 1 === e.index && t.currentHash == e.gallery || (t.currentHash = null, t.close()) : "" !== e.gallery && s(e)
                }), setTimeout(function() {
                    n.fancybox.getInstance() || s(i())
                }, 50))
            })
        }(window, document, e),
        function(e, t) {
            "use strict";
            var n = (new Date).getTime();
            t(e).on({
                "onInit.fb": function(e, t, i) {
                    t.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function(e) {
                        var i = t.current,
                            s = (new Date).getTime();
                        t.group.length < 2 || !1 === i.opts.wheel || "auto" === i.opts.wheel && "image" !== i.type || (e.preventDefault(), e.stopPropagation(), i.$slide.hasClass("fancybox-animated") || (e = e.originalEvent || e, s - n < 250 || (n = s, t[(-e.deltaY || -e.deltaX || e.wheelDelta || -e.detail) < 0 ? "next" : "previous"]())))
                    })
                }
            })
        }(document, e)
    }).call(this, n(1))
}, function(e, t, n) {
    (function(e) {
        ! function(e, t, n, i) {
            var s = e(t);
            e.fn.lazyload = function(i) {
                var a, o = this,
                    r = {
                        threshold: 0,
                        failure_limit: 0,
                        event: "scroll",
                        effect: "show",
                        container: t,
                        data_attribute: "original",
                        skip_invisible: !1,
                        appear: null,
                        load: null,
                        placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
                    };

                function d() {
                    var t = 0;
                    o.each(function() {
                        var n = e(this);
                        if (!r.skip_invisible || n.is(":visible"))
                            if (e.abovethetop(this, r) || e.leftofbegin(this, r));
                            else if (e.belowthefold(this, r) || e.rightoffold(this, r)) {
                            if (++t > r.failure_limit) return !1
                        } else n.trigger("appear"), t = 0
                    })
                }
                return i && (void 0 !== i.failurelimit && (i.failure_limit = i.failurelimit, delete i.failurelimit), void 0 !== i.effectspeed && (i.effect_speed = i.effectspeed, delete i.effectspeed), e.extend(r, i)), a = void 0 === r.container || r.container === t ? s : e(r.container), 0 === r.event.indexOf("scroll") && a.bind(r.event, function() {
                    return d()
                }), this.each(function() {
                    var t = this,
                        n = e(t);
                    t.loaded = !1, void 0 !== n.attr("src") && !1 !== n.attr("src") || n.is("img") && n.attr("src", r.placeholder), n.one("appear", function() {
                        if (!this.loaded) {
                            if (r.appear) {
                                var i = o.length;
                                r.appear.call(t, i, r)
                            }
                            e("<img />").bind("load", function() {
                                var i = n.attr("data-" + r.data_attribute);
                                n.hide(), n.is("img") ? n.attr("src", i) : n.css("background-image", "url('" + i + "')"), n[r.effect](r.effect_speed), t.loaded = !0;
                                var s = e.grep(o, function(e) {
                                    return !e.loaded
                                });
                                if (o = e(s), r.load) {
                                    var a = o.length;
                                    r.load.call(t, a, r)
                                }
                            }).attr("src", n.attr("data-" + r.data_attribute))
                        }
                    }), 0 !== r.event.indexOf("scroll") && n.bind(r.event, function() {
                        t.loaded || n.trigger("appear")
                    })
                }), s.bind("resize", function() {
                    d()
                }), /(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion) && s.bind("pageshow", function(t) {
                    t.originalEvent && t.originalEvent.persisted && o.each(function() {
                        e(this).trigger("appear")
                    })
                }), e(n).ready(function() {
                    d()
                }), this
            }, e.belowthefold = function(n, i) {
                return (void 0 === i.container || i.container === t ? (t.innerHeight ? t.innerHeight : s.height()) + s.scrollTop() : e(i.container).offset().top + e(i.container).height()) <= e(n).offset().top - i.threshold
            }, e.rightoffold = function(n, i) {
                return (void 0 === i.container || i.container === t ? s.width() + s.scrollLeft() : e(i.container).offset().left + e(i.container).width()) <= e(n).offset().left - i.threshold
            }, e.abovethetop = function(n, i) {
                return (void 0 === i.container || i.container === t ? s.scrollTop() : e(i.container).offset().top) >= e(n).offset().top + i.threshold + e(n).height()
            }, e.leftofbegin = function(n, i) {
                return (void 0 === i.container || i.container === t ? s.scrollLeft() : e(i.container).offset().left) >= e(n).offset().left + i.threshold + e(n).width()
            }, e.inviewport = function(t, n) {
                return !(e.rightoffold(t, n) || e.leftofbegin(t, n) || e.belowthefold(t, n) || e.abovethetop(t, n))
            }, e.extend(e.expr[":"], {
                "below-the-fold": function(t) {
                    return e.belowthefold(t, {
                        threshold: 0
                    })
                },
                "above-the-top": function(t) {
                    return !e.belowthefold(t, {
                        threshold: 0
                    })
                },
                "right-of-screen": function(t) {
                    return e.rightoffold(t, {
                        threshold: 0
                    })
                },
                "left-of-screen": function(t) {
                    return !e.rightoffold(t, {
                        threshold: 0
                    })
                },
                "in-viewport": function(t) {
                    return e.inviewport(t, {
                        threshold: 0
                    })
                },
                "above-the-fold": function(t) {
                    return !e.belowthefold(t, {
                        threshold: 0
                    })
                },
                "right-of-fold": function(t) {
                    return e.rightoffold(t, {
                        threshold: 0
                    })
                },
                "left-of-fold": function(t) {
                    return !e.rightoffold(t, {
                        threshold: 0
                    })
                }
            })
        }(e, window, document)
    }).call(this, n(1))
}, function(e, t, n) {
    "use strict";
    var i = "bfred-it:object-fit-images",
        s = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g,
        a = "undefined" == typeof Image ? {
            style: {
                "object-position": 1
            }
        } : new Image,
        o = "object-fit" in a.style,
        r = "object-position" in a.style,
        d = "background-size" in a.style,
        l = "string" == typeof a.currentSrc,
        u = a.getAttribute,
        c = a.setAttribute,
        h = !1;

    function m(e, t, n) {
        var i = function(e, t) {
            return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + e + "' height='" + t + "'%3E%3C/svg%3E"
        }(t || 1, n || 0);
        u.call(e, "src") !== i && c.call(e, "src", i)
    }

    function f(e, t) {
        e.naturalWidth ? t(e) : setTimeout(f, 100, e, t)
    }

    function _(e) {
        var t = function(e) {
                for (var t, n = getComputedStyle(e).fontFamily, i = {}; null !== (t = s.exec(n));) i[t[1]] = t[2];
                return i
            }(e),
            n = e[i];
        if (t["object-fit"] = t["object-fit"] || "fill", !n.img) {
            if ("fill" === t["object-fit"]) return;
            if (!n.skipTest && o && !t["object-position"]) return
        }
        if (!n.img) {
            n.img = new Image(e.width, e.height), n.img.srcset = u.call(e, "data-ofi-srcset") || e.srcset, n.img.src = u.call(e, "data-ofi-src") || e.src, c.call(e, "data-ofi-src", e.src), e.srcset && c.call(e, "data-ofi-srcset", e.srcset), m(e, e.naturalWidth || e.width, e.naturalHeight || e.height), e.srcset && (e.srcset = "");
            try {
                ! function(e) {
                    var t = {
                        get: function(t) {
                            return e[i].img[t || "src"]
                        },
                        set: function(t, n) {
                            return e[i].img[n || "src"] = t, c.call(e, "data-ofi-" + n, t), _(e), t
                        }
                    };
                    Object.defineProperty(e, "src", t), Object.defineProperty(e, "currentSrc", {
                        get: function() {
                            return t.get("currentSrc")
                        }
                    }), Object.defineProperty(e, "srcset", {
                        get: function() {
                            return t.get("srcset")
                        },
                        set: function(e) {
                            return t.set(e, "srcset")
                        }
                    })
                }(e)
            } catch (e) {
                window.console && console.warn("https://bit.ly/ofi-old-browser")
            }
        }! function(e) {
            if (e.srcset && !l && window.picturefill) {
                var t = window.picturefill._;
                e[t.ns] && e[t.ns].evaled || t.fillImg(e, {
                    reselect: !0
                }), e[t.ns].curSrc || (e[t.ns].supported = !1, t.fillImg(e, {
                    reselect: !0
                })), e.currentSrc = e[t.ns].curSrc || e.src
            }
        }(n.img), e.style.backgroundImage = 'url("' + (n.img.currentSrc || n.img.src).replace(/"/g, '\\"') + '")', e.style.backgroundPosition = t["object-position"] || "center", e.style.backgroundRepeat = "no-repeat", e.style.backgroundOrigin = "content-box", /scale-down/.test(t["object-fit"]) ? f(n.img, function() {
            n.img.naturalWidth > e.width || n.img.naturalHeight > e.height ? e.style.backgroundSize = "contain" : e.style.backgroundSize = "auto"
        }) : e.style.backgroundSize = t["object-fit"].replace("none", "auto").replace("fill", "100% 100%"), f(n.img, function(t) {
            m(e, t.naturalWidth, t.naturalHeight)
        })
    }

    function p(e, t) {
        var n = !h && !e;
        if (t = t || {}, e = e || "img", r && !t.skipTest || !d) return !1;
        "img" === e ? e = document.getElementsByTagName("img") : "string" == typeof e ? e = document.querySelectorAll(e) : "length" in e || (e = [e]);
        for (var s = 0; s < e.length; s++) e[s][i] = e[s][i] || {
            skipTest: t.skipTest
        }, _(e[s]);
        n && (document.body.addEventListener("load", function(e) {
            "IMG" === e.target.tagName && p(e.target, {
                skipTest: t.skipTest
            })
        }, !0), h = !0, e = "img"), t.watchMQ && window.addEventListener("resize", p.bind(null, e, {
            skipTest: t.skipTest
        }))
    }
    p.supportsObjectFit = o, p.supportsObjectPosition = r,
        function() {
            function e(e, t) {
                return e[i] && e[i].img && ("src" === t || "srcset" === t) ? e[i].img : e
            }
            r || (HTMLImageElement.prototype.getAttribute = function(t) {
                return u.call(e(this, t), t)
            }, HTMLImageElement.prototype.setAttribute = function(t, n) {
                return c.call(e(this, t), t, String(n))
            })
        }(), e.exports = p
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }(n(1));
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".mobile-menu-icon-container");
        t.on("click", function(e) {
            e.stopPropagation(), (0, i.default)(this).toggleClass("is-active"), (0, i.default)(this).hasClass("is-active") ? (window.emitter.emit("siteSearch", "hide"), window.emitter.emit("mobileMenu", "show")) : window.emitter.emit("mobileMenu", "hide")
        }), window.emitter.on("mobileMenu", function(e) {
            "show" == e ? window.emitter.emit("showMobileMenu", "show") : (t.removeClass("is-active"), window.emitter.emit("showMobileMenu", "hide"))
        })
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }(n(1));
    n(6);
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".js-search-menu");
        t.on("click", function(e) {
            e.stopPropagation(), (0, i.default)(this).toggleClass("is-active"), (0, i.default)(this).hasClass("is-active") ? (window.emitter.emit("mobileMenu", "hide"), window.emitter.emit("siteSearch", "show")) : window.emitter.emit("siteSearch", "hide")
        }), (0, i.default)(".js-search-menu, .search-bar").on("clickout", function() {
            window.emitter.emit("siteSearch", "hide")
        }), window.emitter.on("siteSearch", function(e) {
            "show" == e ? window.emitter.emit("showsiteSearch", "show") : (t.removeClass("is-active"), window.emitter.emit("showsiteSearch", "hide"))
        })
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = o(n(1)),
        s = o(n(2)),
        a = n(3);

    function o(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    n(155);
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".menu-wrapper"),
            n = (0, i.default)(".mobile-menu-icon-container"),
            o = ((0, i.default)(".mobile-menu-icon"), (0, i.default)(".js-search-menu")),
            r = (0, i.default)(".search-bar");
        (0, i.default)(".menu-notification");
        n.on("click", function(e) {
            e.stopPropagation(), o.hasClass("is-active") && (o.removeClass("is-active"), r.removeClass("search-open"))
        }), s.default.register("screen and (min-width:" + a.bp.minDesktop + "px)", {
            match: function() {
                n.removeClass("is-active"), t.css("display", "")
            }
        }), s.default.register("screen and (min-width:" + a.bp.minDesktop + "px)", {
            match: function() {
                (0, i.default)(".header__masthead").sticky({
                    topSpacing: 0,
                    className: "is_stuck"
                }), (0, i.default)(".notification-section").sticky({
                    topSpacing: 55,
                    className: "notification-stick",
                    zIndex: 7
                }), (0, i.default)(".search-bar").sticky({
                    topSpacing: 59,
                    className: "search-stick"
                });
                var e = (0, i.default)(".notification-section").hasClass("active"),
                    t = !(0, i.default)("#speciesSearh").hasClass("species-search--full");
                (0, i.default)("#speciesSearh").sticky({
                    topSpacing: e && t ? (0, i.default)(".notification").outerHeight() + 55 - 2 : 53,
                    className: "search-sticky",
                    zIndex: 5
                }), window.emitter.on("notification-closed", function() {
                    var e = (0, i.default)(".notification-section").hasClass("active"),
                        t = !(0, i.default)("#speciesSearh").hasClass("species-search--full");
                    !e && t && ((0, i.default)("#speciesSearh").unstick(), (0, i.default)("#speciesSearh").sticky({
                        topSpacing: 53,
                        className: "search-sticky",
                        zIndex: 5
                    }), (0, i.default)("html,body").animate({
                        scrollTop: (0, i.default)(document).scrollTop() + 1
                    }, 10))
                })
            },
            unmatch: function() {
                (0, i.default)(".header__masthead").unstick(), (0, i.default)(".search-bar").unstick(), (0, i.default)("#speciesSearh").unstick()
            }
        });
		var d = void 0, l = document.querySelector(".species-title__container"),
      u = document.querySelector(".species-info__title2");
      if (l != null && u != null) {
        window.addEventListener("scroll", function () {
          d || (d = !0, setTimeout(function () {
            document.body.scrollTop > 50 || document.documentElement.scrollTop > 50 ? (l.style.display = "block", u.style.display = "block") : (l.style.display = "none", u.style.display = "none"), d = !1
          }, 250))
        });
      }
    }
}, function(e, t, n) {
    var i = n(153),
        s = n(7),
        a = s.each,
        o = s.isFunction,
        r = s.isArray;

    function d() {
        if (!window.matchMedia) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        this.queries = {}, this.browserIsIncapable = !window.matchMedia("only all").matches
    }
    d.prototype = {
        constructor: d,
        register: function(e, t, n) {
            var s = this.queries,
                d = n && this.browserIsIncapable;
            return s[e] || (s[e] = new i(e, d)), o(t) && (t = {
                match: t
            }), r(t) || (t = [t]), a(t, function(t) {
                o(t) && (t = {
                    match: t
                }), s[e].addHandler(t)
            }), this
        },
        unregister: function(e, t) {
            var n = this.queries[e];
            return n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])), this
        }
    }, e.exports = d
}, function(e, t, n) {
    var i = n(154),
        s = n(7).each;

    function a(e, t) {
        this.query = e, this.isUnconditional = t, this.handlers = [], this.mql = window.matchMedia(e);
        var n = this;
        this.listener = function(e) {
            n.mql = e.currentTarget || e, n.assess()
        }, this.mql.addListener(this.listener)
    }
    a.prototype = {
        constuctor: a,
        addHandler: function(e) {
            var t = new i(e);
            this.handlers.push(t), this.matches() && t.on()
        },
        removeHandler: function(e) {
            var t = this.handlers;
            s(t, function(n, i) {
                if (n.equals(e)) return n.destroy(), !t.splice(i, 1)
            })
        },
        matches: function() {
            return this.mql.matches || this.isUnconditional
        },
        clear: function() {
            s(this.handlers, function(e) {
                e.destroy()
            }), this.mql.removeListener(this.listener), this.handlers.length = 0
        },
        assess: function() {
            var e = this.matches() ? "on" : "off";
            s(this.handlers, function(t) {
                t[e]()
            })
        }
    }, e.exports = a
}, function(e, t) {
    function n(e) {
        this.options = e, !e.deferSetup && this.setup()
    }
    n.prototype = {
        constructor: n,
        setup: function() {
            this.options.setup && this.options.setup(), this.initialised = !0
        },
        on: function() {
            !this.initialised && this.setup(), this.options.match && this.options.match()
        },
        off: function() {
            this.options.unmatch && this.options.unmatch()
        },
        destroy: function() {
            this.options.destroy ? this.options.destroy() : this.off()
        },
        equals: function(e) {
            return this.options === e || this.options.match === e
        }
    }, e.exports = n
}, function(e, t, n) {
    "use strict";
    var i, s, a, o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    };
    s = [n(1)], void 0 === (a = "function" == typeof(i = function(e) {
        var t = Array.prototype.slice,
            n = Array.prototype.splice,
            i = {
                topSpacing: 0,
                bottomSpacing: 0,
                className: "is-sticky",
                wrapperClassName: "sticky-wrapper",
                center: !1,
                getWidthFrom: "",
                widthFromWrapper: !0,
                responsiveWidth: !1,
                zIndex: "inherit"
            },
            s = e(window),
            a = e(document),
            r = [],
            d = s.height(),
            l = function() {
                for (var t = s.scrollTop(), n = a.height(), i = n - d, o = t > i ? i - t : 0, l = 0, u = r.length; l < u; l++) {
                    var c = r[l],
                        h = c.stickyWrapper.offset().top,
                        m = h - c.topSpacing - o;
                    if (c.stickyWrapper.css("height", c.stickyElement.outerHeight()), t <= m) null !== c.currentTop && (c.stickyElement.css({
                        width: "",
                        position: "",
                        top: "",
                        "z-index": ""
                    }), c.stickyElement.parent().removeClass(c.className), c.stickyElement.trigger("sticky-end", [c]), c.currentTop = null);
                    else {
                        var f, _ = n - c.stickyElement.outerHeight() - c.topSpacing - c.bottomSpacing - t - o;
                        _ < 0 ? _ += c.topSpacing : _ = c.topSpacing, c.currentTop !== _ && (c.getWidthFrom ? (padding = c.stickyElement.innerWidth() - c.stickyElement.width(), f = e(c.getWidthFrom).width() - padding || null) : c.widthFromWrapper && (f = c.stickyWrapper.width()), null == f && (f = c.stickyElement.width()), c.stickyElement.css("width", f).css("position", "fixed").css("top", _).css("z-index", c.zIndex), c.stickyElement.parent().addClass(c.className), null === c.currentTop ? c.stickyElement.trigger("sticky-start", [c]) : c.stickyElement.trigger("sticky-update", [c]), c.currentTop === c.topSpacing && c.currentTop > _ || null === c.currentTop && _ < c.topSpacing ? c.stickyElement.trigger("sticky-bottom-reached", [c]) : null !== c.currentTop && _ === c.topSpacing && c.currentTop < _ && c.stickyElement.trigger("sticky-bottom-unreached", [c]), c.currentTop = _);
                        var p = c.stickyWrapper.parent(),
                            g = c.stickyElement.offset().top + c.stickyElement.outerHeight() >= p.offset().top + p.outerHeight() && c.stickyElement.offset().top <= c.topSpacing;
                        g ? c.stickyElement.css("position", "absolute").css("top", "").css("bottom", 0).css("z-index", "") : c.stickyElement.css("position", "fixed").css("top", _).css("bottom", "").css("z-index", c.zIndex)
                    }
                }
            },
            u = function() {
                d = s.height();
                for (var t = 0, n = r.length; t < n; t++) {
                    var i = r[t],
                        a = null;
                    i.getWidthFrom ? i.responsiveWidth && (a = e(i.getWidthFrom).width()) : i.widthFromWrapper && (a = i.stickyWrapper.width()), null != a && i.stickyElement.css("width", a)
                }
            },
            c = {
                init: function(t) {
                    return this.each(function() {
                        var n = e.extend({}, i, t),
                            s = e(this),
                            a = s.attr("id"),
                            o = a ? a + "-" + i.wrapperClassName : i.wrapperClassName,
                            d = e("<div></div>").attr("id", o).addClass(n.wrapperClassName);
                        s.wrapAll(function() {
                            if (0 == e(this).parent("#" + o).length) return d
                        });
                        var l = s.parent();
                        n.center && l.css({
                            width: s.outerWidth(),
                            marginLeft: "auto",
                            marginRight: "auto"
                        }), "right" === s.css("float") && s.css({
                            float: "none"
                        }).parent().css({
                            float: "right"
                        }), n.stickyElement = s, n.stickyWrapper = l, n.currentTop = null, r.push(n), c.setWrapperHeight(this), c.setupChangeListeners(this)
                    })
                },
                setWrapperHeight: function(t) {
                    var n = e(t),
                        i = n.parent();
                    i && i.css("height", n.outerHeight())
                },
                setupChangeListeners: function(e) {
                    if (window.MutationObserver) {
                        var t = new window.MutationObserver(function(t) {
                            (t[0].addedNodes.length || t[0].removedNodes.length) && c.setWrapperHeight(e)
                        });
                        t.observe(e, {
                            subtree: !0,
                            childList: !0
                        })
                    } else window.addEventListener ? (e.addEventListener("DOMNodeInserted", function() {
                        c.setWrapperHeight(e)
                    }, !1), e.addEventListener("DOMNodeRemoved", function() {
                        c.setWrapperHeight(e)
                    }, !1)) : window.attachEvent && (e.attachEvent("onDOMNodeInserted", function() {
                        c.setWrapperHeight(e)
                    }), e.attachEvent("onDOMNodeRemoved", function() {
                        c.setWrapperHeight(e)
                    }))
                },
                update: l,
                unstick: function(t) {
                    return this.each(function() {
                        for (var t = e(this), i = -1, s = r.length; s-- > 0;) r[s].stickyElement.get(0) === this && (n.call(r, s, 1), i = s); - 1 !== i && (t.unwrap(), t.css({
                            width: "",
                            position: "",
                            top: "",
                            float: "",
                            "z-index": ""
                        }))
                    })
                }
            };
        window.addEventListener ? (window.addEventListener("scroll", l, !1), window.addEventListener("resize", u, !1)) : window.attachEvent && (window.attachEvent("onscroll", l), window.attachEvent("onresize", u)), e.fn.sticky = function(n) {
            return c[n] ? c[n].apply(this, t.call(arguments, 1)) : "object" !== (void 0 === n ? "undefined" : o(n)) && n ? void e.error("Method " + n + " does not exist on jQuery.sticky") : c.init.apply(this, arguments)
        }, e.fn.unstick = function(n) {
            return c[n] ? c[n].apply(this, t.call(arguments, 1)) : "object" !== (void 0 === n ? "undefined" : o(n)) && n ? void e.error("Method " + n + " does not exist on jQuery.sticky") : c.unstick.apply(this, arguments)
        }, e(function() {
            setTimeout(l, 0)
        })
    }) ? i.apply(t, s) : i) || (e.exports = a)
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = r(n(1)),
        s = r(n(2)),
        a = n(3);
    n(4);
    var o = r(n(5));

    function r(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        if (function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this, e), (0, i.default)(".notification").length) {
            var t = (0, i.default)(".js-notify-btn"),
                n = (0, i.default)(".notification-section"),
                r = (0, i.default)(".notification", n),
                d = (0, i.default)(".notification__carousel", r),
                l = (0, i.default)(".back-to-top");
            d.slick({
                infinite: !1,
                speed: 1e3,
                autoplaySpeed: 5e3,
                autoplay: !0,
                fade: !0,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: !0,
                dotsClass: "custom_paging",
                customPaging: function(e, t) {
                    return t + 1 + "/" + e.slideCount
                },
                nextArrow: '<button class="notification-next notification-arrow"><i class="icon icon-chevron-small-right"></i><span class="visuallyhidden">Button to view the next items of the slideshow</span></button>',
                prevArrow: '<button class="notification-prev notification-arrow"><i class="icon icon-chevron-small-left"></i><span class="visuallyhidden">Button to view the previous items of the slideshow</span></button>',
                appendArrows: (0, i.default)(".notification__ctrl--arrows"),
                appendDots: (0, i.default)(".notification__ctrl--dots")
            }), s.default.register("screen and (max-width:" + a.bp.minDesktop + "px)", {
                match: function() {
                    var e = new o.default.Controller;
                    new o.default.Scene({
                        triggerElement: "#mainContent",
                        duration: "70%"
                    }).setClassToggle(".notification-btn", "no-back-btn").addTo(e), t.on("click.mblNotification", function(e) {
                        e.preventDefault();
                        var t = (0, i.default)(this);
                        r.toggleClass("mbl-hidden"), t.toggleClass("active"), l.toggleClass("notify-open")
                    })
                },
                unmatch: function() {
                    t.off("click.mblNotification")
                }
            }), s.default.register("screen and (min-width:" + a.bp.minDesktop + "px)", {
                match: function() {
                    t.on("click.dskNotification", function(e) {
                        e.preventDefault(), (0, i.default)(".notification-section").removeClass("active"), t.removeClass("active"), window.emitter.emit("notification-closed")
                    })
                },
                unmatch: function() {
                    t.off("click.dskNotification"), r.css("display", "")
                }
            })
        }
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = r(n(1)),
        s = r(n(2)),
        a = n(3),
        o = r(n(5));

    function r(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".back-to-top");
        window.emitter.on("backToTop", function(e) {
            (0, i.default)("html, body").animate({
                scrollTop: 0
            }, "slow")
        }), t.on("click", function(e) {
            e.preventDefault(), window.emitter.emit("backToTop")
        }), s.default.register("screen and (max-width:" + a.bp.minDesktop + "px)", {
            match: function() {
                var e = new o.default.Controller;
                new o.default.Scene({
                    triggerElement: "#mainContent",
                    duration: "70%"
                }).setClassToggle(".back-to-top", "is-hidden").addTo(e), new o.default.Scene({
                    triggerElement: ".footer",
                    triggerHook: 1,
                    offset: 45
                }).setClassToggle(".back-to-top", "no-fixed").addTo(e)
            }
        })
    }
}, function(e, t, n) {
    var i, s, a;
    ! function(o) {
        "use strict";
        s = [n(1)], void 0 === (a = "function" == typeof(i = function(e) {
            var t = -1,
                n = -1,
                i = function(e) {
                    return parseFloat(e) || 0
                },
                s = function(t) {
                    var n = e(t),
                        s = null,
                        a = [];
                    return n.each(function() {
                        var t = e(this),
                            n = t.offset().top - i(t.css("margin-top")),
                            o = a.length > 0 ? a[a.length - 1] : null;
                        null === o ? a.push(t) : Math.floor(Math.abs(s - n)) <= 1 ? a[a.length - 1] = o.add(t) : a.push(t), s = n
                    }), a
                },
                a = function(t) {
                    var n = {
                        byRow: !0,
                        property: "height",
                        target: null,
                        remove: !1
                    };
                    return "object" == typeof t ? e.extend(n, t) : ("boolean" == typeof t ? n.byRow = t : "remove" === t && (n.remove = !0), n)
                },
                o = e.fn.matchHeight = function(t) {
                    var n = a(t);
                    if (n.remove) {
                        var i = this;
                        return this.css(n.property, ""), e.each(o._groups, function(e, t) {
                            t.elements = t.elements.not(i)
                        }), this
                    }
                    return this.length <= 1 && !n.target ? this : (o._groups.push({
                        elements: this,
                        options: n
                    }), o._apply(this, n), this)
                };
            o.version = "0.7.2", o._groups = [], o._throttle = 80, o._maintainScroll = !1, o._beforeUpdate = null, o._afterUpdate = null, o._rows = s, o._parse = i, o._parseOptions = a, o._apply = function(t, n) {
                var r = a(n),
                    d = e(t),
                    l = [d],
                    u = e(window).scrollTop(),
                    c = e("html").outerHeight(!0),
                    h = d.parents().filter(":hidden");
                return h.each(function() {
                    var t = e(this);
                    t.data("style-cache", t.attr("style"))
                }), h.css("display", "block"), r.byRow && !r.target && (d.each(function() {
                    var t = e(this),
                        n = t.css("display");
                    "inline-block" !== n && "flex" !== n && "inline-flex" !== n && (n = "block"), t.data("style-cache", t.attr("style")), t.css({
                        display: n,
                        "padding-top": "0",
                        "padding-bottom": "0",
                        "margin-top": "0",
                        "margin-bottom": "0",
                        "border-top-width": "0",
                        "border-bottom-width": "0",
                        height: "100px",
                        overflow: "hidden"
                    })
                }), l = s(d), d.each(function() {
                    var t = e(this);
                    t.attr("style", t.data("style-cache") || "")
                })), e.each(l, function(t, n) {
                    var s = e(n),
                        a = 0;
                    if (r.target) a = r.target.outerHeight(!1);
                    else {
                        if (r.byRow && s.length <= 1) return void s.css(r.property, "");
                        s.each(function() {
                            var t = e(this),
                                n = t.attr("style"),
                                i = t.css("display");
                            "inline-block" !== i && "flex" !== i && "inline-flex" !== i && (i = "block");
                            var s = {
                                display: i
                            };
                            s[r.property] = "", t.css(s), t.outerHeight(!1) > a && (a = t.outerHeight(!1)), n ? t.attr("style", n) : t.css("display", "")
                        })
                    }
                    s.each(function() {
                        var t = e(this),
                            n = 0;
                        r.target && t.is(r.target) || ("border-box" !== t.css("box-sizing") && (n += i(t.css("border-top-width")) + i(t.css("border-bottom-width")), n += i(t.css("padding-top")) + i(t.css("padding-bottom"))), t.css(r.property, a - n + "px"))
                    })
                }), h.each(function() {
                    var t = e(this);
                    t.attr("style", t.data("style-cache") || null)
                }), o._maintainScroll && e(window).scrollTop(u / c * e("html").outerHeight(!0)), this
            }, o._applyDataApi = function() {
                var t = {};
                e("[data-match-height], [data-mh]").each(function() {
                    var n = e(this),
                        i = n.attr("data-mh") || n.attr("data-match-height");
                    t[i] = i in t ? t[i].add(n) : n
                }), e.each(t, function() {
                    this.matchHeight(!0)
                })
            };
            var r = function(t) {
                o._beforeUpdate && o._beforeUpdate(t, o._groups), e.each(o._groups, function() {
                    o._apply(this.elements, this.options)
                }), o._afterUpdate && o._afterUpdate(t, o._groups)
            };
            o._update = function(i, s) {
                if (s && "resize" === s.type) {
                    var a = e(window).width();
                    if (a === t) return;
                    t = a
                }
                i ? -1 === n && (n = setTimeout(function() {
                    r(s), n = -1
                }, o._throttle)) : r(s)
            }, e(o._applyDataApi);
            var d = e.fn.on ? "on" : "bind";
            e(window)[d]("load", function(e) {
                o._update(!1, e)
            }), e(window)[d]("resize orientationchange", function(e) {
                o._update(!0, e)
            })
        }) ? i.apply(t, s) : i) || (e.exports = a)
    }()
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }(n(1));
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (0, i.default)(".rte table").each(function() {
            var e = (0, i.default)(this);
            e.parents(".table").length || e.wrap('<div class="table"></div>')
        }), (0, i.default)(".rte").find(".btn_collapse.active").prev().addClass("show")
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = a(n(1));
    n(6);
    var s = a(n(2));

    function a(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".search-bar"),
            n = (0, i.default)(".main-menu__search"),
            a = (0, i.default)("#searchBar");
        s.default.register("screen and (max-width: 1024px)", {
            match: function() {
                a.appendTo(n)
            },
            unmatch: function() {
                a.appendTo((0, i.default)(".header"))
            }
        }), window.emitter.on("showsiteSearch", function(e) {
            "show" == e ? t.addClass("visible") : t.removeClass("visible")
        })
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = a(n(1)),
        s = a(n(2));
    a(n(4));

    function a(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".whatsnew");
        s.default.register("screen and (max-width: 1024px)", {
            match: function() {
                t.appendTo((0, i.default)(".results"))
            },
            unmatch: function() {
                t.appendTo((0, i.default)(".sidebar"))
            }
        }), (0, i.default)(".whats-new__slider").length && (window.emitter.on("initSlick", function () {
            (0, i.default)(".whats-new__slider").on('init reInit afterChange beforeChange', function (event, slick, currentSlide, nextSlide) {
                            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                            let slides = slick.slickGetOption('slidesToShow');
                            let slideNumber = (currentSlide ? currentSlide : 0) + slides;
                            document.querySelector(".whats-new__nav .pagingInfo").innerText=slideNumber/slides + '/' + Math.ceil(slick.slideCount/slides);  
                            let height = document.querySelector(".slick-slide.slick-active .caption").style.height;
                            let slick_clone=document.querySelectorAll(".slick-slide.slick-cloned .caption");
                            for (let index = 0; index < slick_clone.length; index++) {
                                slick_clone[index].style.height = height;  
                            }
                          });
            (0, i.default)(".whats-new__slider").slick({
                dots: !1,
                infinite: !0,
                speed: 300,
				        lazyLoad: "ondemand",
                slidesToShow: 5,
                slidesToScroll: 5,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }],
                nextArrow: (0, i.default)(".carousel-next"),
                prevArrow: (0, i.default)(".carousel-prev"),
            })
        }), window.emitter.emit("initSlick"))
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = s(n(1));
    s(n(4));

    function s(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        if (function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this, e), (0, i.default)(".did-you-know__slider").length) {
            var t = (0, i.default)(".did-you-know__slider"),
                n = Math.round(t.parent("div").width() / 500);
            t.children("div").length < n && (n = t.children("div").length);
            var s = function() {
                var e = (0, i.default)(".did-you-know__slider .slick-slide.slick-current.slick-active"),
                    t = e.find(".name").html(),
                    n = e.find(".rte").html(),
                    s = e.find(".link").attr("href");
                (0, i.default)(".did-you-know__desc").html(n), (0, i.default)(".did-you-know__name").html(t), (0, i.default)(".did-you-know__link").attr("href", s)
            };
            t.on("init", function(e) {
                s(), setTimeout(function() {
                    (0, i.default)(".slick-slide").attr("aria-hidden", !1)
                }, 100)
            }), t.slick({
                accessibility: !1,
                infinite: !0,
                speed: 300,
				lazyLoad: "progressive",
                slidesToShow: n,
                slidesToScroll: 1,
                dots: !0,
                focusOnSelect: !0,
                dotsClass: "custom-paging",
                customPaging: function(e, t) {
                    return t + 1 + "/" + e.slideCount
                },
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }],
                nextArrow: '<button class="carousel-next" type="button" aria-label="Next slide in carousel"><i class="icon icon-arrow-right"></i><span class="visuallyhidden">Button to view the next items of the carousel</span></button>',
                prevArrow: '<button class="carousel-prev" type="button" aria-label="Previous slide in carousel"><i class="icon icon-arrow-left"></i><span class="visuallyhidden">Button to view the previous items of the carousel</span></button>'
            }), t.on("afterChange", function(e, t) {
                s(), setTimeout(function() {
                    (0, i.default)(".slick-slide").attr("aria-hidden", !1)
                }, 100)
            }), (0, i.default)(window).on("resize orientationchange", function() {
                t.slick("resize")
            })
        }
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }(n(1));
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".js-resizer");
        t.on("click", function(e) {
            e.preventDefault();
            var n = (0, i.default)(this).data("size");
            t.removeClass("is-active"), (0, i.default)(this).addClass("is-active"), "normal" == n ? (0, i.default)("#mainContent").removeClass("font-large").removeClass("font-larger").addClass("font-normal") : "big" == n ? (0, i.default)("#mainContent").removeClass("font-larger").removeClass("font-normal").addClass("font-large") : "bigger" == n && (0, i.default)("#mainContent").removeClass("font-normal").removeClass("font-large").addClass("font-larger"), i.default.fn.matchHeight._update()
        })
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    ! function(e) {
        e && e.__esModule
    }(n(1));
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e)
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = o(n(1)),
        s = o(n(2)),
        a = n(3);

    function o(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".main-menu");
        window.emitter.on("showMobileMenu", function(e) {
            "show" == e ? t.addClass("visible") : t.removeClass("visible")
        });
        var n = t.find("li").has("ul");
        s.default.register("screen and (max-width:" + a.bp.minDesktop + "px)", {
            match: function() {
                n.on("click.mobileNav", ".plus-minus-toggle", function(e) {
                    e.preventDefault(), e.stopPropagation();
                    var t = (0, i.default)(this).closest("li");
                    t.toggleClass("open"), (0, i.default)(this).toggleClass("active"), t.find("> ul").toggleClass("show")
                })
            },
            unmatch: function() {
                n.off("click.mobileNav")
            }
        }), (0, i.default)(".main-menu__lvl1-item-link").focusin(function() {
            (0, i.default)(".main-menu__lvl2").removeClass("is-visible");
            var e = (0, i.default)(this).siblings(".main-menu__lvl2");
            e.length && e.addClass("is-visible")
        }), (0, i.default)(".main-menu__lvl2-item-link").focusin(function() {
            var e = (0, i.default)(this).siblings(".main-menu__lvl3");
            e.length && e.addClass("is-visible")
        })
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = s(n(1));
    s(n(4));

    function s(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (0, i.default)(".species-gallery").length > 0 && ((0, i.default)(".slideshow").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !1,
            fade: !0,
            asNavFor: ".slider-nav"
        }), (0, i.default)(".slider-nav").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: ".slideshow",
			lazyLoad: "ondemand",
            arrows: !0,
            focusOnSelect: !0,
            nextArrow: '<button class="carousel-next" type="button"><i class="icon icon-arrow-right"></i><span class="visuallyhidden">Button to view the next items of the carousel</span></button>',
            prevArrow: '<button class="carousel-prev" type="button"><i class="icon icon-arrow-left"></i><span class="visuallyhidden">Button to view the previous items of the carousel</span></button>'
        }))
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }(n(1));
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".dynamicFilter"),
            n = (0, i.default)(".dynamicFilter__modal", t),
            s = (0, i.default)(".dynamicFilter__content", t),
            a = (0, i.default)(".dynamicFilter__closeBtn", t),
            o = (0, i.default)(".dynamicFilter__allTags li", t),
            r = (0, i.default)(".dynamicFilter__allTags", t),
            d = t.data("url"),
            l = [];

        function u(e, t) {
            "flora" == e ? "replace" == t ? s.html((0, i.default)("#dynamicFilterFlora").html()) : s.append((0, i.default)("#dynamicFilterFlora").html()) : "replace" == t ? s.html((0, i.default)("#dynamicFilterFauna").html()) : s.append((0, i.default)("#dynamicFilterFauna").html())
        }
        n.on("change", ".dynamicFilter__select", function() {
            var e = (0, i.default)(this).closest(".dynamicFilter__row");
            (0, i.default)(this).closest("div").nextAll("div").remove(), i.default.ajax({
                url: d,
                dataType: "json",
                data: {
                    id: (0, i.default)(this).val()
                },
                ifModified: !0
            }).done(function(t) {
                void 0 != t && function(e, t) {
                    if ("select" == e.fieldType) {
                        var n = e.options,
                            i = '<div><span class="label">' + e.fieldLabel + '</span><select name="' + e.fieldName + '" class="dynamicFilter__select ' + e.fieldName.toLowerCase() + '">';
                        n.forEach(function(e) {
                            i += '<option value="' + e.Value + '">' + e.Key + "</option>"
                        }), i += "</select></div>", t.append(i)
                    }
                    if ("text" == e.fieldType) {
                        var s = '<div><span class="label">' + e.fieldLabel + '</span><input type="text" name="' + e.fieldName + '" class="' + e.fieldName.toLowerCase() + '"></div>';
                        t.append(s)
                    }
                }(t, e)
            }).fail(function(e) {
                console.log(e)
            })
        }), n.on("click", ".dynamicFilter__addRow", function() {
            u((0, i.default)('input[name="advs-category"]:checked').val())
        }), n.on("click", ".dynamicFilter__search", function() {
            s.find(".dynamicFilter__row").each(function(e) {
                for (var t = (0, i.default)(".dynamicFilter__row").eq(e).find(".value"), n = 0; n < t.length - 1; n++) {
                    if (0 === t.eq(n + 1).prop("selectedIndex")) {
                        t.eq(n + 1).removeAttr("name");
                        break
                    }
                    t.eq(n).removeAttr("name")
                }
            })
        }), n.on("click", ".dynamicFilter__removeBtn", function() {
            (0, i.default)(this).closest(".dynamicFilter__row").remove()
        }), (0, i.default)(".dynamicFilter__advSearch").fancybox({
            beforeLoad: function() {
                u("fauna")
            },
            afterClose: function() {}
        }), (0, i.default)("input[type=radio][name=advs-category]").on("change", function() {
            u(this.value, "replace")
        }), a.on("click", function() {
            i.default.fancybox.close(), s.html("")
        }), (0, i.default)("input[type=radio][name=category]").on("change", function() {
            var e = (0, i.default)(".flora", t),
                n = (0, i.default)(".fauna", t);
            "flora" == this.value ? (n.addClass("hidden").hide(), e.removeClass("hidden").show()) : "fauna" == this.value ? (n.removeClass("hidden").show(), e.addClass("hidden").hide()) : (n.removeClass("hidden").show(), e.removeClass("hidden").show());
            var s = r.find("li.active"),
                a = (0, i.default)("input[type=radio][name=category]:checked").val();
            s.removeClass("active"), c = [], (l = []).push(a), window.emitter.emit("addSpeciesFunc", l)
        });
        var c = [];
        o.on("click", function() {
            var e = r.find("li.active.hidden"),
                t = (0, i.default)(this),
                n = t.data("tag"),
                s = (0, i.default)("input[type=radio][name=category]:checked").val();
            i.default.inArray(s, l), e.removeClass("active"), t.toggleClass("active"), s && (l = []).push(s), t.hasClass("active") ? c.push(n) : c = c.filter(function(e) {
                return e != n
            }), i.default.merge(l, c), window.emitter.emit("addSpeciesFunc", l)
        }), (0, i.default)(".dynamicFilter__radio, .dynamicFilter__categoryRadio").on("keydown", function(e) {
            13 === e.which && (0, i.default)("input", this).click()
        }), (0, i.default)(".dynamicFilter__allTags li").on("keydown", function(e) {
            13 === e.which && (0, i.default)(this).click()
        })
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }(n(1));
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".species-listing"),
            n = (0, i.default)(".export-report"),
            s = (0, i.default)(".form__message", ".export-report"),
            a = (0, i.default)(".form__input", ".export-report"),
            o = (0, i.default)(".form__close", ".export-report"),
            r = (0, i.default)(".form__submit-button", ".export-report"),
            d = (0, i.default)(".export-report").data("export-url"),
            l = ((0, i.default)(".export-report").data("success-message"), (0, i.default)(".export-report").data("failure-message"), (0, i.default)(".export-report").data("processing-message")),
            u = (0, i.default)(".export-report").data("invalid-message");

        function c() {
            var e = function() {
                var e = (0, i.default)(".results__export .dd-select").val(),
                    n = [(0, i.default)(".dynamicFilter__sidebar input:checked").val()];
                return document.querySelectorAll(".dynamicFilter__allTags li.active").forEach(function(e) {
                    var t = e.dataset.tag;
                    n.push(t)
                }), {
                    itemsRequested: 12,
                    nextStart: 1,
                    category: t.data("category"),
                    productTerm: t.data("speciesTerm"),
                    tags: n,
                    sort: e,
                    imageTag: t.data("imageTag"),
                    email: a.val()
                }
            }();
            i.default.ajax({
                url: d,
                method: "POST",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(e),
                ifModified: !0
            }).done(function(e) {
                200 === e.data.Status && (a.val(""), s.html(e.data.Message))
            }).fail(function(e) {
                console.log(e), s.html(e.data.Message)
            })
        }(0, i.default)("#results__export-button").click(function(e) {
            e.preventDefault(), console.log("export button clicked"), n.addClass("export-report--active"), a.focus()
        }), o.click(function(e) {
            e.preventDefault(), n.removeClass("export-report--active")
        }), r.click(function(e) {
            e.preventDefault(),
                function(e) {
                    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(e)
                }(a.val()) ? (s.text(l), c()) : s.text(u)
        }), a.on("keydown", function(e) {
            13 === e.which && (e.preventDefault(), r.click())
        }), o.on("keydown", function(e) {
            13 === e.which && (e.preventDefault(), (0, i.default)(this).click())
        })
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = o(n(1)),
        s = o(n(2)),
        a = n(3);

    function o(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    n(170);
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".sidebar"),
            n = (0, i.default)(".sidebar__explore", t),
            o = (0, i.default)(".sidebar__parent-list", t),
            r = (0, i.default)(".sidebar__submenuIcon", o),
            d = (0, i.default)(".sidebar__link", t),
            l = (0, i.default)(".whatsnew"),
            u = (0, i.default)(".whatsnew__name", l),
            whatsnew_mobile = (0, i.default)(".whatsnew__name.mobile", l),
            c = (0, i.default)(".whatsnew__item", l);
        c.data("scientific-name");
      var maxDots = 6;

      // Variables used to control the sliding animation
      var transformXIntervalNext;
      var transformXIntervalPrev;

      // Keep track of the current X (left/right scroll) position
      var transformCount = 0;

      function setBoundaries($slick, windowSize) {
        let $dots = (0, i.default)('.slick-dots li');
        if (windowSize < $dots.length) {
          $slick.find(".slick-dots li").eq(windowSize - 1).addClass("small");
        }
        let $dot = $dots.first();
        let marginLeft = Math.round(parseFloat($dot.css('margin-left')));
        let marginRight = Math.round(parseFloat($dot.css('margin-right')));
        let dotWidth = $dot.width() + marginLeft + marginRight;
        let viewportWidth = dotWidth * windowSize;

        // Calculate the viewport width
        (0, i.default)('.slick-dots-viewport').css('width', viewportWidth + 'px');

        // Define the left/right increments to smoothly scroll the dots.
        transformXIntervalPrev = dotWidth;
        transformXIntervalNext = -dotWidth;
        let scientific_name = (0, i.default)(".slick-slide.slick-current.slick-active .whatsnew__item").data("scientific-name");
        whatsnew_mobile.html(scientific_name);
      }

      // Slick Selector.
      var slickSlider = (0, i.default)(".whatsnew__slider");
      slickSlider.on("init", function (event, slick) {
        // Since the dots location is customisable, use the config options to find them.
        let $dotsholder = (0, i.default)(slick.options.appendDots).find('.' + slick.options.dotsClass);
        $dotsholder.wrap("<div class='slick-dots-viewport'></div>");
        // $dots.wrap("<div class='slick-dots-viewport'></div>");
        // Add an index to each dot so we can easily identify them.
        $dotsholder
          .find("li")
          .each(function (index) {
            (0, i.default)(this).addClass("dot-index-" + index);
          });

        // Reset the list position inside the viewport window
        $dotsholder.css("transform", "translateX(0)");

        // Resize the viewport and initialise the overflow dot (if necessary)
        setBoundaries((0, i.default)(this), maxDots);
      });

      slickSlider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        let $slider = (0, i.default)(this);
        let $dotList = $slider.find("ul.slick-dots");
        // debugger;
        let $dots = $dotList.find("li");
        let $firstDot = $dots.first();
        let $lastDot = $dots.last();
        let totalCount = $dots.length;
        if ((0, i.default).trim(u.html()) != "") {
          u.empty();
        }
        if (totalCount > maxDots) {
          let delta = nextSlide - currentSlide;
          if (Math.abs(delta) === totalCount - 1) {
            // Reset the style of every dot because we're about to wrap around
            $dots.removeClass("small");
            let boundaryDot;
            if (delta < 0) {
              // Wrapping around to the start
              transformCount = 0;
              boundaryDot = maxDots - 1;
            } else {
              // Wrapping around to the end
              transformCount = (totalCount - maxDots) * transformXIntervalNext;
              boundaryDot = totalCount - maxDots;
            }
            $dots.filter(".dot-index-" + boundaryDot).addClass("small");

            // Animate the dots into position
            $dotList.css("transform", "translateX(" + transformCount + "px)");
          } else {
            let $nextSlide = $dots.filter(".dot-index-" + nextSlide);
            if (nextSlide > currentSlide) {
              if ($nextSlide.hasClass("small")) {
                // We haven't reached the end of the list yet, scroll the dots to the left.
                transformCount = transformCount + transformXIntervalNext;

                // Remove the existing right-side boundary dot...
                $nextSlide.removeClass("small");

                // ...and move it one place to the right UNLESS we already reached the last dot.
                if (!$nextSlide.next().is($lastDot)) {
                  $nextSlide.next().addClass("small");
                }

                // Smoothly slide the dots to the left
                $dotList.css("transform", "translateX(" + transformCount + "px)");

                // Update the left-side boundary dot.
                let $firstVisibleDot = $dots.eq(nextSlide - (maxDots - 2));
                $firstVisibleDot.addClass("small").prev().removeClass("small").addClass("tiny");
              }
            } else {
              // If the previous button has the "small" dot style...
              if ($nextSlide.hasClass("small")) {
                // We haven't reached the start of the list yet, scroll the dots to the right.
                transformCount = transformCount + transformXIntervalPrev;

                // Remove the existing left-side boundary dot...
                $nextSlide.removeClass("small");

                // ...and move it one place to the left UNLESS we already reached the first dot.
                if (!$nextSlide.prev().is($firstDot)) {
                  $nextSlide.prev().addClass("small");
                }

                // Smoothly slide the dots to the left
                $dotList.css("transform", "translateX(" + transformCount + "px)");

                // Update the left-side boundary dot.
                let $lastVisibleDot = $dots.eq(nextSlide + (maxDots - 2));
                $lastVisibleDot.addClass("small").next().removeClass("small").addClass("tiny");
              }
            }
          }
        }
        whatsnew_mobile.html("&nbsp");
      });

      slickSlider.on("afterChange", function (event, slick, currentSlide) {
        let scientific_name = (0, i.default)(".slick-slide.slick-current.slick-active .whatsnew__item").data("scientific-name");
        whatsnew_mobile.html(scientific_name);
        let $slider = (0, i.default)(this);
        let $dotList = $slider.find("ul.slick-dots");
        let $dots = $dotList.find("li");
        $dots.filter('.tiny').removeClass('tiny');

      });
      l.length &&
        (0, i.default)(".whatsnew__slider").slick({
			lazyLoad: "progressive",
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 2,
            slidesPerRow: 1,
            arrows: !1,
            dots: !0,
            autoplay: !0,
            autoplaySpeed: 1500,
            responsive: [
                        { breakpoint: 1023, settings: { slidesToShow: 1, slidesToScroll: 1, rows: 1 } },
            ],
            nextArrow: '<button class="carousel-next" type="button" aria-label="Next slide"><i class="icon icon-chevron-small-right"></i><span class="visuallyhidden">Button to view the next items of the carousel</span></button>',
            prevArrow: '<button class="carousel-prev" type="button" aria-label="Previous slide"><i class="icon icon-chevron-small-left"></i><span class="visuallyhidden">Button to view the previous items of the carousel</span></button>'
        }),
        (0, i.default)(".whatsnew__item", l).each(function () {
          (0, i.default)(this).hover(function (e) {
            var t = (0, i.default)(this).data("scientific-name");
            u.html(t)
          }, function (e) {
            u.html("&nbsp;")
          })
        }),
        r.on("click", function (e) {
            e.preventDefault();
            var t = (0, i.default)(this).closest(".has-submenu");
            t.toggleClass("open"), t.hasClass("open") ? t.find(".sidebar__child-list").slideDown() : t.find(".sidebar__child-list").slideUp()
        }), d.on("click", function() {
            d.closest(".sidebar__item").removeClass("active"), (0, i.default)(this).closest(".sidebar__item").addClass("active")
        }), s.default.register("screen and (max-width:" + (a.bp.minDesktop - 1) + "px)", {
            match: function() {
                n.on("click.mobileSidebar", function() {
                    (0, i.default)(this).toggleClass("mbl-active"), (0, i.default)(this).hasClass("mbl-active") ? o.slideDown() : o.slideUp()
                })
            },
            unmatch: function() {
                n.off("click.mobileSidebar"), o.css("display", "")
            }
        }), s.default.register("screen and (min-width:" + a.bp.minDesktop + "px)", {
            match: function() {
                t.stick_in_parent({
                    offset_top: 80,
                    recalc_every: 1
                })
            },
            unmatch: function() {
                t.trigger("sticky_kit:detach")
            }
        })
    }
}, function(e, t, n) {
    (function(e) {
        (function() {
            var t, n;
            t = this.jQuery || e, n = t(window), t.fn.stick_in_parent = function(e) {
                var i, s, a, o, r, d, l, u, c, h, m, f, _;
                for (null == e && (e = {}), h = e.sticky_class, o = e.inner_scrolling, c = e.recalc_every, u = e.parent, d = e.offset_top, r = e.spacer, a = e.bottoming, null == d && (d = 0), null == u && (u = void 0), null == o && (o = !0), null == h && (h = "is_stuck"), i = t(document), null == a && (a = !0), l = function(e) {
                        var t, n;
                        return window.getComputedStyle ? (e[0], t = window.getComputedStyle(e[0]), n = parseFloat(t.getPropertyValue("width")) + parseFloat(t.getPropertyValue("margin-left")) + parseFloat(t.getPropertyValue("margin-right")), "border-box" !== t.getPropertyValue("box-sizing") && (n += parseFloat(t.getPropertyValue("border-left-width")) + parseFloat(t.getPropertyValue("border-right-width")) + parseFloat(t.getPropertyValue("padding-left")) + parseFloat(t.getPropertyValue("padding-right"))), n) : e.outerWidth(!0)
                    }, m = function(e, s, m, f, _, p, g, y) {
                        var v, M, L, w, b, k, Y, T, D, S, x, H;
                        if (!e.data("sticky_kit")) {
                            if (e.data("sticky_kit", !0), b = i.height(), Y = e.parent(), null != u && (Y = Y.closest(u)), !Y.length) throw "failed to find stick parent";
                            if (L = !1, v = !1, (x = null != r ? r && e.closest(r) : t("<div />")) && x.css("position", e.css("position")), (T = function() {
                                    var t, n, a;
                                    if (!y) return b = i.height(), t = parseInt(Y.css("border-top-width"), 10), n = parseInt(Y.css("padding-top"), 10), s = parseInt(Y.css("padding-bottom"), 10), m = Y.offset().top + t + n, f = Y.height(), L && (L = !1, v = !1, null == r && (e.insertAfter(x), x.detach()), e.css({
                                        position: "",
                                        top: "",
                                        width: "",
                                        bottom: ""
                                    }).removeClass(h), a = !0), _ = e.offset().top - (parseInt(e.css("margin-top"), 10) || 0) - d, p = e.outerHeight(!0), g = e.css("float"), x && x.css({
                                        width: l(e),
                                        height: p,
                                        display: e.css("display"),
                                        "vertical-align": e.css("vertical-align"),
                                        float: g
                                    }), a ? H() : void 0
                                })(), p !== f) return w = void 0, k = d, S = c, H = function() {
                                var t, l, u, M, D, H;
                                if (!y) return u = !1, null != S && (S -= 1) <= 0 && (S = c, T(), u = !0), u || i.height() === b || (T(), u = !0), M = n.scrollTop(), null != w && (l = M - w), w = M, L ? (a && (D = M + p + k > f + m, v && !D && (v = !1, e.css({
                                    position: "fixed",
                                    bottom: "",
                                    top: k
                                }).trigger("sticky_kit:unbottom"))), M < _ && (L = !1, k = d, null == r && ("left" !== g && "right" !== g || e.insertAfter(x), x.detach()), t = {
                                    position: "",
                                    width: "",
                                    top: ""
                                }, e.css(t).removeClass(h).trigger("sticky_kit:unstick")), o && (H = n.height(), p + d > H && (v || (k -= l, k = Math.max(H - p, k), k = Math.min(d, k), L && e.css({
                                    top: k + "px"
                                }))))) : M > _ && (L = !0, (t = {
                                    position: "fixed",
                                    top: k
                                }).width = "border-box" === e.css("box-sizing") ? e.outerWidth() + "px" : e.width() + "px", e.css(t).addClass(h), null == r && (e.after(x), "left" !== g && "right" !== g || x.append(e)), e.trigger("sticky_kit:stick")), L && a && (null == D && (D = M + p + k > f + m), !v && D) ? (v = !0, "static" === Y.css("position") && Y.css({
                                    position: "relative"
                                }), e.css({
                                    position: "absolute",
                                    bottom: s,
                                    top: "auto"
                                }).trigger("sticky_kit:bottom")) : void 0
                            }, D = function() {
                                return T(), H()
                            }, M = function() {
                                if (y = !0, n.off("touchmove", H), n.off("scroll", H), n.off("resize", D), t(document.body).off("sticky_kit:recalc", D), e.off("sticky_kit:detach", M), e.removeData("sticky_kit"), e.css({
                                        position: "",
                                        bottom: "",
                                        top: "",
                                        width: ""
                                    }), Y.position("position", ""), L) return null == r && ("left" !== g && "right" !== g || e.insertAfter(x), x.remove()), e.removeClass(h)
                            }, n.on("touchmove", H), n.on("scroll", H), n.on("resize", D), t(document.body).on("sticky_kit:recalc", D), e.on("sticky_kit:detach", M), setTimeout(H, 0)
                        }
                    }, f = 0, _ = this.length; f < _; f++) s = this[f], m(t(s));
                return this
            }
        }).call(this)
    }).call(this, n(1))
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }(n(1));
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (0, i.default)(".share-buttons__top").on("click", function() {
            window.emitter.emit("backToTop")
        })
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = o(n(1)),
        s = o(n(2)),
        a = n(3);

    function o(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    n(173);
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".species-search").data("autoSuggest"),
            n = (0, i.default)(".notification-section"),
            o = (0, i.default)(".species-search--full");
        s.default.register("screen and (min-width:" + a.bp.minDesktop + "px)", {
            match: function() {
                if (n.hasClass("active")) {
                    var e = (0, i.default)(".notification").outerHeight();
                    o.css("marginTop", e - 2)
                } else o.css("marginTop", 0);
                window.emitter.on("notification-closed", function() {
                    n.hasClass("active") || o.css("marginTop", 0)
                })
            },
            unmatch: function() {
                o.css("marginTop", 0)
            }
        }), (0, i.default)(".species-search__inputBox").on("click", ".autocomplete-suggestion", function() {
            var e = (0, i.default)(this);
            e.attr("pageUrl") ? window.open(e.attr("pageUrl"), "_self") : (0, i.default)("#speciesSearh").submit()
        }), (0, i.default)("#speciesSearch").autocomplete({
            serviceUrl: t,
            minChars: 2,
            appendTo: ".species-search__inputBox",
            beforeRender: function(e, t) {
                for (var n = e.find(".autocomplete-suggestion"), s = 0; s < t.length; s++) {
                    var a = (0, i.default)(n)[s],
                        o = t[s].pageUrl;
                    o && a.setAttribute("pageUrl", o)
                }
            }
        })
    }
}, function(e, t, n) {
    "use strict";
    var i, s, a;
    "function" == typeof Symbol && Symbol.iterator;
    s = [n(1)], void 0 === (a = "function" == typeof(i = function(e) {
        var t = {
                escapeRegExChars: function(e) {
                    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&")
                },
                createNode: function(e) {
                    var t = document.createElement("div");
                    return t.className = e, t.style.position = "absolute", t.style.display = "none", t
                }
            },
            n = {
                ESC: 27,
                TAB: 9,
                RETURN: 13,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40
            },
            i = e.noop;

        function s(t, n) {
            this.element = t, this.el = e(t), this.suggestions = [], this.badQueries = [], this.selectedIndex = -1, this.currentValue = this.element.value, this.timeoutId = null, this.cachedResponse = {}, this.onChangeTimeout = null, this.onChange = null, this.isLocal = !1, this.suggestionsContainer = null, this.noSuggestionsContainer = null, this.options = e.extend(!0, {}, s.defaults, n), this.classes = {
                selected: "autocomplete-selected",
                suggestion: "autocomplete-suggestion"
            }, this.hint = null, this.hintValue = "", this.selection = null, this.initialize(), this.setOptions(n)
        }
        s.utils = t, e.Autocomplete = s, s.defaults = {
            ajaxSettings: {},
            autoSelectFirst: !1,
            appendTo: "body",
            serviceUrl: null,
            lookup: null,
            onSelect: null,
            width: "auto",
            minChars: 1,
            maxHeight: 300,
            deferRequestBy: 0,
            params: {},
            formatResult: function(e, n) {
                if (!n) return e.value;
                var i = "(" + t.escapeRegExChars(n) + ")";
                return e.value.replace(new RegExp(i, "gi"), "<strong>$1</strong>").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/&lt;(\/?strong)&gt;/g, "<$1>")
            },
            formatGroup: function(e, t) {
                return '<div class="autocomplete-group">' + t + "</div>"
            },
            delimiter: null,
            zIndex: 9999,
            type: "GET",
            noCache: !1,
            onSearchStart: i,
            onSearchComplete: i,
            onSearchError: i,
            preserveInput: !1,
            containerClass: "autocomplete-suggestions",
            tabDisabled: !1,
            dataType: "text",
            currentRequest: null,
            triggerSelectOnValidInput: !0,
            preventBadQueries: !0,
            lookupFilter: function(e, t, n) {
                return -1 !== e.value.toLowerCase().indexOf(n)
            },
            paramName: "query",
            transformResult: function(t) {
                return "string" == typeof t ? e.parseJSON(t) : t
            },
            showNoSuggestionNotice: !1,
            noSuggestionNotice: "No results",
            orientation: "bottom",
            forceFixPosition: !1
        }, s.prototype = {
            initialize: function() {
                var t, n = this,
                    i = "." + n.classes.suggestion,
                    a = n.classes.selected,
                    o = n.options;
                n.element.setAttribute("autocomplete", "off"), n.noSuggestionsContainer = e('<div class="autocomplete-no-suggestion"></div>').html(this.options.noSuggestionNotice).get(0), n.suggestionsContainer = s.utils.createNode(o.containerClass), (t = e(n.suggestionsContainer)).appendTo(o.appendTo || "body"), "auto" !== o.width && t.css("width", o.width), t.on("mouseover.autocomplete", i, function() {
                    n.activate(e(this).data("index"))
                }), t.on("mouseout.autocomplete", function() {
                    n.selectedIndex = -1, t.children("." + a).removeClass(a)
                }), t.on("click.autocomplete", i, function() {
                    n.select(e(this).data("index"))
                }), t.on("click.autocomplete", function() {
                    clearTimeout(n.blurTimeoutId)
                }), n.fixPositionCapture = function() {
                    n.visible && n.fixPosition()
                }, e(window).on("resize.autocomplete", n.fixPositionCapture), n.el.on("keydown.autocomplete", function(e) {
                    n.onKeyPress(e)
                }), n.el.on("keyup.autocomplete", function(e) {
                    n.onKeyUp(e)
                }), n.el.on("blur.autocomplete", function() {
                    n.onBlur()
                }), n.el.on("focus.autocomplete", function() {
                    n.onFocus()
                }), n.el.on("change.autocomplete", function(e) {
                    n.onKeyUp(e)
                }), n.el.on("input.autocomplete", function(e) {
                    n.onKeyUp(e)
                })
            },
            onFocus: function() {
                this.fixPosition(), this.el.val().length >= this.options.minChars && this.onValueChange()
            },
            onBlur: function() {
                var t = this,
                    n = t.options,
                    i = t.el.val(),
                    s = t.getQuery(i);
                t.blurTimeoutId = setTimeout(function() {
                    t.hide(), t.selection && t.currentValue !== s && (n.onInvalidateSelection || e.noop).call(t.element)
                }, 200)
            },
            abortAjax: function() {
                this.currentRequest && (this.currentRequest.abort(), this.currentRequest = null)
            },
            setOptions: function(t) {
                var n = e.extend({}, this.options, t);
                this.isLocal = Array.isArray(n.lookup), this.isLocal && (n.lookup = this.verifySuggestionsFormat(n.lookup)), n.orientation = this.validateOrientation(n.orientation, "bottom"), e(this.suggestionsContainer).css({
                    "max-height": n.maxHeight + "px",
                    width: n.width + "px",
                    "z-index": n.zIndex
                }), this.options = n
            },
            clearCache: function() {
                this.cachedResponse = {}, this.badQueries = []
            },
            clear: function() {
                this.clearCache(), this.currentValue = "", this.suggestions = []
            },
            disable: function() {
                this.disabled = !0, clearTimeout(this.onChangeTimeout), this.abortAjax()
            },
            enable: function() {
                this.disabled = !1
            },
            fixPosition: function() {
                var t = e(this.suggestionsContainer),
                    n = t.parent().get(0);
                if (n === document.body || this.options.forceFixPosition) {
                    var i = this.options.orientation,
                        s = t.outerHeight(),
                        a = this.el.outerHeight(),
                        o = this.el.offset(),
                        r = {
                            top: o.top,
                            left: o.left
                        };
                    if ("auto" === i) {
                        var d = e(window).height(),
                            l = e(window).scrollTop(),
                            u = -l + o.top - s,
                            c = l + d - (o.top + a + s);
                        i = Math.max(u, c) === u ? "top" : "bottom"
                    }
                    if (r.top += "top" === i ? -s : a, n !== document.body) {
                        var h, m = t.css("opacity");
                        this.visible || t.css("opacity", 0).show(), h = t.offsetParent().offset(), r.top -= h.top, r.top += n.scrollTop, r.left -= h.left, this.visible || t.css("opacity", m).hide()
                    }
                    "auto" === this.options.width && (r.width = this.el.outerWidth() + "px"), t.css(r)
                }
            },
            isCursorAtEnd: function() {
                var e, t = this.el.val().length,
                    n = this.element.selectionStart;
                return "number" == typeof n ? n === t : !document.selection || ((e = document.selection.createRange()).moveStart("character", -t), t === e.text.length)
            },
            onKeyPress: function(e) {
                if (this.disabled || this.visible || e.which !== n.DOWN || !this.currentValue) {
                    if (!this.disabled && this.visible) {
                        switch (e.which) {
                            case n.ESC:
                                this.el.val(this.currentValue), this.hide();
                                break;
                            case n.RIGHT:
                                if (this.hint && this.options.onHint && this.isCursorAtEnd()) {
                                    this.selectHint();
                                    break
                                }
                                return;
                            case n.TAB:
                                if (this.hint && this.options.onHint) return void this.selectHint();
                                if (-1 === this.selectedIndex) return void this.hide();
                                if (this.select(this.selectedIndex), !1 === this.options.tabDisabled) return;
                                break;
                            case n.RETURN:
                                if (-1 === this.selectedIndex) return void this.hide();
                                this.select(this.selectedIndex);
                                break;
                            case n.UP:
                                this.moveUp();
                                break;
                            case n.DOWN:
                                this.moveDown();
                                break;
                            default:
                                return
                        }
                        e.stopImmediatePropagation(), e.preventDefault()
                    }
                } else this.suggest()
            },
            onKeyUp: function(e) {
                var t = this;
                if (!t.disabled) {
                    switch (e.which) {
                        case n.UP:
                        case n.DOWN:
                            return
                    }
                    clearTimeout(t.onChangeTimeout), t.currentValue !== t.el.val() && (t.findBestHint(), t.options.deferRequestBy > 0 ? t.onChangeTimeout = setTimeout(function() {
                        t.onValueChange()
                    }, t.options.deferRequestBy) : t.onValueChange())
                }
            },
            onValueChange: function() {
                if (this.ignoreValueChange) this.ignoreValueChange = !1;
                else {
                    var t = this.options,
                        n = this.el.val(),
                        i = this.getQuery(n);
                    this.selection && this.currentValue !== i && (this.selection = null, (t.onInvalidateSelection || e.noop).call(this.element)), clearTimeout(this.onChangeTimeout), this.currentValue = n, this.selectedIndex = -1, t.triggerSelectOnValidInput && this.isExactMatch(i) ? this.select(0) : i.length < t.minChars ? this.hide() : this.getSuggestions(i)
                }
            },
            isExactMatch: function(e) {
                var t = this.suggestions;
                return 1 === t.length && t[0].value.toLowerCase() === e.toLowerCase()
            },
            getQuery: function(t) {
                var n, i = this.options.delimiter;
                return i ? (n = t.split(i), e.trim(n[n.length - 1])) : t
            },
            getSuggestionsLocal: function(t) {
                var n, i = this.options,
                    s = t.toLowerCase(),
                    a = i.lookupFilter,
                    o = parseInt(i.lookupLimit, 10);
                return n = {
                    suggestions: e.grep(i.lookup, function(e) {
                        return a(e, t, s)
                    })
                }, o && n.suggestions.length > o && (n.suggestions = n.suggestions.slice(0, o)), n
            },
            getSuggestions: function(t) {
                var n, i, s, a, o = this,
                    r = o.options,
                    d = r.serviceUrl;
                r.params[r.paramName] = t, !1 !== r.onSearchStart.call(o.element, r.params) && (i = r.ignoreParams ? null : r.params, e.isFunction(r.lookup) ? r.lookup(t, function(e) {
                    o.suggestions = e.suggestions, o.suggest(), r.onSearchComplete.call(o.element, t, e.suggestions)
                }) : (o.isLocal ? n = o.getSuggestionsLocal(t) : (e.isFunction(d) && (d = d.call(o.element, t)), s = d + "?" + e.param(i || {}), n = o.cachedResponse[s]), n && Array.isArray(n.suggestions) ? (o.suggestions = n.suggestions, o.suggest(), r.onSearchComplete.call(o.element, t, n.suggestions)) : o.isBadQuery(t) ? r.onSearchComplete.call(o.element, t, []) : (o.abortAjax(), a = {
                    url: d,
                    data: i,
                    type: r.type,
                    dataType: r.dataType
                }, e.extend(a, r.ajaxSettings), o.currentRequest = e.ajax(a).done(function(e) {
                    var n;
                    o.currentRequest = null, n = r.transformResult(e, t), o.processResponse(n, t, s), r.onSearchComplete.call(o.element, t, n.suggestions)
                }).fail(function(e, n, i) {
                    r.onSearchError.call(o.element, t, e, n, i)
                }))))
            },
            isBadQuery: function(e) {
                if (!this.options.preventBadQueries) return !1;
                for (var t = this.badQueries, n = t.length; n--;)
                    if (0 === e.indexOf(t[n])) return !0;
                return !1
            },
            hide: function() {
                var t = e(this.suggestionsContainer);
                e.isFunction(this.options.onHide) && this.visible && this.options.onHide.call(this.element, t), this.visible = !1, this.selectedIndex = -1, clearTimeout(this.onChangeTimeout), e(this.suggestionsContainer).hide(), this.signalHint(null)
            },
            suggest: function() {
                if (this.suggestions.length) {
                    var t, n = this.options,
                        i = n.groupBy,
                        s = n.formatResult,
                        a = this.getQuery(this.currentValue),
                        o = this.classes.suggestion,
                        r = this.classes.selected,
                        d = e(this.suggestionsContainer),
                        l = e(this.noSuggestionsContainer),
                        u = n.beforeRender,
                        c = "";
                    n.triggerSelectOnValidInput && this.isExactMatch(a) ? this.select(0) : (e.each(this.suggestions, function(e, r) {
                        i && (c += function(e, s) {
                            var a = e.data[i];
                            return t === a ? "" : (t = a, n.formatGroup(e, t))
                        }(r)), c += '<div class="' + o + '" data-index="' + e + '">' + s(r, a, e) + "</div>"
                    }), this.adjustContainerWidth(), l.detach(), d.html(c), e.isFunction(u) && u.call(this.element, d, this.suggestions), this.fixPosition(), d.show(), n.autoSelectFirst && (this.selectedIndex = 0, d.scrollTop(0), d.children("." + o).first().addClass(r)), this.visible = !0, this.findBestHint())
                } else this.options.showNoSuggestionNotice ? this.noSuggestions() : this.hide()
            },
            noSuggestions: function() {
                var t = this.options.beforeRender,
                    n = e(this.suggestionsContainer),
                    i = e(this.noSuggestionsContainer);
                this.adjustContainerWidth(), i.detach(), n.empty(), n.append(i), e.isFunction(t) && t.call(this.element, n, this.suggestions), this.fixPosition(), n.show(), this.visible = !0
            },
            adjustContainerWidth: function() {
                var t, n = this.options,
                    i = e(this.suggestionsContainer);
                "auto" === n.width ? (t = this.el.outerWidth(), i.css("width", t > 0 ? t : 300)) : "flex" === n.width && i.css("width", "")
            },
            findBestHint: function() {
                var t = this.el.val().toLowerCase(),
                    n = null;
                t && (e.each(this.suggestions, function(e, i) {
                    var s = 0 === i.value.toLowerCase().indexOf(t);
                    return s && (n = i), !s
                }), this.signalHint(n))
            },
            signalHint: function(t) {
                var n = "";
                t && (n = this.currentValue + t.value.substr(this.currentValue.length)), this.hintValue !== n && (this.hintValue = n, this.hint = t, (this.options.onHint || e.noop)(n))
            },
            verifySuggestionsFormat: function(t) {
                return t.length && "string" == typeof t[0] ? e.map(t, function(e) {
                    return {
                        value: e,
                        data: null
                    }
                }) : t
            },
            validateOrientation: function(t, n) {
                return t = e.trim(t || "").toLowerCase(), -1 === e.inArray(t, ["auto", "bottom", "top"]) && (t = n), t
            },
            processResponse: function(e, t, n) {
                var i = this.options;
                e.suggestions = this.verifySuggestionsFormat(e.suggestions), i.noCache || (this.cachedResponse[n] = e, i.preventBadQueries && !e.suggestions.length && this.badQueries.push(t)), t === this.getQuery(this.currentValue) && (this.suggestions = e.suggestions, this.suggest())
            },
            activate: function(t) {
                var n, i = this.classes.selected,
                    s = e(this.suggestionsContainer),
                    a = s.find("." + this.classes.suggestion);
                return s.find("." + i).removeClass(i), this.selectedIndex = t, -1 !== this.selectedIndex && a.length > this.selectedIndex ? (n = a.get(this.selectedIndex), e(n).addClass(i), n) : null
            },
            selectHint: function() {
                var t = e.inArray(this.hint, this.suggestions);
                this.select(t)
            },
            select: function(e) {
                this.hide(), this.onSelect(e)
            },
            moveUp: function() {
                if (-1 !== this.selectedIndex) return 0 === this.selectedIndex ? (e(this.suggestionsContainer).children("." + this.classes.suggestion).first().removeClass(this.classes.selected), this.selectedIndex = -1, this.ignoreValueChange = !1, this.el.val(this.currentValue), void this.findBestHint()) : void this.adjustScroll(this.selectedIndex - 1)
            },
            moveDown: function() {
                this.selectedIndex !== this.suggestions.length - 1 && this.adjustScroll(this.selectedIndex + 1)
            },
            adjustScroll: function(t) {
                var n = this.activate(t);
                if (n) {
                    var i, s, a, o = e(n).outerHeight();
                    i = n.offsetTop, a = (s = e(this.suggestionsContainer).scrollTop()) + this.options.maxHeight - o, i < s ? e(this.suggestionsContainer).scrollTop(i) : i > a && e(this.suggestionsContainer).scrollTop(i - this.options.maxHeight + o), this.options.preserveInput || (this.ignoreValueChange = !0, this.el.val(this.getValue(this.suggestions[t].value))), this.signalHint(null)
                }
            },
            onSelect: function(t) {
                var n = this.options.onSelect,
                    i = this.suggestions[t];
                this.currentValue = this.getValue(i.value), this.currentValue === this.el.val() || this.options.preserveInput || this.el.val(this.currentValue), this.signalHint(null), this.suggestions = [], this.selection = i, e.isFunction(n) && n.call(this.element, i)
            },
            getValue: function(e) {
                var t, n, i = this.options.delimiter;
                return i ? 1 === (n = (t = this.currentValue).split(i)).length ? e : t.substr(0, t.length - n[n.length - 1].length) + e : e
            },
            dispose: function() {
                this.el.off(".autocomplete").removeData("autocomplete"), e(window).off("resize.autocomplete", this.fixPositionCapture), e(this.suggestionsContainer).remove()
            }
        }, e.fn.devbridgeAutocomplete = function(t, n) {
            return arguments.length ? this.each(function() {
                var i = e(this),
                    a = i.data("autocomplete");
                "string" == typeof t ? a && "function" == typeof a[t] && a[t](n) : (a && a.dispose && a.dispose(), a = new s(this, t), i.data("autocomplete", a))
            }) : this.first().data("autocomplete")
        }, e.fn.autocomplete || (e.fn.autocomplete = e.fn.devbridgeAutocomplete)
    }) ? i.apply(t, s) : i) || (e.exports = a)
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }(n(1));
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".species-details").data("species-login-display"),
            n = (0, i.default)(".species-details__wrap").attr("id"),
            s = void 0;
        (0, i.default)(".species-info__back").click(function(e) {
            e.preventDefault(), window.history.back()
        }), s = n ? t + "?id=" + n : t, i.default.ajax({
            url: s,
            method: "GET",
            dataType: "json"
        }).done(function(e) {
            void 0 != e && e.forEach(function(e, t) {
                var n = e.id,
                    s = e.value;
                if ((0, i.default)("#" + n).length) {
                    var a = (0, i.default)("#" + n),
                        o = a.parent("tr"),
                        r = a.parents(".rte").siblings("h3"),
                        d = a.parents(".rte").siblings("h3");
                    a.html(s), o.removeClass("hiddenField"), r.removeClass("hiddenField"), (0, i.default)(".sidebar__parent-list > .sidebar__item").map(function(e, t) {
                        d.attr("id") + "-heading" == (0, i.default)(t).attr("id") && (0, i.default)(t).removeClass("hiddenField")
                    })
                }
            })
        }).fail(function(e) {});
        for (var a = (0, i.default)(".btn_collapse"), o = function(e) {
                (0, i.default)(a[e]).on("click", function() {
                    (0, i.default)(a[e]).toggleClass("active"), (0, i.default)(a[e]).prev().toggleClass("show")
                })
            }, r = 0; r < a.length; r++) o(r);
        (0, i.default)(a[0]).addClass("active")
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = o(n(1)),
        s = (o(n(2)), n(3)),
        a = o(n(5));

    function o(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".species-of-month"),
            n = (0, i.default)(".home-stats");
        if (t.length && t.on("mouseenter", function() {
                t.addClass("hide"), (0, i.default)(this).addClass("active")
            }).on("mouseleave", function() {
                t.removeClass("hide active")
            }), n.length) {
            var o = new a.default.Controller;
            new a.default.Scene({
                triggerElement: ".home-stats",
                triggerHook: 1,
                offset: 100
            }).on("enter", function(e) {
                var t = (0, i.default)(".figure-stats", n);
                (0, i.default)(".home-stats__data", t), t.each(function(e) {
                    (0, s.animateFigure)((0, i.default)(this))
                })
            }).addTo(o)
        }
    }
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = o(n(1)),
        s = o(n(177)),
        a = o(n(178));

    function o(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e);
        var t = (0, i.default)(".species-listing"),
            n = (0, i.default)("button[name=ExportExcel]"),
            o = (0, i.default)("button[name=ExportPDF]"),
            r = (0, i.default)(".results__found"),
            d = (0, i.default)(".results__container"),
            l = (0, i.default)(".loader");
        if (t.length) {
            var u = t.data("speciesList"),
                c = (n.data("url"), o.data("url"), t.data("itemsRequested")),
                h = (t.data("category"), t.data("speciesTerm"), {
                    itemsRequested: c,
                    page: 1,
                    category: t.data("category"),
                    productTerm: t.data("speciesTerm"),
                    tags: "",
                    sort: "",
                    imageTag: t.data("imageTag")
                });
            (0, i.default)(function() {
                if (window.performance && window.PerformanceNavigation) {
                    var e = performance.navigation.type;
                    e == PerformanceNavigation.TYPE_NAVIGATE ? m(h, 0) : e == PerformanceNavigation.TYPE_RELOAD ? m(h, 0) : e == PerformanceNavigation.TYPE_BACK_FORWARD && m(h, 1)
                }
            });
            var m = function(e, t) {
                var n = e.page;
                t && (n = localStorage.speciesListingPage), l.addClass("is-visible");
                var o = location.search;
                o && (e.advanceSearch = o.replace("?", "")), i.default.ajax({
                    method: "GET",
                    url: u,
                    dataType: "json",
                    data: e
                }).done(function(e) {
                    void 0 != e && (function(e, t) {
                        var n = s.default.template((0, i.default)("#speciesListTemplate").html()),
                            o = e.species,
                            u = e.count,
                            c = e.itemsRequested,
                            h = (e.page, []);
                        1 == u && window.open(o[0].link, "_self");
                        var m = Math.ceil(u / c);
                        new a.default(m, t), o.forEach(function(e, t) {
                            h[t] = {
                                name: e.name,
                                commonName: e.commonName,
                                image: e.image,
                                desc: e.desc,
                                tag: e.tag,
                                link: e.link
                            }
                        });
                        var f = "";
                        f = u ? u > 1 ? u + " results found" : 1 == u ? "1 result found" : "No results found" : "No results found", r.html(f);
                        var _ = n(h);
                        d.html(_), l.removeClass("is-visible")
                    }(e, n), (0, i.default)("html").scrollTop(0))
                }).fail(function(e) {
                    console.log(e)
                })
            };
            (0, i.default)("body").on("click", ".results .pagination a", function(e) {
                e.preventDefault();
                var t = (0, i.default)(this).data("page");
                h.page = t, "undefined" != typeof Storage && (localStorage.speciesListingPage = h.page), m(h, 0)
            }), window.emitter.on("addSpeciesFunc", function(e) {
                h.tags = e.join(","), window.setTimeout(1e3), m(h, 0)
            }), (0, i.default)("select[name=sort-species]").on("change", function() {
                h.sort = (0, i.default)("select[name=sort-species]").val(), m(h, 0)
            })
        }
    }
}, function(e, t, n) {
    var i;
    ! function() {
        "use strict";
        var s, a = {
            name: "doT",
            version: "1.1.1",
            templateSettings: {
                evaluate: /\{\{([\s\S]+?(\}?)+)\}\}/g,
                interpolate: /\{\{=([\s\S]+?)\}\}/g,
                encode: /\{\{!([\s\S]+?)\}\}/g,
                use: /\{\{#([\s\S]+?)\}\}/g,
                useParams: /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
                define: /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
                defineParams: /^\s*([\w$]+):([\s\S]+)/,
                conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
                iterate: /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
                varname: "it",
                strip: !0,
                append: !0,
                selfcontained: !1,
                doNotSkipEncoded: !1
            },
            template: void 0,
            compile: void 0,
            log: !0
        };
        a.encodeHTMLSource = function(e) {
            var t = {
                    "&": "&#38;",
                    "<": "&#60;",
                    ">": "&#62;",
                    '"': "&#34;",
                    "'": "&#39;",
                    "/": "&#47;"
                },
                n = e ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
            return function(e) {
                return e ? e.toString().replace(n, function(e) {
                    return t[e] || e
                }) : ""
            }
        }, s = function() {
            return this || (0, eval)("this")
        }(), e.exports ? e.exports = a : void 0 === (i = function() {
            return a
        }.call(t, n, t, e)) || (e.exports = i);
        var o = {
                append: {
                    start: "'+(",
                    end: ")+'",
                    startencode: "'+encodeHTML("
                },
                split: {
                    start: "';out+=(",
                    end: ");out+='",
                    startencode: "';out+=encodeHTML("
                }
            },
            r = /$^/;

        function d(e) {
            return e.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ")
        }
        a.template = function(e, t, n) {
            var i, l, u = (t = t || a.templateSettings).append ? o.append : o.split,
                c = 0,
                h = t.use || t.define ? function e(t, n, i) {
                    return ("string" == typeof n ? n : n.toString()).replace(t.define || r, function(e, n, s, a) {
                        return 0 === n.indexOf("def.") && (n = n.substring(4)), n in i || (":" === s ? (t.defineParams && a.replace(t.defineParams, function(e, t, s) {
                            i[n] = {
                                arg: t,
                                text: s
                            }
                        }), n in i || (i[n] = a)) : new Function("def", "def['" + n + "']=" + a)(i)), ""
                    }).replace(t.use || r, function(n, s) {
                        t.useParams && (s = s.replace(t.useParams, function(e, t, n, s) {
                            if (i[n] && i[n].arg && s) {
                                var a = (n + ":" + s).replace(/'|\\/g, "_");
                                return i.__exp = i.__exp || {}, i.__exp[a] = i[n].text.replace(new RegExp("(^|[^\\w$])" + i[n].arg + "([^\\w$])", "g"), "$1" + s + "$2"), t + "def.__exp['" + a + "']"
                            }
                        }));
                        var a = new Function("def", "return " + s)(i);
                        return a ? e(t, a, i) : a
                    })
                }(t, e, n || {}) : e;
            h = ("var out='" + (t.strip ? h.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g, " ").replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "") : h).replace(/'|\\/g, "\\$&").replace(t.interpolate || r, function(e, t) {
                return u.start + d(t) + u.end
            }).replace(t.encode || r, function(e, t) {
                return i = !0, u.startencode + d(t) + u.end
            }).replace(t.conditional || r, function(e, t, n) {
                return t ? n ? "';}else if(" + d(n) + "){out+='" : "';}else{out+='" : n ? "';if(" + d(n) + "){out+='" : "';}out+='"
            }).replace(t.iterate || r, function(e, t, n, i) {
                return t ? (c += 1, l = i || "i" + c, t = d(t), "';var arr" + c + "=" + t + ";if(arr" + c + "){var " + n + "," + l + "=-1,l" + c + "=arr" + c + ".length-1;while(" + l + "<l" + c + "){" + n + "=arr" + c + "[" + l + "+=1];out+='") : "';} } out+='"
            }).replace(t.evaluate || r, function(e, t) {
                return "';" + d(t) + "out+='"
            }) + "';return out;").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r").replace(/(\s|;|\}|^|\{)out\+='';/g, "$1").replace(/\+''/g, ""), i && (t.selfcontained || !s || s._encodeHTML || (s._encodeHTML = a.encodeHTMLSource(t.doNotSkipEncoded)), h = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (" + a.encodeHTMLSource.toString() + "(" + (t.doNotSkipEncoded || "") + "));" + h);
            try {
                return new Function(t.varname, h)
            } catch (e) {
                throw "undefined" != typeof console && console.log("Could not create a template function: " + h), e
            }
        }, a.compile = function(e, t) {
            return a.template(e, null, t)
        }
    }()
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function() {
            function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                    var i = t[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                }
            }
            return function(t, n, i) {
                return n && e(t.prototype, n), i && e(t, i), t
            }
        }(),
        s = function(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }(n(1));
    var a = function() {
        function e(t, n) {
            ! function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this, e);
            var i = (0, s.default)(".species-listing__pagination");
            this.pageCount = t, this.currentPage = parseInt(n), this.$paginationContainer = i, this.renderPagination()
        }
        return i(e, [{
            key: "renderPagination",
            value: function() {
                this.$paginationContainer.html("");
                var e = "",
                    t = [],
                    n = '\n      <li>\n      <a href="#" id="first" data-page="1" aria-label="Go to first page" class="is-arrow">\n        <span class="icon">«</span>\n        <span class="pagination__text">Start</span>\n      </a>\n    </li>\n    <li>\n    <a href="#" id="prev" data-page="' + (this.currentPage - 1) + '" aria-label="Go to previous page" class="is-arrow">\n      <span class="icon icon-chevron-small-left"></span>\n    </a>\n    </li>',
                    i = '\n    <li>\n    <a href="#" id="next" data-page="' + (this.currentPage + 1) + '" aria-label="Go to next page" class="is-arrow">\n      <span class="icon icon-chevron-small-right"></span>\n    </a>\n    </li>\n    <li>\n      <a href="#" id="last" data-page="' + this.pageCount + '" aria-label="Go to last page" class="is-arrow">\n      <span class="pagination__text">End</span>\n        <span class="icon">»</span>\n      </a>\n    </li>';
                switch (this.pageCount <= 1 && (n = "", i = ""), this.currentPage) {
                    case 1:
                        t = [1, 2, 3, 4], n = "";
                        break;
                    case this.pageCount:
                        var s = this.pageCount;
                        t = [s - 4, s - 3, s - 2, s - 1, s], i = "";
                        break;
                    default:
                        var a = this.currentPage;
                        t = a + 2 > this.pageCount ? [a - 3, a - 2, a - 1, a, a + 1] : a - 2 > 0 ? [a - 2, a - 1, a, a + 1] : [a - 2, a - 1, a, a + 1, a + 2]
                }
                for (var o = 1; o <= this.pageCount; o++) {
                    var r = o == this.currentPage ? "is-active" : "",
                        d = "";
                    t.indexOf(o) >= 0 && (d = "is-visible"), e += '\n      <li>\n        <a href="#" data-page="' + o + '" class="is-number ' + r + " " + d + '" aria-label="Go to page ' + o + '">' + o + "</a>\n      </li>\n      "
                }
                this.pageCount > 4 && this.pageCount - this.currentPage >= 2 && (this.pageCount - this.currentPage == 2 ? e += '\n\n        <li>\n        <a href="#" data-page="' + this.pageCount + '" class="is-number is-visible" aria-label="Go to page ' + this.pageCount + '">' + this.pageCount + "</a>\n        </li>\n\n        " : e += '\n\n        <li>\n          <span class="pagination__ellipsis">...</span>\n        </li>\n        <li>\n        <a href="#" data-page="' + this.pageCount + '" class="is-number is-visible" aria-label="Go to page ' + this.pageCount + '">' + this.pageCount + "</a>\n        </li>\n\n        ");
                var l = "\n    " + n + "\n    " + e + "\n    " + i + "\n    ";
                this.$paginationContainer.html(l)
            }
        }]), e
    }();
    t.default = a
}, function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = a(n(1)),
        s = a(n(180));
    a(n(0));

    function a(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    t.default = function e() {
        ! function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (0, i.default)(".reports__form .datepicker").each(function() {
            new s.default({
                field: (0, i.default)(this)[0],
                format: "D/M/YYYY"
            })
        })
    }
}, function(e, t, n) {
    ! function(t, i) {
        "use strict";
        var s;
        try {
            s = n(0)
        } catch (e) {}
        e.exports = function(e) {
            var t = "function" == typeof e,
                n = !!window.addEventListener,
                i = window.document,
                s = window.setTimeout,
                a = function(e, t, i, s) {
                    n ? e.addEventListener(t, i, !!s) : e.attachEvent("on" + t, i)
                },
                o = function(e, t, i, s) {
                    n ? e.removeEventListener(t, i, !!s) : e.detachEvent("on" + t, i)
                },
                r = function(e, t) {
                    return -1 !== (" " + e.className + " ").indexOf(" " + t + " ")
                },
                d = function(e, t) {
                    r(e, t) || (e.className = "" === e.className ? t : e.className + " " + t)
                },
                l = function(e, t) {
                    e.className = function(e) {
                        return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "")
                    }((" " + e.className + " ").replace(" " + t + " ", " "))
                },
                u = function(e) {
                    return /Array/.test(Object.prototype.toString.call(e))
                },
                c = function(e) {
                    return /Date/.test(Object.prototype.toString.call(e)) && !isNaN(e.getTime())
                },
                h = function(e) {
                    var t = e.getDay();
                    return 0 === t || 6 === t
                },
                m = function(e, t) {
                    return [31, function(e) {
                        return e % 4 == 0 && e % 100 != 0 || e % 400 == 0
                    }(e) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][t]
                },
                f = function(e) {
                    c(e) && e.setHours(0, 0, 0, 0)
                },
                _ = function(e, t) {
                    return e.getTime() === t.getTime()
                },
                p = function(e, t, n) {
                    var i, s;
                    for (i in t)(s = void 0 !== e[i]) && "object" == typeof t[i] && null !== t[i] && void 0 === t[i].nodeName ? c(t[i]) ? n && (e[i] = new Date(t[i].getTime())) : u(t[i]) ? n && (e[i] = t[i].slice(0)) : e[i] = p({}, t[i], n) : !n && s || (e[i] = t[i]);
                    return e
                },
                g = function(e, t, n) {
                    var s;
                    i.createEvent ? ((s = i.createEvent("HTMLEvents")).initEvent(t, !0, !1), s = p(s, n), e.dispatchEvent(s)) : i.createEventObject && (s = i.createEventObject(), s = p(s, n), e.fireEvent("on" + t, s))
                },
                y = function(e) {
                    return e.month < 0 && (e.year -= Math.ceil(Math.abs(e.month) / 12), e.month += 12), e.month > 11 && (e.year += Math.floor(Math.abs(e.month) / 12), e.month -= 12), e
                },
                v = {
                    field: null,
                    bound: void 0,
                    ariaLabel: "Use the arrow keys to pick a date",
                    position: "bottom left",
                    reposition: !0,
                    format: "YYYY-MM-DD",
                    toString: null,
                    parse: null,
                    defaultDate: null,
                    setDefaultDate: !1,
                    firstDay: 0,
                    firstWeekOfYearMinDays: 4,
                    formatStrict: !1,
                    minDate: null,
                    maxDate: null,
                    yearRange: 10,
                    showWeekNumber: !1,
                    pickWholeWeek: !1,
                    minYear: 0,
                    maxYear: 9999,
                    minMonth: void 0,
                    maxMonth: void 0,
                    startRange: null,
                    endRange: null,
                    isRTL: !1,
                    yearSuffix: "",
                    showMonthAfterYear: !1,
                    showDaysInNextAndPreviousMonths: !1,
                    enableSelectionDaysInNextAndPreviousMonths: !1,
                    numberOfMonths: 1,
                    mainCalendar: "left",
                    container: void 0,
                    blurFieldOnSelect: !0,
                    i18n: {
                        previousMonth: "Previous Month",
                        nextMonth: "Next Month",
                        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                        weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                        weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
                    },
                    theme: null,
                    events: [],
                    onSelect: null,
                    onOpen: null,
                    onClose: null,
                    onDraw: null,
                    keyboardInput: !0
                },
                M = function(e, t, n) {
                    for (t += e.firstDay; t >= 7;) t -= 7;
                    return n ? e.i18n.weekdaysShort[t] : e.i18n.weekdays[t]
                },
                L = function(e) {
                    var t = [],
                        n = "false";
                    if (e.isEmpty) {
                        if (!e.showDaysInNextAndPreviousMonths) return '<td class="is-empty"></td>';
                        t.push("is-outside-current-month"), e.enableSelectionDaysInNextAndPreviousMonths || t.push("is-selection-disabled")
                    }
                    return e.isDisabled && t.push("is-disabled"), e.isToday && t.push("is-today"), e.isSelected && (t.push("is-selected"), n = "true"), e.hasEvent && t.push("has-event"), e.isInRange && t.push("is-inrange"), e.isStartRange && t.push("is-startrange"), e.isEndRange && t.push("is-endrange"), '<td data-day="' + e.day + '" class="' + t.join(" ") + '" aria-selected="' + n + '"><button class="pika-button pika-day" type="button" data-pika-year="' + e.year + '" data-pika-month="' + e.month + '" data-pika-day="' + e.day + '">' + e.day + "</button></td>"
                },
                w = function(n, i, s, a) {
                    var o = new Date(s, i, n),
                        r = t ? e(o).isoWeek() : function(e, t) {
                            e.setHours(0, 0, 0, 0);
                            var n = e.getDate(),
                                i = e.getDay(),
                                s = t,
                                a = s - 1,
                                o = function(e) {
                                    return (e + 7 - 1) % 7
                                };
                            e.setDate(n + a - o(i));
                            var r = new Date(e.getFullYear(), 0, s),
                                d = (e.getTime() - r.getTime()) / 864e5;
                            return 1 + Math.round((d - a + o(r.getDay())) / 7)
                        }(o, a);
                    return '<td class="pika-week">' + r + "</td>"
                },
                b = function(e, t, n, i) {
                    return '<tr class="pika-row' + (n ? " pick-whole-week" : "") + (i ? " is-selected" : "") + '">' + (t ? e.reverse() : e).join("") + "</tr>"
                },
                k = function(e, t, n, i, s, a) {
                    var o, r, d, l, c, h = e._o,
                        m = n === h.minYear,
                        f = n === h.maxYear,
                        _ = '<div id="' + a + '" class="pika-title" role="heading" aria-live="assertive">',
                        p = !0,
                        g = !0;
                    for (d = [], o = 0; o < 12; o++) d.push('<option value="' + (n === s ? o - t : 12 + o - t) + '"' + (o === i ? ' selected="selected"' : "") + (m && o < h.minMonth || f && o > h.maxMonth ? ' disabled="disabled"' : "") + ">" + h.i18n.months[o] + "</option>");
                    for (l = '<div class="pika-label">' + h.i18n.months[i] + '<select class="pika-select pika-select-month" tabindex="-1">' + d.join("") + "</select></div>", u(h.yearRange) ? (o = h.yearRange[0], r = h.yearRange[1] + 1) : (o = n - h.yearRange, r = 1 + n + h.yearRange), d = []; o < r && o <= h.maxYear; o++) o >= h.minYear && d.push('<option value="' + o + '"' + (o === n ? ' selected="selected"' : "") + ">" + o + "</option>");
                    return c = '<div class="pika-label">' + n + h.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + d.join("") + "</select></div>", h.showMonthAfterYear ? _ += c + l : _ += l + c, m && (0 === i || h.minMonth >= i) && (p = !1), f && (11 === i || h.maxMonth <= i) && (g = !1), 0 === t && (_ += '<button class="pika-prev' + (p ? "" : " is-disabled") + '" type="button">' + h.i18n.previousMonth + "</button>"), t === e._o.numberOfMonths - 1 && (_ += '<button class="pika-next' + (g ? "" : " is-disabled") + '" type="button">' + h.i18n.nextMonth + "</button>"), _ += "</div>"
                },
                Y = function(o) {
                    var d = this,
                        l = d.config(o);
                    d._onMouseDown = function(e) {
                        if (d._v) {
                            var t = (e = e || window.event).target || e.srcElement;
                            if (t)
                                if (r(t, "is-disabled") || (!r(t, "pika-button") || r(t, "is-empty") || r(t.parentNode, "is-disabled") ? r(t, "pika-prev") ? d.prevMonth() : r(t, "pika-next") && d.nextMonth() : (d.setDate(new Date(t.getAttribute("data-pika-year"), t.getAttribute("data-pika-month"), t.getAttribute("data-pika-day"))), l.bound && s(function() {
                                        d.hide(), l.blurFieldOnSelect && l.field && l.field.blur()
                                    }, 100))), r(t, "pika-select")) d._c = !0;
                                else {
                                    if (!e.preventDefault) return e.returnValue = !1, !1;
                                    e.preventDefault()
                                }
                        }
                    }, d._onChange = function(e) {
                        var t = (e = e || window.event).target || e.srcElement;
                        t && (r(t, "pika-select-month") ? d.gotoMonth(t.value) : r(t, "pika-select-year") && d.gotoYear(t.value))
                    }, d._onKeyChange = function(e) {
                        if (e = e || window.event, d.isVisible()) switch (e.keyCode) {
                            case 13:
                            case 27:
                                l.field && l.field.blur();
                                break;
                            case 37:
                                d.adjustDate("subtract", 1);
                                break;
                            case 38:
                                d.adjustDate("subtract", 7);
                                break;
                            case 39:
                                d.adjustDate("add", 1);
                                break;
                            case 40:
                                d.adjustDate("add", 7);
                                break;
                            case 8:
                            case 46:
                                d.setDate(null)
                        }
                    }, d._parseFieldValue = function() {
                        if (l.parse) return l.parse(l.field.value, l.format);
                        if (t) {
                            var n = e(l.field.value, l.format, l.formatStrict);
                            return n && n.isValid() ? n.toDate() : null
                        }
                        return new Date(Date.parse(l.field.value))
                    }, d._onInputChange = function(e) {
                        var t;
                        e.firedBy !== d && (t = d._parseFieldValue(), c(t) && d.setDate(t), d._v || d.show())
                    }, d._onInputFocus = function() {
                        d.show()
                    }, d._onInputClick = function() {
                        d.show()
                    }, d._onInputBlur = function() {
                        var e = i.activeElement;
                        do {
                            if (r(e, "pika-single")) return
                        } while (e = e.parentNode);
                        d._c || (d._b = s(function() {
                            d.hide()
                        }, 50)), d._c = !1
                    }, d._onClick = function(e) {
                        var t = (e = e || window.event).target || e.srcElement,
                            i = t;
                        if (t) {
                            !n && r(t, "pika-select") && (t.onchange || (t.setAttribute("onchange", "return;"), a(t, "change", d._onChange)));
                            do {
                                if (r(i, "pika-single") || i === l.trigger) return
                            } while (i = i.parentNode);
                            d._v && t !== l.trigger && i !== l.trigger && d.hide()
                        }
                    }, d.el = i.createElement("div"), d.el.className = "pika-single" + (l.isRTL ? " is-rtl" : "") + (l.theme ? " " + l.theme : ""), a(d.el, "mousedown", d._onMouseDown, !0), a(d.el, "touchend", d._onMouseDown, !0), a(d.el, "change", d._onChange), l.keyboardInput && a(i, "keydown", d._onKeyChange), l.field && (l.container ? l.container.appendChild(d.el) : l.bound ? i.body.appendChild(d.el) : l.field.parentNode.insertBefore(d.el, l.field.nextSibling), a(l.field, "change", d._onInputChange), l.defaultDate || (l.defaultDate = d._parseFieldValue(), l.setDefaultDate = !0));
                    var u = l.defaultDate;
                    c(u) ? l.setDefaultDate ? d.setDate(u, !0) : d.gotoDate(u) : d.gotoDate(new Date), l.bound ? (this.hide(), d.el.className += " is-bound", a(l.trigger, "click", d._onInputClick), a(l.trigger, "focus", d._onInputFocus), a(l.trigger, "blur", d._onInputBlur)) : this.show()
                };
            return Y.prototype = {
                config: function(e) {
                    this._o || (this._o = p({}, v, !0));
                    var t = p(this._o, e, !0);
                    t.isRTL = !!t.isRTL, t.field = t.field && t.field.nodeName ? t.field : null, t.theme = "string" == typeof t.theme && t.theme ? t.theme : null, t.bound = !!(void 0 !== t.bound ? t.field && t.bound : t.field), t.trigger = t.trigger && t.trigger.nodeName ? t.trigger : t.field, t.disableWeekends = !!t.disableWeekends, t.disableDayFn = "function" == typeof t.disableDayFn ? t.disableDayFn : null;
                    var n = parseInt(t.numberOfMonths, 10) || 1;
                    if (t.numberOfMonths = n > 4 ? 4 : n, c(t.minDate) || (t.minDate = !1), c(t.maxDate) || (t.maxDate = !1), t.minDate && t.maxDate && t.maxDate < t.minDate && (t.maxDate = t.minDate = !1), t.minDate && this.setMinDate(t.minDate), t.maxDate && this.setMaxDate(t.maxDate), u(t.yearRange)) {
                        var i = (new Date).getFullYear() - 10;
                        t.yearRange[0] = parseInt(t.yearRange[0], 10) || i, t.yearRange[1] = parseInt(t.yearRange[1], 10) || i
                    } else t.yearRange = Math.abs(parseInt(t.yearRange, 10)) || v.yearRange, t.yearRange > 100 && (t.yearRange = 100);
                    return t
                },
                toString: function(n) {
                    return n = n || this._o.format, c(this._d) ? this._o.toString ? this._o.toString(this._d, n) : t ? e(this._d).format(n) : this._d.toDateString() : ""
                },
                getMoment: function() {
                    return t ? e(this._d) : null
                },
                setMoment: function(n, i) {
                    t && e.isMoment(n) && this.setDate(n.toDate(), i)
                },
                getDate: function() {
                    return c(this._d) ? new Date(this._d.getTime()) : null
                },
                setDate: function(e, t) {
                    if (!e) return this._d = null, this._o.field && (this._o.field.value = "", g(this._o.field, "change", {
                        firedBy: this
                    })), this.draw();
                    if ("string" == typeof e && (e = new Date(Date.parse(e))), c(e)) {
                        var n = this._o.minDate,
                            i = this._o.maxDate;
                        c(n) && e < n ? e = n : c(i) && e > i && (e = i), this._d = new Date(e.getTime()), f(this._d), this.gotoDate(this._d), this._o.field && (this._o.field.value = this.toString(), g(this._o.field, "change", {
                            firedBy: this
                        })), t || "function" != typeof this._o.onSelect || this._o.onSelect.call(this, this.getDate())
                    }
                },
                clear: function() {
                    this.setDate(null)
                },
                gotoDate: function(e) {
                    var t = !0;
                    if (c(e)) {
                        if (this.calendars) {
                            var n = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                                i = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
                                s = e.getTime();
                            i.setMonth(i.getMonth() + 1), i.setDate(i.getDate() - 1), t = s < n.getTime() || i.getTime() < s
                        }
                        t && (this.calendars = [{
                            month: e.getMonth(),
                            year: e.getFullYear()
                        }], "right" === this._o.mainCalendar && (this.calendars[0].month += 1 - this._o.numberOfMonths)), this.adjustCalendars()
                    }
                },
                adjustDate: function(e, t) {
                    var n, i = this.getDate() || new Date,
                        s = 24 * parseInt(t) * 60 * 60 * 1e3;
                    "add" === e ? n = new Date(i.valueOf() + s) : "subtract" === e && (n = new Date(i.valueOf() - s)), this.setDate(n)
                },
                adjustCalendars: function() {
                    this.calendars[0] = y(this.calendars[0]);
                    for (var e = 1; e < this._o.numberOfMonths; e++) this.calendars[e] = y({
                        month: this.calendars[0].month + e,
                        year: this.calendars[0].year
                    });
                    this.draw()
                },
                gotoToday: function() {
                    this.gotoDate(new Date)
                },
                gotoMonth: function(e) {
                    isNaN(e) || (this.calendars[0].month = parseInt(e, 10), this.adjustCalendars())
                },
                nextMonth: function() {
                    this.calendars[0].month++, this.adjustCalendars()
                },
                prevMonth: function() {
                    this.calendars[0].month--, this.adjustCalendars()
                },
                gotoYear: function(e) {
                    isNaN(e) || (this.calendars[0].year = parseInt(e, 10), this.adjustCalendars())
                },
                setMinDate: function(e) {
                    e instanceof Date ? (f(e), this._o.minDate = e, this._o.minYear = e.getFullYear(), this._o.minMonth = e.getMonth()) : (this._o.minDate = v.minDate, this._o.minYear = v.minYear, this._o.minMonth = v.minMonth, this._o.startRange = v.startRange), this.draw()
                },
                setMaxDate: function(e) {
                    e instanceof Date ? (f(e), this._o.maxDate = e, this._o.maxYear = e.getFullYear(), this._o.maxMonth = e.getMonth()) : (this._o.maxDate = v.maxDate, this._o.maxYear = v.maxYear, this._o.maxMonth = v.maxMonth, this._o.endRange = v.endRange), this.draw()
                },
                setStartRange: function(e) {
                    this._o.startRange = e
                },
                setEndRange: function(e) {
                    this._o.endRange = e
                },
                draw: function(e) {
                    if (this._v || e) {
                        var t, n = this._o,
                            i = n.minYear,
                            a = n.maxYear,
                            o = n.minMonth,
                            r = n.maxMonth,
                            d = "";
                        this._y <= i && (this._y = i, !isNaN(o) && this._m < o && (this._m = o)), this._y >= a && (this._y = a, !isNaN(r) && this._m > r && (this._m = r));
                        for (var l = 0; l < n.numberOfMonths; l++) t = "pika-title-" + Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 2), d += '<div class="pika-lendar">' + k(this, l, this.calendars[l].year, this.calendars[l].month, this.calendars[0].year, t) + this.render(this.calendars[l].year, this.calendars[l].month, t) + "</div>";
                        this.el.innerHTML = d, n.bound && "hidden" !== n.field.type && s(function() {
                            n.trigger.focus()
                        }, 1), "function" == typeof this._o.onDraw && this._o.onDraw(this), n.bound && n.field.setAttribute("aria-label", n.ariaLabel)
                    }
                },
                adjustPosition: function() {
                    var e, t, n, s, a, o, r, u, c, h, m, f;
                    if (!this._o.container) {
                        if (this.el.style.position = "absolute", t = e = this._o.trigger, n = this.el.offsetWidth, s = this.el.offsetHeight, a = window.innerWidth || i.documentElement.clientWidth, o = window.innerHeight || i.documentElement.clientHeight, r = window.pageYOffset || i.body.scrollTop || i.documentElement.scrollTop, m = !0, f = !0, "function" == typeof e.getBoundingClientRect) u = (h = e.getBoundingClientRect()).left + window.pageXOffset, c = h.bottom + window.pageYOffset;
                        else
                            for (u = t.offsetLeft, c = t.offsetTop + t.offsetHeight; t = t.offsetParent;) u += t.offsetLeft, c += t.offsetTop;
                        (this._o.reposition && u + n > a || this._o.position.indexOf("right") > -1 && u - n + e.offsetWidth > 0) && (u = u - n + e.offsetWidth, m = !1), (this._o.reposition && c + s > o + r || this._o.position.indexOf("top") > -1 && c - s - e.offsetHeight > 0) && (c = c - s - e.offsetHeight, f = !1), this.el.style.left = u + "px", this.el.style.top = c + "px", d(this.el, m ? "left-aligned" : "right-aligned"), d(this.el, f ? "bottom-aligned" : "top-aligned"), l(this.el, m ? "right-aligned" : "left-aligned"), l(this.el, f ? "top-aligned" : "bottom-aligned")
                    }
                },
                render: function(e, t, n) {
                    var i = this._o,
                        s = new Date,
                        a = m(e, t),
                        o = new Date(e, t, 1).getDay(),
                        r = [],
                        d = [];
                    f(s), i.firstDay > 0 && (o -= i.firstDay) < 0 && (o += 7);
                    for (var l = 0 === t ? 11 : t - 1, u = 11 === t ? 0 : t + 1, p = 0 === t ? e - 1 : e, g = 11 === t ? e + 1 : e, y = m(p, l), v = a + o, k = v; k > 7;) k -= 7;
                    v += 7 - k;
                    for (var Y = !1, T = 0, D = 0; T < v; T++) {
                        var S = new Date(e, t, T - o + 1),
                            x = !!c(this._d) && _(S, this._d),
                            H = _(S, s),
                            j = -1 !== i.events.indexOf(S.toDateString()),
                            C = T < o || T >= a + o,
                            P = T - o + 1,
                            E = t,
                            A = e,
                            O = i.startRange && _(i.startRange, S),
                            F = i.endRange && _(i.endRange, S),
                            $ = i.startRange && i.endRange && i.startRange < S && S < i.endRange,
                            W = i.minDate && S < i.minDate || i.maxDate && S > i.maxDate || i.disableWeekends && h(S) || i.disableDayFn && i.disableDayFn(S);
                        C && (T < o ? (P = y + P, E = l, A = p) : (P -= a, E = u, A = g));
                        var N = {
                            day: P,
                            month: E,
                            year: A,
                            hasEvent: j,
                            isSelected: x,
                            isToday: H,
                            isDisabled: W,
                            isEmpty: C,
                            isStartRange: O,
                            isEndRange: F,
                            isInRange: $,
                            showDaysInNextAndPreviousMonths: i.showDaysInNextAndPreviousMonths,
                            enableSelectionDaysInNextAndPreviousMonths: i.enableSelectionDaysInNextAndPreviousMonths
                        };
                        i.pickWholeWeek && x && (Y = !0), d.push(L(N)), 7 == ++D && (i.showWeekNumber && d.unshift(w(T - o, t, e, i.firstWeekOfYearMinDays)), r.push(b(d, i.isRTL, i.pickWholeWeek, Y)), d = [], D = 0, Y = !1)
                    }
                    return function(e, t, n) {
                        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + n + '">' + function(e) {
                            var t, n = [];
                            for (e.showWeekNumber && n.push("<th></th>"), t = 0; t < 7; t++) n.push('<th scope="col"><abbr title="' + M(e, t) + '">' + M(e, t, !0) + "</abbr></th>");
                            return "<thead><tr>" + (e.isRTL ? n.reverse() : n).join("") + "</tr></thead>"
                        }(e) + function(e) {
                            return "<tbody>" + e.join("") + "</tbody>"
                        }(t) + "</table>"
                    }(i, r, n)
                },
                isVisible: function() {
                    return this._v
                },
                show: function() {
                    this.isVisible() || (this._v = !0, this.draw(), l(this.el, "is-hidden"), this._o.bound && (a(i, "click", this._onClick), this.adjustPosition()), "function" == typeof this._o.onOpen && this._o.onOpen.call(this))
                },
                hide: function() {
                    var e = this._v;
                    !1 !== e && (this._o.bound && o(i, "click", this._onClick), this._o.container || (this.el.style.position = "static", this.el.style.left = "auto", this.el.style.top = "auto"), d(this.el, "is-hidden"), this._v = !1, void 0 !== e && "function" == typeof this._o.onClose && this._o.onClose.call(this))
                },
                destroy: function() {
                    var e = this._o;
                    this.hide(), o(this.el, "mousedown", this._onMouseDown, !0), o(this.el, "touchend", this._onMouseDown, !0), o(this.el, "change", this._onChange), e.keyboardInput && o(i, "keydown", this._onKeyChange), e.field && (o(e.field, "change", this._onInputChange), e.bound && (o(e.trigger, "click", this._onInputClick), o(e.trigger, "focus", this._onInputFocus), o(e.trigger, "blur", this._onInputBlur))), this.el.parentNode && this.el.parentNode.removeChild(this.el)
                }
            }, Y
        }(s)
    }()
}, function(e, t) {
    e.exports = function(e) {
        return e.webpackPolyfill || (e.deprecate = function() {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
            enumerable: !0,
            get: function() {
                return e.l
            }
        }), Object.defineProperty(e, "id", {
            enumerable: !0,
            get: function() {
                return e.i
            }
        }), e.webpackPolyfill = 1), e
    }
}, function(e, t, n) {
    var i = {
        "./af": 8,
        "./af.js": 8,
        "./ar": 9,
        "./ar-dz": 10,
        "./ar-dz.js": 10,
        "./ar-kw": 11,
        "./ar-kw.js": 11,
        "./ar-ly": 12,
        "./ar-ly.js": 12,
        "./ar-ma": 13,
        "./ar-ma.js": 13,
        "./ar-sa": 14,
        "./ar-sa.js": 14,
        "./ar-tn": 15,
        "./ar-tn.js": 15,
        "./ar.js": 9,
        "./az": 16,
        "./az.js": 16,
        "./be": 17,
        "./be.js": 17,
        "./bg": 18,
        "./bg.js": 18,
        "./bm": 19,
        "./bm.js": 19,
        "./bn": 20,
        "./bn-bd": 21,
        "./bn-bd.js": 21,
        "./bn.js": 20,
        "./bo": 22,
        "./bo.js": 22,
        "./br": 23,
        "./br.js": 23,
        "./bs": 24,
        "./bs.js": 24,
        "./ca": 25,
        "./ca.js": 25,
        "./cs": 26,
        "./cs.js": 26,
        "./cv": 27,
        "./cv.js": 27,
        "./cy": 28,
        "./cy.js": 28,
        "./da": 29,
        "./da.js": 29,
        "./de": 30,
        "./de-at": 31,
        "./de-at.js": 31,
        "./de-ch": 32,
        "./de-ch.js": 32,
        "./de.js": 30,
        "./dv": 33,
        "./dv.js": 33,
        "./el": 34,
        "./el.js": 34,
        "./en-au": 35,
        "./en-au.js": 35,
        "./en-ca": 36,
        "./en-ca.js": 36,
        "./en-gb": 37,
        "./en-gb.js": 37,
        "./en-ie": 38,
        "./en-ie.js": 38,
        "./en-il": 39,
        "./en-il.js": 39,
        "./en-in": 40,
        "./en-in.js": 40,
        "./en-nz": 41,
        "./en-nz.js": 41,
        "./en-sg": 42,
        "./en-sg.js": 42,
        "./eo": 43,
        "./eo.js": 43,
        "./es": 44,
        "./es-do": 45,
        "./es-do.js": 45,
        "./es-mx": 46,
        "./es-mx.js": 46,
        "./es-us": 47,
        "./es-us.js": 47,
        "./es.js": 44,
        "./et": 48,
        "./et.js": 48,
        "./eu": 49,
        "./eu.js": 49,
        "./fa": 50,
        "./fa.js": 50,
        "./fi": 51,
        "./fi.js": 51,
        "./fil": 52,
        "./fil.js": 52,
        "./fo": 53,
        "./fo.js": 53,
        "./fr": 54,
        "./fr-ca": 55,
        "./fr-ca.js": 55,
        "./fr-ch": 56,
        "./fr-ch.js": 56,
        "./fr.js": 54,
        "./fy": 57,
        "./fy.js": 57,
        "./ga": 58,
        "./ga.js": 58,
        "./gd": 59,
        "./gd.js": 59,
        "./gl": 60,
        "./gl.js": 60,
        "./gom-deva": 61,
        "./gom-deva.js": 61,
        "./gom-latn": 62,
        "./gom-latn.js": 62,
        "./gu": 63,
        "./gu.js": 63,
        "./he": 64,
        "./he.js": 64,
        "./hi": 65,
        "./hi.js": 65,
        "./hr": 66,
        "./hr.js": 66,
        "./hu": 67,
        "./hu.js": 67,
        "./hy-am": 68,
        "./hy-am.js": 68,
        "./id": 69,
        "./id.js": 69,
        "./is": 70,
        "./is.js": 70,
        "./it": 71,
        "./it-ch": 72,
        "./it-ch.js": 72,
        "./it.js": 71,
        "./ja": 73,
        "./ja.js": 73,
        "./jv": 74,
        "./jv.js": 74,
        "./ka": 75,
        "./ka.js": 75,
        "./kk": 76,
        "./kk.js": 76,
        "./km": 77,
        "./km.js": 77,
        "./kn": 78,
        "./kn.js": 78,
        "./ko": 79,
        "./ko.js": 79,
        "./ku": 80,
        "./ku.js": 80,
        "./ky": 81,
        "./ky.js": 81,
        "./lb": 82,
        "./lb.js": 82,
        "./lo": 83,
        "./lo.js": 83,
        "./lt": 84,
        "./lt.js": 84,
        "./lv": 85,
        "./lv.js": 85,
        "./me": 86,
        "./me.js": 86,
        "./mi": 87,
        "./mi.js": 87,
        "./mk": 88,
        "./mk.js": 88,
        "./ml": 89,
        "./ml.js": 89,
        "./mn": 90,
        "./mn.js": 90,
        "./mr": 91,
        "./mr.js": 91,
        "./ms": 92,
        "./ms-my": 93,
        "./ms-my.js": 93,
        "./ms.js": 92,
        "./mt": 94,
        "./mt.js": 94,
        "./my": 95,
        "./my.js": 95,
        "./nb": 96,
        "./nb.js": 96,
        "./ne": 97,
        "./ne.js": 97,
        "./nl": 98,
        "./nl-be": 99,
        "./nl-be.js": 99,
        "./nl.js": 98,
        "./nn": 100,
        "./nn.js": 100,
        "./oc-lnc": 101,
        "./oc-lnc.js": 101,
        "./pa-in": 102,
        "./pa-in.js": 102,
        "./pl": 103,
        "./pl.js": 103,
        "./pt": 104,
        "./pt-br": 105,
        "./pt-br.js": 105,
        "./pt.js": 104,
        "./ro": 106,
        "./ro.js": 106,
        "./ru": 107,
        "./ru.js": 107,
        "./sd": 108,
        "./sd.js": 108,
        "./se": 109,
        "./se.js": 109,
        "./si": 110,
        "./si.js": 110,
        "./sk": 111,
        "./sk.js": 111,
        "./sl": 112,
        "./sl.js": 112,
        "./sq": 113,
        "./sq.js": 113,
        "./sr": 114,
        "./sr-cyrl": 115,
        "./sr-cyrl.js": 115,
        "./sr.js": 114,
        "./ss": 116,
        "./ss.js": 116,
        "./sv": 117,
        "./sv.js": 117,
        "./sw": 118,
        "./sw.js": 118,
        "./ta": 119,
        "./ta.js": 119,
        "./te": 120,
        "./te.js": 120,
        "./tet": 121,
        "./tet.js": 121,
        "./tg": 122,
        "./tg.js": 122,
        "./th": 123,
        "./th.js": 123,
        "./tk": 124,
        "./tk.js": 124,
        "./tl-ph": 125,
        "./tl-ph.js": 125,
        "./tlh": 126,
        "./tlh.js": 126,
        "./tr": 127,
        "./tr.js": 127,
        "./tzl": 128,
        "./tzl.js": 128,
        "./tzm": 129,
        "./tzm-latn": 130,
        "./tzm-latn.js": 130,
        "./tzm.js": 129,
        "./ug-cn": 131,
        "./ug-cn.js": 131,
        "./uk": 132,
        "./uk.js": 132,
        "./ur": 133,
        "./ur.js": 133,
        "./uz": 134,
        "./uz-latn": 135,
        "./uz-latn.js": 135,
        "./uz.js": 134,
        "./vi": 136,
        "./vi.js": 136,
        "./x-pseudo": 137,
        "./x-pseudo.js": 137,
        "./yo": 138,
        "./yo.js": 138,
        "./zh-cn": 139,
        "./zh-cn.js": 139,
        "./zh-hk": 140,
        "./zh-hk.js": 140,
        "./zh-mo": 141,
        "./zh-mo.js": 141,
        "./zh-tw": 142,
        "./zh-tw.js": 142
    };

    function s(e) {
        var t = a(e);
        return n(t)
    }

    function a(e) {
        if (!n.o(i, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw t.code = "MODULE_NOT_FOUND", t
        }
        return i[e]
    }
    s.keys = function() {
        return Object.keys(i)
    }, s.resolve = a, e.exports = s, s.id = 182
}, function(e, t) {
    function n() {}
    n.prototype = {
        on: function(e, t, n) {
            var i = this.e || (this.e = {});
            return (i[e] || (i[e] = [])).push({
                fn: t,
                ctx: n
            }), this
        },
        once: function(e, t, n) {
            var i = this;

            function s() {
                i.off(e, s), t.apply(n, arguments)
            }
            return s._ = t, this.on(e, s, n)
        },
        emit: function(e) {
            for (var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), i = 0, s = n.length; i < s; i++) n[i].fn.apply(n[i].ctx, t);
            return this
        },
        off: function(e, t) {
            var n = this.e || (this.e = {}),
                i = n[e],
                s = [];
            if (i && t)
                for (var a = 0, o = i.length; a < o; a++) i[a].fn !== t && i[a].fn._ !== t && s.push(i[a]);
            return s.length ? n[e] = s : delete n[e], this
        }
    }, e.exports = n, e.exports.TinyEmitter = n
}]);
//# sourceMappingURL=main.js.map
document.addEventListener("DOMContentLoaded", function () {
  let multiDataCombine = document.querySelectorAll('.rte table .multiDataCombine');
  console.log(multiDataCombine);
  multiDataCombine.forEach(element => {
    element.innerText = element.innerText.replace(/ \,/g, ',');
  });
});
